/* eslint-disable */
!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = t(require('react'), require('react-dom'), require('prop-types')))
    : 'function' == typeof define && define.amd
      ? define(['react', 'react-dom', 'prop-types'], t)
      : ((e = e || self).mobiscroll = t(e.React, e.ReactDOM, e.PropTypes))
})(this, function (b, i, e) {
  'use strict'
  function r(e, t, a) {
    return (t in e ? Object.defineProperty(e, t, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = a), e)
  }
  function g() {
    return (g =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = arguments[t]
          for (var n in a) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n])
        }
        return e
      }).apply(this, arguments)
  }
  function l(e, t) {
    ;((e.prototype = Object.create(t.prototype)), ((e.prototype.constructor = e).__proto__ = t))
  }
  function x(e, t) {
    if (null == e) return {}
    var a,
      n,
      s = {},
      i = Object.keys(e)
    for (n = 0; n < i.length; n++) ((a = i[n]), 0 <= t.indexOf(a) || (s[a] = e[a]))
    return s
  }
  function c(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
    return e
  }
  ;((b = b && b.hasOwnProperty('default') ? b.default : b),
    (i = i && i.hasOwnProperty('default') ? i.default : i),
    (e = e && e.hasOwnProperty('default') ? e.default : e))
  var Z = Z || {},
    t = {},
    ie = {},
    a = { 'column-count': 1, columns: 1, 'font-weight': 1, 'line-height': 1, opacity: 1, 'z-index': 1, zoom: 1 },
    n = { readonly: 'readOnly' },
    s = [],
    o = Array.prototype.slice
  function h(e) {
    return 'function' == typeof e
  }
  function d(e) {
    return 'object' == typeof e
  }
  function u(e) {
    return 'number' == typeof e.length
  }
  function m(e) {
    return e.replace(/-+(.)?/g, function (e, t) {
      return t ? t.toUpperCase() : ''
    })
  }
  function p(e) {
    return e
      .replace(/::/g, '/')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
      .replace(/([a-z\d])([A-Z])/g, '$1_$2')
      .replace(/_/g, '-')
      .toLowerCase()
  }
  function f(e, t) {
    return 'number' != typeof t || a[p(e)] ? t : t + 'px'
  }
  var v,
    T =
      ((v = function e(t, a) {
        var n,
          s,
          i,
          r = [],
          o = 0
        if (t && !a && t instanceof y) return t
        if (h(t)) return e(document).ready(t)
        if (t)
          if ('string' == typeof t)
            if (((t = i = t.trim()), 0 <= i.indexOf('<') && 0 <= i.indexOf('>'))) {
              var l = 'div'
              for (
                0 === i.indexOf('<li') && (l = 'ul'),
                  0 === i.indexOf('<tr') && (l = 'tbody'),
                  (0 !== i.indexOf('<td') && 0 !== i.indexOf('<th')) || (l = 'tr'),
                  0 === i.indexOf('<tbody') && (l = 'table'),
                  0 === i.indexOf('<option') && (l = 'select'),
                  (s = document.createElement(l)).innerHTML = i,
                  o = 0;
                o < s.childNodes.length;
                o++
              )
                r.push(s.childNodes[o])
            } else
              for (
                n =
                  a || '#' !== t[0] || t.match(/[ .<>:~]/)
                    ? (a instanceof y && (a = a[0]), (a || document).querySelectorAll(t))
                    : [document.getElementById(t.split('#')[1])],
                  o = 0;
                o < n.length;
                o++
              )
                n[o] && r.push(n[o])
          else if (t.nodeType || t === window || t === document) r.push(t)
          else if (0 < t.length && t[0].nodeType) for (o = 0; o < t.length; o++) r.push(t[o])
          else e.isArray(t) && (r = t)
        return new y(r)
      }),
      (y.prototype = {
        ready: function (e) {
          return (
            (document.attachEvent ? 'complete' == document.readyState : 'loading' != document.readyState)
              ? e(v)
              : document.addEventListener(
                  'DOMContentLoaded',
                  function () {
                    e(v)
                  },
                  !1,
                ),
            this
          )
        },
        concat: s.concat,
        empty: function () {
          return this.each(function () {
            this.innerHTML = ''
          })
        },
        map: function (a) {
          return v(
            v.map(this, function (e, t) {
              return a.call(e, t, e)
            }),
          )
        },
        slice: function () {
          return v(o.apply(this, arguments))
        },
        addClass: function (e) {
          if (void 0 === e) return this
          for (var t = e.split(' '), a = 0; a < t.length; a++)
            for (var n = 0; n < this.length; n++) void 0 !== this[n].classList && '' !== t[a] && this[n].classList.add(t[a])
          return this
        },
        removeClass: function (e) {
          if (void 0 === e) return this
          for (var t = e.split(' '), a = 0; a < t.length; a++)
            for (var n = 0; n < this.length; n++) void 0 !== this[n].classList && '' !== t[a] && this[n].classList.remove(t[a])
          return this
        },
        hasClass: function (e) {
          return !!this[0] && this[0].classList.contains(e)
        },
        toggleClass: function (e) {
          for (var t = e.split(' '), a = 0; a < t.length; a++)
            for (var n = 0; n < this.length; n++) void 0 !== this[n].classList && this[n].classList.toggle(t[a])
          return this
        },
        closest: function (e, t) {
          var a = this[0],
            n = !1
          for (d(e) && (n = v(e)); a && !(n ? 0 <= n.indexOf(a) : v.matches(a, e)); )
            a = a !== t && a.nodeType !== a.DOCUMENT_NODE && a.parentNode
          return v(a)
        },
        attr: function (e, t) {
          var a
          if (1 !== arguments.length || 'string' != typeof e) {
            for (var n = 0; n < this.length; n++)
              if (2 === arguments.length) this[n].setAttribute(e, t)
              else for (var s in e) ((this[n][s] = e[s]), this[n].setAttribute(s, e[s]))
            return this
          }
          if (this.length) return ((a = this[0].getAttribute(e)), a || '' === a ? a : void 0)
        },
        removeAttr: function (e) {
          for (var t = 0; t < this.length; t++) this[t].removeAttribute(e)
          return this
        },
        prop: function (e, t) {
          if (((e = n[e] || e), 1 === arguments.length && 'string' == typeof e)) return this[0] ? this[0][e] : void 0
          for (var a = 0; a < this.length; a++) this[a][e] = t
          return this
        },
        val: function (e) {
          if (void 0 === e)
            return this.length && this[0].multiple
              ? v.map(this.find('option:checked'), function (e) {
                  return e.value
                })
              : this[0]
                ? this[0].value
                : void 0
          if (this.length && this[0].multiple)
            v.each(this[0].options, function () {
              this.selected = -1 != e.indexOf(this.value)
            })
          else for (var t = 0; t < this.length; t++) this[t].value = e
          return this
        },
        on: function (e, a, n, t) {
          var s,
            i,
            r,
            o,
            l,
            c = e.split(' ')
          function d(e) {
            for (var t = e.target; t; ) (v(t).is(a) && n.call(t, e), (t = t !== this ? t.parentNode : null))
          }
          function u(e, t, a, n) {
            var s = t.split('.')
            ;(e.DomNameSpaces || (e.DomNameSpaces = []),
              e.DomNameSpaces.push({ namespace: s[1], event: s[0], listener: a, capture: n }),
              e.addEventListener(s[0], a, n))
          }
          for (o = 0; o < this.length; o++)
            if (((i = this[o]), h(a) || !1 === a))
              for (h(a) && ((t = n || !1), (n = a)), l = 0; l < c.length; l++)
                -1 != (r = c[l]).indexOf('.') ? u(i, r, n, t) : i.addEventListener(r, n, t)
            else
              for (s = d.bind(i), l = 0; l < c.length; l++)
                ((r = c[l]),
                  i.DomLiveListeners || (i.DomLiveListeners = []),
                  i.DomLiveListeners.push({ listener: n, liveListener: s }),
                  -1 != r.indexOf('.') ? u(i, r, s, t) : i.addEventListener(r, s, t))
          return this
        },
        off: function (e, t, a, n) {
          var s,
            i,
            r,
            o,
            l,
            c,
            d,
            u = this
          function m(e) {
            var t,
              a,
              n,
              s,
              i,
              r = e.split('.'),
              o = r[0],
              l = r[1]
            for (a = 0; a < u.length; ++a)
              if ((i = (t = u[a]).DomNameSpaces)) {
                for (n = 0; n < i.length; ++n)
                  (s = i[n]).namespace != l ||
                    (s.event != o && o) ||
                    (t.removeEventListener(s.event, s.listener, s.capture), (s.removed = !0))
                for (n = i.length - 1; 0 <= n; --n) i[n].removed && i.splice(n, 1)
              }
          }
          for (r = e.split(' '), o = 0; o < r.length; o++)
            for (i = r[o], l = 0; l < this.length; l++)
              if (((d = (s = this[l]).DomLiveListeners), h(t) || !1 === t))
                (h(t) && ((n = a || !1), (a = t)), 0 === i.indexOf('.') ? m(i.substr(1)) : s.removeEventListener(i, a, n))
              else {
                if (d) for (c = 0; c < d.length; c++) d[c].listener === a && s.removeEventListener(i, d[c].liveListener, n)
                s.DomNameSpaces && s.DomNameSpaces.length && i && m(i)
              }
          return this
        },
        trigger: function (e, t) {
          for (var a = e.split(' '), n = 0; n < a.length; n++)
            for (var s = 0; s < this.length; s++) {
              var i
              try {
                i = new CustomEvent(a[n], { detail: t, bubbles: !0, cancelable: !0 })
              } catch (e) {
                ;((i = document.createEvent('Event')).initEvent(a[n], !0, !0), (i.detail = t))
              }
              this[s].dispatchEvent(i)
            }
          return this
        },
        width: function (e) {
          return void 0 !== e
            ? this.css('width', e)
            : this[0] === window
              ? window.innerWidth
              : this[0] === document
                ? document.documentElement.scrollWidth
                : 0 < this.length
                  ? parseFloat(this.css('width'))
                  : null
        },
        height: function (e) {
          if (void 0 !== e) return this.css('height', e)
          if (this[0] === window) return window.innerHeight
          if (this[0] !== document) return 0 < this.length ? parseFloat(this.css('height')) : null
          var t = document.body,
            a = document.documentElement
          return Math.max(t.scrollHeight, t.offsetHeight, a.clientHeight, a.scrollHeight, a.offsetHeight)
        },
        innerWidth: function () {
          var t = this
          if (0 < this.length) {
            if (this[0].innerWidth) return this[0].innerWidth
            var a = this[0].offsetWidth
            return (
              ['left', 'right'].forEach(function (e) {
                a -= parseInt(t.css(m('border-' + e + '-width')) || 0, 10)
              }),
              a
            )
          }
        },
        innerHeight: function () {
          var t = this
          if (0 < this.length) {
            if (this[0].innerHeight) return this[0].innerHeight
            var a = this[0].offsetHeight
            return (
              ['top', 'bottom'].forEach(function (e) {
                a -= parseInt(t.css(m('border-' + e + '-width')) || 0, 10)
              }),
              a
            )
          }
        },
        offset: function () {
          if (0 < this.length) {
            var e = this[0].getBoundingClientRect(),
              t = document.documentElement
            return { top: e.top + window.pageYOffset - t.clientTop, left: e.left + window.pageXOffset - t.clientLeft }
          }
        },
        hide: function () {
          for (var e = 0; e < this.length; e++) this[e].style.display = 'none'
          return this
        },
        show: function () {
          for (var e = 0; e < this.length; e++)
            ('none' == this[e].style.display && (this[e].style.display = ''),
              'none' == getComputedStyle(this[e], '').getPropertyValue('display') && (this[e].style.display = 'block'))
          return this
        },
        clone: function () {
          return this.map(function () {
            return this.cloneNode(!0)
          })
        },
        styles: function () {
          return this[0] ? window.getComputedStyle(this[0], null) : void 0
        },
        css: function (e, t) {
          var a,
            n,
            s = this[0],
            i = ''
          if (arguments.length < 2) {
            if (!s) return
            if ('string' == typeof e) return s.style[e] || getComputedStyle(s, '').getPropertyValue(e)
          }
          if ('string' == typeof e)
            t || 0 === t
              ? (i = p(e) + ':' + f(e, t))
              : this.each(function () {
                  this.style.removeProperty(p(e))
                })
          else
            for (n in e)
              if (e[n] || 0 === e[n]) i += p(n) + ':' + f(n, e[n]) + ';'
              else for (a = 0; a < this.length; a++) this[a].style.removeProperty(p(n))
          return this.each(function () {
            this.style.cssText += ';' + i
          })
        },
        each: function (e) {
          for (var t = 0; t < this.length && !1 !== e.apply(this[t], [t, this[t]]); t++);
          return this
        },
        filter: function (e) {
          for (var t = [], a = 0; a < this.length; a++)
            h(e) ? e.call(this[a], a, this[a]) && t.push(this[a]) : v.matches(this[a], e) && t.push(this[a])
          return new y(t)
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : void 0
          this.empty()
          for (var t = 0; t < this.length; t++) this[t].innerHTML = e
          return this
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null
          for (var t = 0; t < this.length; t++) this[t].textContent = e
          return this
        },
        is: function (e) {
          return 0 < this.length && v.matches(this[0], e)
        },
        not: function (t) {
          var a = []
          if (h(t) && void 0 !== t.call)
            this.each(function (e) {
              t.call(this, e) || a.push(this)
            })
          else {
            var n = 'string' == typeof t ? this.filter(t) : u(t) && h(t.item) ? o.call(t) : v(t)
            ;(d(n) &&
              (n = v.map(n, function (e) {
                return e
              })),
              this.each(function (e, t) {
                n.indexOf(t) < 0 && a.push(t)
              }))
          }
          return v(a)
        },
        indexOf: function (e) {
          for (var t = 0; t < this.length; t++) if (this[t] === e) return t
        },
        index: function (e) {
          return e ? this.indexOf(v(e)[0]) : this.parent().children().indexOf(this[0])
        },
        get: function (e) {
          return void 0 === e ? o.call(this) : this[0 <= e ? e : e + this.length]
        },
        eq: function (e) {
          if (void 0 === e) return this
          var t,
            a = this.length
          return new y(a - 1 < e ? [] : e < 0 ? ((t = a + e) < 0 ? [] : [this[t]]) : [this[e]])
        },
        append: function (e) {
          var t, a
          for (t = 0; t < this.length; t++)
            if ('string' == typeof e) {
              var n = document.createElement('div')
              for (n.innerHTML = e; n.firstChild; ) this[t].appendChild(n.firstChild)
            } else if (e instanceof y) for (a = 0; a < e.length; a++) this[t].appendChild(e[a])
            else this[t].appendChild(e)
          return this
        },
        appendTo: function (e) {
          return (v(e).append(this), this)
        },
        prepend: function (e) {
          var t, a
          for (t = 0; t < this.length; t++)
            if ('string' == typeof e) {
              var n = document.createElement('div')
              for (n.innerHTML = e, a = n.childNodes.length - 1; 0 <= a; a--) this[t].insertBefore(n.childNodes[a], this[t].childNodes[0])
            } else if (e instanceof y) for (a = 0; a < e.length; a++) this[t].insertBefore(e[a], this[t].childNodes[0])
            else this[t].insertBefore(e, this[t].childNodes[0])
          return this
        },
        prependTo: function (e) {
          return (v(e).prepend(this), this)
        },
        insertBefore: function (e) {
          for (var t = v(e), a = 0; a < this.length; a++)
            if (1 === t.length) t[0].parentNode.insertBefore(this[a], t[0])
            else if (1 < t.length) for (var n = 0; n < t.length; n++) t[n].parentNode.insertBefore(this[a].cloneNode(!0), t[n])
          return this
        },
        insertAfter: function (e) {
          for (var t = v(e), a = 0; a < this.length; a++)
            if (1 === t.length) t[0].parentNode.insertBefore(this[a], t[0].nextSibling)
            else if (1 < t.length) for (var n = 0; n < t.length; n++) t[n].parentNode.insertBefore(this[a].cloneNode(!0), t[n].nextSibling)
          return this
        },
        next: function (e) {
          return 0 < this.length
            ? e
              ? this[0].nextElementSibling && v(this[0].nextElementSibling).is(e)
                ? new y([this[0].nextElementSibling])
                : new y([])
              : this[0].nextElementSibling
                ? new y([this[0].nextElementSibling])
                : new y([])
            : new y([])
        },
        nextAll: function (e) {
          var t = [],
            a = this[0]
          if (!a) return new y([])
          for (; a.nextElementSibling; ) {
            var n = a.nextElementSibling
            ;(e ? v(n).is(e) && t.push(n) : t.push(n), (a = n))
          }
          return new y(t)
        },
        prev: function (e) {
          return 0 < this.length
            ? e
              ? this[0].previousElementSibling && v(this[0].previousElementSibling).is(e)
                ? new y([this[0].previousElementSibling])
                : new y([])
              : this[0].previousElementSibling
                ? new y([this[0].previousElementSibling])
                : new y([])
            : new y([])
        },
        prevAll: function (e) {
          var t = [],
            a = this[0]
          if (!a) return new y([])
          for (; a.previousElementSibling; ) {
            var n = a.previousElementSibling
            ;(e ? v(n).is(e) && t.push(n) : t.push(n), (a = n))
          }
          return new y(t)
        },
        parent: function (e) {
          for (var t = [], a = 0; a < this.length; a++)
            null !== this[a].parentNode && (e ? v(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode))
          return v(v.unique(t))
        },
        parents: function (e) {
          for (var t = [], a = 0; a < this.length; a++)
            for (var n = this[a].parentNode; n; ) (e ? v(n).is(e) && t.push(n) : t.push(n), (n = n.parentNode))
          return v(v.unique(t))
        },
        find: function (e) {
          for (var t = [], a = 0; a < this.length; a++) for (var n = this[a].querySelectorAll(e), s = 0; s < n.length; s++) t.push(n[s])
          return new y(t)
        },
        children: function (e) {
          for (var t = [], a = 0; a < this.length; a++)
            for (var n = this[a].childNodes, s = 0; s < n.length; s++)
              e ? 1 === n[s].nodeType && v(n[s]).is(e) && t.push(n[s]) : 1 === n[s].nodeType && t.push(n[s])
          return new y(v.unique(t))
        },
        remove: function () {
          for (var e = 0; e < this.length; e++) this[e].parentNode && this[e].parentNode.removeChild(this[e])
          return this
        },
        add: function () {
          var e, t
          for (e = 0; e < arguments.length; e++) {
            var a = v(arguments[e])
            for (t = 0; t < a.length; t++) ((this[this.length] = a[t]), this.length++)
          }
          return this
        },
        before: function (e) {
          return (v(e).insertBefore(this), this)
        },
        after: function (e) {
          return (v(e).insertAfter(this), this)
        },
        scrollTop: function (e) {
          if (this.length) {
            var t = 'scrollTop' in this[0]
            return void 0 === e
              ? t
                ? this[0].scrollTop
                : this[0].pageYOffset
              : this.each(
                  t
                    ? function () {
                        this.scrollTop = e
                      }
                    : function () {
                        this.scrollTo(this.scrollX, e)
                      },
                )
          }
        },
        scrollLeft: function (e) {
          if (this.length) {
            var t = 'scrollLeft' in this[0]
            return void 0 === e
              ? t
                ? this[0].scrollLeft
                : this[0].pageXOffset
              : this.each(
                  t
                    ? function () {
                        this.scrollLeft = e
                      }
                    : function () {
                        this.scrollTo(e, this.scrollY)
                      },
                )
          }
        },
        contents: function () {
          return this.map(function (e, t) {
            return o.call(t.childNodes)
          })
        },
        nextUntil: function (e) {
          for (var t = this, a = []; t.length && !t.filter(e).length; ) (a.push(t[0]), (t = t.next()))
          return v(a)
        },
        prevUntil: function (e) {
          for (var t = this, a = []; t.length && !v(t).filter(e).length; ) (a.push(t[0]), (t = t.prev()))
          return v(a)
        },
        detach: function () {
          return this.remove()
        },
      }),
      (v.fn = y.prototype),
      v)
  function y(e) {
    var t = 0
    for (t = 0; t < e.length; t++) this[t] = e[t]
    return ((this.length = e.length), v(this))
  }
  var C = T
  ;((Z.$ = T),
    (C.inArray = function (e, t, a) {
      return s.indexOf.call(t, e, a)
    }),
    (C.extend = function (t) {
      var a,
        e = o.call(arguments, 1)
      return (
        'boolean' == typeof t && ((a = t), (t = e.shift())),
        (t = t || {}),
        e.forEach(function (e) {
          !(function e(t, a, n) {
            for (var s in a)
              n && (C.isPlainObject(a[s]) || C.isArray(a[s]))
                ? (((C.isPlainObject(a[s]) && !C.isPlainObject(t[s])) || (C.isArray(a[s]) && !C.isArray(t[s]))) && (t[s] = {}),
                  e(t[s], a[s], n))
                : void 0 !== a[s] && (t[s] = a[s])
          })(t, e, a)
        }),
        t
      )
    }),
    (C.isFunction = h),
    (C.isArray = function (e) {
      return '[object Array]' === Object.prototype.toString.apply(e)
    }),
    (C.isPlainObject = function (e) {
      return d(e) && null !== e && e !== e.window && Object.getPrototypeOf(e) == Object.prototype
    }),
    (C.each = function (e, t) {
      var a, n
      if (d(e) && t) {
        if (C.isArray(e) || e instanceof T) for (a = 0; a < e.length && !1 !== t.call(e[a], a, e[a]); a++);
        else for (n in e) if (e.hasOwnProperty(n) && 'length' !== n && !1 === t.call(e[n], n, e[n])) break
        return this
      }
    }),
    (C.unique = function (e) {
      for (var t = [], a = 0; a < e.length; a++) -1 === t.indexOf(e[a]) && t.push(e[a])
      return t
    }),
    (C.map = function (e, t) {
      var a,
        n,
        s,
        i = []
      if (u(e)) for (n = 0; n < e.length; n++) null !== (a = t(e[n], n)) && i.push(a)
      else for (s in e) null !== (a = t(e[s], s)) && i.push(a)
      return 0 < i.length ? C.fn.concat.apply([], i) : i
    }),
    (C.matches = function (e, t) {
      return (
        !(!t || !e || 1 !== e.nodeType) &&
        (e.matchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector).call(e, t)
      )
    }))
  var _,
    w,
    M,
    S,
    k = [],
    D = 'undefined' != typeof window,
    N = D && window.matchMedia && window.matchMedia('(prefers-color-scheme:dark)').matches,
    E = D ? navigator.userAgent : '',
    O = D ? navigator.platform : '',
    V = D ? navigator.maxTouchPoints : 0,
    F = /Safari/.test(E),
    A = E.match(/Android|iPhone|iPad|iPod|Windows Phone|Windows|MSIE/i),
    sa =
      (D && window.requestAnimationFrame) ||
      function (e) {
        return setTimeout(e, 20)
      },
    ia =
      (D && window.cancelAnimationFrame) ||
      function (e) {
        clearTimeout(e)
      }
  function ra() {}
  function te(e) {
    var t,
      a = []
    for (t in e) a.push(e[t])
    return a
  }
  function ae(e) {
    var t,
      a = {}
    if (e) for (t = 0; t < e.length; t++) a[e[t]] = e[t]
    return a
  }
  function oa(e) {
    return 0 <= e - parseFloat(e)
  }
  function ue(e) {
    return 'string' == typeof e
  }
  function me(e, t, a) {
    return Math.max(t, Math.min(e, a))
  }
  function re(e, t) {
    for (e += '', t = t || 2; e.length < t; ) e = '0' + e
    return e
  }
  function la(n, s) {
    var i, r
    return (
      (s = s || 100),
      function () {
        var e = this,
          t = +new Date(),
          a = arguments
        i && t < i + s
          ? (clearTimeout(r),
            (r = setTimeout(function () {
              ;((i = t), n.apply(e, a))
            }, s)))
          : ((i = t), n.apply(e, a))
      }
    )
  }
  function ca(e) {
    'vibrate' in navigator && navigator.vibrate(e || 50)
  }
  function X(e, t, a) {
    return (100 * (e - t)) / (a - t)
  }
  function I(e, t, a) {
    var n = a.attr(e)
    return void 0 === n || '' === n ? t : 'true' === n
  }
  ;(/Android/i.test(A)
    ? ((_ = 'android'), (w = E.match(/Android\s+([\d.]+)/i)) && (k = w[0].replace('Android ', '').split('.')))
    : /iPhone|iPad|iPod/i.test(A) || /iPhone|iPad|iPod/i.test(O) || ('MacIntel' === O && 1 < V)
      ? ((_ = 'ios'), (w = E.match(/OS\s+([\d_]+)/i)) && (k = w[0].replace(/_/g, '.').replace('OS ', '').split('.')))
      : /Windows Phone/i.test(A)
        ? (_ = 'wp')
        : /Windows|MSIE/i.test(A) && (_ = 'windows'),
    (M = k[0]),
    (S = k[1]))
  var P,
    H = 0
  function da() {
    ;(H++,
      setTimeout(function () {
        H--
      }, 500))
  }
  function L(e, t) {
    if (!t.mbscClick) {
      var a = (e.originalEvent || e).changedTouches[0],
        n = document.createEvent('MouseEvents')
      ;(n.initMouseEvent('click', !0, !0, window, 1, a.screenX, a.screenY, a.clientX, a.clientY, !1, !1, !1, !1, 0, null),
        (n.isMbscTap = !0),
        (n.isIonicTap = !0),
        (P = !0),
        (t.mbscChange = !0),
        (t.mbscClick = !0),
        t.dispatchEvent(n),
        (P = !1),
        da(),
        setTimeout(function () {
          delete t.mbscClick
        }))
    }
  }
  function ua(e, t, a) {
    var n = e.originalEvent || e,
      s = (a ? 'page' : 'client') + t
    return n.targetTouches && n.targetTouches[0]
      ? n.targetTouches[0][s]
      : n.changedTouches && n.changedTouches[0]
        ? n.changedTouches[0][s]
        : e[s]
  }
  function ma(e) {
    var t = ['switch', 'range', 'rating', 'segmented', 'stepper'],
      a = e[0],
      n = e.attr('data-role'),
      s = e.attr('type') || a.nodeName.toLowerCase()
    if (/(switch|range|rating|segmented|stepper|select)/.test(n)) s = n
    else for (var i = 0; i < t.length; i++) e.is('[mbsc-' + t[i] + ']') && (s = t[i])
    return s
  }
  function ha(e, t, a) {
    ;(e.focus(), /(button|submit|checkbox|switch|radio)/.test(t) && a.preventDefault(), /select/.test(t) || L(a, e))
  }
  function z(t, e, a, n, s, i) {
    var r,
      o,
      l,
      c,
      d,
      u = (0, Z.$)(e)
    ;((s = s || 9),
      t.settings.tap &&
        u
          .on('touchstart.mbsc', function (e) {
            l || (n && e.preventDefault(), (l = this), (r = ua(e, 'X')), (o = ua(e, 'Y')), (c = !1), (d = new Date()))
          })
          .on('touchcancel.mbsc', function () {
            l = !1
          })
          .on('touchmove.mbsc', function (e) {
            l && !c && (Math.abs(ua(e, 'X') - r) > s || Math.abs(ua(e, 'Y') - o) > s) && (c = !0)
          })
          .on('touchend.mbsc', function (e) {
            l && ((i && new Date() - d < 100) || !c ? L(e, e.target) : da(), (l = !1))
          }),
      u.on('click.mbsc', function (e) {
        ;(n && e.preventDefault(), a.call(this, e, t))
      }))
  }
  function U(e) {
    if (H && !P && !e.isMbscTap && ('TEXTAREA' != e.target.nodeName || 'mousedown' != e.type))
      return (e.stopPropagation(), e.preventDefault(), !1)
  }
  function Qe(e) {
    return e[0].innerWidth || e.innerWidth()
  }
  function Y(e) {
    var t = e.theme,
      a = e.themeVariant
    return (
      ('auto' != t && t) || (t = $.autoTheme),
      'default' == t && (t = 'mobiscroll'),
      ('dark' === a || (N && 'auto' === a)) && $.themes.form[t + '-dark'] && (t += '-dark'),
      t
    )
  }
  function R(a, n, e) {
    D &&
      pa(function () {
        ;(pa(a).each(function () {
          new n(this, {})
        }),
          pa(document).on('mbsc-enhance', function (e, t) {
            pa(e.target).is(a)
              ? new n(e.target, t || {})
              : pa(a, e.target).each(function () {
                  new n(this, t || {})
                })
          }),
          e &&
            pa(document).on('mbsc-refresh', function (e) {
              var t
              pa(e.target).is(a)
                ? (t = fa[e.target.id]) && t.refresh()
                : pa(a, e.target).each(function () {
                    ;(t = fa[this.id]) && t.refresh()
                  })
            }))
      })
  }
  D &&
    (['mouseover', 'mousedown', 'mouseup', 'click'].forEach(function (e) {
      document.addEventListener(e, U, !0)
    }),
    'android' == _ &&
      M < 5 &&
      document.addEventListener(
        'change',
        function (e) {
          ;(H && 'checkbox' == e.target.type && !e.target.mbscChange && (e.stopPropagation(), e.preventDefault()),
            delete e.target.mbscChange)
        },
        !0,
      ))
  var $,
    pa = Z.$,
    j = +new Date(),
    fa = {},
    W = {},
    B = {},
    J = { xsmall: 0, small: 576, medium: 768, large: 992, xlarge: 1200 },
    va = pa.extend
  ;(va(t, { getCoord: ua, preventClick: da, vibrate: ca }),
    ($ = va(Z, {
      $: pa,
      version: '4.10.2',
      autoTheme: 'mobiscroll',
      themes: { form: {}, page: {}, frame: {}, scroller: {}, listview: {}, navigation: {}, progress: {}, card: {} },
      platform: { name: _, majorVersion: M, minorVersion: S },
      uid: '9b192d68',
      i18n: {},
      instances: fa,
      classes: W,
      util: t,
      settings: {},
      setDefaults: function (e) {
        va(this.settings, e)
      },
      customTheme: function (e, t) {
        var a,
          n = Z.themes,
          s = ['frame', 'scroller', 'listview', 'navigation', 'form', 'page', 'progress', 'card']
        for (a = 0; a < s.length; a++) n[s[a]][e] = va({}, n[s[a]][t], { baseTheme: t })
      },
    })))
  function ba(r, o) {
    var s,
      i,
      l,
      c,
      d,
      u,
      m,
      h,
      p,
      f = this
    function v(e) {
      var a,
        n = B
      return (
        d.responsive &&
          ((a = e || Qe(s)),
          pa.each(d.responsive, function (e, t) {
            a >= (t.breakpoint || J[e]) && (n = t)
          })),
        n
      )
    }
    ;((f.settings = {}),
      (f.element = r),
      (f._init = ra),
      (f._destroy = ra),
      (f._processSettings = ra),
      (f._checkResp = function (e) {
        if (f && f._responsive) {
          var t = v(e)
          if (c !== t) return ((c = t), f.init({}), !0)
        }
      }),
      (f._getRespCont = function () {
        return pa(d.context)[0]
      }),
      (f.init = function (e, t) {
        var a, n
        for (a in (e && f.getVal && (n = f.getVal()), f.settings)) delete f.settings[a]
        ;((d = f.settings),
          va(o, e),
          f._hasDef && (p = $.settings),
          va(d, f._defaults, p, o),
          f._hasTheme && ((m = Y(d)), (o.theme = m), (u = $.themes[f._class] ? $.themes[f._class][m] : {})),
          f._hasLang && (i = $.i18n[d.lang]),
          va(d, u, i, p, o),
          (s = f._getRespCont()),
          f._responsive && ((c = c || v()), va(d, c)),
          f._processSettings(c || {}),
          f._presets && (l = f._presets[d.preset]) && ((l = l.call(r, f, o)), va(d, l, o, c)),
          f._init(e),
          e && f.setVal && f.setVal(void 0 === t ? n : t, !0),
          h('onInit'))
      }),
      (f.destroy = function () {
        f && (f._destroy(), h('onDestroy'), delete fa[r.id], (f = null))
      }),
      (f.tap = function (e, t, a, n, s) {
        z(f, e, t, a, n, s)
      }),
      (f.trigger = function (e, t) {
        var a,
          n,
          s,
          i = [p, u, l, o]
        for (n = 0; n < 4; n++) (s = i[n]) && s[e] && (a = s[e].call(r, t || {}, f))
        return a
      }),
      (f.option = function (e, t, a) {
        var n = {},
          s = ['data', 'invalid', 'valid', 'readonly']
        ;(/calendar|eventcalendar|range/.test(d.preset) && s.push('marked', 'labels', 'colors'),
          'object' == typeof e ? (n = e) : (n[e] = t),
          s.forEach(function (e) {
            o[e] = d[e]
          }),
          f.init(n, a))
      }),
      (f.getInst = function () {
        return f
      }),
      (o = o || {}),
      (h = f.trigger),
      f.__ready ||
        (pa(r).addClass('mbsc-comp'), r.id ? fa[r.id] && fa[r.id].destroy() : (r.id = 'mobiscroll' + ++j), ((fa[r.id] = f).__ready = !0)))
  }
  var q = e.bool,
    K = e.string,
    G = e.func,
    Q = e.number,
    ee = e.object,
    ne = e.oneOfType([ee, K]),
    se = e.oneOfType([Q, e.arrayOf(Q)]),
    oe = { theme: K, themeVariant: e.oneOf(['auto', 'dark', 'light']), lang: K, rtl: q, responsive: ee, context: e.oneOfType([K, ee]) },
    le = {
      anchor: e.oneOfType([K, ee]),
      animate: e.oneOfType([q, e.oneOf(['fade', 'flip', 'pop', 'swing', 'slidevertical', 'slidehorizontal', 'slidedown', 'slideup'])]),
      buttons: e.array,
      closeOnOverlayTap: q,
      cssClass: K,
      disabled: q,
      display: e.oneOf(['top', 'bottom', 'bubble', 'inline', 'center']),
      focusOnClose: e.oneOfType([q, K, ee]),
      focusTrap: q,
      headerText: e.oneOfType([q, K, G]),
      layout: e.oneOf(['liquid', 'fixed']),
      scrollLock: q,
      showOnFocus: q,
      showOnTap: q,
      showOnOverlay: q,
      touchUi: q,
      onBeforeClose: G,
      onBeforeShow: G,
      onCancel: G,
      onClose: G,
      onDestroy: G,
      onMarkupReady: G,
      onPosition: G,
      onShow: G,
    },
    ce = {
      circular: e.oneOfType([q, e.arrayOf(q)]),
      height: Q,
      maxWidth: se,
      minWidth: se,
      multiline: Q,
      readonly: e.oneOfType([q, e.arrayOf(q)]),
      rows: Q,
      showLabel: q,
      showScrollArrows: q,
      wheels: e.array,
      width: Q,
      onChange: G,
      validate: G,
      onSet: G,
      onItemTap: G,
      onClear: G,
      cancelText: K,
      clearText: K,
      selectedText: K,
      setText: K,
      formatValue: G,
      parseValue: G,
    },
    de = {
      defaultValue: ne,
      invalid: e.array,
      max: ne,
      min: ne,
      returnFormat: e.oneOf(['iso8601', 'moment', 'locale', 'jsdate']),
      steps: e.shape({ hour: Q, minute: Q, second: Q, zeroBased: q }),
      valid: e.array,
      calendarSystem: e.oneOf(['jalali', 'hijri', 'gregorian']),
      ampmText: K,
      amText: K,
      dateFormat: K,
      dateWheels: K,
      dayNames: e.arrayOf(K),
      dayNamesShort: e.arrayOf(K),
      dayText: K,
      hourText: K,
      minuteText: K,
      monthNames: e.arrayOf(K),
      monthNamesShort: e.arrayOf(K),
      monthSuffix: K,
      monthText: K,
      nowText: K,
      pmText: K,
      secText: K,
      timeFormat: K,
      timeWheels: K,
      yearSuffix: K,
      yearText: K,
    },
    he = {
      calendarHeight: Q,
      calendarScroll: e.oneOf(['horizontal', 'vertical']),
      calendarWidth: Q,
      counter: q,
      defaultValue: e.oneOfType([ne, e.array]),
      events: e.arrayOf(e.shape({ start: ne, end: ne, d: e.oneOfType([ee, Q, K]), text: K, color: K, background: K, cssClass: K })),
      labels: e.arrayOf(e.shape({ start: ne, end: ne, d: e.oneOfType([ee, Q, K]), text: K, color: K, background: K, cssClass: K })),
      marked: e.arrayOf(e.oneOfType([ee, Q, K, e.shape({ d: e.oneOfType([ee, K, Q]), color: K, background: K, cssClass: K })])),
      colors: e.arrayOf(e.shape({ d: e.oneOfType([ee, K, Q]), background: K, cssClass: K })),
      months: Q,
      mousewheel: q,
      weeks: Q,
      outerMonthChange: q,
      showOuterDays: q,
      tabs: q,
      weekCounter: e.oneOf(['year', 'month']),
      weekDays: e.oneOf(['full', 'short', 'min']),
      yearChange: q,
      dateText: K,
      dayNames: e.arrayOf(K),
      dayNamesMin: e.arrayOf(K),
      firstDay: Q,
      timeText: K,
      moreEventsPluralText: K,
      moreEventsText: K,
      onTabChange: G,
      onCellHoverIn: G,
      onCellHoverOut: G,
      onDayChange: G,
      onLabelTap: G,
      onMonthChange: G,
      onMonthLoading: G,
      onMonthLoaded: G,
      onPageChange: G,
      onPageLoading: G,
      onPageLoaded: G,
      onSetDate: G,
    }
  function pe(e, t) {
    var a = i.findDOMNode(this),
      n = e.replace(/\s+/g, ' ').trim(),
      s = t.replace(/\s+/g, ' ').trim()
    ;(n && a.classList.remove.apply(a.classList, n.split(' ')), s && a.classList.add.apply(a.classList, s.split(' ')))
  }
  function fe(e, t) {
    var r = [],
      o = []
    return (function e(t, a, n) {
      var s
      if (isNaN(t) && isNaN(a) && 'number' == typeof t && 'number' == typeof a) return !0
      if (t === a) return !0
      if ('function' == typeof t && 'function' == typeof a) return !1
      if (
        (t instanceof Date && a instanceof Date) ||
        (t instanceof RegExp && a instanceof RegExp) ||
        (t instanceof String && a instanceof String) ||
        (t instanceof Number && a instanceof Number)
      )
        return t.toString() === a.toString()
      if (!(t instanceof Object && a instanceof Object)) return !1
      if (t.isPrototypeOf(a) || a.isPrototypeOf(t)) return !1
      if (t.constructor !== a.constructor) return !1
      if (t.prototype !== a.prototype) return !1
      if (-1 < r.indexOf(t) || -1 < o.indexOf(a)) return !1
      for (s in a) {
        if (a.hasOwnProperty(s) !== t.hasOwnProperty(s)) return !1
        if (typeof a[s] != typeof t[s]) return !1
      }
      var i = n ? { $$typeof: 1, key: 1, props: 1, ref: 1, type: 1 } : t
      for (s in i) {
        if (a.hasOwnProperty(s) !== t.hasOwnProperty(s)) return !1
        if (typeof a[s] != typeof t[s]) return !1
        switch (typeof t[s]) {
          case 'object':
          case 'function':
            if ((r.push(t), o.push(a), !e(t[s], a[s], t[s] && void 0 !== t[s].$$typeof))) return !1
            ;(r.pop(), o.pop())
            break
          default:
            if (t[s] !== a[s]) return !1
        }
      }
      return !0
    })(e, t)
  }
  var ve = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).initialCssClass = t.props.className || ''), t)
      }
      l(e, a)
      var t = e.prototype
      return (
        (t.render = function () {
          return null
        }),
        (t.getSettingsFromProps = function (e, t) {
          var a = {}
          if (void 0 !== e) {
            var n = e.options,
              s =
                (e.children,
                e.value,
                e.checked,
                e.data,
                e.className,
                x(e, ['options', 'children', 'value', 'checked', 'data', 'className'])),
              i = n || '{}'
            ;((a = n || {}), void 0 !== n && 'string' == typeof i && (a = new Function('return ' + i + ';')()), (a = va({}, a, s, t || {})))
          }
          return a
        }),
        (t.componentWillUnmount = function () {
          ;(this.instance.destroy(), delete this.instance)
        }),
        e
      )
    })(b.Component),
    be = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).updateForIonInput = t.updateForIonInput.bind(c(t))), t)
      }
      l(e, a)
      var t = e.prototype
      return (
        (t.updateForIonInput = function () {
          this.valueState && ((this.optimizeUpdate = null), this.forceUpdate())
        }),
        (t.isIonInput = function (e) {
          return e && 1 == b.Children.count(e) && e.type && e.type.render && 'IonInput' === e.type.render.displayName
        }),
        (t.componentDidUpdate = function () {
          var e = this.getSettingsFromProps(this.props)
          this.optimizeUpdate
            ? (this.optimizeUpdate.updateOptions && this.instance.option(e),
              this.optimizeUpdate.updateValue &&
                void 0 !== this.props.value &&
                !fe(this.props.value, this.instance.getVal()) &&
                this.instance.setVal(this.props.value, !0),
              this.updateForIonInput())
            : null !== this.optimizeUpdate &&
              (this.instance.option(e), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0))
        }),
        e
      )
    })(ve),
    ge = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      return (
        l(e, t),
        (e.prototype.shouldComponentUpdate = function (e) {
          var t = !fe(this.getSettingsFromProps(e), this.getSettingsFromProps(this.props)),
            a = !fe(e.value, this.props.value),
            n = !fe(e.children, this.props.children)
          return ((this.optimizeUpdate = { updateOptions: t, updateValue: a, updateChildren: n }), t || a || n)
        }),
        e
      )
    })(be),
    xe = (function (s) {
      function e() {
        for (var t, e = arguments.length, a = new Array(e), n = 0; n < e; n++) a[n] = arguments[n]
        return (
          r(c((t = s.call.apply(s, [this].concat(a)) || this)), 'element', null),
          r(c(t), 'inputCheckCount', 0),
          r(c(t), 'startInit', function () {
            t.element = i.findDOMNode(c(t))
            var e = pa(t.element).find('input')
            ;(e.length && (t.element = e[0]),
              t.inputCheckCount++,
              !t.isIonInput(t.props.children) || e.length || 17 < t.inputCheckCount ? t.initInstance() : setTimeout(t.startInit, 30))
          }),
          r(c(t), 'initInstance', function () {
            var e = t.getSettingsFromProps(t.props, t.mbscInit)
            ;((t.instance = new W[t.mbscInit.component || 'Scroller'](t.element, e)),
              void 0 !== t.props.value && (t.instance.setVal(t.props.value, !0), t.updateForIonInput()))
          }),
          t
        )
      }
      l(e, s)
      var t = e.prototype
      return (
        (t.render = function () {
          var e = this.props,
            t = e.type,
            a = e.readOnly,
            n = e.disabled,
            s = e.placeholder,
            i = e.children
          if (((t = t || 'text'), this.isIonInput(i))) {
            this.valueState = !0
            var r = this.instance ? this.instance._value : ''
            return b.cloneElement(i, g({ value: r }, i.props))
          }
          return i
            ? this.props.children
            : b.createElement('input', { className: this.initialCssClass, type: t, readOnly: a, disabled: n, placeholder: s })
        }),
        (t.componentDidMount = function () {
          this.startInit()
        }),
        e
      )
    })(ge)
  r(xe, 'propTypes', g({}, oe, {}, le, { type: e.string, placeholder: e.string }))
  var Te = (function (e) {
    function t() {
      return e.apply(this, arguments) || this
    }
    l(t, e)
    var a = t.prototype
    return (
      (a.render = function () {
        return b.createElement('ul', { className: this.initialCssClass + ' mbsc-cloak' }, this.props.children)
      }),
      (a.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props, this.mbscInit),
          t = i.findDOMNode(this)
        ;((this.instance = new W[this.mbscInit.component || 'Scroller'](t, e)),
          void 0 !== this.props.value && this.instance.setVal(this.props.value, !0),
          (this.instance._markup || pa(t)).on('click', function (e) {
            e.stopPropagation()
          }))
      }),
      (a.componentDidUpdate = function () {
        !this.optimizeUpdate.updateOptions &&
          this.optimizeUpdate.updateChildren &&
          this.instance.option(this.getSettingsFromProps(this.props))
        var e = i.findDOMNode(this)
        ;(this.instance._markup || pa(e)).on('click', function (e) {
          e.stopPropagation()
        })
      }),
      t
    )
  })(ge)
  function et(e, t, a, n, s, i, r) {
    var o = new Date(e, t, a, n || 0, s || 0, i || 0, r || 0)
    return (23 == o.getHours() && 0 === (n || 0) && o.setHours(o.getHours() + 2), o)
  }
  function ye(a, e, t) {
    if (!e) return null
    function s(e) {
      for (var t = 0; r + 1 < a.length && a.charAt(r + 1) == e; ) (t++, r++)
      return t
    }
    function n(e, t, a) {
      var n = '' + t
      if (s(e)) for (; n.length < a; ) n = '0' + n
      return n
    }
    function i(e, t, a, n) {
      return s(e) ? n[t] : a[t]
    }
    var r,
      o,
      l = va({}, ke, t),
      c = '',
      d = !1
    for (r = 0; r < a.length; r++)
      if (d) "'" != a.charAt(r) || s("'") ? (c += a.charAt(r)) : (d = !1)
      else
        switch (a.charAt(r)) {
          case 'd':
            c += n('d', l.getDay(e), 2)
            break
          case 'D':
            c += i('D', e.getDay(), l.dayNamesShort, l.dayNames)
            break
          case 'o':
            c += n('o', (e.getTime() - new Date(e.getFullYear(), 0, 0).getTime()) / 864e5, 3)
            break
          case 'm':
            c += n('m', l.getMonth(e) + 1, 2)
            break
          case 'M':
            c += i('M', l.getMonth(e), l.monthNamesShort, l.monthNames)
            break
          case 'y':
            ;((o = l.getYear(e)), (c += s('y') ? o : (o % 100 < 10 ? '0' : '') + (o % 100)))
            break
          case 'h':
            var u = e.getHours()
            c += n('h', 12 < u ? u - 12 : 0 === u ? 12 : u, 2)
            break
          case 'H':
            c += n('H', e.getHours(), 2)
            break
          case 'i':
            c += n('i', e.getMinutes(), 2)
            break
          case 's':
            c += n('s', e.getSeconds(), 2)
            break
          case 'a':
            c += 11 < e.getHours() ? l.pmText : l.amText
            break
          case 'A':
            c += 11 < e.getHours() ? l.pmText.toUpperCase() : l.amText.toUpperCase()
            break
          case "'":
            s("'") ? (c += "'") : (d = !0)
            break
          default:
            c += a.charAt(r)
        }
    return c
  }
  function Ce(a, i, e) {
    var t = va({}, ke, e),
      n = st(t.defaultValue || new Date())
    if (!a || !i) return n
    if (i.getTime) return i
    i = 'object' == typeof i ? i.toString() : i + ''
    function r(e) {
      var t = c + 1 < a.length && a.charAt(c + 1) == e
      return (t && c++, t)
    }
    function s(e) {
      r(e)
      var t = new RegExp('^\\d{1,' + ('@' == e ? 14 : '!' == e ? 20 : 'y' == e ? 4 : 'o' == e ? 3 : 2) + '}'),
        a = i.substr(T).match(t)
      return a ? ((T += a[0].length), parseInt(a[0], 10)) : 0
    }
    function o(e, t, a) {
      var n,
        s = r(e) ? a : t
      for (n = 0; n < s.length; n++) if (i.substr(T, s[n].length).toLowerCase() == s[n].toLowerCase()) return ((T += s[n].length), n + 1)
      return 0
    }
    function l() {
      T++
    }
    var c,
      d = t.shortYearCutoff,
      u = t.getYear(n),
      m = t.getMonth(n) + 1,
      h = t.getDay(n),
      p = -1,
      f = n.getHours(),
      v = n.getMinutes(),
      b = 0,
      g = -1,
      x = !1,
      T = 0
    for (c = 0; c < a.length; c++)
      if (x) "'" != a.charAt(c) || r("'") ? l() : (x = !1)
      else
        switch (a.charAt(c)) {
          case 'd':
            h = s('d')
            break
          case 'D':
            o('D', t.dayNamesShort, t.dayNames)
            break
          case 'o':
            p = s('o')
            break
          case 'm':
            m = s('m')
            break
          case 'M':
            m = o('M', t.monthNamesShort, t.monthNames)
            break
          case 'y':
            u = s('y')
            break
          case 'H':
            f = s('H')
            break
          case 'h':
            f = s('h')
            break
          case 'i':
            v = s('i')
            break
          case 's':
            b = s('s')
            break
          case 'a':
            g = o('a', [t.amText, t.pmText], [t.amText, t.pmText]) - 1
            break
          case 'A':
            g = o('A', [t.amText, t.pmText], [t.amText, t.pmText]) - 1
            break
          case "'":
            r("'") ? l() : (x = !0)
            break
          default:
            l()
        }
    if (
      (u < 100 &&
        (u +=
          new Date().getFullYear() -
          (new Date().getFullYear() % 100) +
          (u <= ('string' != typeof d ? d : (new Date().getFullYear() % 100) + parseInt(d, 10)) ? 0 : -100)),
      -1 < p)
    ) {
      ;((m = 1), (h = p))
      do {
        var y = 32 - new Date(u, m - 1, 32, 12).getDate()
        y < h && (m++, (h -= y))
      } while (y < h)
    }
    f = -1 == g ? f : g && f < 12 ? f + 12 : g || 12 != f ? f : 0
    var C = t.getDate(u, m - 1, h, f, v, b)
    return t.getYear(C) != u || t.getMonth(C) + 1 != m || t.getDay(C) != h ? n : C
  }
  function tt(e, t) {
    return Math.round((t - e) / 864e5)
  }
  function at(e) {
    return et(e.getFullYear(), e.getMonth(), e.getDate())
  }
  function nt(e) {
    return e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate()
  }
  function _e(e, t, a) {
    var n,
      s,
      i = { y: 1, m: 2, d: 3, h: 4, i: 5, s: 6, u: 7, tz: 8 }
    if (a) for (n in i) (s = e[i[n] - t]) && (a[n] = 'tz' == n ? s : 1)
  }
  function we(e, t, a) {
    var n = window.moment || t.moment,
      s = t.returnFormat
    if (e) {
      if ('moment' == s && n) return n(e)
      if ('locale' == s) return ye(a, e, t)
      if ('iso8601' == s)
        return (function (e, t) {
          var a = '',
            n = ''
          return (
            e &&
              (t.h &&
                ((n += re(e.getHours()) + ':' + re(e.getMinutes())),
                t.s && (n += ':' + re(e.getSeconds())),
                t.u && (n += '.' + re(e.getMilliseconds(), 3)),
                t.tz && (n += t.tz)),
              t.y
                ? ((a += e.getFullYear()),
                  t.m && ((a += '-' + re(e.getMonth() + 1)), t.d && (a += '-' + re(e.getDate())), t.h && (a += 'T' + n)))
                : t.h && (a = n)),
            a
          )
        })(e, t.isoParts)
    }
    return e
  }
  function st(e, t, a, n) {
    var s
    return e
      ? e.getTime
        ? e
        : e.toDate
          ? e.toDate()
          : ('string' == typeof e && (e = e.trim()),
            (s = Se.exec(e))
              ? (_e(s, 2, n), new Date(1970, 0, 1, s[2] ? +s[2] : 0, s[3] ? +s[3] : 0, s[4] ? +s[4] : 0, s[5] ? +s[5] : 0))
              : (s = s || Me.exec(e))
                ? (_e(s, 0, n),
                  new Date(
                    s[1] ? +s[1] : 1970,
                    s[2] ? s[2] - 1 : 0,
                    s[3] ? +s[3] : 1,
                    s[4] ? +s[4] : 0,
                    s[5] ? +s[5] : 0,
                    s[6] ? +s[6] : 0,
                    s[7] ? +s[7] : 0,
                  ))
                : Ce(t, e, a))
      : null
  }
  function it(e, t) {
    return e.getFullYear() == t.getFullYear() && e.getMonth() == t.getMonth() && e.getDate() == t.getDate()
  }
  r(Te, 'propTypes', g({}, oe, {}, le, {}, ce))
  var Me = /^(\d{4}|[+-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?((Z)|([+-])(\d{2})(?::(\d{2}))?)?)?$/,
    Se = /^((\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+-])(\d{2})(?::(\d{2}))?)?)?$/,
    rt = /^\d{1,2}(\/\d{1,2})?$/,
    ot = /^w\d$/i,
    ke = {
      shortYearCutoff: '+10',
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      amText: 'am',
      pmText: 'pm',
      getYear: function (e) {
        return e.getFullYear()
      },
      getMonth: function (e) {
        return e.getMonth()
      },
      getDay: function (e) {
        return e.getDate()
      },
      getDate: et,
      getMaxDayOfMonth: function (e, t) {
        return 32 - new Date(e, t, 32, 12).getDate()
      },
      getWeekNumber: function (e) {
        ;((e = new Date(e)).setHours(0, 0, 0), e.setDate(e.getDate() + 4 - (e.getDay() || 7)))
        var t = new Date(e.getFullYear(), 0, 1)
        return Math.ceil(((e - t) / 864e5 + 1) / 7)
      },
    }
  function De(e) {
    var t
    for (t in e) if (void 0 !== Ae[e[t]]) return !0
    return !1
  }
  function ga(e, t) {
    if ('touchstart' == e.type) pa(t).attr('data-touch', '1')
    else if (pa(t).attr('data-touch')) return (pa(t).removeAttr('data-touch'), !1)
    return !0
  }
  function xa(e, t) {
    var a,
      n = getComputedStyle(e[0])
    return (
      pa.each(['t', 'webkitT', 'MozT', 'OT', 'msT'], function (e, t) {
        if (void 0 !== n[t + 'ransform']) return ((a = n[t + 'ransform']), !1)
      }),
      (a = a.split(')')[0].split(', ')),
      t ? a[13] || a[5] : a[12] || a[4]
    )
  }
  function lt(e) {
    if (e) {
      if (Ue[e]) return Ue[e]
      var t = pa('<div style="background-color:' + e + ';"></div>').appendTo('body'),
        a = getComputedStyle(t[0])
          .backgroundColor.replace(/rgb|rgba|\(|\)|\s/g, '')
          .split(','),
        n = 0.299 * a[0] + 0.587 * a[1] + 0.114 * a[2] < 130 ? '#fff' : '#000'
      return (t.remove(), (Ue[e] = n))
    }
  }
  function Ne(e, t, a, n) {
    var s = pa(e)
    a
      ? (s.scrollTop(t), n && n())
      : (function e(t, a, n, s, i) {
          var r = Math.min(1, (new Date() - a) / 468),
            o = 0.5 * (1 - Math.cos(Math.PI * r)),
            l = n + (s - n) * o
          ;(t.scrollTop(l),
            l !== s
              ? sa(function () {
                  e(t, a, n, s, i)
                })
              : i && i())
        })(s, new Date(), s.scrollTop(), t, n)
  }
  function Ee(e, t, a, n) {
    e && e.addEventListener(t, a, n)
  }
  function Oe(e, t, a) {
    e && e.removeEventListener(t, a)
  }
  function Ve() {
    ze.__mbscFocusVisible = !1
  }
  function Fe() {
    ze.__mbscFocusVisible = !0
  }
  t.datetime = { formatDate: ye, parseDate: Ce }
  var Ta,
    Ae,
    ya,
    Ie,
    Pe,
    He,
    Le,
    Ca,
    ze,
    Ue = {}
  function ct(e, t, a, n, s, i) {
    var r,
      o,
      l,
      c,
      d,
      u,
      m,
      h,
      p,
      f = n || ra
    function v(e) {
      var t
      ;((r = pa(this)),
        (h = +r.attr('data-step')),
        (l = +r.attr('data-index')),
        (o = !0),
        s && e.stopPropagation(),
        'touchstart' == e.type && r.closest('.mbsc-no-touch').removeClass('mbsc-no-touch'),
        'mousedown' == e.type && e.preventDefault(),
        (t = 'keydown' != e.type ? ((u = ua(e, 'X')), (m = ua(e, 'Y')), ga(e, this)) : 32 === e.keyCode),
        c ||
          !t ||
          r.hasClass('mbsc-disabled') ||
          (T(l, h, e) && (r.addClass('mbsc-active'), i && i.addRipple(r.find('.mbsc-segmented-content'), e)),
          'mousedown' == e.type && pa(document).on('mousemove', b).on('mouseup', g)))
    }
    function b(e) {
      ;(7 < Math.abs(u - ua(e, 'X')) || 7 < Math.abs(m - ua(e, 'Y'))) && ((o = !0), x())
    }
    function g(e) {
      ;('touchend' == e.type && e.preventDefault(), x(), 'mouseup' == e.type && pa(document).off('mousemove', b).off('mouseup', g))
    }
    function x() {
      ;((c = !1),
        clearInterval(p),
        r &&
          (r.removeClass('mbsc-active'),
          i &&
            setTimeout(function () {
              i.removeRipple()
            }, 100)))
    }
    function T(e, t, a) {
      return (c || f(e) || ((l = e), (h = t), (d = a), (o = !(c = !0)), setTimeout(y, 100)), c)
    }
    function y() {
      r && r.hasClass('mbsc-disabled')
        ? x()
        : ((!c && o) || ((o = !0), t(l, h, d, y)),
          c &&
            a &&
            (clearInterval(p),
            (p = setInterval(function () {
              t(l, h, d)
            }, a))))
    }
    return (
      e.on('touchstart mousedown keydown', v).on('touchmove', b).on('touchend touchcancel keyup', g),
      {
        start: T,
        stop: x,
        destroy: function () {
          e.off('touchstart mousedown keydown', v).off('touchmove', b).off('touchend touchcancel keyup', g)
        },
      }
    )
  }
  D &&
    ((ze = window),
    (Ae = document.createElement('modernizr').style),
    (ya = (function () {
      var e,
        t = ['Webkit', 'Moz', 'O', 'ms']
      for (e in t) if (De([t[e] + 'Transform'])) return '-' + t[e].toLowerCase() + '-'
      return ''
    })()),
    (Ca = ya.replace(/^-/, '').replace(/-$/, '').replace('moz', 'Moz')),
    (Ta = void 0 !== Ae.animation ? 'animationend' : 'webkitAnimationEnd'),
    (Pe = void 0 !== Ae.transition),
    (Le = (He = 'ios' === _ && !F) && ze.webkit && ze.webkit.messageHandlers),
    (Ie = void 0 === Ae.touchAction || (He && !Le)))
  var Ye,
    Re = 'position:absolute;left:0;top:0;',
    $e = Re + 'right:0;bottom:0;overflow:hidden;z-index:-1;',
    je =
      '<div style="' +
      $e +
      '"><div style="' +
      Re +
      '"></div></div><div style="' +
      $e +
      '"><div style="' +
      Re +
      'width:200%;height:200%;"></div></div>',
    We = 0
  function Be(e, t, a) {
    function n() {
      ;((l.style.width = '100000px'),
        (l.style.height = '100000px'),
        (o.scrollLeft = 1e5),
        (o.scrollTop = 1e5),
        (m.scrollLeft = 1e5),
        (m.scrollTop = 1e5))
    }
    function s() {
      var e = new Date()
      ;((d = 0), h || (200 < e - p && !o.scrollTop && !o.scrollLeft && ((p = e), n()), (d = d || sa(s))))
    }
    function i() {
      u = u || sa(r)
    }
    function r() {
      ;((u = 0), n(), t())
    }
    var o,
      l,
      c,
      d,
      u,
      m,
      h,
      p = 0
    return (
      window.ResizeObserver
        ? ((Ye =
            Ye ||
            new ResizeObserver(function (e) {
              var t = e,
                a = Array.isArray(t),
                n = 0
              for (t = a ? t : t[Symbol.iterator](); ; ) {
                var s
                if (a) {
                  if (n >= t.length) break
                  s = t[n++]
                } else {
                  if ((n = t.next()).done) break
                  s = n.value
                }
                s.target.__mbscResize()
              }
            })),
          We++,
          (e.__mbscResize = t),
          Ye.observe(e))
        : (((c = document.createElement('div')).innerHTML = je),
          (c.dir = 'ltr'),
          (m = c.childNodes[1]),
          (o = c.childNodes[0]),
          (l = o.childNodes[0]),
          e.appendChild(c),
          o.addEventListener('scroll', i),
          m.addEventListener('scroll', i),
          a
            ? a.runOutsideAngular(function () {
                sa(s)
              })
            : sa(s)),
      {
        detach: function () {
          Ye ? (We--, Ye.unobserve(e), We || (Ye = null)) : (e.removeChild(c), (h = !0))
        },
      }
    )
  }
  function Je(e) {
    e.preventDefault()
  }
  function qe(a, n, e) {
    var M,
      d,
      u,
      S,
      m,
      k,
      D,
      N,
      E,
      h,
      t,
      O,
      p,
      V,
      F,
      A,
      f,
      I,
      P,
      H,
      L,
      v,
      o,
      b,
      z,
      s,
      g,
      U,
      Y,
      x,
      R,
      $,
      j,
      W = this,
      B = pa(a),
      i = [],
      r = new Date()
    function l(e) {
      ;(t && t.removeClass('mbsc-active'),
        (t = pa(this)).hasClass('mbsc-disabled') || t.hasClass('mbsc-fr-btn-nhl') || t.addClass('mbsc-active'),
        'mousedown' === e.type ? pa(document).on('mouseup', c) : 'pointerdown' === e.type && pa(document).on('pointerup', c))
    }
    function c(e) {
      ;(t && (t.removeClass('mbsc-active'), (t = null)),
        'mouseup' === e.type ? pa(document).off('mouseup', c) : 'pointerup' === e.type && pa(document).off('pointerup', c))
    }
    function T(e) {
      Z.activeInstance == W &&
        (13 != e.keyCode || (pa(e.target).is('textarea,button,input[type="button"],input[type="submit"]') && !e.shiftKey)
          ? 27 == e.keyCode && W.cancel()
          : W.select())
    }
    function y(e) {
      e || dt || !W._activeElm || ((r = new Date()), W._activeElm.focus())
    }
    function C(e) {
      var t = Ke,
        a = U.focusOnClose
      ;(W._markupRemove(),
        S.remove(),
        F &&
          (O.mbscModals--,
          U.scrollLock && O.mbscLock--,
          O.mbscLock || u.removeClass('mbsc-fr-lock'),
          v &&
            (O.mbscIOSLock--,
            O.mbscIOSLock ||
              (u.removeClass('mbsc-fr-lock-ios'),
              M.css({ top: '', left: '' }),
              N.scrollLeft(O.mbscScrollLeft),
              N.scrollTop(O.mbscScrollTop))),
          O.mbscModals || u.removeClass('mbsc-fr-lock-ctx'),
          (O.mbscModals && !g) ||
            e ||
            ((t = t || B),
            setTimeout(function () {
              void 0 === a || !0 === a ? ((Ge = !0), t[0].focus()) : a && pa(a)[0].focus()
            }, 200))),
        (g = void 0),
        (A = !1),
        R('onHide'))
    }
    function _() {
      ;(clearTimeout(s),
        (s = setTimeout(function () {
          W.position(!0) && ((z.style.visibility = 'hidden'), z.offsetHeight, (z.style.visibility = ''))
        }, 200)))
    }
    function w(e) {
      Z.activeInstance == W &&
        e.target.nodeType &&
        !b.contains(e.target) &&
        100 < new Date() - r &&
        ((r = new Date()), W._activeElm.focus())
    }
    function J(e, t) {
      if (F) S.appendTo(M)
      else if (B.is('div') && !W._hasContent) B.empty().append(S)
      else if (B.hasClass('mbsc-control')) {
        var a = B.closest('.mbsc-control-w')
        ;(S.insertAfter(a), a.hasClass('mbsc-select') && a.addClass('mbsc-select-inline'))
      } else S.insertAfter(B)
      var n, s, i, r
      ;((A = !0),
        W._markupInserted(S),
        R('onMarkupInserted', { target: I }),
        F &&
          U.closeOnOverlayTap &&
          m
            .on('touchstart mousedown', function (e) {
              s || e.target != b || ((n = !(s = !0)), (i = ua(e, 'X')), (r = ua(e, 'Y')))
            })
            .on('touchmove mousemove', function (e) {
              s && !n && (9 < Math.abs(ua(e, 'X') - i) || 9 < Math.abs(ua(e, 'Y') - r)) && (n = !0)
            })
            .on('touchcancel', function () {
              s = !1
            })
            .on('touchend click', function (e) {
              ;(s && !n && (W.cancel(), 'touchend' == e.type && da()), (s = !1))
            }))
      ;(S.on('mousedown', '.mbsc-btn-e,.mbsc-fr-btn-e', Je)
        .on('touchstart mousedown', function (e) {
          U.stopProp && e.stopPropagation()
        })
        .on('keydown', '.mbsc-fr-btn-e', function (e) {
          32 == e.keyCode && (e.preventDefault(), e.stopPropagation(), this.click())
        })
        .on('keydown', function (e) {
          if (32 != e.keyCode || pa(e.target).is(ht)) {
            if (9 == e.keyCode && F && U.focusTrap) {
              var t = S.find('input,select,textarea,button,[tabindex="0"]').filter(function () {
                  return 0 < this.offsetWidth || 0 < this.offsetHeight
                }),
                a = t.index(pa(':focus', S)),
                n = t.length - 1,
                s = 0
              ;(e.shiftKey && ((n = 0), (s = -1)), a === n && (t.eq(s)[0].focus(), e.preventDefault()))
            }
          } else e.preventDefault()
        })
        .on('touchstart mousedown pointerdown', '.mbsc-fr-btn-e', l)
        .on('touchend', '.mbsc-fr-btn-e', c),
        I.addEventListener(
          'touchstart',
          function () {
            x || ((x = !0), M.find('.mbsc-no-touch').removeClass('mbsc-no-touch'))
          },
          !0,
        ),
        pa.each(h, function (e, t) {
          W.tap(
            pa('.mbsc-fr-btn' + e, S),
            function (e) {
              ;((t = ue(t) ? W.buttons[t] : t), (ue(t.handler) ? W.handlers[t.handler] : t.handler).call(this, e, W))
            },
            !0,
          )
        }),
        W._attachEvents(S),
        !1 !== W.position() &&
          ((F || W._checkSize) && (o = Be(I, _, U.zone)),
          F &&
            (S.removeClass('mbsc-fr-pos'),
            p && !e
              ? S.addClass('mbsc-anim-in mbsc-anim-trans mbsc-anim-trans-' + p)
                  .on(Ta, function e() {
                    ;(S.off(Ta, e)
                      .removeClass('mbsc-anim-in mbsc-anim-trans mbsc-anim-trans-' + p)
                      .find('.mbsc-fr-popup')
                      .removeClass('mbsc-anim-' + p),
                      y(t))
                  })
                  .find('.mbsc-fr-popup')
                  .addClass('mbsc-anim-' + p)
              : y(t)),
          R('onShow', { target: I, valueText: W._tempValue })))
    }
    function q(e, t) {
      W._isVisible || (e && e(), !1 !== W.show() && (Ke = t))
    }
    function K() {
      ;(W._fillValue(), R('onSet', { valueText: W._value }))
    }
    function G() {
      R('onCancel', { valueText: W._value })
    }
    function X() {
      W.setVal(null, !0)
    }
    ;(ba.call(this, a, n, !0),
      (W.position = function (e) {
        var t,
          a,
          n,
          s,
          i,
          r,
          o,
          l,
          c,
          d,
          u,
          m,
          h,
          p,
          f,
          v,
          b,
          g,
          x,
          T = {},
          y = 0,
          C = 0,
          _ = 0,
          w = 0
        if (!A) return !1
        if (((v = $), (f = j), (h = I.offsetHeight), (p = I.offsetWidth) && h && ($ !== p || j !== h || !e))) {
          if (W._checkResp(p)) return !1
          if (
            (($ = p),
            (j = h),
            W._isFullScreen || /top|bottom/.test(U.display) ? D.width(p) : F && E.width(''),
            W._position(S),
            !W._isFullScreen &&
              /center|bubble/.test(U.display) &&
              (pa('.mbsc-w-p', S).each(function () {
                ;((b = this.getBoundingClientRect().width), (w += b), (_ = _ < b ? b : _))
              }),
              (m = p - 16 < w || !0 === U.tabs),
              E.css({ width: W._isLiquid ? Math.min(U.maxPopupWidth, p - 16) : Math.ceil(m ? _ : w), 'white-space': m ? '' : 'nowrap' })),
            !1 !== R('onPosition', { target: I, popup: z, hasTabs: m, oldWidth: v, oldHeight: f, windowWidth: p, windowHeight: h }) && F)
          )
            return (
              L && ((y = N.scrollLeft()), (C = N.scrollTop()), $ && k.css({ width: '', height: '' })),
              (P = z.offsetWidth),
              (H = z.offsetHeight),
              (Y = H <= h && P <= p),
              'center' == U.display
                ? ((x = Math.max(0, y + (p - P) / 2)), (g = Math.max(0, C + (h - H) / 2)))
                : 'bubble' == U.display
                  ? ((t = void 0 === U.anchor ? B : pa(U.anchor)),
                    (o = pa('.mbsc-fr-arr-i', S)[0]),
                    (i = (s = t.offset()).top + (V ? C - M.offset().top : 0)),
                    (r = s.left + (V ? y - M.offset().left : 0)),
                    (a = t[0].offsetWidth),
                    (n = t[0].offsetHeight),
                    (l = o.offsetWidth),
                    (c = o.offsetHeight),
                    (x = me(r - (P - a) / 2, y + 3, y + p - P - 3)),
                    C + h < (g = i + n + c / 2) + H + 8 && C < i - H - c / 2
                      ? (D.removeClass('mbsc-fr-bubble-bottom').addClass('mbsc-fr-bubble-top'), (g = i - H - c / 2))
                      : D.removeClass('mbsc-fr-bubble-top').addClass('mbsc-fr-bubble-bottom'),
                    pa('.mbsc-fr-arr', S).css({ left: me(r + a / 2 - (x + (P - l) / 2), 0, l) }),
                    (Y = C < g && y < x && g + H <= C + h && x + P <= y + p))
                  : ((x = y), (g = 'top' == U.display ? C : Math.max(0, C + h - H))),
              L &&
                ((d = Math.max(g + H, V ? O.scrollHeight : pa(document).height())),
                (u = Math.max(x + P, V ? O.scrollWidth : pa(document).width())),
                k.css({ width: u, height: d }),
                U.scroll &&
                  'bubble' == U.display &&
                  (C + h < g + H + 8 || C + h < i || i + n < C) &&
                  N.scrollTop(Math.min(i, g + H - h + 8, d - h))),
              (T.top = Math.floor(g)),
              (T.left = Math.floor(x)),
              D.css(T),
              !0
            )
        }
      }),
      (W.attachShow = function (e, t) {
        var a,
          n = pa(e).off('.mbsc'),
          s = n.prop('readonly')
        'inline' !== U.display &&
          ((U.showOnFocus || U.showOnTap) &&
            n.is('input,select') &&
            (n
              .prop('readonly', !0)
              .on('mousedown.mbsc', function (e) {
                e.preventDefault()
              })
              .on('focus.mbsc', function () {
                W._isVisible && this.blur()
              }),
            (a = pa('label[for="' + n.attr('id') + '"]')).length || (a = n.closest('label'))),
          n.is('select') ||
            (U.showOnFocus &&
              n.on('focus.mbsc', function () {
                Ge ? (Ge = !1) : q(t, n)
              }),
            U.showOnTap &&
              (n.on('keydown.mbsc', function (e) {
                ;(32 != e.keyCode && 13 != e.keyCode) || (e.preventDefault(), e.stopPropagation(), q(t, n))
              }),
              W.tap(n, function (e) {
                ;(e.isMbscTap && (x = !0), q(t, n))
              }),
              a &&
                a.length &&
                W.tap(a, function (e) {
                  ;(e.preventDefault(), e.target !== n[0] && q(t, n))
                }))),
          i.push({ readOnly: s, el: n, lbl: a }))
      }),
      (W.select = function () {
        F ? W.hide(!1, 'set', !1, K) : K()
      }),
      (W.cancel = function () {
        F ? W.hide(!1, 'cancel', !1, G) : G()
      }),
      (W.clear = function () {
        ;(W._clearValue(), R('onClear'), F && W._isVisible && !W.live ? W.hide(!1, 'clear', !1, X) : X())
      }),
      (W.enable = function () {
        ;((U.disabled = !1),
          pa.each(i, function (e, t) {
            t.el.is('input,select') && (t.el[0].disabled = !1)
          }))
      }),
      (W.disable = function () {
        ;((U.disabled = !0),
          pa.each(i, function (e, t) {
            t.el.is('input,select') && (t.el[0].disabled = !0)
          }))
      }),
      (W.show = function (e, t) {
        var a, n, s, i
        if (!U.disabled && !W._isVisible) {
          if ((W._readValue(), !1 === R('onBeforeShow'))) return !1
          if (
            ((Ke = null),
            (p = U.animate),
            (h = U.buttons || []),
            (L = V || 'bubble' == U.display),
            (v = Ze && !L && U.scrollLock),
            (a = 0 < h.length),
            !1 !== p &&
              ('top' == U.display
                ? (p = p || 'slidedown')
                : 'bottom' == U.display
                  ? (p = p || 'slideup')
                  : ('center' != U.display && 'bubble' != U.display) || (p = p || 'pop')),
            F &&
              ((j = $ = 0),
              v &&
                !u.hasClass('mbsc-fr-lock-ios') &&
                ((O.mbscScrollTop = i = Math.max(0, N.scrollTop())),
                (O.mbscScrollLeft = s = Math.max(0, N.scrollLeft())),
                M.css({ top: -i + 'px', left: -s + 'px' })),
              u.addClass((U.scrollLock ? 'mbsc-fr-lock' : '') + (v ? ' mbsc-fr-lock-ios' : '') + (V ? ' mbsc-fr-lock-ctx' : '')),
              pa(document.activeElement).is('input,textarea') && document.activeElement.blur(),
              (g = Z.activeInstance),
              (Z.activeInstance = W),
              (O.mbscModals = (O.mbscModals || 0) + 1),
              v && (O.mbscIOSLock = (O.mbscIOSLock || 0) + 1),
              U.scrollLock && (O.mbscLock = (O.mbscLock || 0) + 1)),
            (n =
              '<div lang="' +
              U.lang +
              '" class="mbsc-fr mbsc-' +
              U.theme +
              (U.baseTheme ? ' mbsc-' + U.baseTheme : '') +
              ' mbsc-fr-' +
              U.display +
              ' ' +
              (U.cssClass || '') +
              ' ' +
              (U.compClass || '') +
              (W._isLiquid ? ' mbsc-fr-liq' : '') +
              (F ? ' mbsc-fr-pos' + (U.showOverlay ? '' : ' mbsc-fr-no-overlay') : '') +
              (f ? ' mbsc-fr-pointer' : '') +
              (mt ? ' mbsc-fr-hb' : '') +
              (x ? '' : ' mbsc-no-touch') +
              (v ? ' mbsc-platform-ios' : '') +
              (a ? (3 <= h.length ? ' mbsc-fr-btn-block ' : '') : ' mbsc-fr-nobtn') +
              '">' +
              (F
                ? '<div class="mbsc-fr-persp">' +
                  (U.showOverlay ? '<div class="mbsc-fr-overlay"></div>' : '') +
                  '<div role="dialog" class="mbsc-fr-scroll">'
                : '') +
              '<div class="mbsc-fr-popup' +
              (U.rtl ? ' mbsc-rtl' : ' mbsc-ltr') +
              (U.headerText ? ' mbsc-fr-has-hdr' : '') +
              '">' +
              ('bubble' === U.display
                ? '<div class="mbsc-fr-arr-w"><div class="mbsc-fr-arr-i"><div class="mbsc-fr-arr"></div></div></div>'
                : '') +
              (F ? '<div class="mbsc-fr-focus" tabindex="-1"></div>' : '') +
              '<div class="mbsc-fr-w">' +
              (U.headerText ? '<div class="mbsc-fr-hdr">' + (ue(U.headerText) ? U.headerText : '') + '</div>' : '') +
              '<div class="mbsc-fr-c">'),
            (n += W._generateContent()),
            (n += '</div>'),
            a)
          ) {
            var r,
              o,
              l,
              c = h.length
            for (n += '<div class="mbsc-fr-btn-cont">', o = 0; o < h.length; o++)
              ((l = U.btnReverse ? c - o - 1 : o),
                'set' === (r = ue((r = h[l])) ? W.buttons[r] : r).handler && (r.parentClass = 'mbsc-fr-btn-s'),
                'cancel' === r.handler && (r.parentClass = 'mbsc-fr-btn-c'),
                (n +=
                  '<div' +
                  (U.btnWidth ? ' style="width:' + 100 / h.length + '%"' : '') +
                  ' class="mbsc-fr-btn-w ' +
                  (r.parentClass || '') +
                  '"><div tabindex="0" role="button" class="mbsc-fr-btn' +
                  l +
                  ' mbsc-fr-btn-e ' +
                  (void 0 === r.cssClass ? U.btnClass : r.cssClass) +
                  (r.icon ? ' mbsc-ic mbsc-ic-' + r.icon : '') +
                  '">' +
                  (r.text || '') +
                  '</div></div>'))
            n += '</div>'
          }
          ;((S = pa((n += '</div></div></div></div>' + (F ? '</div></div>' : '')))),
            (k = pa('.mbsc-fr-persp', S)),
            (m = pa('.mbsc-fr-scroll', S)),
            (E = pa('.mbsc-fr-w', S)),
            (D = pa('.mbsc-fr-popup', S)),
            (d = pa('.mbsc-fr-hdr', S)),
            (I = S[0]),
            (b = m[0]),
            (z = D[0]),
            (W._activeElm = pa('.mbsc-fr-focus', S)[0]),
            (W._markup = S),
            (W._isVisible = !0),
            (W.markup = I),
            W._markupReady(S),
            R('onMarkupReady', { target: I }),
            F &&
              (pa(window).on('keydown', T),
              U.scrollLock &&
                S.on('touchmove mousewheel wheel', function (e) {
                  Y && e.preventDefault()
                }),
              U.focusTrap && N.on('focusin', w)),
            F
              ? setTimeout(
                  function () {
                    J(e, t)
                  },
                  v ? 100 : 0,
                )
              : J(e, t))
        }
      }),
      (W.hide = function (t, e, a, n) {
        if (!W._isVisible || (!a && !W._isValid && 'set' == e) || (!a && !1 === R('onBeforeClose', { valueText: W._tempValue, button: e })))
          return !1
        ;((W._isVisible = !1),
          o && (o.detach(), (o = null)),
          F &&
            (pa(document.activeElement).is('input,textarea') && z.contains(document.activeElement) && document.activeElement.blur(),
            Z.activeInstance == W && (Z.activeInstance = g),
            pa(window).off('keydown', T),
            N.off('focusin', w)),
          S &&
            (F && p && !t
              ? S.addClass('mbsc-anim-out mbsc-anim-trans mbsc-anim-trans-' + p)
                  .on(Ta, function e() {
                    ;(S.off(Ta, e), C(t))
                  })
                  .find('.mbsc-fr-popup')
                  .addClass('mbsc-anim-' + p)
              : C(t),
            W._detachEvents(S)),
          n && n(),
          B.trigger('blur'),
          R('onClose', { valueText: W._value }))
      }),
      (W.isVisible = function () {
        return W._isVisible
      }),
      (W.setVal = ra),
      (W.getVal = ra),
      (W._generateContent = ra),
      (W._attachEvents = ra),
      (W._detachEvents = ra),
      (W._readValue = ra),
      (W._clearValue = ra),
      (W._fillValue = ra),
      (W._markupReady = ra),
      (W._markupInserted = ra),
      (W._markupRemove = ra),
      (W._position = ra),
      (W.__processSettings = ra),
      (W.__init = ra),
      (W.__destroy = ra),
      (W._destroy = function () {
        ;(W.hide(!0, !1, !0),
          B.off('.mbsc'),
          pa.each(i, function (e, t) {
            ;(t.el.off('.mbsc').prop('readonly', t.readOnly), t.lbl && t.lbl.off('.mbsc'))
          }),
          W.__destroy())
      }),
      (W._updateHeader = function () {
        var e = U.headerText,
          t = e ? ('function' == typeof e ? e.call(a, W._tempValue) : e.replace(/\{value\}/i, W._tempValue)) : ''
        d.html(t || '&nbsp;')
      }),
      (W._getRespCont = function () {
        return ((V = 'body' != U.context), (N = pa(V ? U.context : window)), 'inline' == U.display ? (B.is('div') ? B : B.parent()) : N)
      }),
      (W._processSettings = function (e) {
        var t, a
        for (
          W.__processSettings(e),
            (f = !U.touchUi) &&
              ((U.display = e.display || n.display || 'bubble'),
              (U.buttons = e.buttons || n.buttons || []),
              (U.showOverlay = e.showOverlay || n.showOverlay || !1)),
            U.buttons = U.buttons || ('inline' !== U.display ? ['cancel', 'set'] : []),
            U.headerText = void 0 === U.headerText ? 'inline' !== U.display && '{value}' : U.headerText,
            h = U.buttons || [],
            F = 'inline' !== U.display,
            M = pa(U.context),
            u = V ? M : pa('body,html'),
            O = M[0],
            W.live = !0,
            a = 0;
          a < h.length;
          a++
        )
          ('ok' != (t = h[a]) && 'set' != t && 'set' != t.handler) || (W.live = !1)
        ;((W.buttons.set = { text: U.setText, icon: U.setIcon, handler: 'set' }),
          (W.buttons.cancel = { text: U.cancelText, icon: U.cancelIcon, handler: 'cancel' }),
          (W.buttons.close = { text: U.closeText, icon: U.closeIcon, handler: 'cancel' }),
          (W.buttons.clear = { text: U.clearText, icon: U.clearIcon, handler: 'clear' }),
          (W._isInput = B.is('input')))
      }),
      (W._init = function (e) {
        var t = W._isVisible,
          a = t && !S.hasClass('mbsc-fr-pos')
        ;(t && W.hide(!0, !1, !0),
          B.off('.mbsc'),
          W.__init(e),
          (W._isLiquid = 'liquid' == U.layout),
          F ? (W._readValue(), W._hasContent || U.skipShow || W.attachShow(B), t && W.show(a)) : W.show(),
          B.removeClass('mbsc-cloak')
            .filter('input, select, textarea')
            .on('change.mbsc', function () {
              ;(W._preventChange || W.setVal(B.val(), !0, !1), (W._preventChange = !1))
            }))
      }),
      (W.buttons = {}),
      (W.handlers = { set: W.select, cancel: W.cancel, clear: W.clear }),
      (W._value = null),
      (W._isValid = !0),
      (W._isVisible = !1),
      (U = W.settings),
      (R = W.trigger),
      e || W.init())
  }
  var Ke,
    Ge,
    Xe = Z.themes,
    Ze = /(iphone|ipod)/i.test(E) && 7 <= M,
    dt = 'android' == _,
    ut = 'ios' == _,
    mt = ut && 7 < M,
    ht = 'input,select,textarea,button'
  ;((qe.prototype._defaults = {
    lang: 'en',
    setText: 'Set',
    selectedText: '{count} selected',
    closeText: 'Close',
    cancelText: 'Cancel',
    clearText: 'Clear',
    context: 'body',
    maxPopupWidth: 600,
    disabled: !1,
    closeOnOverlayTap: !0,
    showOnFocus: dt || ut,
    showOnTap: !0,
    display: 'center',
    scroll: !0,
    scrollLock: !0,
    showOverlay: !0,
    tap: !0,
    touchUi: !0,
    btnClass: 'mbsc-fr-btn',
    btnWidth: !0,
    focusTrap: !0,
    focusOnClose: !(ut && 8 == M),
  }),
    (W.Frame = qe),
    (Xe.frame.mobiscroll = { headerText: !1, btnWidth: !1 }),
    (Xe.scroller.mobiscroll = va({}, Xe.frame.mobiscroll, {
      rows: 5,
      showLabel: !1,
      selectedLineBorder: 1,
      weekDays: 'min',
      checkIcon: 'ion-ios7-checkmark-empty',
      btnPlusClass: 'mbsc-ic mbsc-ic-arrow-down5',
      btnMinusClass: 'mbsc-ic mbsc-ic-arrow-up5',
      btnCalPrevClass: 'mbsc-ic mbsc-ic-arrow-left5',
      btnCalNextClass: 'mbsc-ic mbsc-ic-arrow-right5',
    })),
    D &&
      pa(window).on('focus', function () {
        Ke && (Ge = !0)
      }))
  function pt(s, e, t) {
    var n,
      a,
      i,
      r,
      c,
      o,
      l,
      d,
      u,
      m,
      h,
      p,
      f,
      v,
      b,
      g,
      x,
      T,
      y,
      C,
      _,
      w,
      M,
      S,
      k,
      D,
      N,
      E,
      O,
      V,
      F,
      A,
      I,
      P,
      H,
      L,
      z,
      U,
      Y,
      R,
      $,
      j,
      W,
      B,
      J,
      q = this,
      K = 0,
      G = 1,
      X = e,
      Z = pa(s)
    function Q(e) {
      ;(W('onStart', { domEvent: e }),
        X.stopProp && e.stopPropagation(),
        X.prevDef && e.preventDefault(),
        X.readonly ||
          (X.lock && _) ||
          (ga(e, this) &&
            !C &&
            (n && n.removeClass('mbsc-active'),
            (b = !1),
            _ ||
              ((n = pa(e.target).closest('.mbsc-btn-e', this)).length &&
                !n.hasClass('mbsc-disabled') &&
                ((b = !0),
                (r = setTimeout(function () {
                  n.addClass('mbsc-active')
                }, 100)))),
            (w = O = !(C = !0)),
            (q.scrolled = _),
            (z = ua(e, 'X')),
            (U = ua(e, 'Y')),
            (p = z),
            (d = l = o = 0),
            (L = new Date()),
            (H = +xa(R, B) || 0),
            _ && de(H, ft ? 0 : 1),
            'mousedown' === e.type && pa(document).on('mousemove', ee).on('mouseup', ae))))
    }
    function ee(e) {
      C &&
        (X.stopProp && e.stopPropagation(),
        (p = ua(e, 'X')),
        (f = ua(e, 'Y')),
        (o = p - z),
        (l = f - U),
        (d = B ? l : o),
        b && (Math.abs(l) > X.thresholdY || Math.abs(o) > X.thresholdX) && (clearTimeout(r), n.removeClass('mbsc-active'), (b = !1)),
        (q.scrolled || (!w && Math.abs(d) > j)) && (O || W('onGestureStart', v), (q.scrolled = O = !0), S || ((S = !0), (M = sa(te)))),
        B || X.scrollLock ? e.preventDefault() : q.scrolled ? e.preventDefault() : 7 < Math.abs(l) && ((w = !0), (q.scrolled = !0), ae()))
    }
    function te() {
      ;(T && (d = me(d, -I * T, I * T)), de(me(H + d, y - h, x + h)), (S = !1))
    }
    function ae(e) {
      if (C) {
        var t,
          a = new Date() - L
        ;(X.stopProp && e && e.stopPropagation(),
          ia(M),
          (S = !1),
          !w &&
            q.scrolled &&
            (X.momentum && a < 300 && ((t = d / a), (d = Math.max(Math.abs(d), (t * t) / X.speedUnit) * (d < 0 ? -1 : 1))), ce(d)),
          b &&
            (clearTimeout(r),
            n.addClass('mbsc-active'),
            setTimeout(function () {
              n.removeClass('mbsc-active')
            }, 100),
            w || q.scrolled || W('onBtnTap', { target: n[0], domEvent: e })),
          e && 'mouseup' == e.type && pa(document).off('mousemove', ee).off('mouseup', ae),
          (C = !1))
      }
    }
    function ne(e) {
      if (
        ((e = e.originalEvent || e),
        (d = B ? (null == e.deltaY ? e.wheelDelta || e.detail : e.deltaY) : e.deltaX),
        W('onStart', { domEvent: e }),
        X.stopProp && e.stopPropagation(),
        d)
      ) {
        if ((e.preventDefault(), e.deltaMode && 1 == e.deltaMode && (d *= 15), (d = me(-d, -F, F)), (H = J), X.readonly)) return
        if ((O || le(), H + d < y && ((H = y), (d = 0)), x < H + d && ((H = x), (d = 0)), S || ((S = !0), (M = sa(te))), !d && O)) return
        ;((O = !0),
          clearTimeout(V),
          (V = setTimeout(function () {
            ;(ia(M), (O = S = !1), ce(d))
          }, 200)))
      }
    }
    function se(e) {
      ;(W('onStart', { domEvent: e }),
        X.readonly ||
          (e.stopPropagation(),
          (H = J),
          (O = !1),
          e.target == k ? ((U = ua(e, 'Y', !0)), pa(document).on('mousemove', ie).on('mouseup', re)) : ((U = a.offset().top), ie(e), re())))
    }
    function ie(e) {
      var t = (ua(e, 'Y', !0) - U) / c
      ;((d = g ? me((d = -(T * I * 2 + c) * t), -I * T, I * T) : (y - x - c) * t), O || le(), (O = !0), de(me(H + d, y - h, x + h)))
    }
    function re() {
      ;((H = J), ce(0), pa(document).off('mousemove', ie).off('mouseup', re))
    }
    function oe(e) {
      e.stopPropagation()
    }
    function le() {
      W(
        'onGestureStart',
        (v = {
          posX: B ? 0 : J,
          posY: B ? J : 0,
          originX: B ? 0 : H,
          originY: B ? H : 0,
          direction: 0 < d ? (B ? 270 : 360) : B ? 90 : 180,
        }),
      )
    }
    function ce(e) {
      var t, a, n
      if ((T && (e = me(e, -I * T, I * T)), (n = me(Math.round((H + e) / I) * I, y, x)), P)) {
        if (e < 0) {
          for (t = P.length - 1; 0 <= t; t--)
            if (Math.abs(n) + c >= P[t].breakpoint) {
              ;((G = 2), (n = P[(K = t)].snap2))
              break
            }
        } else if (0 <= e)
          for (t = 0; t < P.length; t++)
            if (Math.abs(n) <= P[t].breakpoint) {
              ;((G = 1), (n = P[(K = t)].snap1))
              break
            }
        n = me(n, y, x)
      }
      ;((a = X.time || (J < y || x < J ? 1e3 : Math.max(1e3, Math.abs(n - J) * X.timeUnit))),
        (v.destinationX = B ? 0 : n),
        (v.destinationY = B ? n : 0),
        (v.duration = a),
        (v.transitionTiming = m),
        W('onGestureEnd', v),
        q.scroll(n, a))
    }
    function de(t, e, a, n) {
      function s() {
        ;(clearInterval(A),
          clearTimeout($),
          (_ = !1),
          (J = t),
          (v.posX = B ? 0 : t),
          (v.posY = B ? t : 0),
          r && W('onMove', v),
          o && W('onAnimationEnd', v),
          n && n())
      }
      var i,
        r = t != J,
        o = 1 < e,
        l = e ? ya + 'transform ' + Math.round(e) + 'ms ' + m : ''
      ;((v = {
        posX: B ? 0 : J,
        posY: B ? J : 0,
        originX: B ? 0 : H,
        originY: B ? H : 0,
        direction: 0 < t - J ? (B ? 270 : 360) : B ? 90 : 180,
      }),
        (J = t),
        o &&
          ((v.destinationX = B ? 0 : t),
          (v.destinationY = B ? t : 0),
          (v.duration = e),
          (v.transitionTiming = m),
          W('onAnimationStart', v)),
        (Y[Ca + 'Transition'] = l),
        (Y[Ca + 'Transform'] = 'translate3d(' + (B ? '0,' + t + 'px,' : t + 'px,0,') + '0)'),
        k &&
          D &&
          ((i = g ? (N - t) / (T * I * 2) : (t - x) / (y - x)),
          (k.style[Ca + 'Transition'] = l),
          (k.style[Ca + 'Transform'] = 'translate3d(0,' + Math.max(0, Math.min((c - D) * i, c - D)) + 'px,0)')),
        (!r && !_) || !e || e <= 1
          ? s()
          : e &&
            ((_ = !a),
            clearInterval(A),
            (A = setInterval(function () {
              var e = +xa(R, B) || 0
              ;((v.posX = B ? 0 : e), (v.posY = B ? e : 0), W('onMove', v), Math.abs(e - t) < 2 && s())
            }, 100)),
            clearTimeout($),
            ($ = setTimeout(function () {
              s()
            }, e))),
        X.sync && X.sync(t, e, m))
    }
    ;(ba.call(this, s, e, !0),
      (q.scrolled = !1),
      (q.scroll = function (e, t, a, n) {
        ;((e = me(
          (e = oa(e) ? Math.round(e / I) * I : Math.ceil((pa(e, s).length ? Math.round(R.offset()[u] - pa(e, s).offset()[u]) : J) / I) * I),
          y,
          x,
        )),
          (K = Math.round(e / I)),
          (H = J),
          (N = T * I + e),
          de(e, t, a, n))
      }),
      (q.refresh = function (e) {
        var t
        for (
          c = (void 0 === X.contSize ? (B ? Z.height() : Z.width()) : X.contSize) || 0,
            x = (void 0 === X.maxScroll ? 0 : X.maxScroll) || 0,
            y = Math.min(x, void 0 === X.minScroll ? Math.min(0, B ? c - R.height() : c - R.width()) : X.minScroll) || 0,
            P = null,
            !B && X.rtl && ((t = x), (x = -y), (y = -t)),
            ue(X.snap) &&
              ((P = []),
              R.find(X.snap).each(function () {
                var e = B ? this.offsetTop : this.offsetLeft,
                  t = B ? this.offsetHeight : this.offsetWidth
                P.push({ breakpoint: e + t / 2, snap1: -e, snap2: c - e - t })
              })),
            I = oa(X.snap) ? X.snap : 1,
            T = X.snap ? X.maxSnapScroll : 0,
            m = X.easing,
            h = X.elastic ? (oa(X.snap) ? I : oa(X.elastic) ? X.elastic : 0) : 0,
            F = I;
          44 < F;
        )
          F /= 2
        ;((F = Math.round(44 / F) * F),
          k &&
            ((g = y == -1 / 0 || x == 1 / 0),
            (D = y < x ? Math.max(20, (c * c) / (x - y + c)) : 0),
            (k.style.height = D + 'px'),
            (E.style.height = D ? '' : 0)),
          void 0 === J && ((J = X.initialPos), (K = Math.round(J / I))),
          e || q.scroll(X.snap ? (P ? P[K]['snap' + G] : K * I) : J))
      }),
      (q._processSettings = function () {
        ;((B = 'Y' == X.axis),
          (u = B ? 'top' : 'left'),
          (R = X.moveElement || Z.children().eq(0)),
          (Y = R[0].style),
          (j = B ? X.thresholdY : X.thresholdX),
          X.scrollbar && ((i = X.scrollbar), (a = i.find('.mbsc-sc-bar')), (k = a[0]), (E = i[0])))
      }),
      (q._init = function () {
        ;(q.refresh(),
          Z.on('touchstart mousedown', Q).on('touchmove', ee).on('touchend touchcancel', ae),
          X.mousewheel && Z.on('wheel mousewheel', ne),
          k && i.on('mousedown', se).on('click', oe),
          s.addEventListener(
            'click',
            function (e) {
              q.scrolled && ((q.scrolled = !1), e.stopPropagation(), e.preventDefault())
            },
            !0,
          ))
      }),
      (q._destroy = function () {
        ;(clearInterval(A),
          Z.off('touchstart mousedown', Q).off('touchmove', ee).off('touchend touchcancel', ae).off('wheel mousewheel', ne),
          k && i.off('mousedown', se).off('click', oe))
      }),
      (X = q.settings),
      (W = q.trigger),
      t || q.init())
  }
  var ft = 'ios' == _
  pt.prototype = {
    _defaults: {
      speedUnit: 0.0022,
      timeUnit: 3,
      initialPos: 0,
      axis: 'Y',
      thresholdX: 10,
      thresholdY: 5,
      easing: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
      stopProp: !0,
      momentum: !0,
      mousewheel: !0,
      elastic: !0,
    },
  }
  var vt = {},
    bt = D ? window.CSS : null,
    gt = bt && bt.supports && bt.supports('(transform-style: preserve-3d)')
  function xt(e) {
    return (e + '').replace('"', '___')
  }
  function Tt(h, t, e) {
    var a,
      c,
      g,
      p,
      x,
      l,
      s,
      T,
      y,
      d,
      u,
      f,
      C,
      v,
      _,
      b,
      i,
      w = 40,
      M = 1e3,
      S = this,
      r = pa(h)
    function n(e) {
      var t,
        a,
        n = +pa(this).attr('data-index')
      ;(38 == e.keyCode ? ((t = !0), (a = -1)) : 40 == e.keyCode ? ((t = !0), (a = 1)) : 32 == e.keyCode && ((t = !0), m(n, pa(e.target))),
        t && (e.stopPropagation(), e.preventDefault(), a && s.start(n, a, e)))
    }
    function o() {
      s.stop()
    }
    function m(e, t) {
      var a = b[e],
        n = +t.attr('data-index'),
        s = V(a, n),
        i = S._tempSelected[e],
        r = oa(a.multiple) ? a.multiple : 1 / 0
      !1 !== v('onItemTap', { target: t[0], index: e, value: s, selected: t.hasClass('mbsc-sc-itm-sel') }) &&
        (a.multiple &&
          !a._disabled[s] &&
          (void 0 !== i[s]
            ? (t.removeClass(x).removeAttr('aria-selected'), delete i[s])
            : (1 == r && ((S._tempSelected[e] = i = {}), a._$markup.find('.mbsc-sc-itm-sel').removeClass(x).removeAttr('aria-selected')),
              te(i).length < r && (t.addClass(x).attr('aria-selected', 'true'), (i[s] = s)))),
        z(a, e, n, M, a._index < n ? 1 : 2, !0, a.multiple),
        S.live &&
          (!a.multiple || (1 === a.multiple && C.tapSelect)) &&
          (!0 === C.setOnTap || C.setOnTap[e]) &&
          setTimeout(
            function () {
              S.select()
            },
            C.tapSelect ? 0 : 200,
          ))
    }
    function k(e) {
      return -(e.max - e._offset - (e.multiple && !p ? Math.floor(C.rows / 2) : 0)) * y
    }
    function D(e) {
      return -(e.min - e._offset + (e.multiple && !p ? Math.floor(C.rows / 2) : 0)) * y
    }
    function N(e, t) {
      return (e._array ? e._map[t] : +e.getIndex(t, S)) || 0
    }
    function E(e, t) {
      var a = e.data
      if (t >= e.min && t <= e.max) return e._array ? (e.circular ? pa(a).get(t % e._length) : a[t]) : pa.isFunction(a) ? a(t, S) : ''
    }
    function O(e) {
      return pa.isPlainObject(e) ? (void 0 !== e.value ? e.value : e.display) : e
    }
    function V(e, t) {
      return O(E(e, t))
    }
    function F(e, t, a) {
      var n = b[e]
      z(n, e, n._index + t, C.delay + 100, 1 == t ? 1 : 2, !1, !1, 'keydown' == a.type)
    }
    function A(e) {
      return pa.isArray(C.readonly) ? C.readonly[e] : C.readonly
    }
    function I(a, e, t) {
      var n = a._index - a._batch
      return (
        (a.data = a.data || []),
        (a.key = void 0 !== a.key ? a.key : e),
        (a.label = void 0 !== a.label ? a.label : e),
        (a._map = {}),
        (a._array = pa.isArray(a.data)),
        a._array &&
          ((a._length = a.data.length),
          pa.each(a.data, function (e, t) {
            a._map[O(t)] = e
          })),
        (a.circular =
          void 0 === C.circular
            ? void 0 === a.circular
              ? a._array && a._length > C.rows
              : a.circular
            : pa.isArray(C.circular)
              ? C.circular[e]
              : C.circular),
        (a.min = a._array ? (a.circular ? -1 / 0 : 0) : void 0 === a.min ? -1 / 0 : a.min),
        (a.max = a._array ? (a.circular ? 1 / 0 : a._length - 1) : void 0 === a.max ? 1 / 0 : a.max),
        (a._nr = e),
        (a._index = N(a, T[e])),
        (a._disabled = {}),
        (a._batch = 0),
        (a._current = a._index),
        (a._first = a._index - w),
        (a._last = a._index + w),
        (a._offset = a._first),
        t ? ((a._offset -= a._margin / y + (a._index - n)), (a._margin += (a._index - n) * y)) : (a._margin = 0),
        (a._refresh = function (e) {
          ;(va(a._scroller.settings, { minScroll: k(a), maxScroll: D(a) }), a._scroller.refresh(e))
        }),
        (i[a.key] = a)
      )
    }
    function P(e, t, a, n, s) {
      var i,
        r,
        o,
        l,
        c,
        d,
        u,
        m,
        h,
        p,
        f = '',
        v = S._tempSelected[t],
        b = e._disabled || {}
      for (i = a; i <= n; i++)
        ((o = E(e, i)),
          (h = o),
          (c = void 0 === (p = pa.isPlainObject(h) ? h.display : h) ? '' : p),
          (l = O(o)),
          (r = o && void 0 !== o.cssClass ? o.cssClass : ''),
          (d = o && void 0 !== o.label ? o.label : ''),
          (u = o && o.invalid),
          (m = void 0 !== l && l == T[t] && !e.multiple),
          (f +=
            '<div role="option" tabindex="-1" aria-selected="' +
            !!v[l] +
            '" class="mbsc-sc-itm ' +
            (s ? 'mbsc-sc-itm-3d ' : '') +
            r +
            ' ' +
            (m ? 'mbsc-sc-itm-sel ' : '') +
            (v[l] ? x : '') +
            (void 0 === l ? ' mbsc-sc-itm-ph' : ' mbsc-btn-e') +
            (u ? ' mbsc-sc-itm-inv-h mbsc-disabled' : '') +
            (b[l] ? ' mbsc-sc-itm-inv mbsc-disabled' : '') +
            '" data-index="' +
            i +
            '" data-val="' +
            xt(l) +
            '"' +
            (d ? ' aria-label="' + d + '"' : '') +
            (m ? ' aria-selected="true"' : '') +
            ' style="height:' +
            y +
            'px;line-height:' +
            y +
            'px;' +
            (s ? ya + 'transform:rotateX(' + (((e._offset - i) * g) % 360) + 'deg) translateZ(' + (y * C.rows) / 2 + 'px);' : '') +
            '">' +
            (1 < _
              ? '<div class="mbsc-sc-itm-ml" style="line-height:' +
                Math.round(y / _) +
                'px;font-size:' +
                Math.round((y / _) * 0.8) +
                'px;">'
              : '') +
            c +
            (1 < _ ? '</div>' : '') +
            '</div>'))
      return f
    }
    function H(e, t, a, n) {
      var s,
        i = b[e],
        r = n || i._disabled,
        o = N(i, t),
        l = V(i, o),
        c = l,
        d = l,
        u = 0,
        m = 0
      if (!0 === r[l]) {
        for (s = 0; o - u >= i.min && r[c] && s < 100; ) (s++, (c = V(i, o - ++u)))
        for (s = 0; o + m < i.max && r[d] && s < 100; ) (s++, (d = V(i, o + ++m)))
        l = ((m < u && m && 2 !== a) || !u || o - u < 0 || 1 == a) && !r[d] ? d : c
      }
      return l
    }
    function L(n, s, i, e, r, t, o) {
      var l,
        c,
        d,
        u,
        m = S._isVisible
      ;((f = !0),
        (u = C.validate.call(h, { values: T.slice(0), index: s, direction: i }, S) || {}),
        (f = !1),
        u.valid && (S._tempWheelArray = T = u.valid.slice(0)),
        t ||
          pa.each(b, function (e, a) {
            if (
              (m && a._$markup.find('.mbsc-sc-itm-inv').removeClass('mbsc-sc-itm-inv mbsc-disabled'),
              (a._disabled = {}),
              u.disabled &&
                u.disabled[e] &&
                pa.each(u.disabled[e], function (e, t) {
                  ;((a._disabled[t] = !0),
                    m && a._$markup.find('.mbsc-sc-itm[data-val="' + xt(t) + '"]').addClass('mbsc-sc-itm-inv mbsc-disabled'))
                }),
              (T[e] = a.multiple ? T[e] : H(e, T[e], i)),
              m)
            ) {
              if (
                ((a.multiple && void 0 !== s) || a._$markup.find('.mbsc-sc-itm-sel').removeClass(x).removeAttr('aria-selected'),
                (c = N(a, T[e])),
                (l = c - a._index + a._batch),
                Math.abs(l) > 2 * w + 1 && ((d = l + (2 * w + 1) * (0 < l ? -1 : 1)), (a._offset += d), (a._margin -= d * y), a._refresh()),
                (a._index = c + a._batch),
                a.multiple)
              ) {
                if (void 0 === s)
                  for (var t in S._tempSelected[e])
                    a._$markup
                      .find('.mbsc-sc-itm[data-val="' + xt(t) + '"]')
                      .addClass(x)
                      .attr('aria-selected', 'true')
              } else
                a._$markup
                  .find('.mbsc-sc-itm[data-val="' + xt(T[e]) + '"]')
                  .addClass('mbsc-sc-itm-sel')
                  .attr('aria-selected', 'true')
              ;(a._$active && a._$active.attr('tabindex', -1),
                (a._$active = a._$markup
                  .find('.mbsc-sc-itm[data-index="' + a._index + '"]')
                  .eq(p && a.multiple ? 1 : 0)
                  .attr('tabindex', 0)),
                o && s === e && a._$active.length && (a._$active[0].focus(), a._$scroller.parent().scrollTop(0)),
                a._scroller.scroll(-(c - a._offset + a._batch) * y, s === e || void 0 === s ? n : M, r))
            }
          }),
        v('onValidated', { index: s, time: n }),
        (S._tempValue = C.formatValue.call(h, T, S)),
        m && S._updateHeader(),
        S.live &&
          (function (e, t) {
            var a = b[e]
            return a && (!a.multiple || (1 !== a.multiple && t && (!0 === C.setOnTap || C.setOnTap[e])))
          })(s, t) &&
          ((S._hasValue = e || S._hasValue), U(e, e, 0, !0), e && v('onSet', { valueText: S._value })),
        e && v('onChange', { index: s, valueText: S._tempValue }))
    }
    function z(e, t, a, n, s, i, r, o) {
      var l = V(e, a)
      void 0 !== l &&
        ((T[t] = l),
        (e._batch = e._array ? Math.floor(a / e._length) * e._length : 0),
        (e._index = a),
        setTimeout(function () {
          L(n, t, s, !0, i, r, o)
        }, 10))
    }
    function U(e, t, a, n, s) {
      if ((n ? (S._tempValue = C.formatValue.call(h, S._tempWheelArray, S)) : L(a), !s)) {
        S._wheelArray = []
        for (var i = 0; i < T.length; i++) S._wheelArray[i] = b[i] && b[i].multiple ? Object.keys(S._tempSelected[i] || {})[0] : T[i]
        ;((S._value = S._hasValue ? S._tempValue : null), (S._selected = va(!0, {}, S._tempSelected)))
      }
      e &&
        (S._isInput && r.val(S._hasValue ? S._tempValue : ''),
        v('onFill', { valueText: S._hasValue ? S._tempValue : '', change: t }),
        t && ((S._preventChange = !0), r.trigger('change')))
    }
    ;(qe.call(this, h, t, !0),
      (S.setVal = S._setVal =
        function (e, t, a, n, s) {
          ;((S._hasValue = null != e),
            (S._tempWheelArray = T = pa.isArray(e) ? e.slice(0) : C.parseValue.call(h, e, S) || []),
            U(t, void 0 === a ? t : a, s, !1, n))
        }),
      (S.getVal = S._getVal =
        function (e) {
          var t = S._hasValue || e ? S[e ? '_tempValue' : '_value'] : null
          return oa(t) ? +t : t
        }),
      (S.setArrayVal = S.setVal),
      (S.getArrayVal = function (e) {
        return e ? S._tempWheelArray : S._wheelArray
      }),
      (S.changeWheel = function (e, t, a) {
        var n, s
        ;(pa.each(e, function (e, t) {
          ;(s = i[e]) &&
            ((n = s._nr),
            va(s, t),
            I(s, n, !0),
            S._isVisible &&
              (p && s._$3d.html(P(s, n, s._first + w - c + 1, s._last - w + c, !0)),
              s._$scroller.html(P(s, n, s._first, s._last)).css('margin-top', s._margin + 'px'),
              s._refresh(f)))
        }),
          !S._isVisible || S._isLiquid || f || S.position(),
          f || L(t, void 0, void 0, a))
      }),
      (S.getValidValue = H),
      (S._generateContent = function () {
        var a,
          n = 0,
          s = '',
          i = p ? ya + 'transform: translateZ(' + ((y * C.rows) / 2 + 3) + 'px);' : '',
          r =
            '<div class="mbsc-sc-whl-l" style="' +
            i +
            'height:' +
            y +
            'px;margin-top:-' +
            (y / 2 + (C.selectedLineBorder || 0)) +
            'px;"></div>',
          o = 0
        return (
          pa.each(C.wheels, function (e, t) {
            ;((s +=
              '<div class="mbsc-w-p mbsc-sc-whl-gr-c' +
              (p ? ' mbsc-sc-whl-gr-3d-c' : '') +
              (C.showLabel ? ' mbsc-sc-lbl-v' : '') +
              '">' +
              r +
              '<div class="mbsc-sc-whl-gr' +
              (p ? ' mbsc-sc-whl-gr-3d' : '') +
              (l ? ' mbsc-sc-cp' : '') +
              (C.width || C.maxWidth ? '"' : '" style="max-width:' + C.maxPopupWidth + 'px;"') +
              '>'),
              pa.each(t, function (e, t) {
                ;((S._tempSelected[o] = va({}, S._selected[o])),
                  (b[o] = I(t, o)),
                  (n += C.maxWidth ? C.maxWidth[o] || C.maxWidth : C.width ? C.width[o] || C.width : 0),
                  (a = void 0 !== t.label ? t.label : e),
                  (s +=
                    '<div class="mbsc-sc-whl-w ' +
                    (t.cssClass || '') +
                    (t.multiple ? ' mbsc-sc-whl-multi' : '') +
                    '" style="' +
                    (C.width
                      ? 'width:' + (C.width[o] || C.width) + 'px;'
                      : (C.minWidth ? 'min-width:' + (C.minWidth[o] || C.minWidth) + 'px;' : '') +
                        (C.maxWidth ? 'max-width:' + (C.maxWidth[o] || C.maxWidth) + 'px;' : '')) +
                    '">' +
                    (u ? '<div class="mbsc-sc-bar-c"><div class="mbsc-sc-bar"></div></div>' : '') +
                    '<div class="mbsc-sc-whl-o" style="' +
                    i +
                    '"></div>' +
                    r +
                    '<div aria-live="off" aria-label="' +
                    a +
                    '"' +
                    (t.multiple ? ' aria-multiselectable="true"' : '') +
                    ' role="listbox" data-index="' +
                    o +
                    '" class="mbsc-sc-whl" style="height:' +
                    C.rows * y * (p ? 1.1 : 1) +
                    'px;">' +
                    (l
                      ? '<div data-index="' +
                        o +
                        '" data-step="1" class="mbsc-sc-btn mbsc-sc-btn-plus ' +
                        (C.btnPlusClass || '') +
                        '"></div><div data-index="' +
                        o +
                        '" data-step="-1" class="mbsc-sc-btn mbsc-sc-btn-minus ' +
                        (C.btnMinusClass || '') +
                        '"></div>'
                      : '') +
                    '<div class="mbsc-sc-lbl">' +
                    a +
                    '</div><div class="mbsc-sc-whl-c" style="height:' +
                    d +
                    'px;margin-top:-' +
                    (d / 2 + 1) +
                    'px;' +
                    i +
                    '"><div class="mbsc-sc-whl-sc" style="top:' +
                    (d - y) / 2 +
                    'px;">'),
                  (s += P(t, o, t._first, t._last) + '</div></div>'),
                  p &&
                    ((s += '<div class="mbsc-sc-whl-3d" style="height:' + y + 'px;margin-top:-' + y / 2 + 'px;">'),
                    (s += P(t, o, t._first + w - c + 1, t._last - w + c, !0)),
                    (s += '</div>')),
                  (s += '</div></div>'),
                  o++)
              }),
              (s += '</div></div>'))
          }),
          n && (C.maxPopupWidth = n),
          s
        )
      }),
      (S._attachEvents = function (e) {
        ;((s = ct(pa('.mbsc-sc-btn', e), F, C.delay, A, !0)), pa('.mbsc-sc-whl', e).on('keydown', n).on('keyup', o))
      }),
      (S._detachEvents = function () {
        s.stop()
        for (var e = 0; e < b.length; e++) b[e]._scroller.destroy()
      }),
      (S._markupReady = function (e) {
        ;(pa('.mbsc-sc-whl-w', (a = e)).each(function (s) {
          var i,
            e = pa(this),
            r = b[s]
          ;((r._$markup = e),
            (r._$scroller = pa('.mbsc-sc-whl-sc', this)),
            (r._$3d = pa('.mbsc-sc-whl-3d', this)),
            (r._scroller = new pt(this, {
              mousewheel: C.mousewheel,
              moveElement: r._$scroller,
              scrollbar: pa('.mbsc-sc-bar-c', this),
              initialPos: (r._first - r._index) * y,
              contSize: C.rows * y,
              snap: y,
              minScroll: k(r),
              maxScroll: D(r),
              maxSnapScroll: w,
              prevDef: !0,
              stopProp: !0,
              timeUnit: 3,
              easing: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
              sync: function (e, t, a) {
                var n = t ? ya + 'transform ' + Math.round(t) + 'ms ' + a : ''
                p && ((r._$3d[0].style[Ca + 'Transition'] = n), (r._$3d[0].style[Ca + 'Transform'] = 'rotateX(' + (-e / y) * g + 'deg)'))
              },
              onStart: function (e, t) {
                t.settings.readonly = A(s)
              },
              onGestureStart: function () {
                ;(e.addClass('mbsc-sc-whl-a mbsc-sc-whl-anim'), v('onWheelGestureStart', { index: s }))
              },
              onGestureEnd: function (e) {
                var t = 90 == e.direction ? 1 : 2,
                  a = e.duration,
                  n = e.destinationY
                ;((i = Math.round(-n / y) + r._offset), z(r, s, i, a, t))
              },
              onAnimationStart: function () {
                e.addClass('mbsc-sc-whl-anim')
              },
              onAnimationEnd: function () {
                ;(e.removeClass('mbsc-sc-whl-a mbsc-sc-whl-anim'),
                  v('onWheelAnimationEnd', { index: s }),
                  r._$3d.find('.mbsc-sc-itm-del').remove())
              },
              onMove: function (e) {
                !(function (e, t, a) {
                  var n = Math.round(-a / y) + e._offset,
                    s = n - e._current,
                    i = e._first,
                    r = e._last,
                    o = i + w - c + 1,
                    l = r - w + c
                  s &&
                    ((e._first += s),
                    (e._last += s),
                    (e._current = n),
                    0 < s
                      ? (e._$scroller.append(P(e, t, Math.max(r + 1, i + s), r + s)),
                        pa('.mbsc-sc-itm', e._$scroller)
                          .slice(0, Math.min(s, r - i + 1))
                          .remove(),
                        p &&
                          (e._$3d.append(P(e, t, Math.max(l + 1, o + s), l + s, !0)),
                          pa('.mbsc-sc-itm', e._$3d)
                            .slice(0, Math.min(s, l - o + 1))
                            .attr('class', 'mbsc-sc-itm-del')))
                      : s < 0 &&
                        (e._$scroller.prepend(P(e, t, i + s, Math.min(i - 1, r + s))),
                        pa('.mbsc-sc-itm', e._$scroller)
                          .slice(Math.max(s, i - r - 1))
                          .remove(),
                        p &&
                          (e._$3d.prepend(P(e, t, o + s, Math.min(o - 1, l + s), !0)),
                          pa('.mbsc-sc-itm', e._$3d)
                            .slice(Math.max(s, o - l - 1))
                            .attr('class', 'mbsc-sc-itm-del'))),
                    (e._margin += s * y),
                    e._$scroller.css('margin-top', e._margin + 'px'))
                })(r, s, e.posY)
              },
              onBtnTap: function (e) {
                m(s, pa(e.target))
              },
            })))
        }),
          L())
      }),
      (S._fillValue = function () {
        U((S._hasValue = !0), !0, 0, !0)
      }),
      (S._clearValue = function () {
        pa('.mbsc-sc-whl-multi .mbsc-sc-itm-sel', a).removeClass(x).removeAttr('aria-selected')
      }),
      (S._readValue = function () {
        var e = r.val() || '',
          a = 0
        ;('' !== e && (S._hasValue = !0),
          (S._tempWheelArray = T = S._hasValue && S._wheelArray ? S._wheelArray.slice(0) : C.parseValue.call(h, e, S) || []),
          (S._tempSelected = va(!0, {}, S._selected)),
          pa.each(C.wheels, function (e, t) {
            pa.each(t, function (e, t) {
              ;((b[a] = I(t, a)), a++)
            })
          }),
          U(!1, !1, 0, !0),
          v('onRead'))
      }),
      (S.__processSettings = function (e) {
        ;((C = S.settings),
          (v = S.trigger),
          (_ = C.multiline),
          (x = 'mbsc-sc-itm-sel mbsc-ic mbsc-ic-' + C.checkIcon),
          (u = !C.touchUi) && ((C.tapSelect = !0), (C.circular = !1), (C.rows = e.rows || t.rows || 7)))
      }),
      (S.__init = function (e) {
        ;(e && (S._wheelArray = null),
          (b = []),
          (i = {}),
          (l = C.showScrollArrows),
          (p = C.scroll3d && gt && !l && !u && ('ios' == C.theme || 'ios' == C.baseTheme)),
          (y = C.height),
          (d = p ? 2 * Math.round((y - 0.03 * ((y * C.rows) / 2 + 3)) / 2) : y),
          (c = Math.round(1.8 * C.rows)),
          (g = 360 / (2 * c)),
          l && (C.rows = Math.max(3, C.rows)))
      }),
      (S._getItemValue = O),
      (S._tempSelected = {}),
      (S._selected = {}),
      e || S.init())
  }
  ;((Tt.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _responsive: !0,
    _class: 'scroller',
    _presets: vt,
    _defaults: va({}, qe.prototype._defaults, {
      minWidth: 80,
      height: 40,
      rows: 3,
      multiline: 1,
      delay: 200,
      readonly: !1,
      showLabel: !0,
      setOnTap: !1,
      wheels: [],
      preset: '',
      speedUnit: 0.0012,
      timeUnit: 0.08,
      checkIcon: 'checkmark',
      compClass: 'mbsc-sc',
      validate: function () {},
      formatValue: function (e) {
        return e.join(' ')
      },
      parseValue: function (e, a) {
        var n,
          s,
          i = [],
          r = [],
          o = 0
        return (
          null != e && (i = (e + '').split(' ')),
          pa.each(a.settings.wheels, function (e, t) {
            pa.each(t, function (e, t) {
              ;((s = t.data),
                (n = a._getItemValue(s[0])),
                pa.each(s, function (e, t) {
                  if (i[o] == a._getItemValue(t)) return ((n = a._getItemValue(t)), !1)
                }),
                r.push(n),
                o++)
            })
          }),
          r
        )
      },
    }),
  }),
    (W.Scroller = Tt))
  function yt(g) {
    function e(e) {
      var t,
        a,
        n,
        s,
        i = []
      if (e) {
        for (t = 0; t < e.length; t++)
          if ((a = e[t]).start && a.end && !Se.test(a.start))
            for (n = new Date(st(a.start, k, A)), s = new Date(st(a.end, k, A)); n <= s; )
              (i.push(et(n.getFullYear(), n.getMonth(), n.getDate())), n.setDate(n.getDate() + 1))
          else i.push(a)
        return i
      }
      return e
    }
    function O(e, t, a, n) {
      return Math.min(n, Math.floor(e / t) * t + a)
    }
    function t(e, t, a) {
      return Math.floor((a - t) / e) * e + t
    }
    function i(e) {
      return e.getFullYear() + '-' + re(e.getMonth() + 1) + '-' + re(e.getDate())
    }
    function o(e, t, a, n) {
      var s
      return void 0 === M[t] || ((s = +e[M[t]]), isNaN(s)) ? (a ? se[t](a) : void 0 !== r[t] ? r[t] : se[t](n)) : s
    }
    function x(e) {
      var t,
        a = new Date(new Date().setHours(0, 0, 0, 0))
      if (null === e) return e
      ;(void 0 !== M.dd && ((t = e[M.dd].split('-')), (t = new Date(t[0], t[1] - 1, t[2]))),
        void 0 !== M.tt && ((t = t || a), (t = new Date(t.getTime() + (e[M.tt] % 86400) * 1e3))))
      var n = o(e, 'y', t, a),
        s = o(e, 'm', t, a),
        i = Math.min(o(e, 'd', t, a), A.getMaxDayOfMonth(n, s)),
        r = o(e, 'h', t, a)
      return A.getDate(n, s, i, R && o(e, 'a', t, a) ? r + 12 : r, o(e, 'i', t, a), o(e, 's', t, a), o(e, 'u', t, a))
    }
    function T(e, t) {
      var a,
        n,
        s = ['y', 'm', 'd', 'a', 'h', 'i', 's', 'u', 'dd', 'tt'],
        i = []
      if (null == e) return e
      for (a = 0; a < s.length; a++) (void 0 !== M[(n = s[a])] && (i[M[n]] = se[n](e)), t && (r[n] = se[n](e)))
      return i
    }
    function a(e, t) {
      return t ? Math.floor(new Date(e) / 864e5) : e.getMonth() + 12 * (e.getFullYear() - 1970)
    }
    function m(e) {
      return { value: e, display: (/yy/i.test(E) ? e : (e + '').substr(2, 2)) + (A.yearSuffix || '') }
    }
    function h(e) {
      return e
    }
    function p(n) {
      var s = /d/i.test(n)
      return {
        label: '',
        cssClass: 'mbsc-dt-whl-date',
        min: z ? a(i(z), s) : void 0,
        max: U ? a(i(U), s) : void 0,
        data: function (e) {
          var t = new Date(new Date().setHours(0, 0, 0, 0)),
            a = s ? new Date(864e5 * e) : new Date(1970, e, 1)
          return (
            s && (a = new Date(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate())),
            { invalid: s && !C(a, !0), value: i(a), display: t.getTime() == a.getTime() ? A.todayText : ye(n, a, A) }
          )
        },
        getIndex: function (e) {
          return a(e, s)
        },
      }
    }
    function f(e) {
      var t,
        a,
        n,
        s = []
      for (/s/i.test(e) ? (a = J) : /i/i.test(e) ? (a = 60 * B) : /h/i.test(e) && (a = 3600 * W), V = ne.tt = a, t = 0; t < 86400; t += a)
        ((n = new Date(new Date().setHours(0, 0, 0, 0) + 1e3 * t)), s.push({ value: t, display: ye(e, n, A) }))
      return { label: '', cssClass: 'mbsc-dt-whl-time', data: s }
    }
    function y(e, t) {
      return A.getYear(e) === A.getYear(t) && A.getMonth(e) === A.getMonth(t)
    }
    function C(e, t) {
      return !(!t && e < z) && !(!t && U < e) && (!!n(e, L) || !n(e, H))
    }
    function n(e, t) {
      var a, n, s
      if (t)
        for (n = 0; n < t.length; n++)
          if (((s = (a = t[n]) + ''), !a.start))
            if (ot.test(s)) {
              if ((s = +s.replace('w', '')) == e.getDay()) return !0
            } else if (rt.test(s)) {
              if ((s = s.split('/'))[1]) {
                if (s[0] - 1 == e.getMonth() && s[1] == e.getDate()) return !0
              } else if (s[0] == e.getDate()) return !0
            } else if (
              ((a = st(a, k, A)), e.getFullYear() == a.getFullYear() && e.getMonth() == a.getMonth() && e.getDate() == a.getDate())
            )
              return !0
      return !1
    }
    function _(e, t, a, n, s, i, r) {
      var o, l, c, d
      if (e)
        for (l = 0; l < e.length; l++)
          if (((d = (o = e[l]) + ''), !o.start))
            if (ot.test(d)) for (c = (d = +d.replace('w', '')) - n; c < s; c += 7) 0 <= c && (i[c + 1] = r)
            else
              rt.test(d)
                ? (d = d.split('/'))[1]
                  ? d[0] - 1 == a && (i[d[1]] = r)
                  : (i[d[0]] = r)
                : ((o = st(o, k, A)), A.getYear(o) == t && A.getMonth(o) == a && (i[A.getDay(o)] = r))
    }
    function w(e, t, a, n, s, i, r, o) {
      var l,
        c,
        d,
        u,
        m,
        h,
        p,
        f,
        v,
        b,
        g,
        x,
        T,
        y,
        C,
        _,
        w,
        M,
        S,
        k,
        D = {},
        N = A.getDate(n, s, i),
        E = ['a', 'h', 'i', 's']
      if (e) {
        for (p = 0; p < e.length; p++)
          (g = e[p]).start &&
            ((g.apply = !1),
            (M = (w = (d = g.d) + '').split('/')),
            d &&
              ((d.getTime && n == A.getYear(d) && s == A.getMonth(d) && i == A.getDay(d)) ||
                (!ot.test(w) && ((M[1] && i == M[1] && s == M[0] - 1) || (!M[1] && i == M[0]))) ||
                (ot.test(w) && N.getDay() == +w.replace('w', ''))) &&
              ((g.apply = !0), (D[N] = !0)))
        for (p = 0; p < e.length; p++)
          if (((g = e[p]), (_ = l = 0), (f = te[a]), (v = ae[a]), (c = !(C = y = !0)), g.start && (g.apply || (!g.d && !D[N])))) {
            for (x = g.start.split(':'), T = g.end.split(':'), b = 0; b < 3; b++)
              (void 0 === x[b] && (x[b] = 0), void 0 === T[b] && (T[b] = 59), (x[b] = +x[b]), (T[b] = +T[b]))
            if ('tt' == a)
              ((f = O(Math.round((new Date(N).setHours(x[0], x[1], x[2]) - new Date(N).setHours(0, 0, 0, 0)) / 1e3), V, 0, 86400)),
                (v = O(Math.round((new Date(N).setHours(T[0], T[1], T[2]) - new Date(N).setHours(0, 0, 0, 0)) / 1e3), V, 0, 86400)))
            else {
              for (
                x.unshift(11 < x[0] ? 1 : 0),
                  T.unshift(11 < T[0] ? 1 : 0),
                  R && (12 <= x[1] && (x[1] = x[1] - 12), 12 <= T[1] && (T[1] = T[1] - 12)),
                  b = 0;
                b < t;
                b++
              )
                void 0 !== F[b] &&
                  ((S = O(x[b], ne[E[b]], te[E[b]], ae[E[b]])),
                  (k = O(T[b], ne[E[b]], te[E[b]], ae[E[b]])),
                  (h = m = u = 0),
                  R && 1 == b && ((u = x[0] ? 12 : 0), (m = T[0] ? 12 : 0), (h = F[0] ? 12 : 0)),
                  y || (S = 0),
                  C || (k = ae[E[b]]),
                  (y || C) && S + u < F[b] + h && F[b] + h < k + m && (c = !0),
                  F[b] != S && (y = !1),
                  F[b] != k && (C = !1))
              if (!o) for (b = t + 1; b < 4; b++) (0 < x[b] && (l = ne[a]), T[b] < ae[E[b]] && (_ = ne[a]))
              c || ((S = O(x[t], ne[a], te[a], ae[a]) + l), (k = O(T[t], ne[a], te[a], ae[a]) - _), y && (f = S), C && (v = k))
            }
            if (y || C || c) for (b = f; b <= v; b += ne[a]) r[b] = !o
          }
      }
    }
    var V,
      v,
      s,
      M = {},
      r = {},
      b = {},
      F = [],
      l = (function (e) {
        var t,
          a,
          n,
          s = {}
        if (e.is('input')) {
          switch (e.attr('type')) {
            case 'date':
              t = 'yy-mm-dd'
              break
            case 'datetime':
              t = 'yy-mm-ddTHH:ii:ssZ'
              break
            case 'datetime-local':
              t = 'yy-mm-ddTHH:ii:ss'
              break
            case 'month':
              ;((t = 'yy-mm'), (s.dateOrder = 'mmyy'))
              break
            case 'time':
              t = 'HH:ii:ss'
          }
          ;((s.format = t),
            (a = e.attr('min')),
            (n = e.attr('max')),
            a && 'undefined' != a && (s.min = Ce(t, a)),
            n && 'undefined' != n && (s.max = Ce(t, n)))
        }
        return s
      })(pa(this)),
      c = va({}, g.settings),
      d = ie[c.calendarSystem],
      A = va(g.settings, ke, d, _t, l, c),
      S = A.preset,
      u = 'datetime' == S ? A.dateFormat + A.separator + A.timeFormat : 'time' == S ? A.timeFormat : A.dateFormat,
      k = l.format || u,
      D = A.dateWheels || A.dateFormat,
      N = A.timeWheels || A.timeFormat,
      E = A.dateWheels || A.dateDisplay,
      I = N,
      P = A.baseTheme || A.theme,
      H = e(A.invalid),
      L = e(A.valid),
      z = st(A.min, k, A),
      U = st(A.max, k, A),
      Y = /time/i.test(S),
      R = /h/.test(I),
      $ = /D/.test(E),
      j = A.steps || {},
      W = j.hour || A.stepHour || 1,
      B = j.minute || A.stepMinute || 1,
      J = j.second || A.stepSecond || 1,
      q = j.zeroBased,
      K = q || !z ? 0 : z.getHours() % W,
      G = q || !z ? 0 : z.getMinutes() % B,
      X = q || !z ? 0 : z.getSeconds() % J,
      Z = t(W, K, R ? 11 : 23),
      Q = t(B, G, 59),
      ee = t(B, G, 59),
      te = { y: z ? z.getFullYear() : -1 / 0, m: 0, d: 1, h: K, i: G, s: X, a: 0, tt: 0 },
      ae = { y: U ? U.getFullYear() : 1 / 0, m: 11, d: 31, h: Z, i: Q, s: ee, a: 1, tt: 86400 },
      ne = { y: 1, m: 1, d: 1, h: W, i: B, s: J, a: 1, tt: 1 },
      se = {
        y: function (e) {
          return A.getYear(e)
        },
        m: function (e) {
          return A.getMonth(e)
        },
        d: function (e) {
          return A.getDay(e)
        },
        h: function (e) {
          var t = e.getHours()
          return O((t = R && 12 <= t ? t - 12 : t), W, K, Z)
        },
        i: function (e) {
          return O(e.getMinutes(), B, G, Q)
        },
        s: function (e) {
          return O(e.getSeconds(), J, X, ee)
        },
        u: function (e) {
          return e.getMilliseconds()
        },
        a: function (e) {
          return 11 < e.getHours() ? 1 : 0
        },
        dd: i,
        tt: function (e) {
          return O(Math.round((e.getTime() - new Date(e).setHours(0, 0, 0, 0)) / 1e3), V || 1, 0, 86400)
        },
      }
    return (
      (g.getVal = function (e) {
        return g._hasValue || e ? we(x(g.getArrayVal(e)), A, k) : null
      }),
      (g.getDate = function (e) {
        return g._hasValue || e ? x(g.getArrayVal(e)) : null
      }),
      (g.setDate = function (e, t, a, n, s) {
        g.setArrayVal(T(e, !0), t, s, n, a)
      }),
      (s = (function () {
        var e,
          t,
          a,
          n,
          s,
          i,
          r,
          o,
          l = 0,
          c = [],
          d = [],
          u = []
        if (/date/i.test(S)) {
          for (e = D.split(/\|/.test(D) ? '|' : ''), n = 0; n < e.length; n++)
            if (((i = 0), (a = e[n]).length))
              if (
                (/y/i.test(a) && ((b.y = 1), i++),
                /m/i.test(a) && ((b.y = 1), (b.m = 1), i++),
                /d/i.test(a) && ((b.y = 1), (b.m = 1), (b.d = 1), i++),
                1 < i && void 0 === M.dd)
              )
                ((M.dd = l), l++, d.push(p(a)), (u = d), (v = !0))
              else if (/y/i.test(a) && void 0 === M.y)
                ((M.y = l),
                  l++,
                  d.push({
                    cssClass: 'mbsc-dt-whl-y',
                    label: A.yearText,
                    min: z ? A.getYear(z) : void 0,
                    max: U ? A.getYear(U) : void 0,
                    data: m,
                    getIndex: h,
                  }))
              else if (/m/i.test(a) && void 0 === M.m) {
                for (M.m = l, r = [], l++, s = 0; s < 12; s++)
                  ((o = E.replace(/[dy|]/gi, '')
                    .replace(/mm/, re(s + 1) + (A.monthSuffix || ''))
                    .replace(/m/, s + 1 + (A.monthSuffix || ''))),
                    r.push({
                      value: s,
                      display: /MM/.test(o)
                        ? o.replace(/MM/, '<span class="mbsc-dt-month">' + A.monthNames[s] + '</span>')
                        : o.replace(/M/, '<span class="mbsc-dt-month">' + A.monthNamesShort[s] + '</span>'),
                    }))
                d.push({ cssClass: 'mbsc-dt-whl-m', label: A.monthText, data: r })
              } else if (/d/i.test(a) && void 0 === M.d) {
                for (M.d = l, r = [], l++, s = 1; s < 32; s++)
                  r.push({ value: s, display: (/dd/i.test(E) ? re(s) : s) + (A.daySuffix || '') })
                d.push({ cssClass: 'mbsc-dt-whl-d', label: A.dayText, data: r })
              }
          c.push(d)
        }
        if (/time/i.test(S)) {
          for (t = N.split(/\|/.test(N) ? '|' : ''), n = 0; n < t.length; n++)
            if (
              ((i = 0),
              (a = t[n]).length &&
                (/h/i.test(a) && ((b.h = 1), i++), /i/i.test(a) && ((b.i = 1), i++), /s/i.test(a) && ((b.s = 1), i++), /a/i.test(a) && i++),
              1 < i && void 0 === M.tt)
            )
              ((M.tt = l), l++, u.push(f(a)))
            else if (/h/i.test(a) && void 0 === M.h) {
              for (r = [], M.h = l, b.h = 1, l++, s = K; s < (R ? 12 : 24); s += W)
                r.push({ value: s, display: R && 0 === s ? 12 : /hh/i.test(I) ? re(s) : s })
              u.push({ cssClass: 'mbsc-dt-whl-h', label: A.hourText, data: r })
            } else if (/i/i.test(a) && void 0 === M.i) {
              for (r = [], M.i = l, b.i = 1, l++, s = G; s < 60; s += B) r.push({ value: s, display: /ii/i.test(I) ? re(s) : s })
              u.push({ cssClass: 'mbsc-dt-whl-i', label: A.minuteText, data: r })
            } else if (/s/i.test(a) && void 0 === M.s) {
              for (r = [], M.s = l, b.s = 1, l++, s = X; s < 60; s += J) r.push({ value: s, display: /ss/i.test(I) ? re(s) : s })
              u.push({ cssClass: 'mbsc-dt-whl-s', label: A.secText, data: r })
            } else
              /a/i.test(a) &&
                void 0 === M.a &&
                ((M.a = l),
                l++,
                u.push({
                  cssClass: 'mbsc-dt-whl-a',
                  label: A.ampmText,
                  data: /A/.test(a)
                    ? [
                        { value: 0, display: A.amText.toUpperCase() },
                        { value: 1, display: A.pmText.toUpperCase() },
                      ]
                    : [
                        { value: 0, display: A.amText },
                        { value: 1, display: A.pmText },
                      ],
                }))
          u != d && c.push(u)
        }
        return c
      })()),
      (A.isoParts = b),
      (g._format = u),
      (g._order = M),
      (g.handlers.now = function () {
        g.setDate(new Date(), g.live, 1e3, !0, !0)
      }),
      (g.buttons.now = { text: A.nowText, icon: A.nowIcon, handler: 'now' }),
      {
        minWidth: v && Y ? { bootstrap: 46, ios: 50, material: 46, mobiscroll: 46, windows: 50 }[P] : void 0,
        compClass: 'mbsc-dt mbsc-sc',
        wheels: s,
        headerText:
          !!A.headerText &&
          function () {
            return ye(u, x(g.getArrayVal(!0)), A)
          },
        formatValue: function (e) {
          return ye(k, x(e), A)
        },
        parseValue: function (e) {
          return (e || ((r = {}), (g._hasValue = !1)), T(st(e || A.defaultValue || new Date(), k, A, b), !!e))
        },
        validate: function (e) {
          var t,
            o,
            a,
            n,
            s = e.values,
            i = e.index,
            r = e.direction,
            l = A.wheels[0][M.d],
            c = (function (e, t) {
              var a,
                n,
                s = !1,
                i = !1,
                r = 0,
                o = 0,
                l = z ? x(T(z)) : -1 / 0,
                c = U ? x(T(U)) : 1 / 0
              if (C(e)) return e
              if ((e < l && (e = l), c < e && (e = c), (n = a = e), 2 !== t))
                for (s = C(a, !0); !s && a < c && r < 100; ) ((s = C((a = new Date(a.getTime() + 864e5)), !0)), r++)
              if (1 !== t) for (i = C(n, !0); !i && l < n && o < 100; ) ((i = C((n = new Date(n.getTime() - 864e5)), !0)), o++)
              return 1 === t && s ? a : 2 === t && i ? n : y(e, a) ? a : y(e, n) ? n : o <= r && i ? n : a
            })(x(s), r),
            d = T(c),
            u = [],
            m = {},
            h = se.y(c),
            p = se.m(c),
            f = A.getMaxDayOfMonth(h, p),
            v = !0,
            b = !0
          if (
            (pa.each(['dd', 'y', 'm', 'd', 'tt', 'a', 'h', 'i', 's'], function (e, a) {
              var t = te[a],
                n = ae[a],
                s = se[a](c)
              if (
                ((u[M[a]] = []),
                v && z && (t = se[a](z)),
                b && U && (n = se[a](U)),
                s < t && (s = t),
                n < s && (s = n),
                'dd' !== a && 'tt' !== a && ((v = v && s == t), (b = b && s == n)),
                void 0 !== M[a])
              ) {
                if ('y' != a && 'dd' != a) for (o = te[a]; o <= ae[a]; o += ne[a]) (o < t || n < o) && u[M[a]].push(o)
                if ('d' == a) {
                  var i = A.getDate(h, p, 1).getDay(),
                    r = {}
                  ;(_(H, h, p, i, f, r, 1),
                    _(L, h, p, i, f, r, 0),
                    pa.each(r, function (e, t) {
                      t && u[M[a]].push(e)
                    }))
                }
              }
            }),
            Y &&
              pa.each(['a', 'h', 'i', 's', 'tt'], function (e, a) {
                var t = se[a](c),
                  n = se.d(c),
                  s = {}
                void 0 !== M[a] &&
                  (w(H, e, a, h, p, n, s, 0),
                  w(L, e, a, h, p, n, s, 1),
                  pa.each(s, function (e, t) {
                    t && u[M[a]].push(e)
                  }),
                  (F[e] = g.getValidValue(M[a], t, r, s)))
              }),
            l && (l._length !== f || ($ && (void 0 === i || i === M.y || i === M.m))))
          ) {
            for ((m[M.d] = l).data = [], t = 1; t <= f; t++)
              ((n = A.getDate(h, p, t).getDay()),
                (a = E.replace(/[my|]/gi, '')
                  .replace(/dd/, (t < 10 ? '0' + t : t) + (A.daySuffix || ''))
                  .replace(/d/, t + (A.daySuffix || ''))),
                l.data.push({
                  value: t,
                  display: /DD/.test(a)
                    ? a.replace(/DD/, '<span class="mbsc-dt-day">' + A.dayNames[n] + '</span>')
                    : a.replace(/D/, '<span class="mbsc-dt-day">' + A.dayNamesShort[n] + '</span>'),
                }))
            ;((g._tempWheelArray[M.d] = d[M.d]), g.changeWheel(m))
          }
          return { disabled: u, valid: d }
        },
      }
    )
  }
  function Ct(k) {
    var f,
      v,
      b,
      a,
      n,
      g,
      l,
      s,
      r,
      e,
      D,
      x,
      T,
      i,
      y,
      C,
      o,
      N,
      c,
      _,
      w,
      E,
      M,
      u,
      O,
      S,
      V,
      d,
      F,
      A,
      I,
      m,
      P,
      h,
      H,
      L,
      z,
      p,
      U,
      Y,
      R,
      $,
      j,
      W,
      B,
      J,
      q,
      K,
      G,
      X,
      Z,
      Q,
      ee,
      te,
      ae,
      ne,
      se,
      ie,
      re,
      oe,
      le,
      ce,
      de,
      ue,
      me,
      he,
      pe,
      fe,
      ve,
      be,
      t,
      ge,
      xe,
      Te = 1,
      ye = this
    function Ce(e) {
      e.hasClass('mbsc-cal-h') || e.addClass('mbsc-cal-h')
    }
    function _e(e) {
      e.hasClass('mbsc-cal-h')
        ? (function (e) {
            e.hasClass('mbsc-cal-h') && (e.removeClass('mbsc-cal-h'), k._onSelectShow())
          })(e)
        : Ce(e)
    }
    function we(e, t, a) {
      ;((e[t] = e[t] || []), e[t].push(a))
    }
    function Me(e, a, n) {
      var s,
        i,
        r,
        o,
        l = re.getYear(a),
        c = re.getMonth(a),
        d = {}
      return (
        e &&
          pa.each(e, function (e, t) {
            if (((s = t.d || t.start || t), (i = s + ''), t.start && t.end))
              for (o = at(st(t.start, u, re)), r = at(st(t.end, u, re)); o <= r; )
                (we(d, o, t), (o = re.getDate(re.getYear(o), re.getMonth(o), re.getDay(o) + 1)))
            else if (ot.test(i))
              for (o = Be(a, !1, +i.replace('w', '')); o <= n; )
                (we(d, o, t), (o = re.getDate(re.getYear(o), re.getMonth(o), re.getDay(o) + 7)))
            else if (rt.test(i))
              if ((i = i.split('/'))[1])
                for (o = re.getDate(l, i[0] - 1, i[1]); o <= n; ) (we(d, o, t), (o = re.getDate(re.getYear(o) + 1, re.getMonth(o), i[1])))
              else for (o = re.getDate(l, c, i[0]); o <= n; ) (we(d, o, t), (o = re.getDate(re.getYear(o), re.getMonth(o) + 1, i[0])))
            else we(d, at(st(s, u, re)), t)
          }),
        d
      )
    }
    function Se(e) {
      var t,
        a,
        n,
        s,
        i = !!p[e] && p[e],
        r = !!U[e] && U[e],
        o = r && r[0].background ? r[0].background : i && i[0].background,
        l = ''
      if (r) for (t = 0; t < r.length; t++) l += (r[t].cssClass || '') + ' '
      if (i) {
        for (n = '<div class="mbsc-cal-marks">', t = 0; t < i.length; t++)
          ((l += ((a = i[t]).cssClass || '') + ' '),
            (n += '<div class="mbsc-cal-mark"' + (a.color ? ' style="background:' + a.color + ';"' : '') + '></div>'))
        n += '</div>'
      }
      return ((s = { marked: i, background: o, cssClass: l, markup: w[e] ? w[e].join('') : d ? n : '' }), va(s, k._getDayProps(e, s)))
    }
    function ke(e) {
      return ' style="' + (L ? 'transform: translateY(' + 100 * e + '%)' : 'left:' + 100 * e * ie + '%') + '"'
    }
    function De(e) {
      return (Je(e, ae - 1) > Y && (e = Je(Y, 1 - ae)), e < B && (e = B), e)
    }
    function Ne(e, t, a) {
      var n = e.color,
        s = e.text
      return (
        '<div data-id="' +
        e._id +
        '" data-index="' +
        t +
        '" class="mbsc-cal-txt" title="' +
        pa('<div>' + s + '</div>').text() +
        '"' +
        (n ? ' style="background:' + n + (a ? ';color:' + lt(n) : '') + ';"' : '') +
        '>' +
        (a ? s : '') +
        '</div>'
      )
    }
    function Ee(e) {
      var t = Be(Je(e, -ne - te), !1),
        a = Be(Je(e, -ne + ae + te - 1), !1)
      ;((a = re.getDate(re.getYear(a), re.getMonth(a), re.getDay(a) + 7 * D)),
        k._onGenMonth(t, a),
        (I = Me(re.invalid, t, a)),
        (ce = Me(re.valid, t, a)),
        (p = Me(re.labels || re.events || re.marked, t, a)),
        (U = Me(re.colors, t, a)),
        (z = k._labels || p || U),
        (V = re.labels || k._labels) &&
          (function () {
            w = {}
            for (
              var g = {},
                x = t,
                e = function () {
                  x.getDay() == O && (g = {})
                  for (var e = $, t = z[x] || [], a = t.length, n = [], s = void 0, i = void 0, r = 0, o = 0, l = 0, c = void 0; r < e; )
                    if (
                      ((s = null),
                      t.forEach(function (e, t) {
                        g[r] == e && ((s = e), (i = t))
                      }),
                      r == e - 1 && (o < a - 1 || (a && l == a && !s)))
                    ) {
                      var d = a - o,
                        u = ((1 < d && re.moreEventsPluralText) || re.moreEventsText).replace(/{count}/, d)
                      ;(d && n.push('<div class="mbsc-cal-txt-more">' + u + '</div>'),
                        s &&
                          ((g[r] = null),
                          s._days.forEach(function (e) {
                            w[e][r] = '<div class="mbsc-cal-txt-more">' + re.moreEventsText.replace(/{count}/, 1) + '</div>'
                          })),
                        o++,
                        r++)
                    } else if (s) (i == l && l++, it(x, st(s.end)) && (g[r] = null), n.push(Ne(s, i)), r++, o++, s._days.push(x))
                    else if (l < a) {
                      var m = t[l],
                        h = m.start && st(m.start),
                        p = m.end && st(m.end),
                        f = x.getDay(),
                        v = 0 < O - f ? 7 : 0,
                        b = p && !it(h, p)
                      ;((h && !it(x, h) && f != O) ||
                        (void 0 === m._id && (m._id = Te++),
                        b && (g[r] = m),
                        (m._days = [x]),
                        (c = b ? 100 * Math.min(tt(x, at(p)) + 1, 7 + O - f - v) : 100),
                        n.push(
                          b ? '<div class="mbsc-cal-txt-w" style="width:' + c + '%">' + Ne(m, l, !0) + '</div>' + Ne(m, l) : Ne(m, l, !0),
                        ),
                        r++,
                        o++),
                        l++)
                    } else (n.push('<div class="mbsc-cal-txt-ph"></div>'), r++)
                  ;((w[x] = n), (x = re.getDate(re.getYear(x), re.getMonth(x), re.getDay(x) + 1)))
                };
              x < a;
            )
              e()
          })())
    }
    function Oe(e) {
      var t = re.getYear(e),
        a = re.getMonth(e)
      ;(Ue((r = _ = e)),
        le('onMonthChange', { year: t, month: a }),
        le('onMonthLoading', { year: t, month: a }),
        le('onPageChange', { firstDay: e }),
        le('onPageLoading', { firstDay: e }),
        Ee(e))
    }
    function Ve(e) {
      var t = re.getYear(e),
        a = re.getMonth(e)
      ;(void 0 === ee ? Fe(e, t, a) : Pe(e, ee, !0), He(r, M.focus), (M.focus = !1))
    }
    function Fe(e, t, a) {
      var n = M.$scroller
      ;(pa('.mbsc-cal-slide', n).removeClass('mbsc-cal-slide-a'),
        pa('.mbsc-cal-slide', n)
          .slice(te, te + ae)
          .addClass('mbsc-cal-slide-a'),
        pa('.mbsc-cal-slide-a .mbsc-cal-day', n)
          .on('mouseenter', function () {
            ue || le('onCellHoverIn', Re(pa(this)))
          })
          .on('mouseleave', function () {
            ue || le('onCellHoverOut', Re(pa(this)))
          }),
        V &&
          pa('.mbsc-cal-slide-a .mbsc-cal-txt', n)
            .on('mouseenter', function () {
              var e = pa(this).attr('data-id')
              pa('.mbsc-cal-txt[data-id="' + e + '"]', n).addClass('mbsc-hover')
            })
            .on('mouseleave', function () {
              pa('.mbsc-cal-txt.mbsc-hover', n).removeClass('mbsc-hover')
            }),
        le('onMonthLoaded', { year: t, month: a }),
        le('onPageLoaded', { firstDay: e }))
    }
    function Ae(e, t) {
      var a,
        n = re.getYear(e),
        s = '<div class="mbsc-cal-slide"' + ke(t) + '><div role="grid" class="mbsc-cal-table"><div role="row" class="mbsc-cal-row">'
      for (a = 0; a < 12; a++)
        (a && a % 3 == 0 && (s += '</div><div role="row" class="mbsc-cal-row">'),
          (s +=
            '<div role="gridcell" tabindex="-1" aria-label="' +
            n +
            '" data-val="' +
            n +
            '" class="mbsc-cal-cell mbsc-btn-e ' +
            (n < K || W < n ? ' mbsc-disabled ' : '') +
            (n == re.getYear(_) ? N : '') +
            '"><div class="mbsc-cal-cell-i mbsc-cal-cell-txt">' +
            n +
            be +
            '</div></div>'),
          n++)
      return (s += '</div></div></div>')
    }
    function Ie(e, t) {
      var a,
        n,
        s,
        i,
        r,
        o,
        l,
        c,
        d,
        u,
        m,
        h,
        p,
        f,
        v,
        b,
        g,
        x = 1,
        T = re.getYear(e),
        y = re.getMonth(e),
        C = re.getDay(e),
        _ = null !== re.defaultValue || k._hasValue ? k.getDate(!0) : null,
        w = re.getDate(T, y, C).getDay(),
        M = 0 < O - w ? 7 : 0,
        S = '<div class="mbsc-cal-slide"' + ke(t) + '><div role="grid" class="mbsc-cal-table"><div role="row" class="mbsc-cal-row">'
      for (b = 0; b < 7 * D; b++)
        ((v = b + O - M),
          (s = (a = re.getDate(T, y, v - w + C)).getFullYear()),
          (i = a.getMonth()),
          (r = a.getDate()),
          (o = re.getMonth(a)),
          (l = re.getDay(a)),
          (f = re.getMaxDayOfMonth(s, i)),
          (c = s + '-' + (i + 1) + '-' + r),
          (u = (d = va({ valid: ((g = a), !(g < B || Y < g || (void 0 !== I[g] && void 0 === ce[g]))), selected: _ && it(_, a) }, Se(a)))
            .valid),
          (m = d.selected),
          (n = d.cssClass),
          (h = new Date(a).setHours(12, 0, 0, 0) === new Date().setHours(12, 0, 0, 0)),
          (p = o !== y),
          (E[c] = d),
          b && b % 7 == 0 && (S += '</div><div role="row" class="mbsc-cal-row">'),
          me &&
            b % 7 == 0 &&
            ('month' == me && p && 1 < x
              ? (x = 1 == r ? 1 : 2)
              : 'year' == me && (x = re.getWeekNumber(re.getDate(s, i, r + ((7 - O + 1) % 7)))),
            (S += '<div role="gridcell" class="mbsc-cal-cell mbsc-cal-week-nr">' + x + '</div>'),
            x++),
          (S +=
            '<div role="gridcell" aria-label="' +
            (h ? re.todayText + ', ' : '') +
            re.dayNames[a.getDay()] +
            ', ' +
            re.monthNames[o] +
            ' ' +
            l +
            ' ' +
            (d.ariaLabel ? ', ' + d.ariaLabel : '') +
            '"' +
            (p && !oe ? ' aria-hidden="true"' : ' data-full="' + c + '"') +
            (p || !u ? ' aria-disabled="true"' : '') +
            (m ? ' aria-selected="true"' : '') +
            (u ? ' tabindex="-1"' : '') +
            ' class="mbsc-cal-cell mbsc-cal-day mbsc-cal-day' +
            (v % 7) +
            ' ' +
            (re.dayClass || '') +
            ' ' +
            (m ? N : '') +
            (h ? ' ' + re.todayClass : '') +
            (n ? ' ' + n : '') +
            (1 == l ? ' mbsc-cal-day-first' : '') +
            (l == f ? ' mbsc-cal-day-last' : '') +
            (p ? ' mbsc-cal-day-diff' : '') +
            (u ? ' mbsc-btn-e' : ' mbsc-disabled') +
            (d.marked ? ' mbsc-cal-day-marked' : '') +
            (d.background ? ' mbsc-cal-day-colored' : '') +
            '"><div class="mbsc-cal-cell-i mbsc-cal-day-i"><div class="mbsc-cal-day-date mbsc-cal-cell-txt"' +
            (d.background ? ' style="background:' + d.background + ';color:' + lt(d.background) + '"' : '') +
            '>' +
            l +
            '</div>' +
            (d.markup ? '<div class="mbsc-cal-day-markup">' + d.markup + '</div>' : '') +
            '</div></div>'))
      return (S += '</div></div></div>')
    }
    function Pe(e, t, a) {
      var n,
        s = re.getYear(e),
        i = re.getMonth(e),
        r = M ? M.pos : 0,
        o = ''
      if (((E = {}), D))
        for (t || (le('onMonthLoading', { year: s, month: i }), le('onPageLoading', { firstDay: e })), Ee(e), n = 0; n < se; n++)
          o += Ie(Je(e, n - ne - te), r * ie + n - te)
      return ((ee = void 0), a && M && ((M.$active = null), M.$scroller.html(o), Fe(e, s, i)), o)
    }
    function He(e, t) {
      if (M) {
        var a = M.$active
        ;(a && a.length && (a[0].blur(), a.hasClass('mbsc-disabled') ? a.removeAttr('tabindex') : a.attr('tabindex', '-1')),
          (M.$active = pa('.mbsc-cal-slide-a .mbsc-cal-day[data-full="' + nt(e) + '"]', M.$scroller).attr('tabindex', '0')),
          t && M.$active.length && M.$active[0].focus())
      }
    }
    function Le(e, t) {
      ;(pa('.mbsc-selected', t).removeClass(N).removeAttr('aria-selected'),
        pa('.mbsc-cal-cell[data-val="' + e + '"]', t)
          .addClass(N)
          .attr('aria-selected', 'true'))
    }
    function ze(e, t, a, n) {
      var s, i
      de &&
        (e < B && (e = B),
        Y < e && (e = Y),
        ('calendar' !== de && F && !t) ||
          ((k._isSetDate = !t),
          S &&
            D &&
            ((i = Be(De(e), h)),
            Q &&
              (e < Je(_, -ne) || e >= Je(_, ae - ne)) &&
              (s = h ? re.getMonth(i) - re.getMonth(_) + 12 * (re.getYear(i) - re.getYear(_)) : Math.floor(tt(_, i) / (7 * D))) &&
              ((M.queue = []), (M.focus = n && a), Ke(M, s, a)),
            (s && a) || He(e, n),
            t ||
              (function (e) {
                var t = M && M.$scroller
                re.highlight &&
                  M &&
                  (pa('.mbsc-selected', t).removeClass(N).removeAttr('aria-selected'),
                  (null === re.defaultValue && !k._hasValue) ||
                    pa('.mbsc-cal-day[data-full="' + nt(e) + '"]', t)
                      .addClass(N)
                      .attr('aria-selected', 'true'))
              })(e),
            h || Ue(e, !0),
            (r = e),
            (Q = !0)),
          k._onSetDate(e, s),
          (k._isSetDate = !1)))
    }
    function Ue(e, t) {
      var a,
        n,
        s,
        i = re.getYear(e),
        r = re.getMonth(e),
        o = i + be
      if (A) {
        if (
          (Le(r, Z.$scroller),
          Le(i, ve.$scroller),
          Ke(ve, Math.floor(i / 12) - Math.floor(re.getYear(ve.first) / 12), !0),
          pa('.mbsc-cal-cell', Z.$scroller).removeClass('mbsc-disabled'),
          i === K)
        )
          for (a = 0; a < q; a++) pa('.mbsc-cal-cell[data-val="' + a + '"]', Z.$scroller).addClass('mbsc-disabled')
        if (i === W) for (a = j + 1; a <= 12; a++) pa('.mbsc-cal-cell[data-val="' + a + '"]', Z.$scroller).addClass('mbsc-disabled')
      }
      for (
        t ||
          (Ye(pa('.mbsc-cal-prev-m', v), Je(e, -ne) <= B),
          Ye(pa('.mbsc-cal-next-m', v), Je(e, ae - ne) > Y),
          Ye(pa('.mbsc-cal-prev-y', v), re.getDate(i - 1, r + 1, 1) <= B),
          Ye(pa('.mbsc-cal-next-y', v), re.getDate(i + 1, r, 1) > Y)),
          l.attr('aria-label', i).html(o),
          a = 0;
        a < ae;
        a++
      )
        ((e = re.getDate(i, r - ne + a, 1)),
          (n = re.getYear(e)),
          (s = re.getMonth(e)),
          (o = n + be),
          b
            .eq(a)
            .attr('aria-label', re.monthNames[s] + (pe ? '' : ' ' + i))
            .html((!pe && fe < G ? o + ' ' : '') + X[s] + (!pe && G < fe ? ' ' + o : '')))
    }
    function Ye(e, t) {
      t ? e.addClass(o).attr('aria-disabled', 'true') : e.removeClass(o).removeAttr('aria-disabled')
    }
    function Re(e) {
      var t = e[0],
        a = e.attr('data-full'),
        n = a ? a.split('-') : [],
        s = et(n[0], n[1] - 1, n[2]),
        i = e.hasClass('mbsc-selected')
      return va(E[a], { date: s, target: t, selected: i })
    }
    function $e(e, t) {
      var a = k.getDate(!0),
        n = Re(e),
        s = e[0],
        i = n.date,
        r = et(i.getFullYear(), i.getMonth(), i.getDate(), a.getHours(), a.getMinutes(), a.getSeconds()),
        o = pa(t.target),
        l = o[0]
      if (oe || !e.hasClass('mbsc-cal-day-diff')) {
        if (((n.date = r), V && s.contains(l)))
          for (; l != s; ) {
            if (o.hasClass('mbsc-cal-txt') || o.hasClass('mbsc-cal-txt-more')) {
              var c = o.attr('data-index'),
                d = z[i]
              if (!1 === le('onLabelTap', { date: r, domEvent: t, target: o[0], labels: d, label: d[c] })) return
              break
            }
            l = (o = o.parent())[0]
          }
        !1 === le('onDayChange', n) || re.readonly || e.hasClass('mbsc-disabled') || k._selectDay(e, i, r, n.selected)
      }
    }
    function je(e) {
      ;(Ce(a), ze(re.getDate(re.getYear(M.first), e.attr('data-val'), 1), !0, !0))
    }
    function We(e) {
      ;(Ce(s), ze(re.getDate(e.attr('data-val'), re.getMonth(M.first), 1), !0, !0))
    }
    function Be(e, t, a) {
      var n = re.getYear(e),
        s = re.getMonth(e),
        i = e.getDay(),
        r = 0 < O - i ? 7 : 0
      return t ? re.getDate(n, s, 1) : re.getDate(n, s, (void 0 === a ? O : a) - r - i + re.getDay(e))
    }
    function Je(e, t) {
      var a = re.getYear(e),
        n = re.getMonth(e),
        s = re.getDay(e)
      return h ? re.getDate(a, n + t, 1) : re.getDate(a, n, s + t * D * 7)
    }
    function qe(e, t) {
      var a = 12 * Math.floor(re.getYear(e) / 12)
      return re.getDate(a + 12 * t, 0, 1)
    }
    function Ke(e, t, a, n) {
      t &&
        k._isVisible &&
        (e.queue.push(arguments),
        1 == e.queue.length &&
          (function n(s, i, e, r) {
            var o,
              l,
              t = '',
              c = s.$scroller,
              d = s.buffer,
              u = s.offset,
              a = s.pages,
              m = s.total,
              h = s.first,
              p = s.genPage,
              f = s.getFirst,
              v = 0 < i ? Math.min(i, d) : Math.max(i, -d),
              b = s.pos * ie + v - i + u,
              g = Math.abs(i) > d
            s.callback && (s.load(), s.callback(!0))
            s.first = f(h, i)
            s.pos += v * ie
            s.changing = !0
            s.load = function () {
              if (g) {
                for (o = 0; o < a; o++) t += p(f(h, (l = i + o - u)), b + l)
                0 < i
                  ? (pa('.mbsc-cal-slide', c).slice(-a).remove(), c.append(t))
                  : i < 0 && (pa('.mbsc-cal-slide', c).slice(0, a).remove(), c.prepend(t))
              }
            }
            s.callback = function (e) {
              var t = Math.abs(v),
                a = ''
              if (k._isVisible) {
                for (o = 0; o < t; o++) a += p(f(h, (l = i + o - u - d + (0 < i ? m - t : 0))), b + l)
                if (
                  (0 < i
                    ? (c.append(a), pa('.mbsc-cal-slide', c).slice(0, v).remove())
                    : i < 0 && (c.prepend(a), pa('.mbsc-cal-slide', c).slice(v).remove()),
                  g)
                ) {
                  for (a = '', o = 0; o < t; o++) a += p(f(h, (l = i + o - u - d + (0 < i ? 0 : m - t))), b + l)
                  0 < i
                    ? (pa('.mbsc-cal-slide', c).slice(0, v).remove(), c.prepend(a))
                    : i < 0 && (pa('.mbsc-cal-slide', c).slice(v).remove(), c.append(a))
                }
                ;(Xe(s),
                  r && !e && r(),
                  (s.callback = null),
                  (s.load = null),
                  s.queue.shift(),
                  (g = !1),
                  s.queue.length ? n.apply(this, s.queue[0]) : ((s.changing = !1), s.onAfterChange(s.first)))
              }
            }
            s.onBeforeChange(s.first)
            s.load && (s.load(), s.scroller.scroll(-s.pos * s.size, e ? 200 : 0, !1, s.callback))
          })(e, t, a, n))
    }
    function Ge(e, t, a, n, s, i, r, o, l, c, d, u, m) {
      var h = L ? 'Y' : 'X',
        p = {
          $scroller: pa('.mbsc-cal-scroll', e),
          queue: [],
          buffer: n,
          offset: s,
          pages: i,
          first: o,
          total: r,
          pos: 0,
          min: t,
          max: a,
          genPage: u,
          getFirst: m,
          onBeforeChange: c,
          onAfterChange: d,
        }
      return (
        (p.scroller = new pt(e, {
          axis: h,
          easing: '',
          contSize: 0,
          maxSnapScroll: n,
          mousewheel: void 0 === re.mousewheel ? L : re.mousewheel,
          time: 200,
          lock: !0,
          rtl: H,
          stopProp: !1,
          minScroll: 0,
          maxScroll: 0,
          onBtnTap: function (e) {
            ;('touchend' == e.domEvent.type && da(), l(pa(e.target), e.domEvent))
          },
          onAnimationStart: function () {
            p.changing = !0
          },
          onAnimationEnd: function (e) {
            u && Ke(p, Math.round((-p.pos * p.size - e['pos' + h]) / p.size) * ie)
          },
        })),
        k._scrollers.push(p.scroller),
        p
      )
    }
    function Xe(e, t) {
      var a,
        n = 0,
        s = 0,
        i = e.first
      if (!e.changing || !t) {
        if (e.getFirst) {
          for (n = e.buffer, s = e.buffer; s && e.getFirst(i, s + e.pages - e.offset - 1) > e.max; ) s--
          for (; n && e.getFirst(i, 1 - n - e.offset) <= e.min; ) n--
        }
        ;((a = Math.round(x / e.pages)),
          P && a && e.size != a && e.$scroller[L ? 'height' : 'width'](a),
          va(e.scroller.settings, { snap: a, minScroll: (-e.pos * ie - s) * a, maxScroll: (-e.pos * ie + n) * a }),
          (e.size = a),
          e.scroller.refresh())
      }
    }
    function Ze(e) {
      ;(k._onRefresh(e), k._isVisible && S && D && (M && M.changing ? (ee = e) : (Pe(_, e, !0), He(r))))
    }
    return (
      (y = {}),
      (C = []),
      (w = {}),
      (le = k.trigger),
      (xe = va({}, k.settings)),
      (t = (re = va(k.settings, wt, xe)).controls.join(',')),
      (O = re.firstDay),
      (H = re.rtl),
      (te = re.pageBuffer),
      (me = re.weekCounter),
      (D = re.weeks),
      (h = 6 == D),
      (L = 'vertical' == re.calendarScroll),
      (i = k._getRespCont()),
      (he = 'full' == re.weekDays ? '' : 'min' == re.weekDays ? 'Min' : 'Short'),
      (ge = re.layout || ('inline' == re.display || (/top|bottom/.test(re.display) && re.touchUi) ? 'liquid' : '')),
      (T = (P = 'liquid' == ge) ? null : re.calendarWidth),
      (ie = H && !L ? -1 : 1),
      (o = 'mbsc-disabled ' + (re.disabledClass || '')),
      (c = 'mbsc-selected ' + (re.selectedTabClass || '')),
      (N = 'mbsc-selected ' + (re.selectedClass || '')),
      ($ = Math.max(1, Math.floor(((re.calendarHeight || 0) / D - 45) / 18))),
      t.match(/calendar/) && ((y.calendar = 1), (S = !0)),
      t.match(/date/) && !S && (y.date = 1),
      t.match(/time/) && (y.time = 1),
      re.controls.forEach(function (e) {
        y[e] && C.push(e)
      }),
      (A = re.quickNav && S && h),
      (pe = re.yearChange && h),
      P && S && 'center' == re.display && (k._isFullScreen = !0),
      (re.layout = ge),
      (re.preset = (y.date || S ? 'date' : '') + (y.time ? 'time' : '')),
      (e = yt.call(this, k)),
      (X = pe ? re.monthNamesShort : re.monthNames),
      (be = re.yearSuffix || ''),
      (G = (re.dateWheels || re.dateFormat).search(/m/i)),
      (fe = (re.dateWheels || re.dateFormat).search(/y/i)),
      (u = k._format),
      re.min && ((B = at(st(re.min, u, re))), (K = re.getYear(B)), (q = re.getMonth(B)), (J = re.getDate(12 * Math.floor(K / 12), 0, 1))),
      re.max && ((Y = at(st(re.max, u, re))), (W = re.getYear(Y)), (j = re.getMonth(Y)), (R = re.getDate(12 * Math.floor(W / 12), 0, 1))),
      (k.refresh = function () {
        Ze(!1)
      }),
      (k.redraw = function () {
        Ze(!0)
      }),
      (k.navigate = function (e, t) {
        ze(st(e, u, re), !0, t)
      }),
      (k.changeTab = function (e) {
        k._isVisible &&
          y[e] &&
          de != e &&
          ((de = e),
          pa('.mbsc-cal-tab', v).removeClass(c).removeAttr('aria-selected'),
          pa('.mbsc-cal-tab[data-control="' + e + '"]', v)
            .addClass(c)
            .attr('aria-selected', 'true'),
          F && (g.addClass('mbsc-cal-h'), y[de].removeClass('mbsc-cal-h')),
          'calendar' == de && ze(k.getDate(!0), !1, !0),
          k._showDayPicker(),
          k.trigger('onTabChange', { tab: de }))
      }),
      (k._checkSize = !0),
      (k._onGenMonth = ra),
      (k._onSelectShow = ra),
      (k._onSetDate = ra),
      (k._onRefresh = ra),
      (k._getDayProps = ra),
      (k._prepareObj = Me),
      (k._showDayPicker = function () {
        A && (Ce(s), Ce(a))
      }),
      (k._selectDay = k.__selectDay =
        function (e, t, a) {
          var n = k.live
          ;((Q = re.outerMonthChange), (m = !0), k.setDate(a, n, 1e3, !n, !0), n && le('onSet', { valueText: k._value }))
        }),
      (k._checkBtn = Ye),
      va(e, {
        labels: null,
        compClass: 'mbsc-calendar mbsc-dt mbsc-sc',
        onMarkupReady: function (e) {
          var t = 0
          ;((v = pa(e.target)),
            (n = pa('.mbsc-fr-c', v)),
            (r = k.getDate(!0)),
            (x = 0),
            S &&
              ((d = !((!re.marked && !re.data) || re.labels || re.multiLabel || re.showEventCount)),
              (Q = !0),
              (de = 'calendar'),
              (ae = 'auto' == re.months ? Math.max(1, Math.min(3, Math.floor((T || Qe(i)) / 280))) : +re.months),
              (se = ae + 2 * te),
              (L = L && ae < 2),
              (oe = void (ne = 0) === re.showOuterDays ? ae < 2 && !L : re.showOuterDays),
              (_ = Be(De(r), h)),
              n.append(
                (function () {
                  var e,
                    t,
                    a,
                    n,
                    s,
                    i,
                    r = '',
                    o = H ? re.btnCalNextClass : re.btnCalPrevClass,
                    l = H ? re.btnCalPrevClass : re.btnCalNextClass
                  for (
                    s =
                      '<div class="mbsc-cal-btn-w"><div data-step="-1" role="button" tabindex="0" aria-label="' +
                      re.prevMonthText +
                      '" class="' +
                      o +
                      ' mbsc-cal-prev mbsc-cal-prev-m mbsc-cal-btn mbsc-fr-btn mbsc-fr-btn-e"></div>',
                      t = 0;
                    t < (D ? ae : 1);
                    t++
                  )
                    s += '<div role="button" class="mbsc-cal-month"></div>'
                  if (
                    ((s +=
                      '<div data-step="1" role="button" tabindex="0" aria-label="' +
                      re.nextMonthText +
                      '" class="' +
                      l +
                      ' mbsc-cal-next mbsc-cal-next-m mbsc-cal-btn mbsc-fr-btn mbsc-fr-btn-e"></div></div>'),
                    pe &&
                      (r =
                        '<div class="mbsc-cal-btn-w"><div data-step="-12" role="button" tabindex="0" aria-label="' +
                        re.prevYearText +
                        '" class="' +
                        o +
                        ' mbsc-cal-prev mbsc-cal-prev-y mbsc-cal-btn mbsc-fr-btn mbsc-fr-btn-e"></div><div role="button" class="mbsc-cal-year"></div><div data-step="12" role="button" tabindex="0" aria-label="' +
                        re.nextYearText +
                        '" class="' +
                        l +
                        ' mbsc-cal-next mbsc-cal-next-y mbsc-cal-btn mbsc-fr-btn mbsc-fr-btn-e"></div></div>'),
                    D && (i = Pe(_)),
                    (e =
                      '<div class="mbsc-w-p mbsc-cal-c"><div class="mbsc-cal ' +
                      (h ? '' : ' mbsc-cal-week-view') +
                      (1 < ae ? ' mbsc-cal-multi ' : '') +
                      (me ? ' mbsc-cal-weeks ' : '') +
                      (L ? ' mbsc-cal-vertical' : '') +
                      (d ? ' mbsc-cal-has-marks' : '') +
                      (V ? ' mbsc-cal-has-labels' : '') +
                      (oe ? '' : ' mbsc-cal-hide-diff ') +
                      (re.calendarClass || '') +
                      '"' +
                      (P ? '' : ' style="width:' + (T || 280 * ae) + 'px;"') +
                      '><div class="mbsc-cal-hdr">' +
                      (fe < G || 1 < ae ? r + s : s + r) +
                      '</div>'),
                    D)
                  ) {
                    for (
                      e += '<div class="mbsc-cal-body"><div class="mbsc-cal-day-picker"><div class="mbsc-cal-days-c">', a = 0;
                      a < ae;
                      a++
                    ) {
                      for (e += '<div class="mbsc-cal-days">', t = 0; t < 7; t++)
                        e +=
                          '<div class="mbsc-cal-week-day' +
                          (n = (t + O) % 7) +
                          '" aria-label="' +
                          re.dayNames[n] +
                          '">' +
                          re['dayNames' + he][n] +
                          '</div>'
                      e += '</div>'
                    }
                    e +=
                      '</div><div class="mbsc-cal-scroll-c mbsc-cal-day-scroll-c ' +
                      (re.calendarClass || '') +
                      '"' +
                      (re.calendarHeight ? ' style="height:' + re.calendarHeight + 'px"' : '') +
                      '><div class="mbsc-cal-scroll" style="width:' +
                      100 / ae +
                      '%">' +
                      i +
                      '</div></div>'
                  }
                  if (((e += '</div>'), A)) {
                    for (
                      e +=
                        '<div class="mbsc-cal-month-picker mbsc-cal-picker mbsc-cal-h"><div class="mbsc-cal-scroll-c ' +
                        (re.calendarClass || '') +
                        '"><div class="mbsc-cal-scroll">',
                        t = 0;
                      t < 3;
                      t++
                    ) {
                      for (
                        e +=
                          '<div class="mbsc-cal-slide"' +
                          ke(t - 1) +
                          '><div role="grid" class="mbsc-cal-table"><div role="row" class="mbsc-cal-row">',
                          a = 0;
                        a < 12;
                        a++
                      )
                        (a && a % 3 == 0 && (e += '</div><div role="row" class="mbsc-cal-row">'),
                          (e +=
                            '<div role="gridcell"' +
                            (1 == t ? ' tabindex="-1" aria-label="' + re.monthNames[a] + '" data-val="' + a + '"' : '') +
                            ' class="mbsc-cal-cell' +
                            (1 == t ? ' mbsc-btn-e' : '') +
                            '"><div class="mbsc-cal-cell-i mbsc-cal-cell-txt">' +
                            (1 == t ? re.monthNamesShort[a] : '&nbsp;') +
                            '</div></div>'))
                      e += '</div></div></div>'
                    }
                    for (
                      e += '</div></div></div>',
                        e +=
                          '<div class="mbsc-cal-year-picker mbsc-cal-picker mbsc-cal-h"><div class="mbsc-cal-scroll-c ' +
                          (re.calendarClass || '') +
                          '"><div class="mbsc-cal-scroll">',
                        t = -1;
                      t < 2;
                      t++
                    )
                      e += Ae(qe(_, t), t)
                    e += '</div></div></div>'
                  }
                  return (e += '</div></div></div>')
                })(),
              ),
              (b = pa('.mbsc-cal-month', v)),
              (l = pa('.mbsc-cal-year', v)),
              (f = pa('.mbsc-cal-day-scroll-c', v))),
            A && ((s = pa('.mbsc-cal-year-picker', v)), (a = pa('.mbsc-cal-month-picker', v))),
            (g = pa('.mbsc-w-p', v)),
            1 < C.length &&
              n.before(
                (function () {
                  var a, n
                  return (
                    (a = '<div class="mbsc-cal-tabs-c"><div class="mbsc-cal-tabs" role="tablist">'),
                    C.forEach(function (e, t) {
                      ;((n = re[('calendar' == e ? 'date' : e) + 'Text']),
                        (a +=
                          '<div role="tab" aria-controls="' +
                          ye.id +
                          '-mbsc-pnl-' +
                          t +
                          '" class="mbsc-cal-tab mbsc-fr-btn-e ' +
                          (t ? '' : c) +
                          '" data-control="' +
                          e +
                          '"' +
                          (re.tabLink ? '><a href="#">' + n + '</a>' : ' tabindex="0">' + n) +
                          '</div>'))
                    }),
                    (a += '</div></div>')
                  )
                })(),
              ),
            ['date', 'time', 'calendar'].forEach(function (e) {
              y[e] ? ((y[e] = g.eq(t)), t++) : 'date' == e && !y.date && S && (g.eq(t).remove(), t++)
            }),
            C.forEach(function (e) {
              n.append(y[e])
            }),
            !S && y.date && y.date.css('position', 'relative'),
            (k._scrollers = []),
            (function () {
              if (S && D) {
                var e = pa('.mbsc-cal-scroll-c', v)
                ;((M = Ge(e[0], B, Y, te, ne, ae, se, _, $e, Oe, Ve, Ie, Je)),
                  A &&
                    ((Z = Ge(e[1], null, null, 1, 0, 1, 3, _, je)),
                    (ve = Ge(e[2], J, R, 1, 0, 1, 3, _, We, ra, ra, Ae, qe)),
                    k.tap(b, function () {
                      ;(_e(a), Ce(s))
                    }),
                    k.tap(l, function () {
                      ;(_e(s), Ce(a))
                    })),
                  ct(pa('.mbsc-cal-btn', v), function (e, t, a, n) {
                    Ke(M, t, !0, n)
                  }),
                  Ve(_),
                  (null === re.defaultValue && !k._hasValue) || k._multiple || (k._activeElm = M.$active[0]),
                  f
                    .on('touchstart mousedown', function (e) {
                      ue = 'touchstart' === e.type
                    })
                    .on('keydown', function (e) {
                      var t,
                        a = re.getYear(r),
                        n = re.getMonth(r),
                        s = re.getDay(r)
                      switch (e.keyCode) {
                        case 32:
                          $e(M.$active, e)
                          break
                        case 37:
                          t = re.getDate(a, n, s - 1 * ie)
                          break
                        case 39:
                          t = re.getDate(a, n, s + 1 * ie)
                          break
                        case 38:
                          t = re.getDate(a, n, s - 7)
                          break
                        case 40:
                          t = re.getDate(a, n, s + 7)
                          break
                        case 36:
                          t = re.getDate(a, n, 1)
                          break
                        case 35:
                          t = re.getDate(a, n + 1, 0)
                          break
                        case 33:
                          t = e.altKey ? re.getDate(a - 1, n, s) : h ? re.getDate(a, n - 1, s) : re.getDate(a, n, s - 7 * D)
                          break
                        case 34:
                          t = e.altKey ? re.getDate(a + 1, n, s) : h ? re.getDate(a, n + 1, s) : re.getDate(a, n, s + 7 * D)
                      }
                      t && (e.preventDefault(), ze(t, !0, !1, !0))
                    }))
              }
              k.tap(pa('.mbsc-cal-tab', v), function () {
                k.changeTab(pa(this).attr('data-control'))
              })
            })())
        },
        onShow: function () {
          S && D && Ue(h ? _ : r)
        },
        onHide: function () {
          ;(k._scrollers.forEach(function (e) {
            e.destroy()
          }),
            (de = ve = Z = M = E = null))
        },
        onValidated: function (e) {
          var t,
            a,
            n = e.index,
            s = k._order
          ;((a = k.getDate(!0)),
            m ? (t = 'calendar') : void 0 !== n && (t = s.dd == n || s.d == n || s.m == n || s.y == n ? 'date' : 'time'),
            le('onSetDate', { date: a, control: t }),
            'time' !== t && ze(a, !1, !!e.time, m && !k._multiple),
            (m = !1))
        },
        onPosition: function (e) {
          var t,
            a,
            n,
            s,
            i,
            r,
            o,
            l = e.oldHeight,
            c = e.windowHeight
          if (
            ((F = (e.hasTabs || !0 === re.tabs || (!1 !== re.tabs && P)) && 1 < C.length),
            P && (e.windowWidth >= re.breakPointMd ? pa(e.target).addClass('mbsc-fr-md') : pa(e.target).removeClass('mbsc-fr-md')),
            F
              ? (v.addClass('mbsc-cal-tabbed'),
                (de = pa('.mbsc-cal-tab.mbsc-selected', v).attr('data-control')),
                g.addClass('mbsc-cal-h'),
                y[de].removeClass('mbsc-cal-h'))
              : (v.removeClass('mbsc-cal-tabbed'), g.removeClass('mbsc-cal-h')),
            k._isFullScreen && (f.height(''), (o = c - (i = e.popup.offsetHeight) + f[0].offsetHeight), i <= c && f.height(o)),
            V && D && c != l)
          ) {
            var d = o || f[0].offsetHeight,
              u = f.find('.mbsc-cal-txt-ph')[0],
              m = u.offsetTop,
              h = u.offsetHeight,
              p = Math.max(1, Math.floor((d / D - m) / (h + 2)))
            $ != p && (($ = p), k.redraw())
          }
          if (S && D) {
            if (((s = (r = P || L || F ? f[0][L ? 'offsetHeight' : 'offsetWidth'] : T || 280 * ae) != x), (x = r), P && s && pe))
              for (
                X = re.maxMonthWidth > b[0].offsetWidth ? re.monthNamesShort : re.monthNames, a = re.getYear(_), n = re.getMonth(_), t = 0;
                t < ae;
                t++
              )
                b.eq(t).text(X[re.getMonth(re.getDate(a, n - ne + t, 1))])
            s && Xe(M, !0)
          }
          A && s && (Xe(Z, !0), Xe(ve, !0))
        },
      })
    )
  }
  var _t = {
      separator: ' ',
      dateFormat: 'mm/dd/yy',
      dateDisplay: 'MMddyy',
      timeFormat: 'h:ii A',
      dayText: 'Day',
      monthText: 'Month',
      yearText: 'Year',
      hourText: 'Hours',
      minuteText: 'Minutes',
      ampmText: '&nbsp;',
      secText: 'Seconds',
      nowText: 'Now',
      todayText: 'Today',
    },
    wt = {
      controls: ['calendar'],
      firstDay: 0,
      weekDays: 'short',
      maxMonthWidth: 170,
      breakPointMd: 768,
      months: 1,
      pageBuffer: 1,
      weeks: 6,
      highlight: !0,
      outerMonthChange: !0,
      quickNav: !0,
      yearChange: !0,
      tabs: 'auto',
      todayClass: 'mbsc-cal-today',
      btnCalPrevClass: 'mbsc-ic mbsc-ic-arrow-left6',
      btnCalNextClass: 'mbsc-ic mbsc-ic-arrow-right6',
      dateText: 'Date',
      timeText: 'Time',
      todayText: 'Today',
      fromText: 'Start',
      toText: 'End',
      moreEventsText: '{count} more',
      prevMonthText: 'Previous Month',
      nextMonthText: 'Next Month',
      prevYearText: 'Previous Year',
      nextYearText: 'Next Year',
    },
    Mt = {}
  vt.calendar = function (l) {
    function i(e) {
      var t,
        a,
        n,
        s = null
      if (((v = {}), e && e.length))
        for (a = 0; a < e.length; a++)
          ((t = st(e[a], r, m, m.isoParts)), (s = s || t), (v[et((n = t).getFullYear(), n.getMonth(), n.getDate())] = t))
      return s
    }
    function c() {
      l.redraw()
    }
    var n,
      d,
      r,
      u,
      t,
      e = va({}, l.settings),
      m = va(l.settings, Mt, e),
      h = 'mbsc-selected ' + (m.selectedClass || ''),
      a = m.defaultValue,
      p = 'multiple' == m.select || 1 < m.select || 'week' == m.selectType,
      f = oa(m.select) ? m.select : 1 / 0,
      v = {}
    return (
      (n = Ct.call(this, l)),
      (u = void 0 === m.firstSelectDay ? m.firstDay : m.firstSelectDay),
      (r = l._format),
      p && i(a),
      (l._multiple = p),
      (l._getDayProps = function (e) {
        return { selected: p ? void 0 !== v[e] : void 0 }
      }),
      (l._selectDay = function (e, t, a, n) {
        if (m.setOnDayTap && 'multiple' != m.select && 'inline' != m.display) return (l.setDate(a), void l.select())
        if (p)
          if ('week' == m.selectType) {
            var s,
              i,
              r = t.getDay() - u
            for (r = r < 0 ? 7 + r : r, 'multiple' != m.select && (v = {}), s = 0; s < 7; s++)
              ((i = et(t.getFullYear(), t.getMonth(), t.getDate() - r + s)), n ? delete v[i] : te(v).length / 7 < f && (v[i] = i))
            c()
          } else {
            var o = pa('.mbsc-cal-day[data-full="' + e.attr('data-full') + '"]', d)
            n
              ? (o.removeClass(h).removeAttr('aria-selected'), delete v[t])
              : te(v).length < f && (o.addClass(h).attr('aria-selected', 'true'), (v[t] = t))
          }
        l.__selectDay(e, t, a)
      }),
      (l.setVal = function (e, t, a, n, s) {
        ;(p && (e = i(e)), l._setVal(e, t, a, n, s), p && c())
      }),
      (l.getVal = function (e) {
        var t,
          a = []
        if (p) {
          for (t in v) a.push(we(v[t], m, r))
          return a
        }
        return we(l.getDate(e), m, r)
      }),
      va({}, n, {
        highlight: !p,
        outerMonthChange: !p,
        parseValue: function (e) {
          return (
            p && e && 'string' == typeof e && (e = i(e.split(','))),
            p && a && a.length && (m.defaultValue = a[0]),
            n.parseValue.call(this, e)
          )
        },
        formatValue: function (e) {
          var t,
            a = []
          if (p) {
            for (t in v) a.push(ye(r, v[t], m))
            return a.join(', ')
          }
          return n.formatValue.call(this, e, l)
        },
        onClear: function () {
          p && ((v = {}), c())
        },
        onBeforeShow: function () {
          ;(void 0 !== m.setOnDayTap || (m.buttons && m.buttons.length) || 1 != m.controls.length || (m.setOnDayTap = !0),
            m.setOnDayTap && 'inline' != m.display && (m.outerMonthChange = !1),
            m.counter &&
              p &&
              (m.headerText = function () {
                var e = 0,
                  t = 'week' == m.selectType ? 7 : 1
                return (
                  pa.each(v, function () {
                    e++
                  }),
                  ((1 < (e = Math.round(e / t)) && m.selectedPluralText) || m.selectedText).replace(/{count}/, e)
                )
              }))
        },
        onMarkupReady: function (e) {
          ;(n.onMarkupReady.call(this, e), (d = pa(e.target)), p && (pa('.mbsc-fr-hdr', d).attr('aria-live', 'off'), (t = va({}, v))))
        },
        onCancel: function () {
          !l.live && p && (v = va({}, t))
        },
      })
    )
  }
  var St = e.bool,
    kt = e.func,
    Dt = e.number,
    Nt = {
      controls: e.arrayOf(e.oneOf(['time', 'date', 'calendar'])),
      firstSelectDay: Dt,
      select: e.oneOfType([Dt, e.oneOf(['single', 'multiple'])]),
      selectType: e.oneOf(['day', 'week']),
      setOnDayTap: St,
      onEventSelect: kt,
      onSetDate: kt,
    },
    Et = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { preset: 'calendar' }), t)
      }
      return (l(e, a), e)
    })(xe)
  ;((Et.propTypes = g({}, Et.propTypes, {}, ce, {}, de, {}, he, {}, Nt)), (Z.Calendar = Et))
  var Ot,
    Vt = 'mbsc-input-wrap',
    Ft = ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'mousedown', 'mousemove', 'mouseup', 'mouseleave'],
    At = { tap: Ie }
  function It(e, t) {
    var a = {},
      n = e[0],
      s = e.parent(),
      i = s.find('.mbsc-err-msg'),
      r = e.attr('data-icon-align') || 'left',
      o = e.attr('data-icon')
    ;(s.hasClass(Vt)
      ? (s = s.parent())
      : pa('<span class="' + Vt + '"></span>')
          .insertAfter(e)
          .append(e),
      i && s.find('.' + Vt).append(i),
      o && (-1 !== o.indexOf('{') ? (a = JSON.parse(o)) : (a[r] = o)),
      'file' == n.type && (a.right = e.attr('data-icon-upload') || 'upload'),
      (o || t) &&
        (va(a, t),
        s
          .addClass((a.right ? 'mbsc-ic-right ' : '') + (a.left ? ' mbsc-ic-left' : ''))
          .find('.' + Vt)
          .append('<span class="mbsc-input-fill"></span>')
          .append(a.left ? '<span class="mbsc-input-ic mbsc-left-ic mbsc-ic mbsc-ic-' + a.left + '"></span>' : '')
          .append(a.right ? '<span class="mbsc-input-ic mbsc-right-ic mbsc-ic mbsc-ic-' + a.right + '"></span>' : '')))
  }
  function Pt(e, t, a, n, s) {
    'segmented' == t
      ? e
          .closest('.mbsc-segmented')
          .addClass('box' == a ? 'mbsc-input-box' : '')
          .addClass('outline' == a ? 'mbsc-input-outline' : '')
      : 'button' != t &&
        'submit' != t &&
        (e
          .addClass('mbsc-control-w')
          .addClass('box' == a ? 'mbsc-input-box' : '')
          .addClass('outline' == a ? 'mbsc-input-outline' : '')
          .addClass('inline' == n ? 'mbsc-label-inline' : '')
          .addClass('stacked' == n ? 'mbsc-label-stacked' : '')
          .addClass('floating' == n ? 'mbsc-label-floating' : '')
          .addClass('floating' == n && s.value ? 'mbsc-label-floating-active' : '')
          .find('label')
          .addClass('mbsc-label')
          .each(function (e, t) {
            pa(t).attr('title', pa(t).text())
          }),
        e
          .contents()
          .filter(function () {
            return 3 == this.nodeType && this.nodeValue && /\S/.test(this.nodeValue)
          })
          .each(function () {
            pa('<span class="mbsc-label" title="' + this.textContent.trim() + '"></span>')
              .insertAfter(this)
              .append(this)
          }))
  }
  function Ht(e) {
    var t = Z.themes.form[e]
    return t && t.addRipple ? t : null
  }
  function Lt(e, t, a) {
    var n = e.attr(t)
    return void 0 === n || '' === n ? a : n
  }
  function zt(e) {
    var t = Z.themes.form[e.theme].baseTheme
    return 'mbsc-' + e.theme + (t ? ' mbsc-' + t : '') + (e.rtl ? ' mbsc-rtl' : ' mbsc-ltr')
  }
  var Ut = (function () {
    function e(e, t) {
      var a = this,
        n = va({}, At, Z.settings, t),
        s = pa(e),
        i = s.parent(),
        r = i.hasClass('mbsc-input-wrap') ? i.parent() : i,
        o = s.next().hasClass('mbsc-fr') ? s.next() : null,
        l = ma(s),
        c = Lt(s, 'data-input-style', n.inputStyle),
        d = Lt(s, 'data-label-style', n.labelStyle)
      ;(e.mbscInst && e.mbscInst.destroy(),
        o && o.insertAfter(r),
        (n.theme = Y(n)),
        void 0 === n.rtl && n.lang && Z.i18n[n.lang] && (n.rtl = Z.i18n[n.lang].rtl),
        Pt(r, l, c, d, e),
        s.addClass('mbsc-control'),
        (this._handle = this._handle.bind(this)),
        Ft.forEach(function (e) {
          s.on(e, a._handle)
        }),
        (this.settings = n),
        (this._type = l),
        (this._elm = e),
        (this._$elm = s),
        (this._$parent = r),
        (this._$frame = o),
        (this._ripple = Ht(n.theme)),
        (this._isFloating = 'floating' == d || r.hasClass('mbsc-label-floating')),
        (this.cssClass = zt(n)),
        this.getClassElm().addClass(this.cssClass),
        (e.mbscInst = this))
    }
    var t = e.prototype
    return (
      (t.getClassElm = function () {
        return this._$parent
      }),
      (t.destroy = function () {
        var t = this
        ;(this._$elm.removeClass('mbsc-control'),
          this.getClassElm().removeClass(this.cssClass),
          Ft.forEach(function (e) {
            t._$elm.off(e, t._handle)
          }),
          delete this._elm.mbscInst)
      }),
      (t.option = function (e) {
        va(this.settings, e)
        var t = this.getClassElm()
        ;(this.cssClass && t.removeClass(this.cssClass),
          (this.cssClass = zt(this.settings)),
          t.addClass(this.cssClass),
          (this._ripple = Ht(this.settings.theme)))
      }),
      (t._handle = function (e) {
        switch (e.type) {
          case 'touchstart':
          case 'mousedown':
            this._onStart(e)
            break
          case 'touchmove':
          case 'mousemove':
            this._onMove(e)
            break
          case 'touchend':
          case 'touchcancel':
          case 'mouseup':
          case 'mouseleave':
            this._onEnd(e)
        }
      }),
      (t._addRipple = function (e) {
        this._ripple && this._$rippleElm && this._ripple.addRipple(this._$rippleElm, e)
      }),
      (t._removeRipple = function () {
        this._ripple && this._$rippleElm && this._ripple.removeRipple()
      }),
      (t._onStart = function (e) {
        var t = this._elm
        ;(ga(e, t) &&
          ((this._startX = ua(e, 'X')),
          (this._startY = ua(e, 'Y')),
          Ot && Ot.removeClass('mbsc-active'),
          t.disabled || ((this._isActive = !0), (Ot = this._$elm).addClass('mbsc-active'), this._addRipple(e))),
          'touchstart' == e.type && this._$elm.closest('.mbsc-no-touch').removeClass('mbsc-no-touch'))
      }),
      (t._onMove = function (e) {
        ;((this._isActive && 9 < Math.abs(ua(e, 'X') - this._startX)) || 9 < Math.abs(ua(e, 'Y') - this._startY)) &&
          (this._$elm.removeClass('mbsc-active'), this._removeRipple(), (this._isActive = !1))
      }),
      (t._onEnd = function (e) {
        var t = this,
          a = this._elm,
          n = this._type
        ;(this._isActive && this.settings.tap && 'touchend' == e.type && !a.readOnly && ha(a, n, e),
          this._isActive &&
            setTimeout(function () {
              ;(t._$elm.removeClass('mbsc-active'), t._removeRipple())
            }, 100),
          (this._isActive = !1),
          (Ot = null))
      }),
      e
    )
  })()
  Z.themes.form.mobiscroll = {}
  var Yt = ['focus', 'change', 'blur', 'animationstart'],
    Rt = (function (o) {
      function e(e, t) {
        var a,
          n = (a = o.call(this, e, t) || this)._$elm,
          s = a._$parent,
          i = s.find('.mbsc-select-input, .mbsc-color-input')
        if (
          (!(function (e, t, a) {
            var n = {},
              s = a[0],
              i = a.attr('data-password-toggle'),
              r = a.attr('data-icon-show') || 'eye',
              o = a.attr('data-icon-hide') || 'eye-blocked'
            ;(i && (n.right = 'password' == s.type ? r : o),
              It(a, n),
              i &&
                z(e, t.find('.mbsc-right-ic').addClass('mbsc-input-toggle'), function () {
                  'text' == s.type
                    ? ((s.type = 'password'),
                      pa(this)
                        .addClass('mbsc-ic-' + r)
                        .removeClass('mbsc-ic-' + o))
                    : ((s.type = 'text'),
                      pa(this)
                        .removeClass('mbsc-ic-' + r)
                        .addClass('mbsc-ic-' + o))
                }))
          })(c(a), s, n),
          (a._checkLabel = a._checkLabel.bind(c(a))),
          (a._mouseDown = a._mouseDown.bind(c(a))),
          (a._setText = a._setText.bind(c(a))),
          'file' == e.type)
        ) {
          var r = s.find('.mbsc-file-input')
          ;((a._$input = r.length
            ? r
            : pa(
                '<input type="text" class="' +
                  (n.attr('class') || '') +
                  ' mbsc-file-input" placeholder="' +
                  (n.attr('placeholder') || '') +
                  '"/>',
              ).insertAfter(n)),
            n.on('change', a._setText))
        }
        return (
          s.addClass('mbsc-input').on('mousedown', a._mouseDown),
          Yt.forEach(function (e) {
            n.on(e, a._checkLabel)
          }),
          i.length && (n.after(i), i.hasClass('mbsc-select-input') && ((a._delm = i[0]), a.refresh())),
          a
        )
      }
      l(e, o)
      var t = e.prototype
      return (
        (t._setText = function (e) {
          for (var t = e.target.files, a = [], n = 0; n < t.length; ++n) a.push(t[n].name)
          this._$input.val(a)
        }),
        (t._checkLabel = function (e) {
          if (this._isFloating) {
            var t = this._delm || this._elm
            t.value ||
            document.activeElement === t ||
            (e && ('focus' == e.type || ('animationstart' == e.type && this._$elm.is('*:-webkit-autofill'))))
              ? this._$parent.addClass('mbsc-label-floating-active')
              : this._$parent.removeClass('mbsc-label-floating-active')
          }
        }),
        (t._mouseDown = function (e) {
          document.activeElement === this._elm && e.target !== this._elm && e.preventDefault()
        }),
        (t.refresh = function () {
          this._checkLabel()
        }),
        (t.destroy = function () {
          var t = this
          ;(o.prototype.destroy.call(this),
            this._$parent.off('mousedown', this._mouseDown).removeClass('mbsc-ic-left mbsc-ic-right').find('.mbsc-input-ic').remove(),
            this._$parent.find('.mbsc-input-fill').remove(),
            Yt.forEach(function (e) {
              t._$elm.off(e, t._checkLabel)
            }),
            this._$elm.off('change', this._setText))
        }),
        e
      )
    })(Ut)
  R('[mbsc-input]', Rt)
  var $t = (function (i) {
    function e(e, t) {
      var a,
        n = (a = i.call(this, e, t) || this)._$elm,
        s = n.attr('data-icon')
      return (
        n.addClass('mbsc-btn mbsc-no-touch').find('.mbsc-btn-ic').remove(),
        s &&
          (n.prepend('<span class="mbsc-btn-ic mbsc-ic mbsc-ic-' + s + '"></span>'), '' === n.text() && n.addClass('mbsc-btn-icon-only')),
        (a._$rippleElm = n),
        a
      )
    }
    return (
      l(e, i),
      (e.prototype.getClassElm = function () {
        return this._$elm
      }),
      e
    )
  })(Ut)
  R('[mbsc-button]', $t)
  var jt = (function (n) {
    function e(e, t) {
      var a
      return (
        (a = n.call(this, e, t) || this)._$parent
          .prepend(a._$elm)
          .addClass('mbsc-checkbox mbsc-control-w')
          .find('.mbsc-checkbox-box')
          .remove(),
        a._$elm.after('<span class="mbsc-checkbox-box"></span>'),
        a
      )
    }
    return (l(e, n), e)
  })(Ut)
  R('[mbsc-checkbox]', jt)
  var Wt = (function (n) {
    function e(e, t) {
      var a
      return (
        (a = n.call(this, e, t) || this)._$parent.addClass('mbsc-radio mbsc-control-w').find('.mbsc-radio-box').remove(),
        a._$elm.after('<span class="mbsc-radio-box"><span></span></span>'),
        a
      )
    }
    return (l(e, n), e)
  })(Ut)
  R('[mbsc-radio]', Wt)
  var Bt = (function (o) {
    function e(e, t) {
      var a,
        n = (a = o.call(this, e, t) || this)._$elm,
        s = a._$parent,
        i = s.find('.mbsc-select-input'),
        r = i.length ? i : pa('<input tabindex="-1" class="mbsc-select-input mbsc-control" readonly>')
      return (
        (a._$input = r),
        (a._delm = r[0]),
        (a._setText = a._setText.bind(c(a))),
        s.addClass('mbsc-select' + (a._$frame ? ' mbsc-select-inline' : '')),
        n.after(r),
        r.after('<span class="mbsc-select-ic mbsc-ic mbsc-ic-arrow-down5"></span>'),
        n.on('change', a._setText),
        a._setText(),
        a
      )
    }
    l(e, o)
    var t = e.prototype
    return (
      (t.destroy = function () {
        ;(o.prototype.destroy.call(this), this._$parent.find('.mbsc-select-ic').remove(), this._$elm.off('change', this._setText))
      }),
      (t._setText = function () {
        var e = this._elm,
          t = pa(e)
        ;(t.is('select') && !t.hasClass('mbsc-comp') && this._$input.val(-1 != e.selectedIndex ? e.options[e.selectedIndex].text : ''),
          this.refresh())
      }),
      e
    )
  })(Rt)
  R('[mbsc-dropdown]', Bt)
  var Jt,
    qt = ['change', 'keydown', 'input', 'scroll']
  function Kt() {
    ;(clearTimeout(Jt),
      (Jt = setTimeout(function () {
        pa('textarea.mbsc-control').each(function () {
          Gt(this)
        })
      }, 100)))
  }
  function Gt(e) {
    var t,
      a,
      n,
      s = pa(e).attr('rows') || 6
    e.offsetHeight &&
      ((e.style.height = ''),
      (n = e.scrollHeight - e.offsetHeight),
      (t = e.offsetHeight + (0 < n ? n : 0)),
      s < (a = Math.round(t / 24))
        ? ((t = 24 * s + (t - 24 * a)), pa(e).addClass('mbsc-textarea-scroll'))
        : pa(e).removeClass('mbsc-textarea-scroll'),
      t && (e.style.height = t + 'px'))
  }
  D && pa(window).on('resize orientationchange', Kt)
  var Xt = (function (n) {
    function e(e, t) {
      var a
      return (
        (a = n.call(this, e, t) || this)._$parent.addClass('mbsc-textarea'),
        qt.forEach(function (e) {
          a._$elm.on(e, a._handle)
        }),
        Gt(e),
        a
      )
    }
    l(e, n)
    var t = e.prototype
    return (
      (t.destroy = function () {
        var t = this
        ;(n.prototype.destroy.call(this),
          qt.forEach(function (e) {
            t._$elm.off(e, t._handle)
          }))
      }),
      (t.refresh = function () {
        ;(n.prototype.refresh.call(this), clearTimeout(this._debounce), Gt(this._elm))
      }),
      (t._handle = function (e) {
        switch ((n.prototype._handle.call(this, e), e.type)) {
          case 'change':
            Gt(this._elm)
            break
          case 'keydown':
          case 'input':
            this._onInput(e)
            break
          case 'scroll':
            !(function (e) {
              var t = pa(e)
              if (!t.hasClass('mbsc-textarea-scroll')) {
                var a = e.scrollHeight - e.offsetHeight,
                  n = e.offsetHeight + a
                Math.round(n / 24) <= (t.attr('rows') || 6) && ((e.scrollTop = 0), (e.style.height = n + 'px'))
              }
            })(this._elm)
        }
      }),
      (t._onInput = function () {
        var e = this
        ;(clearTimeout(this._debounce),
          (this._debounce = setTimeout(function () {
            Gt(e._elm)
          }, 100)))
      }),
      e
    )
  })(Rt)
  R('[mbsc-textarea]', Xt)
  var Zt = (function (o) {
    function e(e, t) {
      var a,
        n,
        s,
        i = (a = o.call(this, e, t) || this)._$elm,
        r = a._$parent
      return (
        r.hasClass('mbsc-segmented-item-ready') ||
          ((n = pa('<div class="mbsc-segmented mbsc-no-touch"></div>')),
          r.after(n),
          r
            .parent()
            .find('input[name="' + i.attr('name') + '"]')
            .each(function () {
              var e = pa(this)
              ;((s = e.parent().addClass('mbsc-segmented-item mbsc-segmented-item-ready')),
                pa(
                  '<span class="mbsc-segmented-content">' +
                    (e.attr('data-icon') ? '<span class="mbsc-ic mbsc-ic-' + e.attr('data-icon') + '"></span>' : '') +
                    '</span>',
                )
                  .append(s.contents())
                  .appendTo(s),
                s.prepend(e),
                n.append(s))
            })),
        (a._$rippleElm = i.next()),
        a
      )
    }
    return (
      l(e, o),
      (e.prototype.getClassElm = function () {
        return this._$elm.closest('.mbsc-segmented')
      }),
      e
    )
  })(Ut)
  R('[mbsc-segmented]', Zt)
  function Qt(t, e) {
    var n,
      s,
      i,
      a,
      r,
      o,
      l,
      c,
      d,
      u,
      m,
      h,
      p,
      f,
      v,
      b,
      g = '',
      x = this,
      T = pa(t),
      y = f
    function C() {
      var e
      t.disabled || ((e = parseFloat(pa(this).val())), M(isNaN(e) ? f : e))
    }
    function _() {
      return t.disabled
    }
    function w(e, t) {
      M(f + t * u)
    }
    function M(e, t, a) {
      ;((y = f),
        void 0 === t && (t = !0),
        void 0 === a && (a = t),
        (f = k(e)),
        i.removeClass('mbsc-disabled'),
        t && T.val(f),
        f == o ? s.addClass('mbsc-disabled') : f == r && n.addClass('mbsc-disabled'),
        f !== y && a && T.trigger('change'))
    }
    function S(e, t, a) {
      var n = T.attr(e)
      return void 0 === n || '' === n ? t : a ? n : +n
    }
    function k(e) {
      return +Math.min(r, Math.max(Math.round(e / u) * u, o)).toFixed(d)
    }
    ;(ba.call(this, t, e, !0),
      (x.getVal = function () {
        var e = parseFloat(T.val())
        return k((e = isNaN(e) ? f : e))
      }),
      (x.setVal = function (e, t, a) {
        ;((e = parseFloat(e)), M(isNaN(e) ? f : e, t, a))
      }),
      (x._init = function () {
        ;((v = T.parent().hasClass('mbsc-stepper')),
          (b = v ? T.closest('.mbsc-stepper-cont') : T.parent()),
          (h = x.settings),
          (o = void 0 === e.min ? S('min', h.min) : e.min),
          (r = void 0 === e.max ? S('max', h.max) : e.max),
          (u = void 0 === e.step ? S('step', h.step) : e.step),
          (d = Math.abs(u) < 1 ? (u + '').split('.')[1].length : 0),
          (l = void 0 === e.inputStyle ? S('data-input-style', h.inputStyle, !0) : e.inputStyle),
          (a = T.attr('data-val') || h.val),
          (f = k(+t.value || 0)),
          (p = Z.themes.form[h.theme]),
          (c = p && p.addRipple ? p : null),
          v ||
            b
              .addClass('mbsc-stepper-cont mbsc-no-touch mbsc-control-w')
              .addClass('box' == l ? 'mbsc-input-box' : '')
              .addClass('outline' == l ? 'mbsc-input-outline' : '')
              .append('<span class="mbsc-segmented mbsc-stepper"></span>')
              .find('.mbsc-stepper')
              .append(
                '<span class="mbsc-segmented-item mbsc-stepper-control mbsc-stepper-minus ' +
                  (f == o ? 'mbsc-disabled' : '') +
                  '" data-step="-1" tabindex="0"><span class="mbsc-segmented-content"><span class="mbsc-ic mbsc-ic-minus"></span></span></span>',
              )
              .append(
                '<span class="mbsc-segmented-item mbsc-stepper-control mbsc-stepper-plus ' +
                  (f == r ? 'mbsc-disabled' : '') +
                  '"  data-step="1" tabindex="0"><span class="mbsc-segmented-content"> <span class="mbsc-ic mbsc-ic-plus"></span></span></span>',
              )
              .prepend(T),
          g && b.removeClass(g).find('.mbsc-segmented').removeClass(g),
          (g = 'mbsc-' + h.theme + (p.baseTheme ? ' mbsc-' + p.baseTheme : '') + (h.rtl ? ' mbsc-rtl' : ' mbsc-ltr')),
          b.addClass(g).find('.mbsc-segmented').addClass(g),
          (s = pa('.mbsc-stepper-minus', b)),
          (n = pa('.mbsc-stepper-plus', b)),
          (i = pa('.mbsc-stepper-control', b)),
          v ||
            ('left' == a
              ? (b.addClass('mbsc-stepper-val-left'),
                T.after('<span class="mbsc-segmented-item"><span class="mbsc-segmented-content"></span></span>'))
              : 'right' == a
                ? (b.addClass('mbsc-stepper-val-right'),
                  n.after('<span class="mbsc-segmented-item"><span class="mbsc-segmented-content"></span></span>'))
                : s.after('<span class="mbsc-segmented-item"><span class="mbsc-segmented-content mbsc-stepper-val"></span></span>')),
          m || (T.on('change', C), (m = ct(i, w, 150, _, !1, c))),
          T.val(f).attr('data-role', 'stepper').attr('min', o).attr('max', r).attr('step', u).addClass('mbsc-control'),
          (t.mbscInst = x))
      }),
      (x._destroy = function () {
        ;(T.removeClass('mbsc-control').off('change', C), m.destroy(), delete t.mbscInst)
      }),
      x.init())
  }
  ;((Qt.prototype = { _class: 'stepper', _hasDef: !0, _hasTheme: !0, _hasLang: !0, _defaults: { min: 0, max: 100, step: 1 } }),
    R('[mbsc-stepper]', (W.Stepper = Qt)))
  function ea(t, e, a) {
    var n,
      s,
      i,
      r,
      o = this
    ;(ba.call(this, t, e, !0),
      (o.__init = ra),
      (o.__destroy = ra),
      (o._init = function () {
        var e
        ;((r = o.settings),
          (n = pa(t)),
          (e = !!s),
          (s = (s = n.parent()).hasClass('mbsc-input-wrap') ? s.parent() : s),
          (o._$parent = s),
          i && s.removeClass(i),
          (i = o._css + ' mbsc-progress-w mbsc-control-w ' + zt(r)),
          s.addClass(i),
          n.addClass('mbsc-control'),
          o.__init(),
          e || o._attachChange(),
          o.refresh(),
          (t.mbscInst = o))
      }),
      (o._destroy = function () {
        ;(o.__destroy(), s.removeClass(i), n.removeClass('mbsc-control'), delete t.mbscInst)
      }),
      a || o.init())
  }
  function ta(a, e, t) {
    var n,
      s,
      i,
      l,
      r,
      o,
      c,
      d,
      u,
      m,
      h,
      p,
      f,
      v,
      b,
      g,
      x,
      T,
      y,
      C,
      _,
      w,
      M,
      S,
      k,
      D,
      N,
      E,
      O,
      V,
      F,
      A,
      I,
      P,
      H = this,
      L = new Date()
    function z(e) {
      ;('mousedown' === e.type && e.preventDefault(),
        !ga(e, this) ||
          (d && !x) ||
          a.disabled ||
          a.readOnly ||
          (N.stopProp && e.stopPropagation(),
          (m = M = !(d = !0)),
          (O = ua(e, 'X')),
          (V = ua(e, 'Y')),
          (v = O),
          c.removeClass('mbsc-progress-anim'),
          (s = S ? pa('.mbsc-slider-handle', this) : l),
          i && i.removeClass('mbsc-handle-curr'),
          (i = s.parent().addClass('mbsc-active mbsc-handle-curr')),
          n.addClass('mbsc-active'),
          (g = +s.attr('data-index')),
          (I = c[0].offsetWidth),
          (f = c[0].getBoundingClientRect().left),
          'mousedown' === e.type && ((T = !0), pa(document).on('mousemove', U).on('mouseup', Y)),
          'mouseenter' === e.type && ((x = !0), pa(document).on('mousemove', U))))
    }
    function U(e) {
      d &&
        ((v = ua(e, 'X')),
        (b = ua(e, 'Y')),
        (h = v - O),
        (p = b - V),
        5 < Math.abs(h) && (M = !0),
        (M || T || x) && 50 < Math.abs(L - new Date()) && ((L = new Date()), K(v, N.round, C && (!x || T))),
        M ? e.preventDefault() : 7 < Math.abs(p) && 'touchmove' == e.type && q())
    }
    function Y(e) {
      d &&
        (e.preventDefault(),
        S || c.addClass('mbsc-progress-anim'),
        x && !T ? G(P[g], g, !1, !1, !0) : K(v, !0, !0),
        M || m || ('touchend' == e.type && da(), H._onTap(P[g])),
        'mouseup' == e.type && (T = !1),
        'mouseleave' == e.type && (x = !1),
        x || q())
    }
    function R() {
      d && q()
    }
    function $() {
      var e = H._readValue(pa(this)),
        t = +pa(this).attr('data-index')
      e !== P[t] && ((P[t] = e), G((k[t] = e), t))
    }
    function j(e) {
      e.stopPropagation()
    }
    function W(e) {
      e.preventDefault()
    }
    function B(e) {
      var t
      if (!a.disabled) {
        switch (e.keyCode) {
          case 38:
          case 39:
            t = 1
            break
          case 40:
          case 37:
            t = -1
        }
        t &&
          (e.preventDefault(),
          A ||
            ((g = +pa(this).attr('data-index')),
            G(P[g] + D * t, g, !0),
            (A = setInterval(function () {
              G(P[g] + D * t, g, !0)
            }, 200))))
      }
    }
    function J(e) {
      ;(e.preventDefault(), clearInterval(A), (A = null))
    }
    function q() {
      ;((d = !1), i.removeClass('mbsc-active'), n.removeClass('mbsc-active'), pa(document).off('mousemove', U).off('mouseup', Y))
    }
    function K(e, t, a) {
      var n = t
        ? Math.min((Math[H._rounding || 'round'](Math.max((100 * (e - f)) / I, 0) / E / D) * D * 100) / (_ - w + u), 100)
        : Math.max(0, Math.min((100 * (e - f)) / I, 100))
      ;(y && (n = 100 - n), G(Math.round((w - u + n / E) * F) / F, g, a, n))
    }
    function G(e, t, a, n, s, i) {
      var r = l.eq(t),
        o = r.parent()
      ;((e = Math.min(_, Math.max(e, w))),
        void 0 === i && (i = a),
        H._update
          ? (e = H._update(e, P, t, n, S, s, o))
          : o.css({ left: y ? 'auto' : (n || X(e, w, _)) + '%', right: y ? (n || X(e, w, _)) + '%' : 'auto' }),
        w < e ? o.removeClass('mbsc-slider-start') : (P[t] > w || s) && o.addClass('mbsc-slider-start'),
        a && (P[t] = e),
        a && k[t] != e && ((m = !0), (k[t] = e), H._fillValue(e, t, i)),
        r.attr('aria-valuenow', e))
    }
    ;(ea.call(this, a, e, !0),
      (H._onTap = ra),
      (H.___init = ra),
      (H.___destroy = ra),
      (H._attachChange = function () {
        n.on(N.changeEvent, $)
      }),
      (H.__init = function () {
        var e
        ;(l && ((e = !0), l.parent().remove()),
          H.___init(),
          (o = H._$parent),
          (c = H._$track),
          (n = o.find('input')),
          (N = H.settings),
          (w = H._min),
          (_ = H._max),
          (u = H._base || 0),
          (D = H._step),
          (C = H._live),
          (F = D % 1 != 0 ? 100 / (100 * (D % 1).toFixed(2)) : 1),
          (E = 100 / (_ - w + u) || 100),
          (S = 1 < n.length),
          (y = N.rtl),
          (P = []),
          (k = []),
          n.each(function (e) {
            ;((P[e] = H._readValue(pa(this))), pa(this).attr('data-index', e))
          }),
          (l = o.find('.mbsc-slider-handle')),
          (r = o.find(S ? '.mbsc-slider-handle-cont' : '.mbsc-progress-cont')),
          l.on('keydown', B).on('keyup', J).on('blur', J),
          r
            .on('touchstart mousedown' + (N.hover ? ' mouseenter' : ''), z)
            .on('touchmove', U)
            .on('touchend touchcancel' + (N.hover ? ' mouseleave' : ''), Y)
            .on('pointercancel', R),
          e || (n.on('click', j), o.on('click', W)))
      }),
      (H.__destroy = function () {
        ;(o.off('click', W),
          n.off(N.changeEvent, $).off('click', j),
          l.off('keydown', B).off('keyup', J).off('blur', J),
          r.off('touchstart mousedown mouseenter', z).off('touchmove', U).off('touchend touchcancel mouseleave', Y).off('pointercancel', R),
          H.___destroy())
      }),
      (H.refresh = function () {
        n.each(function (e) {
          G(H._readValue(pa(this)), e, !0, !1, !0, !1)
        })
      }),
      (H.getVal = function () {
        return S ? P.slice(0) : P[0]
      }),
      (H.setVal = H._setVal =
        function (e, t, a) {
          ;(pa.isArray(e) || (e = [e]),
            pa.each(e, function (e, t) {
              P[e] = t
            }),
            pa.each(e, function (e, t) {
              G(t, e, !0, !1, !0, a)
            }))
        }),
      t || H.init())
  }
  function aa(e, t) {
    var n,
      a,
      s,
      i,
      r = this
    ;(va((t = t || {}), { changeEvent: 'click', round: !1 }),
      ta.call(this, e, t, !0),
      (r._readValue = function () {
        return e.checked ? 1 : 0
      }),
      (r._fillValue = function (e, t, a) {
        ;(n.prop('checked', !!e), a && n.trigger('change'))
      }),
      (r._onTap = function (e) {
        r._setVal(e ? 0 : 1)
      }),
      (r.___init = function () {
        ;((s = r.settings),
          (n = pa(e)),
          (a = n.parent()).find('.mbsc-switch-track').remove(),
          a.prepend(n),
          n
            .attr('data-role', 'switch')
            .after(
              '<span class="mbsc-progress-cont mbsc-switch-track"><span class="mbsc-progress-track mbsc-progress-anim"><span class="mbsc-slider-handle-cont"><span class="mbsc-slider-handle mbsc-switch-handle" data-index="0"><span class="mbsc-switch-txt-off">' +
                s.offText +
                '</span><span class="mbsc-switch-txt-on">' +
                s.onText +
                '</span></span></span></span></span>',
            ),
          i && i.destroy(),
          (i = new Ut(e, s)),
          (r._$track = a.find('.mbsc-progress-track')),
          (r._min = 0),
          (r._max = 1),
          (r._step = 1))
      }),
      (r.___destroy = function () {
        i.destroy()
      }),
      (r.getVal = function () {
        return e.checked
      }),
      (r.setVal = function (e, t, a) {
        r._setVal(e ? 1 : 0, t, a)
      }),
      r.init())
  }
  ;((aa.prototype = {
    _class: 'switch',
    _css: 'mbsc-switch',
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: { stopProp: !0, offText: 'Off', onText: 'On' },
  }),
    R('[mbsc-switch]', (W.Switch = aa)))
  function na(s, i, e) {
    var r,
      o,
      l,
      c,
      d,
      u,
      m,
      h,
      p,
      f,
      v,
      b,
      g,
      t,
      x = this
    function a() {
      var e = T('value', m)
      e !== g && n(e)
    }
    function T(e, t, a) {
      var n = o.attr(e)
      return void 0 === n || '' === n ? t : a ? n : +n
    }
    function n(e, t, a, n) {
      ;((e = Math.min(h, Math.max(e, m))),
        c.css('width', (100 * (e - m)) / (h - m) + '%'),
        void 0 === a && (a = !0),
        void 0 === n && (n = a),
        (e === g && !t) || x._display(e),
        e !== g && ((g = e), a && o.attr('value', g), n && o.trigger('change')))
    }
    ;(ea.call(this, s, i, !0),
      (x._display = function (e) {
        ;((t = b && v.returnAffix ? b.replace(/\{value\}/, e).replace(/\{max\}/, h) : e), d && d.html(t), r && r.html(t))
      }),
      (x._attachChange = function () {
        o.on('change', a)
      }),
      (x.__init = function () {
        var e, t, a, n
        if (
          ((v = x.settings),
          (o = pa(s)),
          (n = !!l),
          (l = x._$parent),
          (m = x._min = void 0 === i.min ? T('min', v.min) : i.min),
          (h = x._max = void 0 === i.max ? T('max', v.max) : i.max),
          (p = void 0 === i.inputStyle ? T('data-input-style', v.inputStyle, !0) : i.inputStyle),
          (f = void 0 === i.labelStyle ? T('data-label-style', v.labelStyle, !0) : i.labelStyle),
          (g = T('value', m)),
          (e = o.attr('data-val') || v.val),
          (a = (a = o.attr('data-step-labels')) ? JSON.parse(a) : v.stepLabels),
          (b = o.attr('data-template') || (100 != h || v.template ? v.template : '{value}%')),
          n
            ? (e && (r.remove(), l.removeClass('mbsc-progress-value-' + ('right' == e ? 'right' : 'left'))),
              a && pa('.mbsc-progress-step-label', u).remove())
            : (Pt(l, null, p, f, s),
              It(o),
              l
                .find('.mbsc-input-wrap')
                .append(
                  '<span class="mbsc-progress-cont"><span class="mbsc-progress-track mbsc-progress-anim"><span class="mbsc-progress-bar"></span></span></span>',
                ),
              (c = x._$progress = l.find('.mbsc-progress-bar')),
              (u = x._$track = l.find('.mbsc-progress-track'))),
          o.attr('min', m).attr('max', h),
          e &&
            ((r = pa('<span class="mbsc-progress-value"></span>')),
            l
              .addClass('mbsc-progress-value-' + ('right' == e ? 'right' : 'left'))
              .find('.mbsc-input-wrap')
              .append(r)),
          a)
        )
          for (t = 0; t < a.length; ++t)
            u.append(
              '<span class="mbsc-progress-step-label" style="' +
                (v.rtl ? 'right' : 'left') +
                ': ' +
                (100 * (a[t] - m)) / (h - m) +
                '%" >' +
                a[t] +
                '</span>',
            )
        d = pa(o.attr('data-target') || v.target)
      }),
      (x.__destroy = function () {
        ;(l.removeClass('mbsc-ic-left mbsc-ic-right').find('.mbsc-progress-cont').remove(),
          l.find('.mbsc-input-ic').remove(),
          o.off('change', a))
      }),
      (x.refresh = function () {
        n(T('value', m), !0, !1)
      }),
      (x.getVal = function () {
        return g
      }),
      (x.setVal = function (e, t, a) {
        n(e, !0, t, a)
      }),
      e || x.init())
  }
  ;((na.prototype = {
    _class: 'progress',
    _css: 'mbsc-progress',
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: { min: 0, max: 100, returnAffix: !0 },
  }),
    R('[mbsc-progress]', (W.Progress = na)))
  function _a(e, t, a) {
    var n,
      s,
      o,
      l,
      i,
      c,
      d,
      u,
      m,
      h,
      p,
      r,
      f,
      v = this
    na.call(this, e, t, !0)
    var b = v.__init,
      g = v.__destroy
    ta.call(this, e, t, !0)
    var x = v.__init,
      T = v.__destroy
    ;((v.__init = function () {
      ;(b(), x())
    }),
      (v.__destroy = function () {
        ;(g(), T())
      }),
      (v._update = function (e, t, a, n, s, i, r) {
        return (
          u
            ? 0 === a
              ? ((e = Math.min(e, t[1])),
                o.css({
                  width: X(t[1], p, h) - X(e, p, h) + '%',
                  left: m ? 'auto' : X(e, p, h) + '%',
                  right: m ? X(e, p, h) + '%' : 'auto',
                }))
              : ((e = Math.max(e, t[0])), o.css({ width: X(e, p, h) - X(t[0], p, h) + '%' }))
            : s || !c
              ? r.css({ left: m ? 'auto' : (n || X(e, p, h)) + '%', right: m ? (n || X(e, p, h)) + '%' : 'auto' })
              : o.css('width', (n || X(e, p, h)) + '%'),
          d && l.eq(a).html(e),
          s || (t[a] == e && !i) || v._display(e),
          e
        )
      }),
      (v._readValue = function (e) {
        return +e.val()
      }),
      (v._fillValue = function (e, t, a) {
        ;(n.eq(t).val(e), a && n.eq(t).trigger('change'))
      }),
      (v._markupReady = function () {
        var e, t
        if ((d && s.addClass('mbsc-slider-has-tooltip'), 1 != r))
          for (t = (h - p) / r, e = 0; e <= t; ++e)
            i.append('<span class="mbsc-slider-step" style="' + (m ? 'right' : 'left') + ':' + (100 / t) * e + '%"></span>')
        ;(n.each(function (e) {
          ;('range' == this.type && pa(this).attr('min', p).attr('max', h).attr('step', r),
            (c ? o : i).append(
              '<span class="mbsc-slider-handle-cont' +
                (u && !e ? ' mbsc-slider-handle-left' : '') +
                '"><span tabindex="0" class="mbsc-slider-handle" aria-valuemin="' +
                p +
                '" aria-valuemax="' +
                h +
                '" data-index="' +
                e +
                '"></span>' +
                (d ? '<span class="mbsc-slider-tooltip"></span>' : '') +
                '</span>',
            ))
        }),
          (l = s.find('.mbsc-slider-tooltip')))
      }),
      (v.___init = function () {
        ;(s && (s.removeClass('mbsc-slider-has-tooltip'), 1 != r && pa('.mbsc-slider-step', i).remove()),
          (s = v._$parent),
          (i = v._$track),
          (o = v._$progress),
          (n = s.find('input')),
          (f = v.settings),
          (p = v._min),
          (h = v._max),
          (v._step = r = void 0 === t.step ? +n.attr('step') || f.step : t.step),
          (v._live = I('data-live', f.live, n)),
          (d = I('data-tooltip', f.tooltip, n)),
          (c = I('data-highlight', f.highlight, n) && n.length < 3),
          (u = c && 2 == n.length),
          (m = f.rtl),
          v._markupReady())
      }),
      a || v.init())
  }
  ;((_a.prototype = {
    _class: 'progress',
    _css: 'mbsc-progress mbsc-slider',
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: { changeEvent: 'change', stopProp: !0, min: 0, max: 100, step: 1, live: !0, highlight: !0, round: !0, returnAffix: !0 },
  }),
    R('[mbsc-slider]', (W.Slider = _a)))
  function wa(e, t, a) {
    var r,
      n,
      o,
      s,
      i,
      l,
      c,
      d = this,
      u = pa(e)
    ;(_a.call(this, e, t, !0),
      (d._update = function (e, t, a, n, s, i) {
        return (r.css('width', X(e, 0, o) + '%'), s || (t[a] == e && !i) || d._display(e), e)
      }),
      (d._markupReady = function () {
        var e,
          t = '',
          a = ''
        for (
          n = d._$track,
            r = d._$progress,
            c = d.settings,
            s = d._min,
            o = d._max,
            d._base = s,
            d._rounding = c.rtl ? 'floor' : 'ceil',
            i = u.attr('data-empty') || c.empty,
            l = u.attr('data-filled') || c.filled,
            e = 0;
          e < o;
          ++e
        )
          ((t += '<span class="mbsc-ic mbsc-ic-' + i + '"></span>'), (a += '<span class="mbsc-ic mbsc-ic-' + l + '"></span>'))
        ;(n.html(t),
          n.append(r),
          r.html(a),
          n.append(
            '<span class="mbsc-rating-handle-cont"><span tabindex="0" class="mbsc-slider-handle" aria-valuemin="' +
              s +
              '" aria-valuemax="' +
              o +
              '" data-index="0"></span></span>',
          ))
      }),
      a || d.init())
  }
  ;((wa.prototype = {
    _class: 'progress',
    _css: 'mbsc-progress mbsc-rating',
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: {
      changeEvent: 'change',
      stopProp: !0,
      min: 1,
      max: 5,
      step: 1,
      live: !0,
      round: !0,
      hover: !0,
      highlight: !0,
      returnAffix: !0,
      empty: 'star',
      filled: 'star3',
    },
  }),
    R('[mbsc-rating]', (W.Rating = wa)))
  var Ma = 1,
    Sa = (function () {
      function e(e, t) {
        var a,
          n,
          s,
          i = this,
          r = pa(e)
        if (
          ((this.settings = t),
          (this._isOpen = t.isOpen || !1),
          r.addClass('mbsc-collapsible ' + (this._isOpen ? 'mbsc-collapsible-open' : '')),
          (a = (s = r.hasClass('mbsc-card')
            ? ((n = r.find('.mbsc-card-header').eq(0).addClass('mbsc-collapsible-header')),
              r.find('.mbsc-card-content').eq(0).addClass('mbsc-collapsible-content'))
            : r.hasClass('mbsc-form-group') || r.hasClass('mbsc-form-group-inset')
              ? ((n = r.find('.mbsc-form-group-title').eq(0).addClass('mbsc-collapsible-header')),
                r.find('.mbsc-form-group-content').eq(0).addClass('mbsc-collapsible-content'))
              : ((n = r.find('.mbsc-collapsible-header').eq(0)), r.find('.mbsc-collapsible-content').eq(0)))[0]) &&
            !a.id &&
            (a.id = 'mbsc-collapsible-' + Ma++),
          n.length && a)
        ) {
          var o = pa('<span class="mbsc-collapsible-icon mbsc-ic mbsc-ic-arrow-down5"></span>')
          ;(z(this, n, function () {
            i.collapse()
          }),
            n
              .attr('role', 'button')
              .attr('aria-expanded', this._isOpen)
              .attr('aria-controls', a.id)
              .attr('tabindex', '0')
              .on('mousedown', function (e) {
                e.preventDefault()
              })
              .on('keydown', function (e) {
                ;(32 !== e.which && 13 != e.keyCode) || (e.preventDefault(), i.collapse())
              })
              .append(o))
        }
        ;(((e.mbscInst = this)._$header = n),
          (this._$content = s),
          (this._$elm = r),
          (this._$accordionParent = r.parent('[mbsc-accordion], mbsc-accordion, .mbsc-accordion')),
          (this.show = this.show.bind(this)),
          (this.hide = this.hide.bind(this)),
          (this.toggle = this.toggle.bind(this)))
      }
      var t = e.prototype
      return (
        (t.collapse = function (e) {
          var t = this._$elm,
            a = this._$content
          ;(void 0 === e && (e = !this._isOpen),
            (e && this._isOpen) ||
              (!e && !this._isOpen) ||
              !a.length ||
              (e
                ? (Pe &&
                    a
                      .on('transitionend', function e() {
                        a.off('transitionend', e).css('height', '')
                      })
                      .css('height', a[0].scrollHeight),
                  t.addClass('mbsc-collapsible-open'))
                : (Pe && a.css('height', getComputedStyle(a[0]).height),
                  setTimeout(function () {
                    ;(a.css('height', 0), t.removeClass('mbsc-collapsible-open'))
                  }, 50)),
              e &&
                this._$accordionParent &&
                this._$accordionParent.find('.mbsc-collapsible-open').each(function () {
                  this !== t[0] && this.mbscInst.hide()
                }),
              (this._isOpen = e),
              this._$header.attr('aria-expanded', this._isOpen)))
        }),
        (t.show = function () {
          this.collapse(!0)
        }),
        (t.hide = function () {
          this.collapse(!1)
        }),
        (t.toggle = function () {
          this.collapse()
        }),
        (t.destroy = function () {
          ;(this._$elm.removeClass('mbsc-collapsible mbsc-collapsible-open'),
            this._$content.removeClass('mbsc-collapsible-content'),
            this._$header.removeClass('mbsc-collapsible-header').find('.mbsc-collapsible-icon').remove())
        }),
        e
      )
    })()
  W.CollapsibleBase = Sa
  var ka = 0
  function Da(e, n, s, t) {
    ;(pa('input,select,textarea,progress,button', e).each(function () {
      var e = this,
        t = pa(e),
        a = ma(t)
      if ('false' != t.attr('data-enhance'))
        if (t.hasClass('mbsc-control'))
          e.mbscInst &&
            e.mbscInst.option({ theme: s.theme, lang: s.lang, rtl: s.rtl, onText: s.onText, offText: s.offText, stopProp: s.stopProp })
        else
          switch ((e.id || (e.id = 'mbsc-form-control-' + ++ka), a)) {
            case 'button':
            case 'submit':
              n[e.id] = new $t(e, { theme: s.theme, rtl: s.rtl, tap: s.tap })
              break
            case 'switch':
              n[e.id] = new aa(e, {
                theme: s.theme,
                lang: s.lang,
                rtl: s.rtl,
                tap: s.tap,
                onText: s.onText,
                offText: s.offText,
                stopProp: s.stopProp,
              })
              break
            case 'checkbox':
              n[e.id] = new jt(e, { tap: s.tap, theme: s.theme, rtl: s.rtl })
              break
            case 'range':
              pa(e).parent().hasClass('mbsc-slider') ||
                (n[e.id] = new _a(e, { theme: s.theme, lang: s.lang, rtl: s.rtl, stopProp: s.stopProp, labelStyle: s.labelStyle }))
              break
            case 'rating':
              n[e.id] = new wa(e, { theme: s.theme, lang: s.lang, rtl: s.rtl, stopProp: s.stopProp })
              break
            case 'progress':
              n[e.id] = new na(e, { theme: s.theme, lang: s.lang, rtl: s.rtl, labelStyle: s.labelStyle })
              break
            case 'radio':
              n[e.id] = new Wt(e, { tap: s.tap, theme: s.theme, rtl: s.rtl })
              break
            case 'select':
            case 'select-one':
            case 'select-multiple':
              n[e.id] = new Bt(e, { tap: s.tap, inputStyle: s.inputStyle, labelStyle: s.labelStyle, theme: s.theme, rtl: s.rtl })
              break
            case 'textarea':
              n[e.id] = new Xt(e, { tap: s.tap, inputStyle: s.inputStyle, labelStyle: s.labelStyle, theme: s.theme, rtl: s.rtl })
              break
            case 'segmented':
              n[e.id] = new Zt(e, { theme: s.theme, rtl: s.rtl, tap: s.tap, inputStyle: s.inputStyle })
              break
            case 'stepper':
              n[e.id] = new Qt(e, { theme: s.theme, rtl: s.rtl })
              break
            case 'hidden':
              return
            default:
              n[e.id] = new Rt(e, { tap: s.tap, inputStyle: s.inputStyle, labelStyle: s.labelStyle, theme: s.theme, rtl: s.rtl })
          }
    }),
      pa('[data-collapsible]:not(.mbsc-collapsible)', e).each(function () {
        var e = this,
          t = pa(e).attr('data-open')
        ;(e.id || (e.id = 'mbsc-form-control-' + ++ka),
          (n[e.id] = new Sa(e, { isOpen: void 0 !== t && 'false' != t })),
          (fa[e.id] = n[e.id]))
      }),
      t || Kt())
  }
  function Na(a, e) {
    var n,
      s,
      i = '',
      r = pa(a),
      t = {},
      o = this
    function l() {
      r.removeClass('mbsc-no-touch')
    }
    ;(ba.call(this, a, e, !0),
      (o.refresh = function (e) {
        Da(r, t, n, e)
      }),
      (o._init = function () {
        var e = void 0 !== n.collapsible || void 0 !== r.attr('data-collapsible')
        if (
          (r.hasClass('mbsc-card') || r.on('touchstart', l).show(),
          i && r.removeClass(i),
          (i =
            'mbsc-card mbsc-form mbsc-no-touch mbsc-' +
            n.theme +
            (Ea ? ' mbsc-form-hb' : '') +
            (n.baseTheme ? ' mbsc-' + n.baseTheme : '') +
            (n.rtl ? ' mbsc-rtl' : ' mbsc-ltr')),
          r.addClass(i).removeClass('mbsc-cloak'),
          e && !s)
        ) {
          var t = r.attr('data-open')
          s = new Sa(a, { isOpen: (void 0 !== t && 'false' != t) || !0 === n.collapsible })
        }
        o.refresh()
      }),
      (o._destroy = function () {
        for (var e in (r.removeClass(i).off('touchstart', l), t)) t[e].destroy()
        s && s.destroy()
      }),
      (o.toggle = function () {
        s && s.toggle()
      }),
      (o.hide = function () {
        s && s.hide()
      }),
      (o.show = function () {
        s && s.show()
      }),
      (n = o.settings),
      o.init())
  }
  var Ea = 'ios' == _ && 7 < M
  ;((Na.prototype = { _hasDef: !0, _hasTheme: !0, _hasLang: !0, _class: 'card', _defaults: { tap: Ie, stopProp: !0, rtl: !1 } }),
    R('[mbsc-card]', (W.Card = Na), !0))
  var Oa = { collapsible: e.bool, open: e.bool },
    Va = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      l(e, t)
      var a = e.prototype
      return (
        (a.componentDidUpdate = function () {
          if (this.optimizeThisUpdate.updateOptions) {
            var e = this.getSettingsFromProps(this.props, { collapsible: this.props.open || !1 })
            this.instance.option(e)
          } else this.optimizeThisUpdate.updateCollapsible && (this.props.open ? this.instance.show() : this.instance.hide())
        }),
        (a.shouldComponentUpdate = function (e) {
          var t = this.getSettingsFromProps(this.props),
            a = t.open,
            n = x(t, ['open']),
            s = this.getSettingsFromProps(e),
            i = s.open,
            r = !fe(x(s, ['open']), n),
            o = !fe(i, a),
            l = !fe(e.children, this.props.children)
          return ((this.optimizeThisUpdate = { updateOptions: r, updateCollapsible: o, updateChildren: l }), r || o || l)
        }),
        (a.componentDidMount = function () {
          var e = this.getSettingsFromProps(this.props)
          ;(this.props.collapsible && (e.collapsible = this.props.open || !1), (this.instance = new Na(i.findDOMNode(this), e)))
        }),
        (a.render = function () {
          var e = this.props,
            t =
              (e.className,
              e.children,
              e.collapsible,
              e.open,
              e.theme,
              e.lang,
              e.rtl,
              x(e, ['className', 'children', 'collapsible', 'open', 'theme', 'lang', 'rtl']))
          return b.createElement('div', g({ className: this.initialCssClass + ' mbsc-cloak' }, t), this.props.children)
        }),
        e
      )
    })(be),
    Fa = (function (a) {
      function e(e) {
        var t
        return (
          ((t = a.call(this, e) || this).initialCssClass = e.className),
          (t.state = { cssClasses: e.className }),
          (t.getCssClasses = t.getCssClasses.bind(c(t))),
          t
        )
      }
      return (
        l(e, a),
        (e.prototype.getCssClasses = function (e) {
          return e + (this.initialCssClass ? ' ' + this.initialCssClass : '')
        }),
        e
      )
    })(b.Component),
    Aa = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      return (
        l(e, t),
        (e.prototype.render = function () {
          var e = this.props,
            t = (e.className, e.children, x(e, ['className', 'children'])),
            a = this.getCssClasses('mbsc-card-header')
          return b.createElement('div', g({ className: a }, t), this.props.children)
        }),
        e
      )
    })(Fa),
    Ia = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      return (
        l(e, t),
        (e.prototype.render = function () {
          var e = this.props,
            t = (e.className, e.children, x(e, ['className', 'children'])),
            a = this.getCssClasses('mbsc-card-content')
          return b.createElement('div', g({ className: a }, t), this.props.children)
        }),
        e
      )
    })(Fa),
    Pa = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      return (
        l(e, t),
        (e.prototype.render = function () {
          var e = this.props,
            t = (e.className, e.children, x(e, ['className', 'children'])),
            a = this.getCssClasses('mbsc-card-footer')
          return b.createElement('div', g({ className: a }, t), this.props.children)
        }),
        e
      )
    })(Fa),
    Ha = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      return (
        l(e, t),
        (e.prototype.render = function () {
          var e = this.props,
            t = (e.className, e.children, x(e, ['className', 'children'])),
            a = this.getCssClasses('mbsc-card-title')
          return b.createElement('div', g({ className: a }, t), this.props.children)
        }),
        e
      )
    })(Fa),
    La = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      return (
        l(e, t),
        (e.prototype.render = function () {
          var e = this.props,
            t = (e.className, e.children, x(e, ['className', 'children'])),
            a = this.getCssClasses('mbsc-card-subtitle')
          return b.createElement('div', g({ className: a }, t), this.props.children)
        }),
        e
      )
    })(Fa)
  function za(e) {
    var a = [Math.round(e.r).toString(16), Math.round(e.g).toString(16), Math.round(e.b).toString(16)]
    return (
      pa.each(a, function (e, t) {
        1 == t.length && (a[e] = '0' + t)
      }),
      '#' + a.join('')
    )
  }
  function Ua(e) {
    return {
      r: (e = parseInt(-1 < e.indexOf('#') ? e.substring(1) : e, 16)) >> 16,
      g: (65280 & e) >> 8,
      b: 255 & e,
      toString: function () {
        return 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')'
      },
    }
  }
  function Ya(e) {
    var t,
      a,
      n,
      s = e.h,
      i = (255 * e.s) / 100,
      r = (255 * e.v) / 100
    if (0 == i) t = a = n = r
    else {
      var o = ((255 - i) * r) / 255,
        l = ((s % 60) * (r - o)) / 60
      ;(360 == s && (s = 0),
        s < 60
          ? ((t = r), (a = (n = o) + l))
          : s < 120
            ? ((n = o), (t = (a = r) - l))
            : s < 180
              ? ((a = r), (n = (t = o) + l))
              : s < 240
                ? ((t = o), (a = (n = r) - l))
                : s < 300
                  ? ((n = r), (t = (a = o) + l))
                  : s < 360
                    ? ((a = o), (n = (t = r) - l))
                    : (t = a = n = 0))
    }
    return {
      r: t,
      g: a,
      b: n,
      toString: function () {
        return 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')'
      },
    }
  }
  function Ra(e) {
    var t,
      a,
      n = 0,
      s = Math.min(e.r, e.g, e.b),
      i = Math.max(e.r, e.g, e.b),
      r = i - s
    return (
      (n = (t = (a = i) ? (255 * r) / i : 0) ? (e.r == i ? (e.g - e.b) / r : e.g == i ? 2 + (e.b - e.r) / r : 4 + (e.r - e.g) / r) : -1),
      (n *= 60) < 0 && (n += 360),
      {
        h: n,
        s: (t *= 100 / 255),
        v: (a *= 100 / 255),
        toString: function () {
          return 'hsv(' + Math.round(this.h) + ',' + Math.round(this.s) + '%,' + Math.round(this.v) + '%)'
        },
      }
    )
  }
  function $a(e) {
    var t,
      a,
      n = e.r / 255,
      s = e.g / 255,
      i = e.b / 255,
      r = Math.max(n, s, i),
      o = Math.min(n, s, i),
      l = (r + o) / 2
    if (r == o) t = a = 0
    else {
      var c = r - o
      switch (((a = 0.5 < l ? c / (2 - r - o) : c / (r + o)), r)) {
        case n:
          t = (s - i) / c + (s < i ? 6 : 0)
          break
        case s:
          t = (i - n) / c + 2
          break
        case i:
          t = (n - s) / c + 4
      }
      t /= 6
    }
    return {
      h: Math.round(360 * t),
      s: Math.round(100 * a),
      l: Math.round(100 * l),
      toString: function () {
        return 'hsl(' + this.h + ',' + this.s + '%,' + this.l + '%)'
      },
    }
  }
  function ja(e) {
    return $a(Ua(e))
  }
  function Wa(e) {
    return za(
      (function (e) {
        var t,
          a,
          n,
          s,
          i,
          r,
          o = e.h,
          l = e.s,
          c = e.l
        return (
          isFinite(o) || (o = 0),
          isFinite(l) || (l = 0),
          isFinite(c) || (c = 0),
          (o /= 60) < 0 && (o = 6 - (-o % 6)),
          (o %= 6),
          (l = Math.max(0, Math.min(1, l / 100))),
          (c = Math.max(0, Math.min(1, c / 100))),
          (r = (i = (1 - Math.abs(2 * c - 1)) * l) * (1 - Math.abs((o % 2) - 1))),
          (n =
            o < 1
              ? ((t = i), (a = r), 0)
              : o < 2
                ? ((t = r), (a = i), 0)
                : o < 3
                  ? ((t = 0), (a = i), r)
                  : o < 4
                    ? ((t = 0), (a = r), i)
                    : o < 5
                      ? ((t = r), (a = 0), i)
                      : ((t = i), (a = 0), r)),
          (s = c - i / 2),
          {
            r: Math.round(255 * (t + s)),
            g: Math.round(255 * (a + s)),
            b: Math.round(255 * (n + s)),
            toString: function () {
              return 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')'
            },
          }
        )
      })(e),
    )
  }
  function Ba(e) {
    return za(Ya(e))
  }
  function Ja(e) {
    return Ra(Ua(e))
  }
  ;((Va.propTypes = g({}, oe, {}, Oa)),
    (Z.Card = Va),
    (Z.CardHeader = Aa),
    (Z.CardContent = Ia),
    (Z.CardFooter = Pa),
    (Z.CardTitle = Ha),
    (Z.CardSubtitle = La))
  function qa(a, e, t) {
    var c,
      n,
      d,
      s,
      u,
      m,
      i,
      r,
      o,
      l,
      h,
      p,
      f,
      v,
      b,
      g,
      x,
      T,
      y,
      C,
      _,
      w,
      M,
      S,
      k,
      D = this,
      N = pa(a),
      E = 0,
      O = {},
      V = {}
    function F(e, t, a) {
      if (!a) {
        D._value = D._hasValue ? D._tempValue.slice(0) : null
        for (var n = 0; n < d.length; ++n)
          (d[n].tempChangedColor &&
            D._value &&
            -1 != D._value.indexOf(d[n].tempChangedColor) &&
            (d[n].changedColor = d[n].tempChangedColor),
            delete d[n].tempChangedColor)
      }
      e &&
        (D._isInput && N.val(D._hasValue ? D._tempValue : ''),
        s('onFill', { valueText: D._hasValue ? D._tempValue : '', change: t }),
        t && ((O = va(!0, {}, V)), (D._preventChange = !0), N.trigger('change')),
        z(D._value, !0))
    }
    function A(e, t) {
      return (
        '<div class="mbsc-color-input-item" data-color="' +
        (void 0 !== (t = void 0 !== t ? t : P(e)) ? t : e) +
        '" style="background: ' +
        e +
        ';">' +
        (T ? '' : '<div class="mbsc-color-input-item-close mbsc-ic mbsc-ic-material-close"></div>') +
        '</div>'
      )
    }
    function I(e) {
      p[0].style.background = e
        ? ya +
          'linear-gradient(left, ' +
          (c.rtl ? '#000000' : '#FFFFFF') +
          ' 0%, ' +
          e +
          ' 50%, ' +
          (c.rtl ? '#FFFFFF' : '#000000') +
          ' 100%)'
        : ''
    }
    function P(e) {
      if (Object.keys(V).length && !isNaN(e)) return e
      for (var t in d) if (e == d[t].color || e == d[t].changedColor) return t
    }
    function H(e, t) {
      var a,
        n = e.match(/\d+/gim)
      switch (!0) {
        case -1 < e.indexOf('rgb'):
          a = za({ r: n[0], g: n[1], b: n[2] })
          break
        case -1 < e.indexOf('hsl'):
          a = Wa({ h: n[0], s: n[1], l: n[2] })
          break
        case -1 < e.indexOf('hsv'):
          a = Ba({ h: n[0], s: n[1], v: n[2] })
          break
        case -1 < e.indexOf('#'):
          a = e
      }
      return (function (e, t) {
        switch (t) {
          case 'rgb':
            return Ua(e)
          case 'hsl':
            return ja(e)
          case 'hsv':
            return Ja(e)
          default:
            return e
        }
      })(a, t || c.format)
    }
    function L(e, t) {
      ;(pa('.mbsc-color-active', t).removeClass('mbsc-color-active'),
        f && (e.parent().addClass('mbsc-color-active'), h && e && void 0 !== E && M.eq(E).parent().addClass('mbsc-color-active')))
    }
    function z(e, t) {
      var a,
        n,
        s = [],
        i = 0,
        r = pa.map(d, function (e) {
          return e.changedColor || e.color
        })
      if (T) {
        if (((e = pa.isArray(e) ? e[0] : e), -1 < (n = r.indexOf(e)) && s.push(n), e && !s.length && f)) {
          var o = +pa('.mbsc-color-input-item', _).attr('data-color')
          ;(isNaN(o) ? (o = void 0) : s.push(o), (g = o))
        }
      } else if (e)
        if (h && f) for (var l in O) void 0 !== O[l].colorIndex && s.push(+O[l].colorIndex)
        else for (a = 0; a < e.length; ++a) -1 < (n = r.indexOf(e[a])) && (s.push(n), (r[n] = 'temp' + a))
      for (a = 0; a < s.length; ++a) d[s[a]] && U(!0, s[a], i++, d[s[a]].changedColor || d[s[a]].color, !0)
      for (a = 0; a < d.length; ++a) -1 == s.indexOf(a) && U(!1, a, void 0, d[a].changedColor || d[a].color, !1)
      if (h)
        for (a = i; a < c.select; ++a)
          ((V[a] = {}), M && M.eq(a).addClass('mbsc-color-preview-item-empty').css({ background: 'transparent' }))
      ;((O = va(!0, {}, V)),
        !1 !== t &&
          (function () {
            if (x) {
              var e,
                t = ''
              if ((_.empty(), D._hasValue)) {
                if (T) t += A(D._value, g)
                else
                  for (e = 0; e < D._value.length; ++e)
                    t += A(D._value[e], Object.keys(V).length && V[e].colorIndex ? V[e].colorIndex : P(D._value[e]))
                ;(_.append(t),
                  D.tap(pa('.mbsc-color-input-item', _), function (e) {
                    if (pa(e.target).hasClass('mbsc-color-input-item-close')) {
                      var t = pa(this).index()
                      ;(e.stopPropagation(),
                        e.preventDefault(),
                        void 0 === g && (g = pa(e.target).parent().attr('data-color')),
                        h && d[g] && ((E = d[g].previewInd), M.eq(E).parent().removeClass('mbsc-color-active'), (O[t] = {}), (V[t] = {})),
                        D._value.splice(t, 1),
                        D.setVal(D._value, !0, !0))
                    } else
                      f &&
                        'inline' !== c.display &&
                        ((g = pa(e.target).attr('data-color')),
                        isNaN(g) && (g = P(g)),
                        g &&
                          d[g] &&
                          ((d[g].selected = !0),
                          (E = d[g].previewInd),
                          setTimeout(function () {
                            ;(u.scroll(w.eq(g), 400), h && m.scroll(M.eq(E), 400))
                          }, 200)))
                  }))
              }
            }
          })())
    }
    function U(e, t, a, n, s, i) {
      if (h && s && ((V[a].colorIndex = e ? t : void 0), (V[a].color = e ? n : void 0), M)) {
        var r = M.eq(a)
        ;(r.removeClass('mbsc-color-preview-item-empty').css({ background: e ? n : 'transparent' }),
          e || r.addClass('mbsc-color-preview-item-empty').parent().removeClass('mbsc-color-active'))
      }
      ;(i && (e ? D._tempValue.splice(a, 0, n) : D._tempValue.splice(D._tempValue.indexOf(n), 1)),
        w &&
          (e
            ? w.eq(t).addClass('mbsc-color-selected')
            : w.eq(t).removeClass('mbsc-color-selected').parent().removeClass('mbsc-color-active')),
        (d[t].previewInd = e ? a : void 0),
        (d[t].selected = e))
    }
    function Y(e, t) {
      void 0 !== e && (T || (d[e] && d[e].selected))
        ? d[(g = e)] &&
          ((r = d[e].changedColor || d[e].color),
          (S = w.eq(e)),
          f && (L(w.eq(e), t || ''), ((o = H(d[e].color, 'hsl')).l = H(r, 'hsl').l), I(d[e].color), b.setVal(100 - o.l, !1, !1)))
        : f && I()
    }
    function R(e, t) {
      var a = pa(e.target).index()
      ;((g = V[a].colorIndex),
        (S = w.eq(g)),
        (E = a),
        Y(g, t),
        u.scroll(S, 250),
        s('onPreviewItemTap', { target: e.target, value: V[a].color, index: a }))
    }
    function $(e, t) {
      var a = !1,
        n = pa('.mbsc-color-selected', t)
      if ((S = pa(e.target)).hasClass('mbsc-color-clear-item')) return ((r = ''), void D.clear())
      ;(T || y > +n.length || S.hasClass('mbsc-color-selected')) &&
        ((g = S.attr('data-index')),
        h &&
          ((E =
            void 0 !== d[g].previewInd
              ? d[g].previewInd
              : (function () {
                  var e
                  for (e = 0; e < c.select; ++e) if (void 0 === V[e].colorIndex) return e
                })()),
          (a = f && S.hasClass('mbsc-color-selected') && !S.parent().hasClass('mbsc-color-active')),
          6 < M.length && m.scroll(M.eq(E))),
        (r = d[g].changedColor || d[g].color),
        T
          ? (n.removeClass('mbsc-color-selected'), (D._tempValue = r) && S.toggleClass('mbsc-color-selected'), L(S, t))
          : (L(S, t), a || U(!d[g].selected, g, E, r, !0, !0)),
        Y(g, t),
        D.live && (D._fillValue(), s('onSet', { value: D._value })),
        s('onItemTap', { target: e.target, value: r, selected: d[g].selected, index: g }),
        D._updateHeader())
    }
    ;(qe.call(this, a, e, !0),
      (D.setVal = D._setVal =
        function (e, t, a, n) {
          ;((D._hasValue = null != e),
            (D._tempValue = T ? (pa.isArray(e) ? e[0] : e) : pa.isArray(e) ? e : e ? [e] : []),
            F(t, void 0 === a ? t : a, n))
        }),
      (D.getVal = D._getVal =
        function (e) {
          return D._hasValue || e
            ? C
              ? (function () {
                  var e,
                    t = []
                  for (e = 0; e < d.length; ++e) d[e].selected && t.push(d[e])
                  return t
                })()
              : D[e ? '_tempValue' : '_value']
            : null
        }),
      (D._readValue = function () {
        var e = N.val() || ''
        ;((D._hasValue = !1),
          0 !== e.length && '' !== e && (D._hasValue = !0),
          D._hasValue
            ? ((D._tempValue = T
                ? e
                : 'hex' == c.format
                  ? e.split(',')
                  : e.match(/[a-z]{3}\((\d+\.?\d{0,}?),\s*([\d.]+)%{0,},\s*([\d.]+)%{0,}\)/gim)),
              F(!0))
            : (D._tempValue = []),
          z(D._tempValue, D._hasValue))
      }),
      (D._fillValue = function () {
        F((D._hasValue = !0), !0)
      }),
      (D._generateContent = function () {
        var e,
          t,
          a,
          n = i ? 1 : 0
        for (
          v = l ? Math.ceil((d.length + n) / c.rows) : c.rows,
            t =
              '<div class="mbsc-color-scroll-cont mbsc-w-p ' +
              (l ? '' : 'mbsc-color-vertical') +
              '"><div class="mbsc-color-cont">' +
              (l ? '<div class="mbsc-color-row">' : ''),
            e = 0;
          e < d.length;
          ++e
        )
          ((a = d[e].changedColor || d[e].color),
            i &&
              0 === e &&
              (t +=
                '<div class="mbsc-color-item-c"><div tabindex="0" class="mbsc-color-clear-item mbsc-btn-e mbsc-color-selected"><div class="mbsc-color-clear-cross"></div></div></div>'),
            0 !== e && (e + n) % v == 0 && (t += l ? '</div><div class="mbsc-color-row">' : ''),
            (t +=
              '<div class="mbsc-color-item-c"><div tabindex="0" data-index="' +
              e +
              '" class="mbsc-color-item mbsc-btn-e mbsc-ic mbsc-ic-material-check mbsc-color-btn-e ' +
              (d[e].selected ? 'mbsc-color-selected' : '') +
              '"  style="background:' +
              a +
              '"></div></div>'))
        if (
          ((t += '</div></div>' + (l ? '</div>' : '')),
          f &&
            (t +=
              '<div class="mbsc-color-slider-cont"><input class="mbsc-color-slider" type="range" data-highlight="false" value="50" min="0" max="100"/></div>'),
          h)
        ) {
          for (var s in ((t += '<div class="mbsc-color-preview-cont"><div class="mbsc-color-refine-preview">'), O))
            t +=
              '<div class="mbsc-color-preview-item-c mbsc-btn-e mbsc-color-btn-e" tabindex="0"><div class="mbsc-color-preview-item ' +
              (O[s].color ? '' : 'mbsc-color-preview-item-empty') +
              '" style="background: ' +
              (O[s].color || 'initial') +
              ';"></div></div>'
          t += '</div></div>'
        }
        return t
      }),
      (D._position = function (e) {
        var t, a
        ;(l ||
          ((t = e.find('.mbsc-color-cont')),
          (a = Math.ceil(t.find('.mbsc-color-item-c')[0].offsetWidth)),
          t.width(Math.min(Math.floor(e.find('.mbsc-fr-c').width() / a), Math.round(d.length / c.rows)) * a + 1)),
          u && u.refresh(),
          m && m.refresh())
      }),
      (D._markupInserted = function (t) {
        ;(l || t.find('.mbsc-color-scroll-cont').css('max-height', t.find('.mbsc-color-item-c')[0].offsetHeight * c.rows),
          (u = new pt(t.find('.mbsc-color-scroll-cont')[0], {
            axis: l ? 'X' : 'Y',
            rtl: c.rtl,
            elastic: 60,
            stopProp: !1,
            mousewheel: c.mousewheel,
            onBtnTap: function (e) {
              $(e, t)
            },
          })))
      }),
      (D._attachEvents = function (t) {
        var e
        ;((w = pa('.mbsc-color-item', t)),
          t.on('keydown', '.mbsc-color-btn-e', function (e) {
            ;(e.stopPropagation(), 32 == e.keyCode && (e.target.classList.contains('mbsc-color-item') ? $(e, t) : R(e, t)))
          }),
          h && (M = pa('.mbsc-color-preview-item', t)),
          f &&
            (t.addClass('mbsc-color-refine'),
            (k = pa('.mbsc-color-slider', t)),
            (b = new _a(k[0], { theme: c.theme, rtl: c.rtl })),
            (p = t.find('.mbsc-progress-track')),
            g && D._value && Y(g, t),
            k.on('change', function () {
              void 0 !== g &&
                (T || (d[g] && d[g].selected)) &&
                ((o.l = 100 - this.value),
                (e = H(o.toString()).toString()),
                T ? (D._tempValue = e) : (D._tempValue[void 0 !== E ? E : D._tempValue.length] = e),
                (d[g].tempChangedColor = e),
                w.eq(g).css('background', e),
                h && ((V[E].color = e), M.eq(E).removeClass('mbsc-color-preview-item-empty').css({ background: e })),
                D.live && la(D._fillValue()))
            })),
          h &&
            (m = new pt(t.find('.mbsc-color-preview-cont')[0], {
              axis: 'X',
              rtl: c.rtl,
              stopProp: !1,
              mousewheel: c.mousewheel,
              onBtnTap: function (e) {
                R(e, t)
              },
            })),
          D._updateHeader())
      }),
      (D._markupRemove = function () {
        ;(u && u.destroy(), b && b.destroy(), m && m.destroy())
      }),
      (D.__processSettings = function () {
        var e, t
        if (
          ((c = D.settings),
          (s = D.trigger),
          (l = 'horizontal' == c.navigation),
          (D._value = []),
          (D._tempValue = []),
          (T = 'single' == c.select),
          (i = void 0 !== c.clear ? c.clear : T),
          !(t = c.data || []).length)
        )
          switch (c.format) {
            case 'rgb':
              ;((t = [
                'rgb(255,235,60)',
                'rgb(255,153,0)',
                'rgb(244,68,55)',
                'rgb(234,30,99)',
                'rgb(156,38,176)',
                'rgb(104,58,183)',
                'rgb(63,81,181)',
                'rgb(33,150,243)',
                'rgb(0,151,136)',
                'rgb(75,175,79)',
                'rgb(126,93,78)',
                'rgb(158,158,158)',
              ]),
                i && t.splice(10, 0, 'rgb(83, 71, 65)'))
              break
            case 'hsl':
              ;((t = [
                'hsl(54,100%,62%)',
                'hsl(36,100%,50%)',
                'hsl(4,90%,59%)',
                'hsl(340,83%,52%)',
                'hsl(291,64%,42%)',
                'hsl(262,52%,47%)',
                'hsl(231,48%,48%)',
                'hsl(207,90%,54%)',
                'hsl(174,100%,30%)',
                'hsl(122,40%,49%)',
                'hsl(19,24%,40%)',
                'hsl(0,0%,62%)',
              ]),
                i && t.splice(10, 0, 'hsl(20, 12%, 29%)'))
              break
            default:
              ;((t = [
                '#ffeb3c',
                '#ff9900',
                '#f44437',
                '#ea1e63',
                '#9c26b0',
                '#683ab7',
                '#3f51b5',
                '#2196f3',
                '#009788',
                '#4baf4f',
                '#7e5d4e',
                '#9e9e9e',
              ]),
                i && t.splice(10, 0, '#534741'))
          }
        if (
          ((f = 'refine' == c.mode),
          (h = !isNaN(c.select)),
          (y = isNaN(c.select) ? (T ? 2 : t.length) : c.select),
          (C = pa.isPlainObject(t[0])),
          h && !Object.keys(O).length)
        )
          for (e = 0; e < c.select; ++e) ((O[e] = {}), (V[e] = {}))
        for (d = t.slice(0), e = 0; e < d.length; ++e)
          pa.isPlainObject(t[e]) ? (d[e].color = t[e].color) : ((t[e] = t[e].toLowerCase()), (d[e] = { key: e, name: t[e], color: t[e] }))
        ;((n = c.defaultValue || d[0].color),
          (o = H((r = n), 'hsl')),
          (x = c.enhance && N.is('input')) &&
            (N.hasClass('mbsc-color-input-hdn')
              ? (_ = N.prev())
              : ((_ = pa(
                  '<div ' +
                    (a.placeholder ? 'data-placeholder="' + a.placeholder + '"' : '') +
                    ' class="mbsc-control mbsc-color-input ' +
                    (c.inputClass || '') +
                    '" readonly ></div>',
                )).insertBefore(N),
                N.addClass('mbsc-color-input-hdn').attr('tabindex', -1)),
            (c.anchor = _),
            D.attachShow(_)))
      }),
      (D.__destroy = function () {
        x && (N.removeClass('mbsc-color-input-hdn'), _.remove())
      }),
      (D._checkSize = !0),
      t || D.init())
  }
  ;((qa.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _class: 'color',
    _defaults: va({}, qe.prototype._defaults, {
      headerText: !1,
      validate: ra,
      parseValue: ra,
      enhance: !0,
      rows: 2,
      select: 'single',
      format: 'hex',
      navigation: 'horizontal',
      compClass: 'mbsc-color',
    }),
  }),
    (W.Color = qa),
    (Z.themes.color = Z.themes.frame),
    (t.color = { hsv2hex: Ba, hsv2rgb: Ya, rgb2hsv: Ra, rgb2hex: za, rgb2hsl: $a, hex2rgb: Ua, hex2hsv: Ja, hex2hsl: ja }))
  var Ka = {
      clear: e.bool,
      data: e.array,
      defaultValue: e.string,
      enhance: e.bool,
      format: e.oneOf(['hex', 'rgb', 'hsl']),
      inputClass: e.string,
      mode: e.oneOf(['preset', 'refine']),
      navigation: e.oneOf(['horizontal', 'vertical']),
      preview: e.bool,
      previewText: e.bool,
      rows: e.number,
      select: e.oneOfType([e.oneOf(['single', 'multiple']), e.number]),
      valueText: e.string,
      onSet: e.func,
      onClear: e.func,
    },
    Ga = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { component: 'Color', data: e.data }), t)
      }
      l(e, a)
      var t = e.prototype
      return (
        (t.shouldComponentUpdate = function (e) {
          var t = a.prototype.shouldComponentUpdate.call(this, e)
          return ((this.optimizeUpdate.updateData = !fe(this.props.data, e.data)), t || this.optimizeUpdate.updateData)
        }),
        (t.componentDidUpdate = function () {
          var e = this.getSettingsFromProps(this.props)
          ;((e.data = this.props.data),
            (this.optimizeUpdate.updateOptions || this.optimizeUpdate.updateData) && this.instance.option(e),
            this.optimizeUpdate.updateValue &&
              void 0 !== this.props.value &&
              !fe(this.props.value, this.instance.getVal()) &&
              this.instance.setVal(this.props.value, !0))
        }),
        e
      )
    })(xe)
  ;((Ga.propTypes = g({}, Ga.propTypes, {}, Ka)), (Z.Color = Ga), (vt.date = yt), (vt.time = yt), (vt.datetime = yt))
  var Xa = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'datetime' }), t)
    }
    return (l(e, a), e)
  })(xe)
  Xa.propTypes = g({}, Xa.propTypes, {}, ce, {}, de)
  var Za = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'date' }), t)
    }
    return (l(e, a), e)
  })(xe)
  Za.propTypes = g({}, Za.propTypes, {}, ce, {}, de)
  var Qa = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'time' }), t)
    }
    return (l(e, a), e)
  })(xe)
  ;((Qa.propTypes = g({}, Qa.propTypes, {}, ce, {}, de)), (Z.Datetime = Xa), (Z.Date = Za), (Z.Time = Qa))
  var en = function (e, t, a) {
    function n(e) {
      pa('.mbsc-fr-c', e).hasClass('mbsc-wdg-c') ||
        (pa('.mbsc-fr-c', e).addClass('mbsc-wdg-c').append(r.show()), pa('.mbsc-w-p', e).length || pa('.mbsc-fr-c', e).addClass('mbsc-w-p'))
    }
    var s,
      i,
      r = pa(e),
      o = this
    ;(qe.call(this, e, t, !0),
      (o._generateContent = function () {
        return ''
      }),
      (o._markupReady = function (e) {
        'inline' != s.display && n(e)
      }),
      (o._markupInserted = function (e) {
        ;('inline' == s.display && n(e), e.trigger('mbsc-enhance', [{ theme: s.theme, lang: s.lang }]))
      }),
      (o._markupRemove = function () {
        ;(r.hide(), i && i.parent().length && i.after(r))
      }),
      (o.__processSettings = function () {
        ;((s = o.settings),
          (o.buttons.ok = { text: s.okText, icon: s.okIcon, handler: 'set' }),
          (s.buttons = s.buttons || ('inline' == s.display ? [] : ['ok'])),
          !i && r.parent().length && ((i = pa(document.createComment('popup'))), r.before(i)),
          r.hide())
      }),
      a || o.init())
  }
  ;((en.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasContent: !0,
    _hasLang: !0,
    _responsive: !0,
    _class: 'popup',
    _defaults: va({}, qe.prototype._defaults, { compClass: 'mbsc-wdg', okText: 'OK', headerText: !1 }),
  }),
    (W.Popup = en),
    (W.Widget = en),
    (Z.themes.popup = Z.themes.frame))
  var tn = 0
  function an(e, t, a) {
    'jsonp' == a
      ? (function (e, t) {
          var a = document.createElement('script'),
            n = 'mbscjsonp' + ++tn
          ;((window[n] = function (e) {
            ;(a.parentNode.removeChild(a), delete window[n], e && t(e))
          }),
            (a.src = e + (0 <= e.indexOf('?') ? '&' : '?') + 'callback=' + n),
            document.body.appendChild(a))
        })(e, t)
      : (function (e, t) {
          var a = new XMLHttpRequest()
          ;(a.open('GET', e, !0),
            (a.onload = function () {
              200 <= this.status && this.status < 400 && t(JSON.parse(this.response))
            }),
            (a.onerror = function () {}),
            a.send())
        })(e, t)
  }
  t.getJson = an
  var nn = {
      view: { calendar: { type: 'month', popover: !0 } },
      allDayText: 'All-day',
      labelsShort: ['Yrs', 'Mths', 'Days', 'Hrs', 'Mins', 'Secs'],
      eventText: 'event',
      eventsText: 'events',
      noEventsText: 'No events',
    },
    sn = { yearChange: !1, weekDays: 'short' }
  vt.eventcalendar = function (C, e) {
    function n(e, t, a) {
      var n,
        s,
        i,
        r,
        o,
        l = 0,
        c = [],
        d = '',
        u = []
      for (a = a || C._prepareObj(Z, e, t), n = at(e); n <= t; n.setDate(n.getDate() + 1))
        (r = a[at(n)]) && r.length && u.push({ d: new Date(n), list: w(r) })
      if (0 < u.length)
        for (s = 0; s < u.length; s++) {
          for (
            d +=
              '<div><div class="mbsc-lv-gr-title mbsc-event-day" data-full="' +
              nt((r = u[s]).d) +
              '">' +
              ye(K.dateFormat, r.d, K) +
              '</div>',
              i = 0;
            i < r.list.length;
            i++
          ) {
            var m = r.list[i],
              h = m.start ? st(m.start) : null,
              p = m.end ? st(m.end) : null,
              f = m.color,
              v = ot.test(m.d) || rt.test(m.d),
              b = h && p && !it(h, p),
              g = !b || it(h, r.d),
              x = !b || it(p, r.d),
              T = m.d ? (v ? m.d : st(m.d)) : h,
              y = m.allDay || v || (b && !g && !x)
            ;(c.push({ d: r.d, e: m }),
              (d +=
                '<div tabindex="0" role="button" class="mbsc-lv-item mbsc-lv-item-actionable" data-index="' +
                l +
                '"><div class="mbsc-event-time">' +
                (y ? K.allDayText : g && T && T.getTime ? ye(K.timeFormat, T) : b && x ? K.toText : '') +
                (!y && x && p && p.getTime ? '<br/>' + ye(K.timeFormat, p) : '') +
                '</div><div class="mbsc-event-color"' +
                (f ? ' style="background:' + f + ';"' : '') +
                '></div><div class="mbsc-event-txt">' +
                m.text +
                '</div></div>'),
              l++)
          }
          d += '</div>'
        }
      else d += '<div class="mbsc-lv-gr-title mbsc-event-empty"><div class="mbsc-empty"><h3>' + K.noEventsText + '</h3></div></div>'
      ;(G++,
        M.html('<div class="mbsc-lv mbsc-lv-v">' + d + '</div>').scrollTop(0),
        setTimeout(function () {
          G--
        }, 150),
        (o = pa('.mbsc-lv-item', M)),
        C.tap(o, function (e) {
          var t = c[pa(this).attr('data-index')]
          ee('onEventSelect', { domEvent: e, event: t.e, date: t.d })
        }),
        _(o))
    }
    function _(e) {
      e.on('keydown', function (e) {
        ;(13 !== e.keyCode && 32 !== e.keyCode) || this.click()
      })
        .on('focus', function () {
          window.__mbscFocusVisible && pa(this).addClass('mbsc-focus')
        })
        .on('blur', function () {
          pa(this).removeClass('mbsc-focus')
        })
    }
    function s() {
      if (V) {
        var e = at(V.d)
        ;(!(function (t, p, e) {
          if (t) {
            var a,
              n,
              s,
              i,
              r,
              f = '<div class="mbsc-cal-event-list">'
            ;((a = pa(
              '<div class="mbsc-cal-events ' +
                (K.eventBubbleClass || '') +
                '"><div class="mbsc-cal-events-i"><div class="mbsc-cal-events-sc"></div><div class="mbsc-sc-bar-c"><div class="mbsc-sc-bar"></div></div></div></div>',
            )),
              (n = pa('.mbsc-cal-events-i', a)),
              (s = pa('.mbsc-cal-events-sc', a)),
              C.tap(n, function () {
                i.scrolled || o()
              }),
              F && F.hide(),
              (F = new en(a[0], {
                display: 'bubble',
                theme: K.theme,
                lang: K.lang,
                context: K.context,
                buttons: [],
                anchor: e,
                showOverlay: !1,
                cssClass: 'mbsc-no-padding mbsc-cal-events-popup',
                onShow: function () {
                  i = new pt(n[0], { scrollbar: pa('.mbsc-sc-bar-c', a), stopProp: !1 })
                },
                onClose: function (e, t) {
                  ;(t.destroy(), i && i.destroy())
                },
              })),
              (v = e),
              (t = w(t)),
              pa.each(t, function (e, t) {
                var a = t.start ? st(t.start) : null,
                  n = t.end ? st(t.end) : null,
                  s = ot.test(t.d) || rt.test(t.d),
                  i = t.d ? (s ? t.d : st(t.d)) : a,
                  r = a && n && !it(a, n),
                  o = !r || it(a, p),
                  l = !r || it(n, p),
                  c = t.allDay || s || (r && !o && !l),
                  d = t.color,
                  u = '',
                  m = '',
                  h = pa('<div>' + t.text + '</div>').text()
                ;(i.getTime && (u = ye((r ? 'MM d yy ' : '') + K.timeFormat, i)),
                  n && (m = ye((r ? 'MM d yy ' : '') + K.timeFormat, n)),
                  (f +=
                    '<div tabindex="0" role="button" title="' +
                    h +
                    '" aria-label="' +
                    h +
                    (u ? ', ' + K.fromText + ': ' + u : '') +
                    (m ? ', ' + K.toText + ': ' + m : '') +
                    '" class="mbsc-cal-event mbsc-lv-item mbsc-lv-item-actionable"><div class="mbsc-cal-event-color" style="' +
                    (d ? 'background:' + d + ';' : '') +
                    '"></div><div class="mbsc-cal-event-text"><div class="mbsc-cal-event-time">' +
                    (c ? K.allDayText : o && i.getTime ? ye(K.timeFormat, i) : '') +
                    '</div>' +
                    t.text +
                    '</div>' +
                    (a && n && !t.allDay ? '<div class="mbsc-cal-event-dur">' + K.formatDuration(a, n, t) + '</div>' : '') +
                    '</div>'))
              }),
              (f += '</div>'),
              s.html(f),
              F.show(),
              ee('onEventBubbleShow', { target: v, eventList: a[0] }),
              (r = pa('.mbsc-cal-event', s)),
              C.tap(r, function (e) {
                i.scrolled || ee('onEventSelect', { domEvent: e, event: t[pa(this).index()], date: p })
              }),
              _(r),
              (x = !0))
          }
        })(V.events || g[e], e, V.cell || pa('.mbsc-cal-slide-a .mbsc-cal-day[data-full="' + nt(e) + '"]', C._markup)[0]),
          (V = null))
      }
    }
    function w(e) {
      return e.slice(0).sort(function (e, t) {
        var a = e.start ? st(e.start) : null,
          n = t.start ? st(t.start) : null,
          s = e.end ? st(e.end) : null,
          i = t.end ? st(t.end) : null,
          r = ot.test(e.d) || rt.test(e.d),
          o = ot.test(t.d) || rt.test(t.d),
          l = e.d ? (r ? e.d : st(e.d)) : a,
          c = t.d ? (o ? t.d : st(t.d)) : n,
          d = l.getTime ? (a && s && a.toDateString() !== s.toDateString() ? 1 : e.allDay ? 2 : l.getTime()) : 0,
          u = c.getTime ? (n && i && n.toDateString() !== i.toDateString() ? 1 : t.allDay ? 2 : c.getTime()) : 0
        return d == u ? (e.text > t.text ? 1 : -1) : d - u
      })
    }
    function a() {
      var e, t, a
      G ||
        pa('.mbsc-event-day', this).each(function () {
          if (0 <= (t = this.offsetTop - b.scrollTop) && t < 35)
            return ((a = pa(this).attr('data-full').split('-')), it((e = et(a[0], a[1] - 1, a[2])), m) || ((A = !0), C.setVal(e)), !1)
        })
    }
    function o() {
      ;(F && x && F.hide(), (v = null), (x = !1))
    }
    function t() {
      ;(o(), C.redraw())
    }
    function i(e) {
      var t = K.getYear(e),
        a = K.getMonth(e),
        n = K.getDay(e)
      if (((h = e), 'day' == k)) p = K.getDate(t, a, n + D - 1)
      else if ('week' == k) {
        var s,
          i = h.getDay()
        ;((s = n + K.firstDay - (0 < K.firstDay - i ? 7 : 0) - i), (h = K.getDate(t, a, s)), (p = K.getDate(t, a, s + 7 * D - 1)))
      } else
        'month' == k
          ? ((h = K.getDate(t, a, 1)), (p = K.getDate(t, a + D, 0)))
          : 'year' == k && ((h = K.getDate(t, 0, 1)), (p = K.getDate(t + D, 0, 0)))
    }
    function r(e, t) {
      if (z && !A) {
        var a = pa('.mbsc-event-day[data-full="' + nt(e) + '"]', M)
        a.length &&
          (G++,
          Ne(b, a.parent()[0].offsetTop, t, function () {
            setTimeout(function () {
              G--
            }, 150)
          }))
      }
    }
    function l(e, t) {
      ;(e && ee('onPageChange', { firstDay: h, lastDay: p }),
        t || ee('onPageLoading', { firstDay: h, lastDay: p }),
        ee('onPageLoaded', { firstDay: h, lastDay: p }))
    }
    var c,
      d,
      M,
      u,
      m,
      h,
      p,
      f,
      v,
      b,
      g,
      x,
      T,
      y,
      S,
      k,
      D,
      N,
      E,
      O,
      V,
      F,
      A,
      I,
      P,
      H,
      L,
      z,
      U,
      Y,
      R,
      $,
      j,
      W,
      B,
      J = this,
      q = va({}, C.settings),
      K = va(C.settings, nn, q, sn, e),
      G = 0,
      X = 0,
      Z = va(!0, [], K.data),
      Q = !0,
      ee = C.trigger
    return (
      (K.data = Z),
      pa.each(Z, function (e, t) {
        void 0 === t._id && (t._id = X++)
      }),
      (R = K.view),
      ($ = R.calendar),
      (j = R.eventList),
      (W = K.months),
      (B = K.weeks),
      (S = $ ? ('week' == $.type ? (B = $.size || 1) : $.size && (W = $.size), !1) : !(B = 0)),
      j && ((k = j.type), (D = j.size || 1)),
      (O = $ && $.labels),
      (L = j && j.scrollable),
      (z = R.eventList),
      (U = void 0 === K.eventBubble ? $ && $.popover : K.eventBubble),
      (K.weeks = B),
      (K.months = W),
      (c = Ct.call(this, C)),
      (f = C._format),
      K.min && (E = at(st(K.min, f, K))),
      K.max && (N = at(st(K.max, f, K))),
      C._hideEventsOnClick && (C._hideEventsOnClick(), pa(document).off('click', C._hideEventsOnClick)),
      (C._hideEventsOnClick = function (e) {
        ;(void 0 !== e && 0 != pa(e.target).closest('.mbsc-cal-day').length) || o()
      }),
      (C._onSelectShow = function () {
        o()
      }),
      (C._onGenMonth = function (e, t) {
        ;((g = C._prepareObj(Z, e, t)), (C._labels = O ? g : null))
      }),
      (C._onRefresh = function (e) {
        ;((I = !0), (H = P = null), S && l(!1, e))
      }),
      (C._onSetDate = function (e, t) {
        ;((m = e), S ? A || (i(e), l(!0)) : t || T || (z && 'day' == k && n(e, e, g), (!U && !Y) || y || s(), r(e)), (y = Y = A = !1))
      }),
      (C._getDayProps = function (e) {
        var t = g[e],
          a = { events: t }
        return (
          K.marked ||
            K.labels ||
            O ||
            (t
              ? ((a.background = t[0] && t[0].background),
                (a.marked = t),
                (a.markup = K.showEventCount
                  ? '<div class="mbsc-cal-txt">' + t.length + ' ' + (1 < t.length ? K.eventsText : K.eventText) + '</div>'
                  : '<div class="mbsc-cal-marks"><div class="mbsc-cal-mark"></div></div>'))
              : (a.markup = K.showEventCount ? '<div class="mbsc-cal-txt-ph"></div>' : '')),
          a
        )
      }),
      (C.addEvent = function (e) {
        var a = []
        return (
          (e = va(!0, [], pa.isArray(e) ? e : [e])),
          pa.each(e, function (e, t) {
            ;(void 0 === t._id && (t._id = X++), Z.push(t), a.push(t._id))
          }),
          t(),
          a
        )
      }),
      (C.updateEvent = function (a) {
        ;(pa.each(Z, function (e, t) {
          if (t._id === a._id) return (Z.splice(e, 1, a), !1)
        }),
          t())
      }),
      (C.removeEvent = function (e) {
        ;((e = pa.isArray(e) ? e : [e]),
          pa.each(e, function (e, a) {
            pa.each(Z, function (e, t) {
              if (t._id === a) return (Z.splice(e, 1), !1)
            })
          }),
          t())
      }),
      (C.getEvents = function (e) {
        var t
        return e ? (e.setHours(0, 0, 0, 0), (t = C._prepareObj(Z, e, e))[e] ? w(t[e]) : []) : va(!0, [], Z)
      }),
      (C.setEvents = function (e) {
        var a = []
        return (
          (K.data = Z = va(!0, [], e)),
          pa.each(Z, function (e, t) {
            ;(void 0 === t._id && (t._id = X++), a.push(t._id))
          }),
          t(),
          a
        )
      }),
      (C.navigate = function (e, t, a) {
        ;((V = a ? { d: e } : null), C.setVal(e, !0, !0, !1, t ? 200 : 0))
      }),
      va({}, c, {
        multiLabel: O,
        headerText: !1,
        buttons: 'inline' !== K.display ? ['close'] : K.buttons,
        compClass: 'mbsc-ev-cal mbsc-calendar mbsc-dt mbsc-sc',
        formatDuration: function (e, t) {
          var a = K.labelsShort,
            n = t - e,
            s = Math.abs(n) / 1e3,
            i = s / 60,
            r = i / 60,
            o = r / 24,
            l = o / 365
          return (
            (s < 45 && Math.round(s) + ' ' + a[5].toLowerCase()) ||
            (i < 45 && Math.round(i) + ' ' + a[4].toLowerCase()) ||
            (r < 24 && Math.round(r) + ' ' + a[3].toLowerCase()) ||
            (o < 30 && Math.round(o) + ' ' + a[2].toLowerCase()) ||
            (o < 365 && Math.round(o / 30) + ' ' + a[1].toLowerCase()) ||
            Math.round(l) + ' ' + a[0].toLowerCase()
          )
        },
        onMarkupReady: function (e, t) {
          ;((d = pa(e.target)),
            (m = t.getDate(!0)),
            z &&
              ((M = pa(
                '<div class="mbsc-lv-cont mbsc-lv-' +
                  K.theme +
                  (K.baseTheme ? ' mbsc-lv-' + K.baseTheme : '') +
                  (L ? ' mbsc-event-list-h' : '') +
                  ' mbsc-event-list"></div>',
              ).appendTo(pa('.mbsc-fr-w', d))).on('scroll', la(a)),
              (b = M[0])),
            c.onMarkupReady.call(this, e),
            (u = pa('.mbsc-cal-month', d)),
            (x = !1),
            i(m),
            z &&
              S &&
              (l(),
              ct(
                pa('.mbsc-cal-btn', d),
                function (e, t) {
                  var a = K.getYear(h),
                    n = K.getMonth(h),
                    s = K.getDay(h)
                  ;('day' == k
                    ? ((h = K.getDate(a, n, s + t * D)), (p = K.getDate(a, n, s + (t + 1) * D - 1)))
                    : 'week' == k
                      ? ((h = K.getDate(a, n, s + t * D * 7)), (p = K.getDate(a, n, s + (t + 1) * D * 7 - 1)))
                      : 'month' == k
                        ? ((h = K.getDate(a, n + t * D, 1)), (p = K.getDate(a, n + (t + 1) * D, 0)))
                        : 'year' == k && ((h = K.getDate(a + t * D, 0, 1)), (p = K.getDate(a + (t + 1) * D, 0, 0))),
                    l(!0))
                },
                200,
              )),
            (function () {
              var e = ze.__mbscFocusCount || 0
              ;(0 === e && (Ee(ze, 'mousedown', Ve, !0), Ee(ze, 'keydown', Fe, !0)), (ze.__mbscFocusCount = ++e))
            })(),
            pa(document).on('click', t._hideEventsOnClick))
        },
        onDayChange: function (e) {
          var t = e.target,
            a = t !== v
          ;(o(),
            a &&
              ((Y = !1 !== U && pa('.mbsc-cal-txt-more', t).length),
              (V = { d: e.date, cell: K.outerMonthChange && pa(t).hasClass('mbsc-cal-day-diff') ? null : t, events: e.events })))
        },
        onLabelTap: function (e) {
          e.label && (ee('onEventSelect', { domEvent: e.domEvent, event: e.label, date: e.date }), (y = !0))
        },
        onPageChange: function (e) {
          ;(o(), (T = !0), C._isSetDate || C.setVal(e.firstDay))
        },
        onPageLoaded: function (e) {
          var t = e.firstDay,
            a = e.lastDay
          ;(z &&
            (S
              ? (P && H && it(P, t) && it(H, a)) ||
                (n((P = t), (H = a)),
                (function (e, t) {
                  var a,
                    n = (K.dateWheels || K.dateFormat).search(/m/i),
                    s = (K.dateWheels || K.dateFormat).search(/y/i),
                    i = K.getYear(e),
                    r = K.getMonth(e),
                    o = K.getYear(t),
                    l = K.getMonth(t)
                  ;('day' == k
                    ? ((a = ye(K.dateFormat, e, K) + (1 < D ? ' - ' + ye(K.dateFormat, t, K) : '')),
                      C._checkBtn(pa('.mbsc-cal-prev-m', d), at(e) <= E),
                      C._checkBtn(pa('.mbsc-cal-next-m', d), at(t) >= N))
                    : 'week' == k
                      ? (a = ye(K.dateFormat, e, K) + ' - ' + ye(K.dateFormat, t, K))
                      : 'month' == k
                        ? (a =
                            1 == D
                              ? s < n
                                ? i + ' ' + K.monthNames[r]
                                : K.monthNames[r] + ' ' + i
                              : s < n
                                ? i + ' ' + K.monthNamesShort[r] + ' - ' + o + ' ' + K.monthNamesShort[l]
                                : K.monthNamesShort[r] + ' ' + i + ' - ' + K.monthNamesShort[l] + ' ' + o)
                        : 'year' == k && (a = i + (1 < D ? ' - ' + o : '')),
                    u.html(a))
                })(t, a))
              : ((a =
                  'month' == k
                    ? K.getDate(K.getYear(t), K.getMonth(t) + D, 0)
                    : 'week' == k
                      ? K.getDate(K.getYear(t), K.getMonth(t), K.getDay(t) + 7 * D - 1)
                      : (t = C.getVal(!0))),
                n(t, a, g)),
            Q || it(m, t) || (r(m, I), (I = !1))),
            U && s(),
            (T = !1))
        },
        onPosition: function (e) {
          if ((c.onPosition.call(this, e), F && F.position(), z && L)) {
            M.addClass('mbsc-event-list-h')
            var t =
              (function (e) {
                var t = getComputedStyle(e)
                return e.innerHeight || e.clientHeight - parseFloat(t.paddingTop) - parseFloat(t.paddingBottom)
              })('inline' == K.display ? J.parentNode : window) - e.popup.offsetHeight
            ;((b.style.height = 200 < t ? t + 'px' : ''), M.removeClass('mbsc-event-list-h'), Q && t && (r(m, !0), (Q = !1)))
          }
        },
        onHide: function () {
          ;(c.onHide.call(this),
            F && F.destroy(),
            (function () {
              var e = ze.__mbscFocusCount || 0
              ;((ze.__mbscFocusCount = --e), 0 === ze.__mbscFocusCount && (Oe(ze, 'mousedown', Ve), Oe(ze, 'keydown', Fe)))
            })(),
            pa(document).off('click', C._hideEventsOnClick))
        },
      })
    )
  }
  var rn = e.number,
    on = e.bool,
    ln = e.func,
    cn = e.object,
    dn = e.string,
    un = {
      data: e.arrayOf(e.shape({ start: ne, end: ne, d: e.oneOfType([cn, rn, dn]), text: dn, color: dn, allDay: on })),
      eventBubble: on,
      formatDuration: ln,
      showEventCount: on,
      view: e.shape({
        calendar: e.shape({ type: e.oneOf(['week', 'month']), size: rn, popover: on, labels: on }),
        eventList: e.shape({ type: e.oneOf(['day', 'week', 'month', 'year']), size: rn, scrollable: on }),
      }),
      allDayText: dn,
      noEventsText: dn,
      eventText: dn,
      eventsText: dn,
      labelsShort: e.arrayOf(dn),
      onEventSelect: e.func,
    },
    mn = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      l(e, t)
      var a = e.prototype
      return (
        (a.componentDidMount = function () {
          var e = this.getSettingsFromProps(this.props, { preset: 'eventcalendar', data: this.props.data || [] })
          this.instance = new Tt(i.findDOMNode(this), e)
        }),
        (a.componentDidUpdate = function () {
          ;(this.optimizeUpdate.updateOptions && this.instance.option(this.getSettingsFromProps(this.props)),
            this.optimizeUpdate.updateData && this.instance.setEvents(this.props.data))
        }),
        (a.shouldComponentUpdate = function (e) {
          var t = !fe(this.getSettingsFromProps(this.props), this.getSettingsFromProps(e)),
            a = !fe(this.props.data, e.data)
          return ((this.optimizeUpdate = { updateOptions: t, updateValue: !1, updateData: a }), t || a)
        }),
        (a.render = function () {
          return b.createElement('div', { className: this.initialCssClass })
        }),
        e
      )
    })(be)
  ;((mn.propTypes = g({}, mn.propTypes, {}, ce, {}, de, {}, he, {}, un)), (Z.Eventcalendar = mn))
  var hn,
    pn = D && !!window.Promise,
    fn = [],
    vn = []
  function bn(e) {
    ;(fn.length || e.show(), fn.push(e))
  }
  function gn(e, a, n, t) {
    return va(
      {
        display: a.display || 'center',
        cssClass: 'mbsc-alert',
        okText: a.okText,
        cancelText: a.cancelText,
        context: a.context,
        theme: a.theme,
        closeOnOverlayTap: !1,
        onBeforeClose: function () {
          e.shift()
        },
        onHide: function (e, t) {
          ;(n && n(t._resolve),
            a.callback && a.callback(t._resolve),
            t && t.destroy(),
            fn.length ? fn[0].show() : vn.length && vn[0].show(!1, !0))
        },
      },
      t,
    )
  }
  function xn(e) {
    return (e.title ? '<h2>' + e.title + '</h2>' : '') + '<p>' + (e.message || '') + '</p>'
  }
  function Tn(e, t, a) {
    bn(new en(e, gn(fn, t, a)))
  }
  function yn(e, t, a) {
    var n = new en(
      e,
      gn(fn, t, a, {
        buttons: ['cancel', 'ok'],
        onSet: function () {
          n._resolve = !0
        },
      }),
    )
    ;((n._resolve = !1), bn(n))
  }
  function Cn(e, t, a) {
    var n,
      s = new en(
        e,
        gn(fn, t, a, {
          buttons: ['cancel', 'ok'],
          onMarkupReady: function (e, t) {
            var a = t.settings
            ;(t._markup.find('label').addClass('mbsc-' + a.theme + (a.baseTheme ? ' mbsc-' + a.baseTheme : '')),
              (n = t._markup.find('input')[0]),
              setTimeout(function () {
                ;(n.focus(), n.setSelectionRange(0, n.value.length))
              }, 300))
          },
          onSet: function () {
            s._resolve = n.value
          },
        }),
      )
    ;((s._resolve = null), bn(s))
  }
  function _n(e, a, t, n, s) {
    var i
    !(function (e) {
      var t = vn.length
      ;(vn.push(e), fn.length || (t ? vn[0].hide() : e.show(!1, !0)))
    })(
      new en(
        e,
        gn(vn, a, t, {
          display: a.display || 'bottom',
          animate: s,
          cssClass: (n || 'mbsc-snackbar') + (a.color ? ' mbsc-' + a.color : ''),
          scrollLock: !1,
          focusTrap: !1,
          buttons: [],
          onMarkupReady: function (e, t) {
            var a = t.settings
            t._markup.find('button').addClass('mbsc-' + a.theme + (a.baseTheme ? ' mbsc-' + a.baseTheme : ''))
          },
          onShow: function (e, t) {
            ;((hn = t),
              !1 !== a.duration &&
                (i = setTimeout(function () {
                  t && t.hide()
                }, a.duration || 3e3)),
              a.button &&
                t.tap(pa('.mbsc-snackbar-btn', e.target), function () {
                  ;(t.hide(), a.button.action && a.button.action.call(this))
                }))
          },
          onClose: function () {
            ;((hn = null), clearTimeout(i))
          },
        }),
      ),
    )
  }
  function wn(e, t, a) {
    _n(e, t, a, 'mbsc-toast', 'fade')
  }
  function Mn(t, a, n) {
    var e
    return (
      pn
        ? (e = new Promise(function (e) {
            t(a, n, e)
          }))
        : t(a, n),
      e
    )
  }
  ;((Z.alert = function (e) {
    var t = document.createElement('div')
    return ((t.innerHTML = xn(e)), Mn(Tn, t, e))
  }),
    (Z.confirm = function (e) {
      var t = document.createElement('div')
      return ((t.innerHTML = xn(e)), Mn(yn, t, e))
    }),
    (Z.prompt = function (e) {
      var t = document.createElement('div')
      return (
        (t.innerHTML =
          xn(e) +
          '<label class="mbsc-input">' +
          (e.label ? '<span class="mbsc-label">' + e.label + '</span>' : '') +
          '<input class="mbsc-control" tabindex="0" type="' +
          (e.inputType || 'text') +
          '" placeholder="' +
          (e.placeholder || '') +
          '" value="' +
          (e.value || '') +
          '"></label>'),
        Mn(Cn, t, e)
      )
    }),
    (Z.snackbar = function (e) {
      var t = document.createElement('div'),
        a = e.button
      return (
        (t.innerHTML =
          '<div class="mbsc-snackbar-cont"><div class="mbsc-snackbar-msg">' +
          (e.message || '') +
          '</div>' +
          (a
            ? '<button class="mbsc-snackbar-btn mbsc-btn mbsc-btn-flat">' +
              (a.icon ? '<span class="mbsc-ic ' + (a.text ? 'mbsc-btn-ic ' : '') + 'mbsc-ic-' + a.icon + '"></span>' : '') +
              (a.text || '') +
              '</button>'
            : '') +
          '</div>'),
        Mn(_n, t, e)
      )
    }),
    (Z.toast = function (e) {
      var t = document.createElement('div')
      return ((t.innerHTML = '<div class="mbsc-toast-msg">' + (e.message || '') + '</div>'), Mn(wn, t, e))
    }),
    (Z.notification = {
      dismiss: function () {
        hn && hn.hide()
      },
    }))
  function Sn(e, t) {
    var a,
      n = '',
      s = pa(e),
      i = {},
      r = this
    function o() {
      s.removeClass('mbsc-no-touch')
    }
    ;(ba.call(this, e, t, !0),
      (r.refresh = function (e) {
        a.enhance && Da(s, i, a, e)
      }),
      (r._init = function () {
        ;(Z.themes.form[a.theme] || (a.theme = 'mobiscroll'),
          s.hasClass('mbsc-form') || s.on('touchstart', o).show(),
          n && s.removeClass(n),
          (n =
            'mbsc-form mbsc-no-touch mbsc-' +
            a.theme +
            (kn ? ' mbsc-form-hb' : '') +
            (a.baseTheme ? ' mbsc-' + a.baseTheme : '') +
            (a.rtl ? ' mbsc-rtl' : ' mbsc-ltr') +
            ('box' == a.inputStyle ? ' mbsc-form-box' : '') +
            ('outline' == a.inputStyle ? ' mbsc-form-outline' : '')),
          s.addClass(n).removeClass('mbsc-cloak'),
          r.refresh())
      }),
      (r._destroy = function () {
        for (var e in (s.removeClass(n).off('touchstart', o), i)) i[e].destroy()
      }),
      (r.controls = i),
      (a = r.settings),
      r.init())
  }
  var kn = 'ios' == _ && 7 < M
  ;((Sn.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _class: 'form',
    _defaults: { tap: Ie, stopProp: !0, rtl: !1, enhance: !0 },
  }),
    R('[mbsc-enhance],[mbsc-form]', (W.Form = Sn), !0))
  function Dn(e, t) {
    var i = '',
      r = pa(e),
      a = this,
      o = a.settings
    ;(ba.call(this, e, t, !0),
      (a._init = function () {
        var e = o.context,
          t = pa(e),
          a = t.find('.mbsc-ms-top .mbsc-ms'),
          n = t.find('.mbsc-ms-bottom .mbsc-ms'),
          s = {}
        ;('body' == e ? pa('body,html').addClass('mbsc-page-ctx') : t.addClass('mbsc-page-ctx'),
          i && r.removeClass(i),
          a.length && (s.paddingTop = a[0].offsetHeight),
          n.length && (s.paddingBottom = n[0].offsetHeight),
          (i = 'mbsc-page mbsc-' + o.theme + (o.baseTheme ? ' mbsc-' + o.baseTheme : '') + (o.rtl ? ' mbsc-rtl' : ' mbsc-ltr')),
          r.addClass(i).removeClass('mbsc-cloak').css(s))
      }),
      (a._destroy = function () {
        r.removeClass(i)
      }),
      (o = a.settings),
      a.init())
  }
  ;((Dn.prototype = { _hasDef: !0, _hasTheme: !0, _hasLang: !0, _class: 'page', _defaults: { context: 'body' } }),
    (W.Page = Dn),
    (Z.themes.page.mobiscroll = {}),
    R('[mbsc-page]', Dn))
  var Nn = (function (t) {
    function e(e) {
      return t.call(this, e) || this
    }
    l(e, t)
    var a = e.prototype
    return (
      (a.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new Dn(i.findDOMNode(this), e)
      }),
      (a.shouldComponentUpdate = function (e) {
        var t = !fe(this.getSettingsFromProps(this.props), this.getSettingsFromProps(e))
        return ((this.optimizeUpdate = { updateOptions: t }), !0)
      }),
      (a.render = function () {
        return b.createElement('div', { className: this.initialCssClass }, this.props.children)
      }),
      e
    )
  })(be)
  Nn.propTypes = g({}, Nn.propTypes, {}, oe, { onInit: e.func })
  var En = (function (t) {
    function e(e) {
      return t.call(this, e) || this
    }
    return (
      l(e, t),
      (e.prototype.render = function () {
        var e = 'mbsc-note mbsc-note-' + this.props.color
        return b.createElement('div', { className: e }, this.props.children)
      }),
      e
    )
  })(b.Component)
  ;(r(En, 'propTypes', { color: e.string }), r(En, 'defaultProps', { color: 'primary' }))
  var On = (function (t) {
    function e(e) {
      return t.call(this, e) || this
    }
    return (
      l(e, t),
      (e.prototype.render = function () {
        return b.createElement('img', { className: 'mbsc-avatar', src: this.props.src, alt: this.props.alt })
      }),
      e
    )
  })(b.Component)
  ;((Z.Page = Nn), (Z.Note = En), (Z.Avatar = On))
  var Vn = e.number,
    Fn = e.string,
    An = e.func,
    In = e.bool,
    Pn = { onInit: An, onChange: An, value: Vn, disabled: In, min: Vn, max: Vn, step: Vn, val: e.oneOf(['left', 'right']) },
    Hn = { onInit: An, onChange: An, checked: In, disabled: In, value: In },
    Ln = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      l(e, t)
      var a = e.prototype
      return (
        (a.componentDidMount = function () {
          var e = this.getSettingsFromProps(this.props)
          this.instance = new Sn(i.findDOMNode(this), e)
        }),
        (a.componentDidUpdate = function () {
          if (!this.optimizeUpdate.updateOptions && this.optimizeUpdate.updateChildren) this.instance.refresh(!0)
          else if (this.optimizeUpdate.updateOptions) {
            var e = this.getSettingsFromProps(this.props)
            this.instance.option(e)
          }
        }),
        (a.checkFormWrapper = function (e) {
          return 1 == b.Children.count(e.props.children) && 'form' == e.props.children.type
        }),
        (a.render = function () {
          var e = this.props,
            t = e.action,
            a = e.method,
            n = e.noValidate,
            s = e.renderForm,
            i = e.name,
            r = e.target,
            o = e.autoComplete,
            l = e.onSubmit
          return this.checkFormWrapper(this) || !s
            ? this.props.children
            : b.createElement(
                'form',
                { className: this.initialCssClass, action: t, name: i, target: r, method: a, autoComplete: o, noValidate: n, onSubmit: l },
                this.props.children,
              )
        }),
        e
      )
    })(ge)
  ;(r(Ln, 'defaultProps', { renderForm: !0 }),
    r(Ln, 'propTypes', g({}, oe, { enhance: In, labelStyle: Fn, inputStyle: Fn, onInit: An })),
    (Z.Form = Ln))
  var zn = (function (t) {
    function e(e) {
      return t.call(this, e) || this
    }
    l(e, t)
    var a = e.prototype
    return (
      (a.componentDidMount = function () {
        pe.call(this, '', this.getClasses(this.props))
      }),
      (a.componentDidUpdate = function () {
        this.cssClassUpdate && pe.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next)
      }),
      (a.shouldComponentUpdate = function (e) {
        var t = this.getClasses(e),
          a = this.getClasses(this.props)
        return ((this.cssClassUpdate = a !== t ? { prev: a, next: t } : null), !fe(this.props, e))
      }),
      (a.getClasses = function (e) {
        var t = e.valid,
          a = e.className,
          n = e.color,
          s = e.presetName,
          i = e.inputStyle,
          r = e.labelStyle,
          o = []
        ;(n && o.push('mbsc-' + s + '-' + n),
          a && o.push(a),
          i && o.push('mbsc-input-' + i),
          r && o.push('mbsc-label-' + r),
          void 0 === t || t || o.push('mbsc-err'))
        var l = ''
        return (
          o.length &&
            (l = o
              .reduce(function (e, t) {
                return e + ' ' + t
              })
              .replace(/\s+/g, ' ')
              .trim()),
          l
        )
      }),
      (a.render = function () {
        var e = this.props,
          t = (e.valid, e.className, e.color, e.children),
          a =
            (e.presetName,
            e.inputStyle,
            e.labelStyle,
            x(e, ['valid', 'className', 'color', 'children', 'presetName', 'inputStyle', 'labelStyle']))
        return b.createElement('label', a, t)
      }),
      e
    )
  })(b.Component)
  ;(r(zn, 'propTypes', { valid: e.bool, color: e.string, presetName: e.string, inputStyle: e.string, labelStyle: e.string }),
    (Z.Form.Label = zn),
    (Z.Label = zn))
  var Un = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).inputMounted = t.inputMounted.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new Rt(this.inputNode, e)
      }),
      (t.inputMounted = function (e) {
        this.inputNode = e
      }),
      (t.render = function () {
        var e = this.props,
          t = e.valid,
          a = e.errorMessage,
          n = e.type,
          s = e.icon,
          i = e.iconAlign,
          r = e.passwordToggle,
          o = e.iconShow,
          l = e.iconHide,
          c = e.iconUpload,
          d = e.inputStyle,
          u = e.labelStyle,
          m = e.children,
          h = e.dropdown,
          p = x(e, [
            'valid',
            'errorMessage',
            'type',
            'icon',
            'iconAlign',
            'passwordToggle',
            'iconShow',
            'iconHide',
            'iconUpload',
            'inputStyle',
            'labelStyle',
            'children',
            'dropdown',
          ]),
          f = null
        a && !t && (f = b.createElement('span', { className: 'mbsc-err-msg' }, a))
        var v = null
        return (
          h && (v = b.createElement('span', { className: 'mbsc-select-ic mbsc-ic mbsc-ic-arrow-down5' })),
          (n = n || 'text'),
          b.createElement(
            zn,
            { valid: t, inputStyle: d, labelStyle: u, className: h ? 'mbsc-select' : '' },
            m,
            b.createElement(
              'span',
              { className: 'mbsc-input-wrap' },
              b.createElement(
                'input',
                g(
                  {
                    ref: this.inputMounted,
                    type: n,
                    'data-icon': s,
                    'data-icon-align': i,
                    'data-password-toggle': r,
                    'data-icon-show': o,
                    'data-icon-hide': l,
                    'data-icon-upload': c,
                  },
                  p,
                ),
              ),
              v,
              f,
            ),
          )
        )
      }),
      e
    )
  })(ve)
  ;(r(Un, 'propTypes', {
    disabled: e.bool,
    valid: e.bool,
    errorMessage: e.string,
    type: e.string,
    icon: e.string,
    iconAlign: e.string,
    passwordToggle: e.bool,
    iconShow: e.string,
    iconHide: e.string,
    iconUpload: e.string,
    name: e.string,
    dropdown: e.bool,
    inputStyle: e.string,
    labelStyle: e.string,
  }),
    (Z.Input = Un))
  var Yn = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).textMounted = t.textMounted.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidUpdate = function () {
        var e = this.getSettingsFromProps(this.props)
        this.optimizeUpdate
          ? (this.optimizeUpdate.updateOptions && this.instance.option(e), this.optimizeUpdate.updateValue && this.instance.refresh())
          : (this.instance.option(e), void 0 !== this.props.value && this.instance.refresh())
      }),
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new Xt(this.inputNode, e)
      }),
      (t.textMounted = function (e) {
        this.inputNode = e
      }),
      (t.render = function () {
        var e = this.props,
          t = e.valid,
          a = e.errorMessage,
          n = e.icon,
          s = e.iconAlign,
          i = (e.inputStyle, e.labelStyle, e.children),
          r = x(e, ['valid', 'errorMessage', 'icon', 'iconAlign', 'inputStyle', 'labelStyle', 'children']),
          o = null
        return (
          a && !t && (o = b.createElement('span', { className: 'mbsc-err-msg' }, a)),
          b.createElement(
            zn,
            { valid: t },
            i,
            b.createElement(
              'span',
              { className: 'mbsc-input-wrap' },
              b.createElement('textarea', g({ ref: this.textMounted, 'data-icon': n, 'data-icon-align': s }, r)),
              o,
            ),
          )
        )
      }),
      e
    )
  })(ge)
  ;(r(Yn, 'propTypes', {
    disabled: e.bool,
    valid: e.bool,
    errorMessage: e.string,
    icon: e.string,
    iconAlign: e.string,
    name: e.string,
    inputStyle: e.string,
    labelStyle: e.string,
  }),
    (Z.Textarea = Yn))
  var Rn = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).selectMounted = t.selectMounted.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new Bt(this.selectNode, e)
      }),
      (t.selectMounted = function (e) {
        this.selectNode = e
      }),
      (t.componentDidUpdate = function () {
        this.instance._setText()
      }),
      (t.render = function () {
        var e = this.props,
          t = e.label,
          a = e.valid,
          n = e.errorMessage,
          s = e.icon,
          i = e.iconAlign,
          r = (e.inputStyle, e.labelStyle, e.children),
          o = x(e, ['label', 'valid', 'errorMessage', 'icon', 'iconAlign', 'inputStyle', 'labelStyle', 'children']),
          l = null
        return (
          (l = n && !a ? b.createElement('span', { className: 'mbsc-err-msg' }, n) : b.createElement('span', null)),
          b.createElement(
            zn,
            { valid: a },
            t,
            b.createElement(
              'span',
              { className: 'mbsc-input-wrap' },
              b.createElement('select', g({ ref: this.selectMounted, 'data-icon': s, 'data-icon-align': i }, o), r),
              l,
            ),
          )
        )
      }),
      e
    )
  })(ve)
  ;(r(Rn, 'propTypes', {
    label: e.string,
    disabled: e.bool,
    valid: e.bool,
    errorMessage: e.string,
    icon: e.string,
    iconAlign: e.string,
    name: e.string,
    inputStyle: e.string,
    labelStyle: e.string,
  }),
    (Z.Dropdown = Rn))
  var $n = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).btnMounted = t.btnMounted.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        ;((this.instance = new $t(this.btnNode, e)), pe.call(this, '', this.getCssClasses(this.props)))
      }),
      (t.componentDidUpdate = function () {
        this.cssClassUpdate && pe.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next)
      }),
      (t.shouldComponentUpdate = function (e) {
        var t = this.getCssClasses(e),
          a = this.getCssClasses(this.props)
        return ((this.cssClassUpdate = a !== t ? { prev: a, next: t } : null), !0)
      }),
      (t.btnMounted = function (e) {
        this.btnNode = e
      }),
      (t.getCssClasses = function (e) {
        var t = e.className,
          a = e.color,
          n = e.flat,
          s = e.block,
          i = e.outline,
          r = []
        ;(n && r.push('mbsc-btn-flat'),
          s && r.push('mbsc-btn-block'),
          i && r.push('mbsc-btn-outline'),
          a && r.push('mbsc-btn-' + a),
          t && r.push(t))
        var o = ''
        return (
          r.length &&
            (o = r
              .reduce(function (e, t) {
                return e + ' ' + t
              })
              .replace(/\s+/g, ' ')
              .trim()),
          o
        )
      }),
      (t.render = function () {
        var e = this.props,
          t = e.type,
          a = e.children,
          n = (e.className, e.color, e.flat, e.block, e.outline, e.icon),
          s = x(e, ['type', 'children', 'className', 'color', 'flat', 'block', 'outline', 'icon'])
        return ((t = t || 'button'), b.createElement('button', g({ ref: this.btnMounted, type: t, 'data-icon': n }, s), a))
      }),
      e
    )
  })(ve)
  ;(r($n, 'propTypes', {
    type: e.string,
    color: e.string,
    flat: e.bool,
    block: e.bool,
    outline: e.bool,
    icon: e.string,
    disabled: e.bool,
    name: e.string,
  }),
    (Z.Button = $n))
  var jn = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).inputMounted = t.inputMounted.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new jt(this.inputNode, e)
      }),
      (t.inputMounted = function (e) {
        this.inputNode = e
      }),
      (t.render = function () {
        var e = this.props,
          t = e.color,
          a = e.children,
          n = e.errorMessage,
          s = (e.inputStyle, e.valid),
          i = x(e, ['color', 'children', 'errorMessage', 'inputStyle', 'valid']),
          r = null
        return (
          n && !s && (r = b.createElement('span', { className: 'mbsc-err-msg' }, n)),
          b.createElement(
            zn,
            { valid: s, color: t, presetName: 'checkbox' },
            b.createElement('input', g({ ref: this.inputMounted, type: 'checkbox' }, i)),
            a,
            r,
          )
        )
      }),
      e
    )
  })(ve)
  ;(r(jn, 'propTypes', { color: e.string, disabled: e.bool, valid: e.bool, errorMessage: e.string, name: e.string, inputStyle: e.string }),
    (Z.Checkbox = jn))
  var Wn = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).inputMounted = t.inputMounted.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new Wt(this.inputNode, e)
      }),
      (t.inputMounted = function (e) {
        this.inputNode = e
      }),
      (t.render = function () {
        var e = this.props,
          t = e.color,
          a = e.children,
          n = (e.inputStyle, e.valid),
          s = e.errorMessage,
          i = x(e, ['color', 'children', 'inputStyle', 'valid', 'errorMessage']),
          r = null
        return (
          s && !n && (r = b.createElement('span', { className: 'mbsc-err-msg' }, s)),
          b.createElement(
            zn,
            { valid: n, color: t, presetName: 'radio' },
            b.createElement('input', g({ ref: this.inputMounted, type: 'radio' }, i)),
            a,
            r,
          )
        )
      }),
      e
    )
  })(ve)
  ;(r(Wn, 'propTypes', { color: e.string, name: e.string, disabled: e.bool, inputStyle: e.string, valid: e.bool, errorMessage: e.string }),
    (Z.Radio = Wn))
  var Bn = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).inputMounted = t.inputMounted.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new Zt(this.inputNode, e)
      }),
      (t.inputMounted = function (e) {
        this.inputNode = e
      }),
      (t.render = function () {
        var e = this.props,
          t = e.color,
          a = e.children,
          n = e.multiSelect,
          s = e.icon,
          i = x(e, ['color', 'children', 'multiSelect', 'icon']),
          r = n ? 'checkbox' : 'radio'
        return b.createElement(
          zn,
          { color: t, presetName: 'segmented' },
          b.createElement('input', g({ ref: this.inputMounted, type: r, 'data-icon': s, 'data-role': 'segmented' }, i)),
          a,
        )
      }),
      e
    )
  })(ve)
  ;(r(Bn, 'propTypes', { color: e.string, name: e.string, disabled: e.bool, multiSelect: e.bool, icon: e.string }), (Z.Segmented = Bn))
  var Jn = (function (n) {
    function e(e, t) {
      var a
      return (((a = n.call(this, e) || this).presetName = t), (a.inputMounted = a.inputMounted.bind(c(a))), a)
    }
    l(e, n)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props, this.mbscInit)
        ;((this.instance = new W[this.mbscInit.component || 'Scroller'](this.inputNode, e)),
          pa(this.inputNode).on('change', this.props.onChange || function () {}),
          pe.call(this, '', this.getCssClasses(this.props)))
      }),
      (t.shouldComponentUpdate = function (e) {
        var t = this.getCssClasses(e),
          a = this.getCssClasses(this.props)
        return (
          (this.cssClassUpdate = a !== t ? { prev: a, next: t } : null),
          n.prototype.shouldComponentUpdate.call(this, e) || this.cssClassUpdate
        )
      }),
      (t.componentDidUpdate = function () {
        if ((this.cssClassUpdate && pe.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next), this.optimizeUpdate.updateOptions)) {
          var e = this.getSettingsFromProps(this.props)
          this.instance.option(e)
        }
      }),
      (t.inputMounted = function (e) {
        this.inputNode = e
      }),
      (t.getCssClasses = function (e) {
        var t = e.className,
          a = e.color,
          n = []
        return (
          a && n.push('mbsc-' + this.presetName + '-' + a),
          t && n.push(t),
          n.length
            ? n
                .reduce(function (e, t) {
                  return e + ' ' + t
                })
                .replace(/\s+/g, ' ')
                .trim()
            : ''
        )
      }),
      (t.render = function () {
        var e = this.props,
          t = (e.className, e.children),
          a = (e.value, e.valid),
          n = e.errorMessage,
          s = (e.checked, e.onChange, e.name),
          i = (e.color, e.labelStyle),
          r = e.inputStyle,
          o = x(e, [
            'className',
            'children',
            'value',
            'valid',
            'errorMessage',
            'checked',
            'onChange',
            'name',
            'color',
            'labelStyle',
            'inputStyle',
          ]),
          l = null
        n && !a && (l = b.createElement('span', { className: 'mbsc-err-msg' }, n))
        var c = this.inputType || 'text'
        return b.createElement(
          zn,
          { valid: a, inputStyle: r, labelStyle: i },
          t,
          b.createElement('input', g({ ref: this.inputMounted, type: c, 'data-role': s, 'data-enhance': 'false' }, o)),
          l,
        )
      }),
      e
    )
  })(ge)
  r(Jn, 'propTypes', g({}, oe, { color: Fn, labelStyle: Fn, inputStyle: Fn }))
  var qn = (function (n) {
    function e(e) {
      var t
      return (((t = n.call(this, e, 'switch') || this).mbscInit = { component: 'Switch' }), (t.inputType = 'checkbox'), t)
    }
    l(e, n)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        ;(n.prototype.componentDidMount.call(this), void 0 !== this.props.checked && this.instance.setVal(this.props.checked, !0, !1))
      }),
      (t.shouldComponentUpdate = function (e) {
        var t = n.prototype.shouldComponentUpdate.call(this, e),
          a = (this.optimizeUpdate.updateChecked = !fe(e.checked, this.props.checked))
        return t || a
      }),
      (t.componentDidUpdate = function () {
        ;(n.prototype.componentDidUpdate.call(this),
          this.optimizeUpdate.updateChecked && !fe(this.instance.getVal(), this.props.checked) && this.instance.setVal(this.props.checked))
      }),
      e
    )
  })(Jn)
  ;((qn.propTypes = g({}, qn.propTypes, {}, Hn)), (Z.Switch = qn))
  var Kn = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e, 'stepper') || this).mbscInit = { component: 'Stepper' }), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        ;(a.prototype.componentDidMount.call(this), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0, !1))
      }),
      (t.componentDidUpdate = function () {
        ;(a.prototype.componentDidUpdate.call(this),
          this.optimizeUpdate.updateValue && !fe(this.props.value, this.instance.getVal()) && this.instance.setVal(this.props.value))
      }),
      e
    )
  })(Jn)
  ;((Kn.propTypes = g({}, Kn.propTypes, {}, Pn)), (Z.Stepper = Kn))
  var Gn = (function (n) {
      function e(e) {
        return n.call(this, e) || this
      }
      l(e, n)
      var t = e.prototype
      return (
        (t.componentDidMount = function () {
          pe.call(this, '', this.getCssClasses(this.props))
        }),
        (t.componentDidUpdate = function () {
          ;(n.prototype.componentDidUpdate.call(this),
            this.cssClassUpdate && pe.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next))
        }),
        (t.shouldComponentUpdate = function (e) {
          var t = this.getCssClasses(e),
            a = this.getCssClasses(this.props)
          return (
            (this.cssClassUpdate = a !== t ? { prev: a, next: t } : null),
            n.prototype.shouldComponentUpdate.call(this, e) || this.cssClassUpdate
          )
        }),
        (t.getCssClasses = function (e) {
          var t = e.className,
            a = e.color,
            n = []
          return (
            a && n.push('mbsc-' + this.presetName + '-' + a),
            t && n.push(t),
            n.length
              ? n
                  .reduce(function (e, t) {
                    return e + ' ' + t
                  })
                  .replace(/\s+/g, ' ')
                  .trim()
              : ''
          )
        }),
        e
      )
    })(ge),
    Xn = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).presetName = 'progress'), (t.progressMounted = t.progressMounted.bind(c(t))), t)
      }
      l(e, a)
      var t = e.prototype
      return (
        (t.componentDidMount = function () {
          var e = this.getSettingsFromProps(this.props)
          ;((this.instance = new na(this.progressNode, e)),
            void 0 !== this.props.value && this.instance.setVal(this.props.value, !0),
            a.prototype.componentDidMount.call(this))
        }),
        (t.progressMounted = function (e) {
          this.progressNode = e
        }),
        (t.render = function () {
          var e = this.props,
            t = (e.className, e.children),
            a = (e.value, e.color, e.inputStyle),
            n = e.labelStyle,
            s = x(e, ['className', 'children', 'value', 'color', 'inputStyle', 'labelStyle'])
          return b.createElement(zn, { labelStyle: n, inputStyle: a }, t, b.createElement('progress', g({ ref: this.progressMounted }, s)))
        }),
        e
      )
    })(Gn)
  ;(r(
    Xn,
    'propTypes',
    g({}, oe, {
      'data-icon': Fn,
      'data-icon-align': e.oneOf(['left', 'right']),
      val: e.oneOf(['left', 'right']),
      disabled: In,
      max: Vn,
      value: Vn,
      color: Fn,
      inputStyle: Fn,
      labelStyle: Fn,
    }),
  ),
    (Z.Progress = Xn))
  var Zn = (function (a) {
    function e(e) {
      var t
      return (
        ((t = a.call(this, e) || this).presetName = 'slider'),
        (t.firstInputMounted = t.firstInputMounted.bind(c(t))),
        (t.parentMounted = t.parentMounted.bind(c(t))),
        t
      )
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        ;((this.instance = new _a(this.firstInput, e)), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0))
        var t = this
        ;(pa(this.label).on('change', function () {
          if (t.props.onChange) {
            var e = t.instance.getVal()
            t.props.onChange(e)
          }
        }),
          a.prototype.componentDidMount.call(this))
      }),
      (t.firstInputMounted = function (e) {
        this.firstInput = e
      }),
      (t.parentMounted = function (e) {
        this.label = i.findDOMNode(e)
      }),
      (t.onValueChanged = function () {}),
      (t.render = function () {
        var e = this.props,
          t = e.children,
          a = e.value,
          n = (e.onChange, e.className, e.icon),
          s = e.live,
          i = (e.stepLabels, e.tooltip, e.color, e.inputStyle),
          r = e.labelStyle,
          o = x(e, [
            'children',
            'value',
            'onChange',
            'className',
            'icon',
            'live',
            'stepLabels',
            'tooltip',
            'color',
            'inputStyle',
            'labelStyle',
          ]),
          l = a || []
        return (
          (s = s || this.props['data-live'] || !1),
          (n = n || this.props['data-icon']),
          void 0 === a || Array.isArray(a) || (l = [a]),
          b.createElement(
            zn,
            { ref: this.parentMounted, labelStyle: r, inputStyle: i },
            t,
            l.map(function (e, t) {
              return 0 === t
                ? b.createElement(
                    'input',
                    g(
                      {
                        ref: this.firstInputMounted,
                        'data-label-style': r,
                        'data-input-style': i,
                        'data-icon': n,
                        'data-live': s,
                        key: t,
                        type: 'range',
                      },
                      o,
                    ),
                  )
                : b.createElement('input', {
                    key: t,
                    type: 'range',
                    'data-live': s,
                    'data-index': t,
                    'data-label-style': r,
                    'data-input-style': i,
                  })
            }, this),
          )
        )
      }),
      e
    )
  })(Gn)
  ;(r(
    Zn,
    'propTypes',
    g({}, oe, {
      highlight: In,
      live: In,
      stepLabels: e.arrayOf(Vn),
      'data-icon': Fn,
      tooltip: In,
      val: e.oneOf(['left', 'right']),
      disabled: In,
      max: Vn,
      min: Vn,
      step: Vn,
      value: e.oneOfType([Vn, e.arrayOf(Vn)]),
      color: Fn,
      inputStyle: Fn,
      labelStyle: Fn,
    }),
  ),
    (Z.Slider = Zn))
  var Qn = (function (a) {
    function e(e) {
      var t
      return (
        ((t = a.call(this, e) || this).presetName = 'rating'),
        (t.inputMounted = t.inputMounted.bind(c(t))),
        (t.parentMounted = t.parentMounted.bind(c(t))),
        t
      )
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var t = this,
          e = this.getSettingsFromProps(this.props)
        ;((this.instance = new wa(this.inputNode, e)),
          void 0 !== this.props.value && this.instance.setVal(this.props.value, !0),
          pa(this.label).on('change', function () {
            if (t.props.onChange) {
              var e = t.instance.getVal()
              t.props.onChange(e)
            }
          }),
          a.prototype.componentDidMount.call(this))
      }),
      (t.inputMounted = function (e) {
        this.inputNode = e
      }),
      (t.parentMounted = function (e) {
        this.label = e
      }),
      (t.render = function () {
        var e = this.props,
          t = (e.className, e.children),
          a = (e.onChange, e.value, e.empty),
          n = e.filled,
          s = e.template,
          i = e.val,
          r = (e.color, e.inputStyle),
          o = e.labelStyle,
          l = x(e, [
            'className',
            'children',
            'onChange',
            'value',
            'empty',
            'filled',
            'template',
            'val',
            'color',
            'inputStyle',
            'labelStyle',
          ])
        return b.createElement(
          zn,
          { ref: this.parentMounted, labelStyle: o, inputStyle: r },
          t,
          b.createElement(
            'input',
            g(
              {
                type: 'rating',
                'data-role': 'rating',
                'data-val': i,
                'data-template': s,
                'data-empty': a,
                'data-filled': n,
                ref: this.inputMounted,
              },
              l,
            ),
          ),
        )
      }),
      e
    )
  })(Gn)
  ;(r(
    Qn,
    'propTypes',
    g({}, oe, {
      val: e.oneOf(['left', 'right']),
      disabled: In,
      max: Vn,
      min: Vn,
      step: Vn,
      template: Fn,
      empty: Fn,
      filled: Fn,
      value: Vn,
      color: Fn,
      inputStyle: Fn,
      labelStyle: Fn,
    }),
  ),
    (Z.Rating = Qn))
  var es = (function (t) {
    function e(e) {
      return t.call(this, e) || this
    }
    l(e, t)
    var a = e.prototype
    return (
      (a.componentDidMount = function () {
        if (void 0 !== this.props.collapsible) {
          var e = this.props.open || !1
          this.instance = new Sa(i.findDOMNode(this), { isOpen: e })
        }
      }),
      (a.componentDidUpdate = function (e) {
        void 0 !== this.props.open && this.props.open != e.open && (this.props.open ? this.instance.show() : this.instance.hide())
      }),
      (a.render = function () {
        var e = this.props,
          t = e.children,
          a = e.inset,
          n = (e.collapsible, e.className),
          s = x(e, ['children', 'inset', 'collapsible', 'className']),
          i = 'mbsc-form-group' + (void 0 !== a ? '-inset' : '') + ' ' + (n || '')
        return b.createElement('div', g({ className: i }, s), t)
      }),
      e
    )
  })(b.Component)
  ;(r(es, 'propTypes', { collapsible: e.bool, open: e.bool, inset: e.any }), (Z.FormGroup = es), (Z.MbscFormGroup = es))
  var ts = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).cssClasses = 'mbsc-form-group-title ' + (t.props.className || '')), t)
    }
    return (
      l(e, a),
      (e.prototype.render = function () {
        return b.createElement('div', { className: this.cssClasses }, this.props.children)
      }),
      e
    )
  })(b.Component)
  ;((Z.FormGroupTitle = ts), (Z.MbscFormGroupTitle = ts))
  var as = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).cssClasses = 'mbsc-form-group-content ' + (t.props.className || '')), t)
    }
    return (
      l(e, a),
      (e.prototype.render = function () {
        return b.createElement('div', { className: this.cssClasses }, this.props.children)
      }),
      e
    )
  })(b.Component)
  ;((Z.FormGroupContent = as), (Z.MbscFormGroupContent = as))
  var ns = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).cssClasses = 'mbsc-accordion ' + (t.props.className || '')), t)
    }
    return (
      l(e, a),
      (e.prototype.render = function () {
        return b.createElement('div', { className: this.cssClasses }, this.props.children)
      }),
      e
    )
  })(b.Component)
  Z.Accordion = ns
  function ss(c) {
    var s,
      t,
      l,
      e,
      a = va({}, c.settings),
      d = va(c.settings, is, a),
      n = d.layout || (/top|bottom/.test(d.display) ? 'liquid' : ''),
      u = 'liquid' == n,
      i = d.readonly,
      r = pa(this),
      o = this.id + '_dummy',
      m = 0,
      h = [],
      p =
        d.wheelArray ||
        (function o(e) {
          var l = []
          var t = 1 < e.length ? e : e.children(d.itemSelector)
          t.each(function (e) {
            var t = pa(this),
              a = t.clone()
            ;(a.children('ul,ol').remove(), a.children(d.itemSelector).remove())
            var n = c._processMarkup
                ? c._processMarkup(a)
                : a
                    .html()
                    .replace(/^\s\s*/, '')
                    .replace(/\s\s*$/, ''),
              s = !!t.attr('data-invalid'),
              i = {
                key: void 0 === t.attr('data-val') || null === t.attr('data-val') ? e : t.attr('data-val'),
                value: n,
                invalid: s,
                children: null,
              },
              r = 'li' === d.itemSelector ? t.children('ul,ol') : t.children(d.itemSelector)
            ;(r.length && (i.children = o(r)), l.push(i))
          })
          return l
        })(r),
      f = (function (e) {
        var t,
          a = [],
          n = e,
          s = !0,
          i = 0
        for (; s; ) ((t = g(n)), (a[i++] = t.key), (s = t.children) && (n = s))
        return a
      })(p)
    function v(e, t, a) {
      for (var n, s = 0, i = a, r = []; s < t; ) {
        var o = e[s]
        for (n in i)
          if (i[n].key == o) {
            i = i[n].children
            break
          }
        s++
      }
      for (s = 0; s < i.length; ) (i[s].invalid && r.push(i[s].key), s++)
      return r
    }
    function b(e, t, a) {
      var n,
        s,
        i = 0,
        r = !0,
        o = [[]],
        l = p
      if (t) for (s = 0; s < t; s++) u ? (o[0][s] = {}) : (o[s] = [{}])
      for (; r; ) {
        for (u ? (o[0][i] = x(l, i)) : (o[i] = [x(l, i)]), s = 0, n = null; s < l.length && !n; )
          (l[s].key == e[i] && ((void 0 !== a && i <= a) || void 0 === a) && (n = l[s]), s++)
        ;(n = n || g(l)) && n.children ? ((l = n.children), i++) : (r = !1)
      }
      return o
    }
    function g(e, t) {
      if (!e) return !1
      for (var a, n = 0; n < e.length; ) if (!(a = e[n++]).invalid) return t ? n - 1 : a
      return !1
    }
    function x(e, t) {
      for (var a = { data: [], label: d.labels && d.labels[t] ? d.labels[t] : t }, n = 0; n < e.length; )
        (a.data.push({ value: e[n].key, display: e[n].value }), n++)
      return a
    }
    function T(e) {
      c._isVisible && pa('.mbsc-sc-whl-w', c._markup).css('display', '').slice(e).hide()
    }
    function y(e, t) {
      for (var a, n, s, i = 0, r = p, o = !0, l = []; o; ) {
        if (void 0 !== e[i] && i <= t)
          for (s = 0, n = e[i], a = void 0; s < r.length && void 0 === a; ) (r[s].key != e[i] || r[s].invalid || (a = s), s++)
        else n = r[(a = g(r, !0))] && r[a].key
        ;((l[i] = n), i++, (o = !!r[a] && r[a].children), (r = r[a] && r[a].children))
      }
      return { lvl: i, nVector: l }
    }
    function C(e, t, a) {
      var n,
        s,
        i = (t || 0) + 1,
        r = [],
        o = {}
      for (s = b(e, null, t), n = 0; n < e.length; n++) c._tempWheelArray[n] = e[n] = a.nVector[n] || 0
      for (; i < a.lvl; ) ((o[i] = u ? s[0][i] : s[i][0]), r.push(i++))
      ;(T(a.lvl), (h = e.slice(0)), r.length && ((l = !0), c.changeWheel(o)))
    }
    return (
      (function e(t, a) {
        var n
        for (m = m < a ? a : m, n = 0; n < t.length; n++) t[n].children && e(t[n].children, a + 1)
      })(p, 1),
      (e = b(f, m)),
      pa('#' + o).remove(),
      d.input
        ? (t = pa(d.input))
        : d.showInput &&
          (t = pa(
            '<input type="text" id="' +
              o +
              '" value="" class="' +
              d.inputClass +
              '" placeholder="' +
              (d.placeholder || '') +
              '" readonly />',
          ).insertBefore(r)),
      t && c.attachShow(t),
      d.wheelArray || r.hide(),
      {
        wheels: e,
        anchor: t,
        layout: n,
        headerText: !1,
        setOnTap: 1 == m,
        formatValue: function (e) {
          return (void 0 === s && (s = y(e, e.length).lvl), e.slice(0, s).join(' '))
        },
        parseValue: function (e) {
          return e ? (e + '').split(' ') : (d.defaultValue || f).slice(0)
        },
        onBeforeShow: function () {
          var e = c.getArrayVal(!0)
          ;((h = e.slice(0)), (d.wheels = b(e, m, m)), (l = !0))
        },
        onWheelGestureStart: function (e) {
          d.readonly = (function (e, t) {
            for (var a = []; e; ) a[--e] = !0
            return ((a[t] = !1), a)
          })(m, e.index)
        },
        onWheelAnimationEnd: function (e) {
          var t = e.index,
            a = c.getArrayVal(!0),
            n = y(a, t)
          ;((s = n.lvl), (d.readonly = i), a[t] != h[t] && C(a, t, n))
        },
        onFill: function (e) {
          ;((s = void 0), t && t.val(e.valueText))
        },
        validate: function (e) {
          var t = e.values,
            a = e.index,
            n = y(t, t.length)
          return (
            (s = n.lvl),
            void 0 === a && (T(n.lvl), l || C(t, a, n)),
            (l = !1),
            {
              disabled: (function (e, t, a) {
                for (var n = 0, s = []; n < e; ) ((s[n] = v(a, n, t)), n++)
                return s
              })(s, p, t),
            }
          )
        },
        onDestroy: function () {
          ;(t && pa('#' + o).remove(), r.show())
        },
      }
    )
  }
  var is = { invalid: [], showInput: !0, inputClass: '', itemSelector: 'li' }
  vt.image = function (e) {
    return (
      e.settings.enhance &&
        (e._processMarkup = function (e) {
          var t = e.attr('data-icon')
          return (
            e.children().each(function (e, t) {
              ;(t = pa(t)).is('img')
                ? pa('<div class="mbsc-img-c"></div>').insertAfter(t).append(t.addClass('mbsc-img'))
                : t.is('p') && t.addClass('mbsc-img-txt')
            }),
            t && e.prepend('<div class="mbsc-ic mbsc-ic-' + t + '"></div'),
            e.html('<div class="mbsc-img-w">' + e.html() + '</div>'),
            e.html()
          )
        }),
      ss.call(this, e)
    )
  }
  var rs = {
      defaultValue: e.arrayOf(e.oneOfType([e.number, e.string])),
      enhance: e.bool,
      inputClass: e.string,
      invalid: e.array,
      labels: e.arrayOf(e.string),
      placeholder: e.string,
      showInput: e.bool,
    },
    os = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { preset: 'image' }), t)
      }
      return (l(e, a), e)
    })(Te)
  ;((os.propTypes = g({}, os.propTypes, {}, rs)), (Z.Image = os))
  function ls(e, t) {
    var l,
      s,
      c,
      d,
      a,
      u,
      m,
      T,
      h,
      p,
      o,
      f,
      n,
      i,
      r,
      v,
      b,
      g,
      x,
      y,
      C,
      _,
      w,
      M,
      S,
      k,
      D,
      N,
      E,
      O,
      V,
      F,
      A,
      I,
      P,
      H,
      L,
      z,
      U,
      Y,
      R,
      $,
      j,
      W,
      B,
      J,
      q,
      K,
      G,
      X,
      Z,
      Q,
      ee,
      te,
      ae,
      ne,
      se,
      ie,
      re,
      oe,
      le,
      ce,
      de,
      ue,
      me,
      he,
      pe,
      fe,
      ve,
      be,
      ge,
      xe,
      Te,
      ye,
      Ce,
      _e,
      we,
      Me,
      Se,
      ke,
      De,
      Ne,
      Ee,
      Oe,
      Ve,
      Fe,
      Ae,
      Ie,
      Pe,
      He,
      Le,
      ze,
      Ue,
      Ye,
      Re,
      $e,
      je,
      We,
      Be,
      Je,
      qe,
      Ke,
      Ge,
      Xe,
      Ze,
      Qe = this,
      et = e,
      tt = pa(et),
      at = 0,
      nt = 0,
      st = 0,
      it = {},
      rt = {},
      ot = {}
    function lt() {
      ;((ve = we = !1),
        (Ae = d = 0),
        (Ie = new Date()),
        (G = p.width()),
        (n = zt(p)),
        (Q = n.index(X)),
        (Z = X[0].offsetHeight),
        (st = X[0].offsetTop),
        (We = Be[X.attr('data-type') || 'defaults']),
        (Fe = We.stages))
    }
    function ct(e) {
      var t
      ;('touchstart' === e.type && (T.removeClass('mbsc-no-touch'), (be = !0), clearTimeout(ge)),
        !ga(e, this) ||
          l ||
          at ||
          cs ||
          Qt ||
          ((J = !(a = l = !0)),
          (K = 'touchstart' === e.type),
          (Pe = ua(e, 'X')),
          (He = ua(e, 'Y')),
          (x = g = 0),
          (X = pa(this)),
          (t = X),
          lt(),
          (Re = We.actionable || X.hasClass('mbsc-lv-parent') || X.hasClass('mbsc-lv-back')),
          (ae = X.offset().top),
          Re &&
            (c = setTimeout(function () {
              ;(t.addClass(K ? us : ''), D('onItemActivate', { target: t[0], domEvent: e }))
            }, 120)),
          Qe.sortable &&
            !X.hasClass('mbsc-lv-back') &&
            (Qe.sortable.group ||
              ((he = X.nextUntil('.mbsc-lv-gr-title').filter('.mbsc-lv-item')),
              (xe = X.prevUntil('.mbsc-lv-gr-title').filter('.mbsc-lv-item'))),
            (oe = (Qe.sortable.group ? p.children(te).eq(0) : xe.length ? xe.eq(-1) : X)[0].offsetTop - st),
            (re = (Qe.sortable.group ? p.children(te).eq(-1) : he.length ? he.eq(-1) : X)[0].offsetTop - st),
            Qe.sortable.handle
              ? pa(e.target).hasClass('mbsc-lv-handle') &&
                (clearTimeout(c),
                'Moz' === Ca
                  ? (e.preventDefault(), vt())
                  : (je = setTimeout(function () {
                      vt()
                    }, 100)))
              : (je = setTimeout(function () {
                  ;(N.appendTo(X),
                    (N[0].style[Ca + 'Animation'] = 'mbsc-lv-fill ' + (ke.sortDelay - 100) + 'ms linear'),
                    clearTimeout(M),
                    clearTimeout(c),
                    (a = !1),
                    (je = setTimeout(function () {
                      ;((N[0].style[Ca + 'Animation'] = ''), vt())
                    }, ke.sortDelay - 80)))
                }, 80))),
          'mousedown' == e.type && pa(document).on('mousemove', dt).on('mouseup', ut)))
    }
    function dt(e) {
      var t = !1,
        a = !0,
        n = d
      if (l)
        if (
          ((S = ua(e, 'X')),
          (k = ua(e, 'Y')),
          (g = S - Pe),
          (x = k - He),
          clearTimeout(M),
          _ ||
            ze ||
            De ||
            X.hasClass('mbsc-lv-back') ||
            (10 < Math.abs(x)
              ? ((De = !0), ut(va({}, e, { type: 'mousemove' == e.type ? 'mouseup' : 'touchend' })), clearTimeout(c))
              : 7 < Math.abs(g) && ht()),
          ze)
        )
          (e.preventDefault(), (d = (g / G) * 100), pt(n))
        else if (_) {
          e.preventDefault()
          var s,
            i = Ke.scrollTop(),
            r = Math.max(oe, Math.min(x + Xe, re)),
            o = A ? ae - Ze + i - Xe : ae
          ;(Ge + i < o + r + Z ? (Ke.scrollTop(o + r - Ge + Z), (s = !0)) : o + r < i && (Ke.scrollTop(o + r), (s = !0)),
            s && (Xe += Ke.scrollTop() - i),
            ue &&
              (Qe.sortable.multiLevel && de.hasClass('mbsc-lv-parent')
                ? ue < st + Z / 4 + r
                  ? (t = !0)
                  : ue < st + Z - Z / 4 + r && ((y = de.addClass('mbsc-lv-item-hl')), (a = !1))
                : ue < st + Z / 2 + r &&
                  (de.hasClass('mbsc-lv-back') ? Qe.sortable.multiLevel && ((C = de.addClass('mbsc-lv-item-hl')), (a = !1)) : (t = !0)),
              t && (Te.insertAfter(de), (de = Yt((ye = de), 'next')), (Ce = ue), (ue = de.length && de[0].offsetTop), h++)),
            !t &&
              Ce &&
              (Qe.sortable.multiLevel && ye.hasClass('mbsc-lv-parent')
                ? st + Z - Z / 4 + r < Ce
                  ? (t = !0)
                  : st + Z / 4 + r < Ce && ((y = ye.addClass('mbsc-lv-item-hl')), (a = !1))
                : st + Z / 2 + r < Ce &&
                  (ye.hasClass('mbsc-lv-back') ? Qe.sortable.multiLevel && ((C = ye.addClass('mbsc-lv-item-hl')), (a = !1)) : (t = !0)),
              t &&
                (Te.insertBefore(ye),
                (ye = Yt((de = ye), 'prev')),
                (ue = Ce),
                (Ce = ye.length && ye[0].offsetTop + ye[0].offsetHeight),
                h--)),
            a && (y && (y.removeClass('mbsc-lv-item-hl'), (y = !1)), C && (C.removeClass('mbsc-lv-item-hl'), (C = !1))),
            t && D('onSortChange', { target: X[0], index: h }),
            Nt(X, r),
            D('onSort', { target: X[0], index: h }))
        } else (5 < Math.abs(g) || 5 < Math.abs(x)) && Et()
    }
    function ut(e) {
      var t,
        a,
        n,
        s = X
      l &&
        ((l = !1),
        Et(),
        'mouseup' == e.type && pa(document).off('mousemove', dt).off('mouseup', ut),
        De ||
          (ge = setTimeout(function () {
            be = !1
          }, 300)),
        (ze || De || _) && (ve = !0),
        ze
          ? ft()
          : _
            ? ((n = p),
              y
                ? (At(X.detach()),
                  (a = ot[y.attr('data-ref')]),
                  (h = zt(a.child).length),
                  y.removeClass('mbsc-lv-item-hl'),
                  ke.navigateOnDrop
                    ? Jt(y, function () {
                        ;(Qe.add(null, X, null, null, y, !0), Wt(X), bt(X, Q, n, !0))
                      })
                    : (Qe.add(null, X, null, null, y, !0), bt(X, Q, n, !0)))
                : C
                  ? (At(X.detach()),
                    (a = ot[C.attr('data-back')]),
                    (h = zt(a.parent).index(a.item) + 1),
                    C.removeClass('mbsc-lv-item-hl'),
                    ke.navigateOnDrop
                      ? Jt(C, function () {
                          ;(Qe.add(null, X, h, null, p, !0), Wt(X), bt(X, Q, n, !0))
                        })
                      : (Qe.add(null, X, h, null, a.parent, !0), bt(X, Q, n, !0)))
                  : ((t = Te[0].offsetTop - st),
                    Nt(X, t, 6 * Math.abs(t - Math.max(oe, Math.min(x + Xe, re))), function () {
                      ;(At(X), X.insertBefore(Te), bt(X, Q, n, h !== Q))
                    })),
              (_ = !1))
            : !De && Math.abs(g) < 5 && Math.abs(x) < 5 && ((J = !0), 'touchend' === e.type && ke.tap && ha(e.target, ma(pa(e.target)), e)),
        clearTimeout(c),
        setTimeout(function () {
          ;(s.removeClass(us), D('onItemDeactivate', { target: s[0] }))
        }, 100),
        (De = !1),
        (i = null))
    }
    function mt(e) {
      var t
      J &&
        ((t = 'true' == X.attr('data-selected')),
        We.tap && We.tap.call(et, { target: X, index: Q, domEvent: e }, Qe),
        Re && !X.hasClass(us) && (X.addClass(K ? us : ''), D('onItemActivate', { target: X[0], domEvent: e })),
        Ne && (ce ? (t ? Zt(X) : Xt(X)) : (Zt(pa(te, T).filter('.' + ds)), Xt(X))),
        !1 !== D('onItemTap', { target: X[0], index: Q, domEvent: e, selected: t }) && Jt(X))
    }
    function ht() {
      ;(ze = It(We.swipe, { target: X[0], index: Q, direction: 0 < g ? 'right' : 'left' })) &&
        (Et(),
        clearTimeout(c),
        We.actions
          ? ((s = jt(We, g)),
            le
              .html(We.icons)
              .show()
              .children()
              .css('width', s + '%'),
            W.hide(),
            pa('.mbsc-lv-ic-m', B).removeClass('mbsc-lv-ic-disabled'),
            pa(We.leftMenu).each(_t),
            pa(We.rightMenu).each(_t))
          : (W.show(), le.hide(), (r = We.start), (i = Fe[r]), (_e = Fe[r - 1]), (me = Fe[r + 1])),
        X.addClass('mbsc-lv-item-swiping').removeClass(us),
        $e.css('line-height', Z + 'px'),
        B.css({ top: st, height: Z, backgroundColor: Rt(g) })
          .addClass('mbsc-lv-stage-c-v')
          .appendTo(p.parent()),
        ke.iconSlide && X.append(W),
        D('onSlideStart', { target: X[0], index: Q }))
    }
    function pt(e) {
      var t = !1
      Se ||
        (We.actions
          ? B.attr('class', 'mbsc-lv-stage-c-v mbsc-lv-stage-c mbsc-lv-' + (d < 0 ? 'right' : 'left'))
          : (_e && (d < 0 ? d <= _e.percent : d < i.percent)
              ? ((me = i), (i = _e), (_e = Fe[--r - 1]), (t = !0))
              : me && (d < 0 ? d > i.percent : d >= me.percent) && ((_e = i), (i = me), (me = Fe[++r + 1]), (t = !0)),
            i && ((!t && 0 < d != e <= 0) || Ot(i, ke.iconSlide), t && D('onStageChange', { target: X[0], index: Q, stage: i }))),
        Ee || ((Se = !0), (Me = sa(St))))
    }
    function ft(t) {
      var e,
        a,
        n = !1
      ;(ia(Me),
        (Se = !1),
        Ee || St(),
        We.actions
          ? 10 < Math.abs(d) &&
            s &&
            (Dt(X, d < 0 ? -s : s, 200),
            (cs = n = !0),
            (u = X),
            (m = Q),
            pa(document).on('touchstart.mbsc-lv-conf mousedown.mbsc-lv-conf', function (e) {
              ;(e.preventDefault(), kt(X, !0, t))
            }))
          : d &&
            (ke.quickSwipe &&
              !Ee &&
              ((e = (a = new Date() - Ie) < 300 && 50 < g),
              a < 300 && g < -50 ? ((we = !0), Ot((i = We.left), ke.iconSlide)) : e && ((we = !0), Ot((i = We.right), ke.iconSlide))),
            i &&
              i.action &&
              (It(i.disabled, { target: X[0], index: Q }) ||
                ((n = !0),
                (cs = Ee || It(i.confirm, { target: X[0], index: Q }))
                  ? (Dt(X, ((d < 0 ? -1 : 1) * W[0].offsetWidth * 100) / G, 200, !0), Mt(i, X, Q, !1, t))
                  : wt(i, X, Q, t)))),
        n || kt(X, !0, t),
        (ze = !1))
    }
    function vt() {
      ;((C = y = !(_ = !0)),
        (Xe = 0),
        (h = Q),
        ke.vibrate && ca(),
        (de = Yt(X, 'next')),
        (ue = de.length && de[0].offsetTop),
        (ye = Yt(X, 'prev')),
        (Ce = ye.length && ye[0].offsetTop + ye[0].offsetHeight),
        Te.height(Z).insertAfter(X),
        X.css({ top: st }).addClass('mbsc-lv-item-dragging').removeClass(us).appendTo(w),
        D('onSortStart', { target: X[0], index: h }))
    }
    function bt(t, a, n, e) {
      ;(t.removeClass('mbsc-lv-item-dragging'),
        Te.remove(),
        D('onSortEnd', { target: t[0], index: h }),
        ke.vibrate && ca(),
        e &&
          (Qe.addUndoAction(function (e) {
            Qe.move(t, a, null, e, n, !0)
          }, !0),
          D('onSortUpdate', { target: t[0], index: h })))
    }
    function gt() {
      be || (clearTimeout(Y), cs && pa(document).trigger('touchstart'), L && (Qe.close(H, z), (L = !1), (H = null)))
    }
    function xt() {
      ;(clearTimeout(v),
        (v = setTimeout(function () {
          ;((Ge = Ke[0].innerHeight || Ke.innerHeight()),
            (Ze = A ? Ke.offset().top : 0),
            l && ((st = X[0].offsetTop), (Z = X[0].offsetHeight), B.css({ top: st, height: Z })))
        }, 200)))
    }
    function Tt(e) {
      ve && (e.stopPropagation(), e.preventDefault(), (ve = !1))
    }
    function yt() {
      q ||
        (clearTimeout(fe),
        (fe = setTimeout(function () {
          var e = A ? Ke[0].getBoundingClientRect().top + Ke.innerHeight() : window.innerHeight,
            t = ie[0].getBoundingClientRect().top - 3 < e
          !q && t && D('onListEnd')
        }, 250)))
    }
    function Ct() {
      if (_ || !l) {
        var a,
          e = Ke.scrollTop(),
          t = tt.offset().top,
          n = tt[0].offsetHeight,
          s = A ? Ke.offset().top : e
        ;(pa('.mbsc-lv-gr-title', tt).each(function (e, t) {
          pa(t).offset().top < s && (a = t)
        }),
          t < s && s < t + n ? O.show().empty().append(pa(a).clone()) : O.hide())
      }
    }
    function _t(e, t) {
      It(t.disabled, { target: X[0], index: Q }) && pa('.mbsc-ic-' + t.icon, B).addClass('mbsc-lv-ic-disabled')
    }
    function wt(e, t, a, n) {
      var s,
        i = {
          icon: 'undo2',
          text: ke.undoText,
          action: function () {
            Qe.undo()
          },
        }
      ;(e.undo &&
        (Qe.startActionTrack(),
        pa.isFunction(e.undo) &&
          Qe.addUndoAction(function () {
            e.undo.call(et, { target: t[0], index: a }, Qe)
          }),
        (Je = t.attr('data-ref'))),
        (s = e.action.call(et, { target: t[0], index: a }, Qe)),
        e.undo
          ? (Qe.endActionTrack(),
            !1 !== s && Dt(t, +t.attr('data-pos') < 0 ? -100 : 100, 200),
            Te.height(Z).insertAfter(t),
            t.css('top', st).addClass('mbsc-lv-item-undo'),
            le.hide(),
            W.show(),
            B.append(W),
            Ot(i),
            Mt(i, t, a, !0, n))
          : kt(t, s, n))
    }
    function Mt(t, a, n, s, i) {
      var r, o
      ;((cs = !0),
        pa(document)
          .off('.mbsc-lv-conf')
          .on('touchstart.mbsc-lv-conf mousedown.mbsc-lv-conf', function (e) {
            ;(e.preventDefault(), s && Ft(a), kt(a, !0, i))
          }),
        b ||
          W.off('.mbsc-lv-conf')
            .on('touchstart.mbsc-lv-conf mousedown.mbsc-lv-conf', function (e) {
              ;(e.stopPropagation(), (r = ua(e, 'X')), (o = ua(e, 'Y')))
            })
            .on('touchend.mbsc-lv-conf mouseup.mbsc-lv-conf', function (e) {
              ;(e.preventDefault(),
                'touchend' === e.type && da(),
                Math.abs(ua(e, 'X') - r) < 10 && Math.abs(ua(e, 'Y') - o) < 10 && (wt(t, a, n, i), s && ((qe = null), Ft(a))))
            }))
    }
    function St() {
      ;(Dt(X, Ae + (100 * g) / G), (Se = !1))
    }
    function kt(e, t, a) {
      ;(pa(document).off('.mbsc-lv-conf'),
        W.off('.mbsc-lv-conf'),
        !1 !== t
          ? Dt(e, 0, '0' !== e.attr('data-pos') ? 200 : 0, !1, function () {
              ;(Vt(e, a), At(e))
            })
          : Vt(e, a),
        (cs = !1))
    }
    function Dt(e, t, a, n, s) {
      ;((t = Math.max('right' == ze ? 0 : -100, Math.min(t, 'left' == ze ? 0 : 100))),
        (Le = e[0].style),
        e.attr('data-pos', t),
        (Le[Ca + 'Transform'] = 'translate3d(' + (n ? (G * t) / 100 + 'px' : t + '%') + ',0,0)'),
        (Le[Ca + 'Transition'] = ya + 'transform ' + (a || 0) + 'ms'),
        s &&
          (at++,
          setTimeout(function () {
            ;(s(), at--)
          }, a)),
        (d = t))
    }
    function Nt(e, t, a, n) {
      ;((t = Math.max(oe, Math.min(t, re))),
        ((Le = e[0].style)[Ca + 'Transform'] = 'translate3d(0,' + t + 'px,0)'),
        (Le[Ca + 'Transition'] = ya + 'transform ' + (a || 0) + 'ms ease-out'),
        n &&
          (at++,
          setTimeout(function () {
            ;(n(), at--)
          }, a)))
    }
    function Et() {
      ;(clearTimeout(je), !a && Qe.sortable && ((a = !0), N.remove()))
    }
    function Ot(e, t) {
      var a = It(e.text, { target: X[0], index: Q }) || ''
      ;(It(e.disabled, { target: X[0], index: Q }) ? B.addClass('mbsc-lv-ic-disabled') : B.removeClass('mbsc-lv-ic-disabled'),
        B.css('background-color', e.color || (0 === e.percent ? Rt(d) : ps)),
        W.attr('class', 'mbsc-lv-ic-c mbsc-lv-ic-' + (t ? 'move-' : '') + (d < 0 ? 'right' : 'left')),
        j.attr('class', ' mbsc-lv-ic-s mbsc-lv-ic mbsc-ic mbsc-ic-' + (e.icon || 'none')),
        $e.attr('class', 'mbsc-lv-ic-text' + (e.icon ? '' : ' mbsc-lv-ic-text-only') + (a ? '' : ' mbsc-lv-ic-only')).html(a || '&nbsp;'),
        ke.animateIcons &&
          (we
            ? j.addClass('mbsc-lv-ic-v')
            : setTimeout(function () {
                j.addClass('mbsc-lv-ic-a')
              }, 10)))
    }
    function Vt(e, t) {
      ;(l ||
        (j.attr('class', 'mbsc-lv-ic-s mbsc-lv-ic mbsc-ic mbsc-ic-none'),
        B.attr('style', '').removeClass('mbsc-lv-stage-c-v'),
        $e.html('')),
        B.removeClass('mbsc-lv-left mbsc-lv-right'),
        e && (D('onSlideEnd', { target: e[0], index: Q }), t && t()))
    }
    function Ft(e) {
      ;(e.css('top', '').removeClass('mbsc-lv-item-undo'),
        qe
          ? Qe.animate(Te, 'collapse', function () {
              Te.remove()
            })
          : Te.remove(),
        Vt(),
        (qe = Je = null))
    }
    function At(e) {
      ;(((Le = e[0].style)[Ca + 'Transform'] = ''), (Le[Ca + 'Transition'] = ''), (Le.top = ''), e.removeClass('mbsc-lv-item-swiping'))
    }
    function It(e, t) {
      return pa.isFunction(e) ? e.call(this, t, Qe) : e
    }
    function Pt(e) {
      return Ne && !e.hasClass('mbsc-lv-parent') && !e.hasClass('mbsc-lv-back')
    }
    function Ht(e) {
      var t = e.attr('data-ref'),
        a = e.attr('data-role'),
        n = Be[e.attr('data-type') || 'defaults'],
        s = Pt(e) && 'true' == e.attr('data-selected')
      if (
        (t || ((t = hs++), e.attr('data-ref', t)),
        (ot[t] = {
          item: e,
          child: e.children(se),
          parent: e.parent(),
          ref: e.parent()[0] === et ? null : e.parent().parent().attr('data-ref'),
        }),
        e.addClass(
          'list-divider' == a
            ? 'mbsc-lv-gr-title'
            : 'mbsc-lv-item' + (n.actionable ? ' mbsc-lv-item-actionable' : '') + (s ? ' ' + ds : ''),
        ),
        e.attr('aria-selected', s ? 'true' : 'false'),
        Qe.sortable.handle && 'list-divider' != a && !e.children('.mbsc-lv-handle-c').length && e.append(I),
        ke.enhance && !e.hasClass('mbsc-lv-item-enhanced'))
      ) {
        var i = e.attr('data-icon'),
          r = e.find('img').eq(0).addClass('mbsc-lv-img')
        ;(r.is(':first-child')
          ? e.addClass('mbsc-lv-img-' + (ke.rtl ? 'right' : 'left'))
          : r.length && e.addClass('mbsc-lv-img-' + (ke.rtl ? 'left' : 'right')),
          e
            .addClass('mbsc-lv-item-enhanced')
            .children()
            .each(function (e, t) {
              ;(t = pa(t)).is('p, h1, h2, h3, h4, h5, h6') && t.addClass('mbsc-lv-txt')
            }),
          i &&
            e
              .addClass('mbsc-lv-item-ic-' + (e.attr('data-icon-align') || (ke.rtl ? 'right' : 'left')))
              .append('<div class="mbsc-lv-item-ic mbsc-ic mbsc-ic-' + i + '"></div>'))
      }
    }
    function Lt(e) {
      ;(pa(te, e)
        .not('.mbsc-lv-back')
        .each(function () {
          Ht(pa(this))
        }),
        pa(se, e).not('.mbsc-lv').addClass('mbsc-lv').prepend(R).parent().addClass('mbsc-lv-parent mbsc-lv-item-actionable').prepend($),
        pa('.mbsc-lv-back', e).each(function () {
          pa(this).attr('data-back', pa(this).parent().parent().attr('data-ref'))
        }))
    }
    function zt(e) {
      return e.children(te).not('.mbsc-lv-back').not('.mbsc-lv-removed').not('.mbsc-lv-ph')
    }
    function Ut(e) {
      return ('object' != typeof e && (e = pa(te, T).filter('[data-id="' + e + '"]')), pa(e))
    }
    function Yt(e, t) {
      for (e = e[t](); e.length && (!e.hasClass('mbsc-lv-item') || e.hasClass('mbsc-lv-ph') || e.hasClass('mbsc-lv-item-dragging')); ) {
        if (!Qe.sortable.group && e.hasClass('mbsc-lv-gr-title')) return !1
        e = e[t]()
      }
      return e
    }
    function Rt(e) {
      return (0 < e ? We.right : We.left).color || ps
    }
    function $t(e) {
      return oa(e) ? e + '' : 0
    }
    function jt(e, t) {
      return +(t < 0
        ? $t((e.actionsWidth || 0).right) || $t(e.actionsWidth) || $t(ke.actionsWidth.right) || $t(ke.actionsWidth)
        : $t((e.actionsWidth || 0).left) || $t(e.actionsWidth) || $t(ke.actionsWidth.left) || $t(ke.actionsWidth))
    }
    function Wt(e, t) {
      if (e) {
        var a = Ke.scrollTop(),
          n = e.is('.mbsc-lv-item') ? e[0].offsetHeight : 0,
          s = e.offset().top + (A ? a - Ze : 0)
        t
          ? (s < a || a + Ge < s + n) && Ke.scrollTop(s)
          : s < a
            ? Ke.scrollTop(s)
            : a + Ge < s + n && Ke.scrollTop(Math.min(s, s + n - Ge / 2))
      }
    }
    function Bt(e, t, a, n, s) {
      var i = t.parent(),
        r = t.prev()
      ;((n = n || ra),
        r[0] === W[0] && (r = W.prev()),
        ke.rtl && (e = 'l' === e ? 'r' : 'l'),
        p[0] !== t[0]
          ? (D('onNavStart', { level: nt, direction: e, list: t[0] }),
            Oe.prepend(t.addClass('mbsc-lv-v mbsc-lv-sl-new')),
            Wt(T),
            qt(Oe, 'mbsc-lv-sl-' + e, function () {
              ;(p.removeClass('mbsc-lv-sl-curr'),
                t.removeClass('mbsc-lv-sl-new').addClass('mbsc-lv-sl-curr'),
                o && o.length ? p.removeClass('mbsc-lv-v').insertAfter(o) : f.append(p.removeClass('mbsc-lv-v')),
                (o = r),
                (f = i),
                (p = t),
                Wt(a, s),
                n.call(et, a),
                D('onNavEnd', { level: nt, direction: e, list: t[0] }))
            }))
          : (Wt(a, s), n.call(et, a)))
    }
    function Jt(e, t) {
      at ||
        (e.hasClass('mbsc-lv-parent')
          ? (nt++, Bt('r', ot[e.attr('data-ref')].child, null, t))
          : e.hasClass('mbsc-lv-back') && (nt--, Bt('l', ot[e.attr('data-back')].parent, ot[e.attr('data-back')].item, t)))
    }
    function qt(e, t, a) {
      var n
      function s() {
        ;(clearTimeout(n), at--, e.off(Ta, s).removeClass(t), a.call(et, e))
      }
      ;((a = a || ra),
        ke.animation && 'mbsc-lv-item-none' !== t ? (at++, e.on(Ta, s).addClass(t), (n = setTimeout(s, 250))) : a.call(et, e))
    }
    function Kt(e, t) {
      var a,
        n = e.attr('data-ref')
      ;((a = rt[n] = rt[n] || []),
        t && a.push(t),
        e.attr('data-action') ||
          ((t = a.shift()) &&
            (e.attr('data-action', 1),
            t(function () {
              ;(e.removeAttr('data-action'), a.length ? Kt(e) : delete rt[n])
            }))))
    }
    function Gt(a, n, s) {
      var i, r
      a &&
        a.length &&
        ((i = 100 / (a.length + 2)),
        pa.each(a, function (e, t) {
          ;(void 0 === t.key && (t.key = Ve++),
            void 0 === t.percent &&
              ((t.percent = n * i * (e + 1)), s && (((r = va({}, t)).key = Ve++), (r.percent = -i * (e + 1)), a.push(r), (it[r.key] = r))),
            (it[t.key] = t))
        }))
    }
    function Xt(e) {
      Pt(e) && e.addClass(ds).attr('data-selected', 'true').attr('aria-selected', 'true')
    }
    function Zt(e) {
      e.removeClass(ds).removeAttr('data-selected').removeAttr('aria-selected')
    }
    ;(ba.call(this, e, t, !0),
      (Qe.animate = function (e, t, a) {
        qt(e, 'mbsc-lv-item-' + t, a)
      }),
      (Qe.add = function (e, t, a, n, s, i) {
        var r,
          o,
          l,
          c,
          d,
          u,
          m = '',
          h = void 0 === s ? tt : Ut(s),
          p = h,
          f = pa('object' != typeof t ? '<' + ee + ' data-ref="' + hs++ + '" data-id="' + e + '">' + t + '</' + ee + '>' : t),
          v = f[0],
          b = v.style,
          g = f.attr('data-pos') < 0 ? 'left' : 'right',
          x = f.attr('data-ref')
        ;((n = n || ra),
          x || ((x = hs++), f.attr('data-ref', x)),
          Ht(f),
          i ||
            Qe.addUndoAction(function (e) {
              c
                ? Qe.navigate(h, function () {
                    ;(p.remove(),
                      h.removeClass('mbsc-lv-parent').children('.mbsc-lv-arr').remove(),
                      (d.child = h.children(se)),
                      Qe.remove(f, null, e, !0))
                  })
                : Qe.remove(f, null, e, !0)
            }, !0),
          Kt(f, function (t) {
            ;(At(f.css('top', '').removeClass('mbsc-lv-item-undo')),
              h.is(te)
                ? ((u = h.attr('data-ref')), h.children(se).length || ((c = !0), h.append('<' + ne + '></' + ne + '>')))
                : (u = h.children('.mbsc-lv-back').attr('data-back')),
              (d = ot[u]) &&
                (d.child.length
                  ? (p = d.child)
                  : (h.addClass('mbsc-lv-parent').prepend($),
                    (p = h.children(se).prepend(R).addClass('mbsc-lv')),
                    (d.child = p),
                    pa('.mbsc-lv-back', h).attr('data-back', u))),
              (ot[x] = { item: f, child: f.children(se), parent: p, ref: u }),
              (l = zt(p)),
              (o = l.length),
              null == a && (a = o),
              i && (m = 'mbsc-lv-item-new-' + (i ? g : '')),
              Lt(f.addClass(m)),
              !1 !== a &&
                (o
                  ? a < o
                    ? f.insertBefore(l.eq(a))
                    : f.insertAfter(l.eq(o - 1))
                  : (r = pa('.mbsc-lv-back', p)).length
                    ? f.insertAfter(r)
                    : p.append(f)),
              T.trigger('mbsc-refresh'),
              ke.animateAddRemove && p.hasClass('mbsc-lv-v')
                ? ((b.height = v.offsetHeight + 'px'),
                  Qe.animate(f, i && Je === x ? 'none' : 'expand', function (e) {
                    Qe.animate(e, i ? 'add-' + g : 'pop-in', function (e) {
                      ;((b.height = ''), n.call(et, e.removeClass(m)), t())
                    })
                  }))
                : (n.call(et, f.removeClass(m)), t()),
              D('onItemAdd', { target: v }))
          }))
      }),
      (Qe.swipe = function (e, t, a, n, s) {
        var i
        ;((e = Ut(e)),
          (X = e),
          (b = n),
          (l = Ee = !0),
          (a = void 0 === a ? 300 : a),
          (g = 0 < t ? 1 : -1),
          lt(),
          ht(),
          Dt(e, t, a),
          clearTimeout(Ye),
          clearInterval(Ue),
          (Ue = setInterval(function () {
            ;((i = d), (d = (xa(e) / G) * 100), pt(i))
          }, 10)),
          (Ye = setTimeout(function () {
            ;(clearInterval(Ue), (i = d), (d = t), pt(i), ft(s), (l = Ee = b = !1))
          }, a)))
      }),
      (Qe.openStage = function (e, t, a, n) {
        it[t] && Qe.swipe(e, it[t].percent, a, n)
      }),
      (Qe.openActions = function (e, t, a, n) {
        e = Ut(e)
        var s = jt(Be[e.attr('data-type') || 'defaults'], 'left' == t ? -1 : 1)
        Qe.swipe(e, 'left' == t ? -s : s, a, n)
      }),
      (Qe.close = function (e, t) {
        Qe.swipe(e, 0, t)
      }),
      (Qe.remove = function (e, a, n, s) {
        var i, r, t, o, l, c, d
        ;((n = n || ra),
          (l = (i = Ut(e)).attr('data-ref')),
          i.length &&
            ot[l] &&
            ((r = i.parent()),
            (o = zt(r).index(i)),
            (d = i[0].style),
            (function t(e) {
              e &&
                ((c = c || e.hasClass('mbsc-lv-v')),
                e.children('[data-ref]').each(function () {
                  var e = pa(this).attr('data-ref')
                  ot[e] && (t(ot[e].child), delete ot[e])
                }))
            })(ot[l].child),
            c && ((t = ke.animation), (ke.animation = !1), Qe.navigate(i), (ke.animation = t)),
            delete ot[l],
            s ||
              (i.attr('data-ref') === Je && (qe = !0),
              Qe.addUndoAction(function (e) {
                Qe.add(null, i, o, e, r, !0)
              }, !0)),
            Kt(i, function (t) {
              ;((a = a || (i.attr('data-pos') < 0 ? 'left' : 'right')),
                ke.animateAddRemove && r.hasClass('mbsc-lv-v')
                  ? Qe.animate(i.addClass('mbsc-lv-removed'), s ? 'pop-out' : 'remove-' + a, function (e) {
                      ;((d.height = e[0].offsetHeight + 'px'),
                        Qe.animate(e, 'collapse', function (e) {
                          ;((d.height = ''), At(e.removeClass('mbsc-lv-removed')), !1 !== n.call(et, e) && e.remove(), t())
                        }))
                    })
                  : (!1 !== n.call(et, i) && i.remove(), t()),
                D('onItemRemove', { target: i[0] }))
            })))
      }),
      (Qe.move = function (e, t, a, n, s, i) {
        ;((e = Ut(e)),
          i || Qe.startActionTrack(),
          B.append(W),
          Qe.remove(e, a, null, i),
          Qe.add(null, e, t, n, s, i),
          i || Qe.endActionTrack())
      }),
      (Qe.navigate = function (e, t) {
        var a, n
        ;((e = Ut(e)),
          (a = ot[e.attr('data-ref')]),
          (n = (function (e) {
            for (var t = 0, a = ot[e.attr('data-ref')]; a && a.ref; ) (t++, (a = ot[a.ref]))
            return t
          })(e)),
          a && (Bt(nt <= n ? 'r' : 'l', a.parent, e, t, !0), (nt = n)))
      }),
      (Qe.showLoading = function () {
        ;((q = !0), ie.addClass('mbsc-show-lv-loading'), Ke.scrollTop(A ? Ke[0].scrollHeight : pa(ke.context)[0].scrollHeight))
      }),
      (Qe.hideLoading = function () {
        ;(ie.removeClass('mbsc-show-lv-loading'),
          setTimeout(function () {
            q = !1
          }, 100))
      }),
      (Qe.select = function (e) {
        ;(ce || Zt(pa(te, T).filter('.' + ds)), Xt(Ut(e)))
      }),
      (Qe.deselect = function (e) {
        Zt(Ut(e))
      }),
      (Qe._processSettings = function () {
        tt.is('[mbsc-enhance]') && ((V = !0), tt.removeAttr('mbsc-enhance'))
      }),
      (Qe._init = function () {
        var e,
          t,
          a,
          n = tt.find(se).length ? 'left' : 'right',
          s = 0,
          i = '',
          r = '',
          o = ''
        ;((ne = ke.listNode),
          (se = ke.listSelector),
          (ee = ke.itemNode),
          (te = ke.itemSelector),
          (ce = 'multiple' == ke.select),
          (Ne = 'off' != ke.select),
          'group' === (a = ke.sort || ke.sortable || !1) && (a = { group: !1, multiLevel: !0 }),
          !0 === a && (a = { group: !0, multiLevel: !0, handle: ke.sortHandle }),
          a && void 0 === a.handle && (a.handle = ke.sortHandle),
          a.handle &&
            ((F = !0 === a.handle ? n : a.handle),
            (I =
              '<div class="mbsc-lv-handle-c mbsc-lv-item-h-' +
              F +
              ' mbsc-lv-handle"><div class="' +
              ke.handleClass +
              ' mbsc-lv-handle-bar-c mbsc-lv-handle">' +
              ke.handleMarkup +
              '</div></div>')),
          (R =
            '<' +
            ee +
            ' class="mbsc-lv-item mbsc-lv-back mbsc-lv-item-actionable">' +
            ke.backText +
            '<div class="mbsc-lv-arr mbsc-lv-ic mbsc-ic ' +
            ke.leftArrowClass +
            '"></div></' +
            ee +
            '>'),
          ($ = '<div class="mbsc-lv-arr mbsc-lv-ic mbsc-ic ' + ke.rightArrowClass + '"></div>'),
          (e =
            'mbsc-no-touch mbsc-lv-cont mbsc-lv-' +
            ke.theme +
            ' mbsc-' +
            ke.theme +
            (ms ? ' mbsc-lv-hb' : '') +
            (ke.rtl ? ' mbsc-lv-rtl mbsc-rtl' : ' mbsc-ltr') +
            (ke.baseTheme ? ' mbsc-lv-' + ke.baseTheme + ' mbsc-' + ke.baseTheme : '') +
            (ke.animateIcons ? ' mbsc-lv-ic-anim' : '') +
            (ke.striped ? ' mbsc-lv-alt-row' : '') +
            (ke.fixedHeader ? ' mbsc-lv-has-fixed-header' : '') +
            (a.handle ? ' mbsc-lv-handle-' + F : '')),
          (Qe.sortable = a || !1),
          T
            ? (T.attr('class', e),
              pa('.mbsc-lv-handle-c', T).remove(),
              pa(te, T).not('.mbsc-lv-back').removeClass('mbsc-lv-item'),
              Ke.off('orientationchange resize', xt),
              pe && Ke.off('scroll touchmove', pe),
              Ke.off('scroll touchmove', yt))
            : ((i += '<div class="mbsc-lv-multi-c"></div>'),
              (i +=
                '<div class="mbsc-lv-ic-c"><div class="mbsc-lv-ic-s mbsc-lv-ic mbsc-ic mbsc-ic-none"></div><div class="mbsc-lv-ic-text"></div></div>'),
              tt.addClass('mbsc-lv mbsc-lv-v mbsc-lv-root').removeClass('mbsc-cloak').show(),
              (B = pa('<div class="mbsc-lv-stage-c">' + i + '</div>')),
              (W = pa('.mbsc-lv-ic-c', B)),
              (le = pa('.mbsc-lv-multi-c', B)),
              (j = pa('.mbsc-lv-ic-s', B)),
              ($e = pa('.mbsc-lv-ic-text', B)),
              (Te = pa('<' + ee + ' class="mbsc-lv-item mbsc-lv-ph"></' + ee + '>')),
              (N = pa('<div class="mbsc-lv-fill-item"></div>')),
              (T = pa(
                '<div class="' +
                  e +
                  '"><' +
                  ne +
                  ' class="mbsc-lv mbsc-lv-dummy"></' +
                  ne +
                  '><div class="mbsc-lv-sl-c"></div><div class="mbsc-lv-loading"><span class="mbsc-ic mbsc-ic-' +
                  (ke.loadingIcon || 'loop2') +
                  '"></span></div></div>',
              )),
              (w = pa('.mbsc-lv-dummy', T)),
              (ie = pa('.mbsc-lv-loading', T)),
              T.insertAfter(tt),
              xt(),
              T.on('touchstart mousedown', '.mbsc-lv-item', ct)
                .on('touchmove', '.mbsc-lv-item', dt)
                .on('touchend touchcancel', '.mbsc-lv-item', ut)
                .on('click', '.mbsc-lv-item', mt),
              et.addEventListener('click', Tt, !0),
              T.on('touchstart mousedown', '.mbsc-lv-ic-m', function (e) {
                ;(b || (e.stopPropagation(), e.preventDefault()), (Pe = ua(e, 'X')), (He = ua(e, 'Y')))
              }).on('touchend mouseup', '.mbsc-lv-ic-m', function (e) {
                b ||
                  ('touchend' === e.type && da(),
                  cs &&
                    !pa(this).hasClass('mbsc-lv-ic-disabled') &&
                    Math.abs(ua(e, 'X') - Pe) < 10 &&
                    Math.abs(ua(e, 'Y') - He) < 10 &&
                    wt((d < 0 ? We.rightMenu : We.leftMenu)[pa(this).index()], u, m))
              }),
              (Oe = pa('.mbsc-lv-sl-c', T).append(tt.addClass('mbsc-lv-sl-curr')).attr('data-ref', hs++)),
              (p = tt),
              (f = T)),
          (A = 'body' !== ke.context),
          (Ke = pa(A ? ke.context : window)).on('orientationchange resize', xt),
          Ke.on('scroll touchmove', yt),
          (Ve = 0),
          ((Be = ke.itemGroups || {}).defaults = {
            swipeleft: ke.swipeleft,
            swiperight: ke.swiperight,
            stages: ke.stages,
            actions: ke.actions,
            actionsWidth: ke.actionsWidth,
            actionable: ke.actionable,
          }),
          Lt(tt),
          pa.each(Be, function (e, a) {
            if (
              ((a.swipe = void 0 !== a.swipe ? a.swipe : ke.swipe),
              (a.actionable = void 0 !== a.actionable ? a.actionable : ke.actionable),
              (a.stages = a.stages || []),
              Gt(a.stages, 1, !0),
              Gt(a.stages.left, 1),
              Gt(a.stages.right, -1),
              (a.stages.left || a.stages.right) && (a.stages = [].concat(a.stages.left || [], a.stages.right || [])),
              (E = !1),
              a.stages.length ||
                (a.swipeleft && a.stages.push({ percent: -30, action: a.swipeleft }),
                a.swiperight && a.stages.push({ percent: 30, action: a.swiperight })),
              pa.each(a.stages, function (e, t) {
                if (0 === t.percent) return !(E = !0)
              }),
              E || a.stages.push({ percent: 0 }),
              a.stages.sort(function (e, t) {
                return e.percent - t.percent
              }),
              pa.each(a.stages, function (e, t) {
                if (0 === t.percent) return ((a.start = e), !1)
              }),
              E
                ? (a.left = a.right = a.stages[a.start])
                : ((a.left = a.stages[a.start - 1] || {}), (a.right = a.stages[a.start + 1] || {})),
              a.actions)
            ) {
              for (
                a.leftMenu = a.actions.left || a.actions, a.rightMenu = a.actions.right || a.leftMenu, o = r = '', s = 0;
                s < a.leftMenu.length;
                s++
              )
                r +=
                  '<div ' +
                  (a.leftMenu[s].color ? 'style="background-color: ' + a.leftMenu[s].color + '"' : '') +
                  ' class="mbsc-lv-ic-m mbsc-lv-ic mbsc-ic mbsc-ic-' +
                  a.leftMenu[s].icon +
                  '">' +
                  (a.leftMenu[s].text || '') +
                  '</div>'
              for (s = 0; s < a.rightMenu.length; ++s)
                o +=
                  '<div ' +
                  (a.rightMenu[s].color ? 'style="background-color: ' + a.rightMenu[s].color + '"' : '') +
                  ' class="mbsc-lv-ic-m mbsc-lv-ic mbsc-ic mbsc-ic-' +
                  a.rightMenu[s].icon +
                  '">' +
                  (a.rightMenu[s].text || '') +
                  '</div>'
              ;(a.actions.left && (a.swipe = a.actions.right ? a.swipe : 'right'),
                a.actions.right && (a.swipe = a.actions.left ? a.swipe : 'left'),
                (a.icons =
                  '<div class="mbsc-lv-multi mbsc-lv-multi-ic-left">' +
                  r +
                  '</div><div class="mbsc-lv-multi mbsc-lv-multi-ic-right">' +
                  o +
                  '</div>'))
            }
          }),
          ke.fixedHeader &&
            ((t =
              'mbsc-lv-fixed-header' +
              (A
                ? ' mbsc-lv-fixed-header-ctx mbsc-lv-' +
                  ke.theme +
                  ' mbsc-' +
                  ke.theme +
                  (ke.baseTheme ? ' mbsc-lv-' + ke.baseTheme + ' mbsc-' + ke.baseTheme : '')
                : '')),
            O ? (O.attr('class', t), Ct()) : (O = pa('<div class="' + t + '"></div>')),
            A ? Ke.before(O) : T.prepend(O),
            (pe = la(Ct, 200)),
            Ke.on('scroll touchmove', pe)),
          ke.hover &&
            (z ||
              T.on('mouseover.mbsc-lv', '.mbsc-lv-item', function () {
                ;(H && H[0] == this) ||
                  (gt(),
                  (H = pa(this)),
                  Be[H.attr('data-type') || 'defaults'].actions &&
                    (Y = setTimeout(function () {
                      be ? (H = null) : ((L = !0), Qe.openActions(H, P, z, !1))
                    }, U)))
              }).on('mouseleave.mbsc-lv', gt),
            (z = ke.hover.time || 200),
            (U = ke.hover.timeout || 200),
            (P = ke.hover.direction || ke.hover || 'right')),
          V && T.attr('mbsc-enhance', ''),
          T.trigger('mbsc-enhance', [{ theme: ke.theme, lang: ke.lang }]))
      }),
      (Qe._destroy = function () {
        var e
        ;(f.append(p),
          A && O && O.remove(),
          V && (tt.attr('mbsc-enhance', ''), (e = fa[T[0].id]) && e.destroy()),
          et.removeEventListener('click', Tt, !0),
          T.find('.mbsc-lv-txt,.mbsc-lv-img').removeClass('mbsc-lv-txt mbsc-lv-img'),
          T.find(se)
            .removeClass('mbsc-lv mbsc-lv-v mbsc-lv-root mbsc-lv-sl-curr')
            .find(te)
            .removeClass(
              'mbsc-lv-gr-title mbsc-lv-item mbsc-lv-item-enhanced mbsc-lv-parent mbsc-lv-img-left mbsc-lv-img-right mbsc-lv-item-ic-left mbsc-lv-item-ic-right',
            )
            .removeAttr('data-ref'),
          pa('.mbsc-lv-back,.mbsc-lv-handle-c,.mbsc-lv-arr,.mbsc-lv-item-ic', T).remove(),
          tt.insertAfter(T),
          T.remove(),
          B.remove(),
          Ke.off('orientationchange resize', xt),
          Ke.off('scroll touchmove', yt),
          pe && Ke.off('scroll touchmove', pe))
      }))
    var Qt,
      ea = [],
      ta = [],
      aa = [],
      na = 0
    ;((Qe.startActionTrack = function () {
      ;(na || (aa = []), na++)
    }),
      (Qe.endActionTrack = function () {
        --na || ta.push(aa)
      }),
      (Qe.addUndoAction = function (e, t) {
        var a = { action: e, async: t }
        na ? aa.push(a) : (ta.push([a]), ta.length > ke.undoLimit && ta.shift())
      }),
      (Qe.undo = function () {
        var e, t, a
        function n() {
          t < 0 ? ((Qt = !1), s()) : ((e = a[t]), t--, e.async ? e.action(n) : (e.action(), n()))
        }
        function s() {
          ;(a = ea.shift()) && ((Qt = !0), (t = a.length - 1), n())
        }
        ;(ta.length && ea.push(ta.pop()), Qt || s())
      }),
      (ke = Qe.settings),
      (D = Qe.trigger),
      Qe.init())
  }
  var cs,
    ds = 'mbsc-selected',
    us = 'mbsc-lv-item-active',
    ms = 'ios' == _ && 7 < M,
    hs = 1,
    ps = 'transparent'
  ;((ls.prototype = {
    _class: 'listview',
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _defaults: {
      context: 'body',
      actionsWidth: 90,
      sortDelay: 250,
      undoLimit: 10,
      tap: Ie,
      swipe: !0,
      quickSwipe: !0,
      animateAddRemove: !0,
      animateIcons: !0,
      animation: !0,
      revert: !0,
      vibrate: !0,
      actionable: !0,
      handleClass: '',
      handleMarkup:
        '<div class="mbsc-lv-handle-bar mbsc-lv-handle"></div><div class="mbsc-lv-handle-bar mbsc-lv-handle"></div><div class="mbsc-lv-handle-bar mbsc-lv-handle"></div>',
      listNode: 'ul',
      listSelector: 'ul,ol',
      itemNode: 'li',
      itemSelector: 'li',
      leftArrowClass: 'mbsc-ic-arrow-left4',
      rightArrowClass: 'mbsc-ic-arrow-right4',
      backText: 'Back',
      undoText: 'Undo',
      stages: [],
      select: 'off',
    },
  }),
    (W.ListView = ls),
    (Z.themes.listview.mobiscroll = { leftArrowClass: 'mbsc-ic-arrow-left5', rightArrowClass: 'mbsc-ic-arrow-right5' }))
  var fs = (function (t) {
      function a(e) {
        var s
        return (
          r(c((s = t.call(this, e) || this)), 'componentWillLeave', function (e) {
            var t = pa(i.findDOMNode(c(s)))
            s.props.instanceReady
              ? s.props.instance.remove(t, void 0, function () {
                  return (t.parent().find('.mbsc-lv-stage-c').remove(), e(), !1)
                })
              : e()
          }),
          r(c(s), 'componentWillEnter', function (e) {
            if (s.props.instanceReady) {
              var t = pa(i.findDOMNode(c(s))),
                a = s.props.parentItem ? pa(i.findDOMNode(s.props.parentItem)) : void 0
              if (a) {
                var n = t.parent()
                n.prepend(n.children('.mbsc-lv-back'))
              }
              s.props.instance.add(null, t, t.index(), void 0, a)
            }
            e()
          }),
          (s.childrenMounted = s.childrenMounted.bind(c(s))),
          s
        )
      }
      l(a, t)
      var e = a.prototype
      return (
        (e.shouldComponentUpdate = function (e) {
          return !fe(this.props, e)
        }),
        (e.childrenMounted = function (e) {
          var t, a
          if (this.props.instanceReady)
            if (e) {
              var n = pa(i.findDOMNode(this))
              ;((a = this.props.instance),
                (t = pa(i.findDOMNode(e)).children('li')),
                n &&
                  n.hasClass('mbsc-lv-item') &&
                  t.each(function () {
                    var e = pa(this)
                    a.add(null, e, e.index(), void 0, n)
                  }))
            } else {
              var s = pa(i.findDOMNode(this)).children('ul')
              ;((a = this.props.instance),
                (t = s.children('li').not('.mbsc-lv-back')).each(function () {
                  var e = pa(this)
                  a.remove(e, void 0, function () {
                    e.parent().find('.mbsc-lv-stage-c').remove()
                  })
                }))
            }
        }),
        (e.render = function () {
          var e = va({}, { item: this.props.item }, this.props.itemProps),
            t = null
          return (
            this.props.item.children &&
              (t =
                void 0 !== b.addons && void 0 !== b.addons.TransitionGroup
                  ? b.createElement(
                      b.addons.TransitionGroup,
                      { component: 'ul', ref: this.childrenMounted },
                      this.props.item.children.map(function (e) {
                        return b.createElement(a, {
                          key: e[this.props.dataKeyField],
                          item: e,
                          instance: this.props.instance,
                          instanceReady: this.props.instanceReady,
                          itemType: this.props.itemType,
                          itemProps: this.props.itemProps,
                          dataKeyField: this.props.dataKeyField,
                          mounter: this.props.mounter,
                          parentItem: this,
                          ref: this.props.mounter(e, this),
                        })
                      }, this),
                    )
                  : b.createElement(
                      'ul',
                      null,
                      this.props.item.children.map(function (e) {
                        return b.createElement(a, {
                          key: e[this.props.dataKeyField],
                          item: e,
                          instance: this.props.instance,
                          instanceReady: this.props.instanceReady,
                          itemType: this.props.itemType,
                          itemProps: this.props.itemProps,
                          dataKeyField: this.props.dataKeyField,
                          mounter: this.props.mounter,
                          parentItem: this,
                          ref: this.props.mounter(e, this),
                        })
                      }, this),
                    )),
            b.createElement(this.props.itemType, e, t)
          )
        }),
        a
      )
    })(b.Component),
    vs = e.object,
    bs = e.array,
    gs = e.number,
    xs = e.bool,
    Ts = e.string,
    ys = e.func,
    Cs = (function (a) {
      function e(e) {
        var t
        return (
          ((t = a.call(this, e) || this).mountFunctions = {}),
          (t.state = { instanceReady: !1 }),
          (t.listMounted = t.listMounted.bind(c(t))),
          (t.listItemMounted = t.listItemMounted.bind(c(t))),
          (t.getMountFunction = t.getMountFunction.bind(c(t))),
          t
        )
      }
      l(e, a)
      var t = e.prototype
      return (
        (t.listMounted = function (e) {
          this.wrapperList = i.findDOMNode(e)
        }),
        (t.listItemMounted = function (e, t, a) {
          if (!b.addons || !b.addons.TransitionGroup)
            if (a) {
              if (void 0 !== this.instance) {
                var n = pa(i.findDOMNode(a)),
                  s = t ? pa(i.findDOMNode(t)) : void 0
                ;(void 0 !== s && !s.hasClass('mbsc-lv-item')) || this.instance.add(null, n, n.index(), void 0, s)
              }
            } else pa(this.wrapperList).find('.mbsc-lv-stage-c').remove()
        }),
        (t.getMountFunction = function (e, t) {
          return (
            void 0 === this.mountFunctions[e[this.props.dataKeyField]] &&
              (this.mountFunctions[e[this.props.dataKeyField]] = this.listItemMounted.bind(this, e, t)),
            this.mountFunctions[e[this.props.dataKeyField]]
          )
        }),
        (t.componentDidMount = function () {
          var e = this.getSettingsFromProps(this.props)
          ;((this.instance = new ls(this.wrapperList, e)), this.setState({ instanceReady: !0 }))
        }),
        (t.render = function () {
          var e,
            t = this.props.data.map(function (e) {
              return b.createElement(fs, {
                instance: this.instance,
                instanceReady: this.state.instanceReady,
                itemType: this.props.itemType,
                itemProps: this.props.itemProps,
                key: e[this.props.dataKeyField],
                dataKeyField: this.props.dataKeyField,
                ref: this.getMountFunction(e),
                mounter: this.getMountFunction,
                item: e,
              })
            }, this)
          return (
            (e =
              void 0 !== b.addons && void 0 !== b.addons.TransitionGroup
                ? b.createElement(b.addons.TransitionGroup, { component: 'ul', className: 'mbsc-cloak', ref: this.listMounted }, t)
                : b.createElement('ul', { className: 'mbsc-cloak', ref: this.listMounted }, t)),
            b.createElement('div', { className: this.initialCssClass }, e)
          )
        }),
        (t.shouldComponentUpdate = function (e, t) {
          var a = this.getSettingsFromProps(this.props),
            n = !fe(this.getSettingsFromProps(e), a),
            s = !fe(e.data, this.props.data),
            i = this.state.instanceReady !== t.instanceReady
          return ((this.optimizeUpdate = { updateOptions: n, updateValue: !1, updateData: s }), n || s || i)
        }),
        e
      )
    })(be)
  ;(r(
    Cs,
    'propTypes',
    g({}, oe, {
      dataKeyField: e.string,
      itemType: e.func.isRequired,
      itemProps: vs,
      data: e.array.isRequired,
      actions: e.oneOfType([vs, bs]),
      actionsWidth: gs,
      striped: xs,
      animateAddRemove: xs,
      actionable: xs,
      animateIcons: xs,
      display: e.oneOf(['inline']),
      enhance: xs,
      fillAnimation: xs,
      fixedHeader: xs,
      hover: e.oneOfType([e.shape({ time: gs, timeout: gs, direction: e.oneOf(['left', 'right']) }), e.oneOf(['left', 'right'])]),
      iconSlide: xs,
      itemGroups: vs,
      loadingIcon: Ts,
      navigateOnDrop: xs,
      quickSwipe: xs,
      sortable: e.oneOfType([xs, vs]),
      select: e.oneOf(['off', 'single', 'multiple']),
      sortDelay: gs,
      stages: e.oneOfType([bs, vs]),
      swipe: e.oneOfType([ys, xs, e.oneOf(['left', 'right'])]),
      swipeLeft: ys,
      swipeRight: ys,
      vibrate: xs,
      undoText: Ts,
      backText: Ts,
      onItemTap: ys,
      onItemAdd: ys,
      onItemRemove: ys,
      onListEnd: ys,
      onNavEnd: ys,
      onNavStart: ys,
      onSlideEnd: ys,
      onSlideStart: ys,
      onSort: ys,
      onSortChange: ys,
      onSortStart: ys,
      onSortEnd: ys,
      onSortUpdate: ys,
      onStageChange: ys,
    }),
  ),
    r(Cs, 'defaultProps', { dataKeyField: 'id' }),
    (Z.Listview = Cs))
  var _s = {
    batch: 50,
    min: 0,
    max: 100,
    defaultUnit: '',
    units: null,
    unitNames: null,
    invalid: [],
    sign: !1,
    step: 0.05,
    scale: 2,
    convert: function (e) {
      return e
    },
    decimalSeparator: '.',
    signText: '&nbsp;',
    wholeText: 'Whole',
    fractionText: 'Fraction',
    unitText: 'Unit',
  }
  vt.measurement = function (v) {
    var a,
      b,
      g,
      x,
      T,
      y,
      C,
      _,
      w,
      M,
      S,
      k,
      e,
      t,
      n = va({}, v.settings),
      D = va(v.settings, _s, n),
      s = {},
      i = [[]],
      N = {},
      E = {},
      r = {},
      O = [],
      V = D.sign,
      F = D.units && D.units.length,
      A = F ? D.defaultUnit || D.units[0] : '',
      o = [],
      I = D.step < 1,
      P = 1 < D.step ? D.step : 1,
      l = I ? Math.max(D.scale, (D.step + '').split('.')[1].length) : 1,
      c = Math.pow(10, l),
      H = Math.round(I ? D.step * c : D.step),
      d = 0,
      u = 0,
      L = 0
    function m(e) {
      return Math.max(w, Math.min(M, I ? (e < 0 ? Math.ceil(e) : Math.floor(e)) : Y(Math.round(e - d), H) + d))
    }
    function h(e) {
      return I ? Y((Math.abs(e) - Math.abs(m(e))) * c - u, H) + u : 0
    }
    function z(e) {
      var t = m(e),
        a = h(e)
      return (c <= a && (e < 0 ? t-- : t++, (a = 0)), [e < 0 ? '-' : '+', t, a])
    }
    function U(e) {
      var t = +e[T],
        a = I ? (e[x] / c) * (t < 0 ? -1 : 1) : 0
      return (V && '-' == e[0] ? -1 : 1) * (t + a)
    }
    function Y(e, t) {
      return Math.round(e / t) * t
    }
    function R(e, t, a) {
      return t !== a && D.convert ? D.convert.call(this, e, t, a) : e
    }
    function $(e) {
      var t, a
      ;((C = R(D.min, A, e)),
        (_ = R(D.max, A, e)),
        I
          ? ((w = C < 0 ? Math.ceil(C) : Math.floor(C)), (M = _ < 0 ? Math.ceil(_) : Math.floor(_)), (S = h(C)), (k = h(_)))
          : ((w = Math.round(C)), (M = Math.round(_)), (M = w + Math.floor((M - w) / H) * H), (d = w % H)),
        (t = w),
        (a = M),
        V && ((a = Math.abs(t) > Math.abs(a) ? Math.abs(t) : Math.abs(a)), (t = t < 0 ? 0 : t)),
        (E.min = t < 0 ? Math.ceil(t / P) : Math.floor(t / P)),
        (E.max = a < 0 ? Math.ceil(a / P) : Math.floor(a / P)))
    }
    function p(e) {
      return U(e).toFixed(I ? l : 0) + (F ? ' ' + o[e[y]] : '')
    }
    if (
      ((v.setVal = function (e, t, a, n, s) {
        v._setVal(pa.isArray(e) ? p(e) : e, t, a, n, s)
      }),
      D.units)
    )
      for (t = 0; t < D.units.length; ++t) ((e = D.units[t]), o.push((D.unitNames && D.unitNames[e]) || e))
    if (V)
      if (((V = !1), F)) for (t = 0; t < D.units.length; t++) R(D.min, A, D.units[t]) < 0 && (V = !0)
      else V = D.min < 0
    if (
      (V && (i[0].push({ data: ['-', '+'], label: D.signText }), L++),
      (E = {
        label: D.wholeText,
        data: function (e) {
          return (w % P) + e * P
        },
        getIndex: function (e) {
          return Math.round((e - (w % P)) / P)
        },
      }),
      i[0].push(E),
      (T = L++),
      $(A),
      I)
    ) {
      for (i[0].push(r), r.data = [], r.label = D.fractionText, t = u; t < c; t += H)
        (O.push(t), r.data.push({ value: t, display: D.decimalSeparator + re(t, l) }))
      ;((x = L++),
        (a = Math.ceil(100 / H)),
        D.invalid &&
          D.invalid.length &&
          (pa.each(D.invalid, function (e, t) {
            var a = 0 < t ? Math.floor(t) : Math.ceil(t)
            ;(0 === a && (a = t <= 0 ? -0.001 : 0.001), (N[a] = (N[a] || 0) + 1), 0 === t && (N[(a = 0.001)] = (N[a] || 0) + 1))
          }),
          pa.each(N, function (e, t) {
            t < a ? delete N[e] : (N[e] = e)
          })))
    }
    if (F) {
      for (s = { data: [], label: D.unitText, cssClass: 'mbsc-msr-whl-unit', circular: !1 }, t = 0; t < D.units.length; t++)
        s.data.push({ value: t, display: o[t] })
      i[0].push(s)
    }
    return (
      (y = L),
      {
        wheels: i,
        minWidth: V && I ? 70 : 80,
        showLabel: !1,
        formatValue: p,
        compClass: 'mbsc-msr mbsc-sc',
        parseValue: function (e) {
          var t,
            a = ((('number' == typeof e ? e + '' : e) || D.defaultValue) + '').split(' '),
            n = +a[0],
            s = [],
            i = ''
          return (
            F && (i = -1 == (i = -1 == (i = pa.inArray(a[1], o)) ? pa.inArray(A, D.units) : i) ? 0 : i),
            $((g = F ? D.units[i] : '')),
            ((t = z((n = me((n = isNaN(n) ? 0 : n), C, _))))[1] = me(t[1], w, M)),
            (b = n),
            V && ((s[0] = t[0]), (t[1] = Math.abs(t[1]))),
            (s[T] = t[1]),
            I && (s[x] = t[2]),
            F && (s[y] = i),
            s
          )
        },
        onCancel: function () {
          b = void 0
        },
        validate: function (e) {
          var a,
            n,
            t,
            s,
            i,
            r = e.values,
            o = e.index,
            l = e.direction,
            c = {},
            d = [],
            u = {},
            m = F ? D.units[r[y]] : ''
          if (
            (V && 0 === o && (b = Math.abs(b) * ('-' == r[0] ? -1 : 1)),
            (o === T || (o === x && I) || void 0 === b || void 0 === o) && ((b = U(r)), (g = m)),
            ((F && o === y && g !== m) || void 0 === o) &&
              ($(m), (b = R(b, g, m)), (g = m), (n = z(b)), void 0 !== o && ((u[T] = E), v.changeWheel(u)), V && (r[0] = n[0])),
            (d[T] = []),
            V)
          )
            for (
              d[0] = [],
                0 < C && (d[0].push('-'), (r[0] = '+')),
                _ < 0 && (d[0].push('+'), (r[0] = '-')),
                i = Math.abs('-' == r[0] ? w : M),
                L = i + P;
              L < i + 20 * P;
              L += P
            )
              (d[T].push(L), (c[L] = !0))
          if (
            ((b = me(b, C, _)),
            (n = z(b)),
            (t = V ? Math.abs(n[1]) : n[1]),
            (a = V ? '-' == r[0] : b < 0),
            (r[T] = t),
            a && (n[0] = '-'),
            I && (r[x] = n[2]),
            pa.each(I ? N : D.invalid, function (e, t) {
              if (V && a) {
                if (!(t <= 0)) return
                t = Math.abs(t)
              }
              ;((t = Y(R(t, A, m), I ? 1 : H)), (c[t] = !0), d[T].push(t))
            }),
            (r[T] = v.getValidValue(T, t, l, c)),
            (n[1] = r[T] * (V && a ? -1 : 1)),
            I)
          ) {
            d[x] = []
            var h = V ? r[0] + r[1] : (b < 0 ? '-' : '+') + Math.abs(n[1]),
              p = (C < 0 ? '-' : '+') + Math.abs(w),
              f = (_ < 0 ? '-' : '+') + Math.abs(M)
            ;(h === p &&
              pa(O).each(function (e, t) {
                ;(a ? S < t : t < S) && d[x].push(t)
              }),
              h === f &&
                pa(O).each(function (e, t) {
                  ;(a ? t < k : k < t) && d[x].push(t)
                }),
              pa.each(D.invalid, function (e, t) {
                ;((s = z(R(t, A, m))), (n[0] === s[0] || (0 === n[1] && 0 === s[1] && 0 === s[2])) && n[1] === s[1] && d[x].push(s[2]))
              }))
          }
          return { disabled: d, valid: r }
        },
      }
    )
  }
  var ws = { min: 0, max: 100, defaultUnit: 'km', units: ['m', 'km', 'in', 'ft', 'yd', 'mi'] },
    Ms = {
      mm: 0.001,
      cm: 0.01,
      dm: 0.1,
      m: 1,
      dam: 10,
      hm: 100,
      km: 1e3,
      in: 0.0254,
      ft: 0.3048,
      yd: 0.9144,
      ch: 20.1168,
      fur: 201.168,
      mi: 1609.344,
      lea: 4828.032,
    }
  vt.distance = function (e) {
    var t = va({}, ws, e.settings)
    return (
      va(e.settings, t, {
        sign: !1,
        convert: function (e, t, a) {
          return (e * Ms[t]) / Ms[a]
        },
      }),
      vt.measurement.call(this, e)
    )
  }
  var Ss = { min: 0, max: 100, defaultUnit: 'N', units: ['N', 'kp', 'lbf', 'pdl'] },
    ks = { N: 1, kp: 9.80665, lbf: 4.448222, pdl: 0.138255 }
  vt.force = function (e) {
    var t = va({}, Ss, e.settings)
    return (
      va(e.settings, t, {
        sign: !1,
        convert: function (e, t, a) {
          return (e * ks[t]) / ks[a]
        },
      }),
      vt.measurement.call(this, e)
    )
  }
  var Ds = { min: 0, max: 1e3, defaultUnit: 'kg', units: ['g', 'kg', 'oz', 'lb'], unitNames: { tlong: 't (long)', tshort: 't (short)' } },
    Ns = {
      mg: 0.001,
      cg: 0.01,
      dg: 0.1,
      g: 1,
      dag: 10,
      hg: 100,
      kg: 1e3,
      t: 1e6,
      drc: 1.7718452,
      oz: 28.3495,
      lb: 453.59237,
      st: 6350.29318,
      qtr: 12700.58636,
      cwt: 50802.34544,
      tlong: 1016046.9088,
      tshort: 907184.74,
    }
  vt.mass = function (e) {
    var t = va({}, Ds, e.settings)
    return (
      va(e.settings, t, {
        sign: !1,
        convert: function (e, t, a) {
          return (e * Ns[t]) / Ns[a]
        },
      }),
      vt.measurement.call(this, e)
    )
  }
  var Es = {
      min: 0,
      max: 100,
      defaultUnit: 'kph',
      units: ['kph', 'mph', 'mps', 'fps', 'knot'],
      unitNames: { kph: 'km/h', mph: 'mi/h', mps: 'm/s', fps: 'ft/s', knot: 'knot' },
    },
    Os = { kph: 1, mph: 1.60934, mps: 3.6, fps: 1.09728, knot: 1.852 }
  vt.speed = function (e) {
    var t = va({}, Es, e.settings)
    return (
      va(e.settings, t, {
        sign: !1,
        convert: function (e, t, a) {
          return (e * Os[t]) / Os[a]
        },
      }),
      vt.measurement.call(this, e)
    )
  }
  var Vs = { min: -20, max: 40, defaultUnit: 'c', units: ['c', 'k', 'f', 'r'], unitNames: { c: '°C', k: 'K', f: '°F', r: '°R' } },
    Fs = {
      c2k: function (e) {
        return e + 273.15
      },
      c2f: function (e) {
        return (9 * e) / 5 + 32
      },
      c2r: function (e) {
        return (9 * (e + 273.15)) / 5
      },
      k2c: function (e) {
        return e - 273.15
      },
      k2f: function (e) {
        return (9 * e) / 5 - 459.67
      },
      k2r: function (e) {
        return (9 * e) / 5
      },
      f2c: function (e) {
        return (5 * (e - 32)) / 9
      },
      f2k: function (e) {
        return (5 * (e + 459.67)) / 9
      },
      f2r: function (e) {
        return e + 459.67
      },
      r2c: function (e) {
        return (5 * (e - 491.67)) / 9
      },
      r2k: function (e) {
        return (5 * e) / 9
      },
      r2f: function (e) {
        return e - 459.67
      },
    }
  vt.temperature = function (e) {
    var t = va({}, Vs, e.settings)
    return (
      va(e.settings, t, {
        sign: !0,
        convert: function (e, t, a) {
          return Fs[t + '2' + a](e)
        },
      }),
      vt.measurement.call(this, e)
    )
  }
  var As = e.number,
    Is = e.bool,
    Ps = e.string,
    Hs = e.object,
    Ls = {
      max: As,
      min: As,
      convert: e.func,
      decimalSeparator: Ps,
      defaultValue: Ps,
      invalid: e.array,
      scale: As,
      step: As,
      wholeText: Ps,
      fractionText: Ps,
      signText: Ps,
    },
    zs = { convert: Is, defaultUnit: Ps, unitNames: Hs, units: e.arrayOf(Ps) },
    Us = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { preset: 'measurement' }), t)
      }
      return (l(e, a), e)
    })(xe)
  Us.propTypes = g({}, Us.propTypes, {}, ce, {}, Ls)
  var Ys = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'temperature' }), t)
    }
    return (l(e, a), e)
  })((Z.Measurement = Us))
  Ys.propTypes = g({}, Ys.propTypes, {}, zs)
  var Rs = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'mass' }), t)
    }
    return (l(e, a), e)
  })((Z.Temperature = Ys))
  Z.Mass = Rs
  var $s = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'force' }), t)
    }
    return (l(e, a), e)
  })(Ys)
  Z.Force = $s
  var js = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'speed' }), t)
    }
    return (l(e, a), e)
  })(Ys)
  Z.Speed = js
  var Ws = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { preset: 'distance' }), t)
    }
    return (l(e, a), e)
  })(Ys)
  Z.Distance = Ws
  function Bs(r, e, t) {
    var o,
      l,
      a,
      n,
      c,
      s,
      i,
      d,
      u,
      m,
      h,
      p,
      f,
      v,
      b,
      g,
      x,
      T = {},
      y = 1e3,
      C = this,
      _ = pa(r)
    function w(e) {
      ;(clearTimeout(m),
        (m = setTimeout(function () {
          D(!e || 'load' !== e.type)
        }, 200)))
    }
    function M() {
      i && this.parentNode === r && S(pa(this), !0)
    }
    function S(e, t) {
      if (e.length) {
        if (((t = C._onItemTap(e, t)), (o = e).parent()[0] == r)) {
          var a = e.offset().left,
            n = e[0].offsetLeft,
            s = e[0].offsetWidth,
            i = l.offset().left
          ;(h && (n = b - n - s),
            'a' == v.variant
              ? a < i
                ? p.scroll(h ? n + s - c : -n, y, !0)
                : i + c < a + s && p.scroll(h ? n : c - n - s, y, !0)
              : p.scroll((c / 2 - n - s / 2) * (h ? -1 : 1), y, !0))
        }
        t && x('onItemTap', { target: e[0] })
      }
    }
    function k() {
      var s
      ;(C._initMarkup(l),
        _.find('.mbsc-ripple').remove(),
        (C._$items = _.children()),
        C._$items.each(function (e) {
          var t,
            a = pa(this),
            n = a.attr('data-ref')
          ;((n = n || Js++),
            0 === e && (s = a),
            (o = o || C._getActiveItem(a)),
            (t = 'mbsc-scv-item mbsc-btn-e ' + ((C._getItemProps(a) || {}).cssClass || '')),
            a.attr('data-ref', n).removeClass(T[n]).addClass(t),
            (T[n] = t))
        }),
        (o = o || s),
        C._markupReady(l))
    }
    function D(e, t) {
      var a = v.itemWidth,
        n = v.layout
      if (((C.contWidth = c = l.width()), C._checkResp())) return !1
      ;(e && u === c) ||
        !c ||
        ((u = c),
        oa(n) && (s = c ? c / n : a) < a && (n = 'liquid'),
        a && ('liquid' == n ? (s = c ? c / Math.min(Math.floor(c / a), C._$items.length) : a) : 'fixed' == n && (s = a)),
        C._size(c, s),
        s && _.children().css('width', s + 'px'),
        (C.totalWidth = b = r.offsetWidth),
        va(p.settings, {
          contSize: c,
          maxSnapScroll: !!v.paging && 1,
          maxScroll: 0,
          minScroll: c < b ? c - b : 0,
          snap: v.paging ? c : !!f && (s || '.mbsc-scv-item'),
          elastic: c < b && (s || c),
        }),
        p.refresh(t))
    }
    ;(ba.call(this, r, e, !0),
      (C.navigate = function (e, t) {
        S(C._getItem(e), t)
      }),
      (C.next = function (e) {
        if (o) {
          var t = o.next()
          t.length && S((o = t), e)
        }
      }),
      (C.prev = function (e) {
        if (o) {
          var t = o.prev()
          t.length && S((o = t), e)
        }
      }),
      (C.refresh = C.position =
        function (e) {
          ;(k(), D(!1, e))
        }),
      (C._init = function () {
        var e
        ;((a = pa(v.context)),
          (n = pa('body' == v.context ? window : v.context)),
          C.__init(),
          (h = v.rtl),
          (f = !(!v.itemWidth || 'fixed' == v.layout || void 0 !== v.snap) || v.snap),
          (e =
            'mbsc-scv-c mbsc-no-touch mbsc-' +
            v.theme +
            ' ' +
            (v.cssClass || '') +
            ' ' +
            (v.wrapperClass || '') +
            (v.baseTheme ? ' mbsc-' + v.baseTheme : '') +
            (h ? ' mbsc-rtl' : ' mbsc-ltr') +
            (v.itemWidth ? ' mbsc-scv-hasw' : '') +
            ('body' == v.context ? '' : ' mbsc-scv-ctx') +
            ' ' +
            (C._getContClass() || '')),
          l
            ? (l.attr('class', e), _.off('.mbsc-ripple'))
            : ((l = pa('<div class="' + e + '"><div class="mbsc-scv-sc"></div></div>')
                .on('click', '.mbsc-scv-item', M)
                .insertAfter(_))
                .find('.mbsc-scv-sc')
                .append(_),
              l.find('img').on('load', w),
              n.on('orientationchange resize', w),
              (d = Be(l[0], w, v.zone)),
              (p = new pt(l[0], {
                axis: 'X',
                contSize: 0,
                maxScroll: 0,
                maxSnapScroll: 1,
                minScroll: 0,
                snap: 1,
                elastic: 1,
                rtl: h,
                mousewheel: v.mousewheel,
                thresholdX: v.threshold,
                stopProp: v.stopProp,
                onStart: function (e) {
                  'touchstart' == e.domEvent.type && ((i = !1), g || ((g = !0), a.find('.mbsc-no-touch').removeClass('mbsc-no-touch')))
                },
                onBtnTap: function (e) {
                  i = !0
                  var t = e.domEvent,
                    a = t.target
                  'touchend' === t.type && v.tap && ha(a, ma(pa(a)), t)
                },
                onGestureStart: function (e) {
                  x('onGestureStart', e)
                },
                onGestureEnd: function (e) {
                  x('onGestureEnd', e)
                },
                onMove: function (e) {
                  x('onMove', e)
                },
                onAnimationStart: function (e) {
                  x('onAnimationStart', e)
                },
                onAnimationEnd: function (e) {
                  x('onAnimationEnd', e)
                },
              }))),
          _.css('display', '').addClass('mbsc-scv').removeClass('mbsc-cloak'),
          k(),
          x('onMarkupReady', { target: l[0] }),
          D())
      }),
      (C._size = ra),
      (C._initMarkup = ra),
      (C._markupReady = ra),
      (C._getContClass = ra),
      (C._getItemProps = ra),
      (C._getActiveItem = ra),
      (C.__init = ra),
      (C.__destroy = ra),
      (C._destroy = function () {
        ;(C.__destroy(),
          n.off('orientationchange resize', w),
          _.removeClass('mbsc-scv')
            .insertAfter(l)
            .find('.mbsc-scv-item')
            .each(function () {
              var e = pa(this)
              e.width('').removeClass(T[e.attr('data-ref')])
            }),
          l.remove(),
          p.destroy(),
          d.detach())
      }),
      (C._getItem = function (e) {
        return ('object' != typeof e && (e = C._$items.filter('[data-id="' + e + '"]')), pa(e))
      }),
      (C._onItemTap = function (e, t) {
        return void 0 === t || t
      }),
      (v = C.settings),
      (x = C.trigger),
      t || C.init())
  }
  var Js = 1
  ;((Bs.prototype = {
    _class: 'scrollview',
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _responsive: !0,
    _defaults: { tap: Ie, stopProp: !1, context: 'body', layout: 'liquid' },
  }),
    (W.ScrollView = Bs))
  function qs(a, e, t) {
    var n,
      s,
      i,
      r,
      o,
      l,
      c = pa(a),
      d = this
    function u() {
      s && 'inline' != s && n.find('.mbsc-page').css('padding-' + s, '')
    }
    function m(e) {
      e.addClass(o).attr('data-selected', 'true').attr('aria-selected', 'true')
    }
    function h(e) {
      e.removeClass(o).removeAttr('data-selected').removeAttr('aria-selected')
    }
    ;(Bs.call(this, a, e, !0),
      (d.select = function (e) {
        ;(i || h(d._$items.filter('.mbsc-ms-item-sel')), m(d._getItem(e)))
      }),
      (d.deselect = function (e) {
        h(d._getItem(e))
      }),
      (d.enable = function (e) {
        d._getItem(e).removeClass('mbsc-disabled').removeAttr('data-disabled').removeAttr('aria-disabled')
      }),
      (d.disable = function (e) {
        d._getItem(e).addClass('mbsc-disabled').attr('data-disabled', 'true').attr('aria-disabled', 'true')
      }),
      (d.setBadge = function (e, t) {
        var a
        ;((e = d._getItem(e).attr('data-badge', t)),
          (a = pa('.mbsc-ms-badge', e)).length
            ? t
              ? a.html(t)
              : a.remove()
            : t && e.append('<span class="mbsc-ms-badge">' + t + '</span>'))
      }),
      (d._markupReady = function (e) {
        ;(d._hasIcons ? e.addClass('mbsc-ms-icons') : e.removeClass('mbsc-ms-icons'),
          d._hasText ? e.addClass('mbsc-ms-txt') : e.removeClass('mbsc-ms-txt'),
          d.__markupReady(e))
      }),
      (d._size = function (e, t) {
        ;(d.__size(e, t), 'inline' != s && n.find('.mbsc-page').css('padding-' + s, a.offsetHeight + 'px'))
      }),
      (d._onItemTap = function (e, t) {
        return (
          !1 !== d.__onItemTap(e, t) &&
          (void 0 === t && (t = !i),
          r &&
            t &&
            !e.hasClass('mbsc-disabled') &&
            (i ? ('true' == e.attr('data-selected') ? h(e) : m(e)) : (h(d._$items.filter('.mbsc-ms-item-sel')), m(e))),
          t)
        )
      }),
      (d._getActiveItem = function (e) {
        var t = 'true' == e.attr('data-selected')
        if (r && !i && t) return e
      }),
      (d._getItemProps = function (e) {
        var t = 'true' == e.attr('data-selected'),
          a = 'true' == e.attr('data-disabled'),
          n = e.attr('data-icon'),
          s = e.attr('data-badge')
        return (
          e
            .attr('data-role', 'button')
            .attr('aria-selected', t ? 'true' : 'false')
            .attr('aria-disabled', a ? 'true' : 'false')
            .find('.mbsc-ms-badge')
            .remove(),
          s && e.append('<span class="mbsc-ms-badge">' + s + '</span>'),
          n && (d._hasIcons = !0),
          e.text() && (d._hasText = !0),
          {
            cssClass:
              'mbsc-ms-item ' +
              (l.itemClass || '') +
              ' ' +
              (t ? o : '') +
              (a ? ' mbsc-disabled ' + (l.disabledClass || '') : '') +
              (n ? ' mbsc-ms-ic mbsc-ic mbsc-ic-' + n : ''),
          }
        )
      }),
      (d._getContClass = function () {
        return ' mbsc-ms-c mbsc-ms-' + l.variant + ' mbsc-ms-' + s + (r ? '' : ' mbsc-ms-nosel') + (d.__getContClass() || '')
      }),
      (d.__init = function () {
        ;(d.___init(),
          (n = pa(l.context)),
          u(),
          (s = l.display),
          (i = 'multiple' == l.select),
          (r = 'off' != l.select),
          (o = ' mbsc-ms-item-sel ' + (l.activeClass || '')),
          c.addClass('mbsc-ms mbsc-ms-base ' + (l.groupClass || '')))
      }),
      (d.__destroy = function () {
        ;(c.removeClass('mbsc-ms mbsc-ms-base ' + (l.groupClass || '')), u(), d.___destroy())
      }),
      (d.__onItemTap = ra),
      (d.__getContClass = ra),
      (d.__markupReady = ra),
      (d.__size = ra),
      (d.___init = ra),
      (d.___destroy = ra),
      (l = d.settings),
      t || d.init())
  }
  qs.prototype = { _defaults: va({}, Bs.prototype._defaults) }
  function Ks(e, t) {
    ;(qs.call(this, e, t, !0), (this.___init = function () {}), this.init())
  }
  ;((Ks.prototype = {
    _class: 'optionlist',
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _responsive: !0,
    _defaults: va({}, qs.prototype._defaults, { select: 'multiple', variant: 'a', display: 'inline' }),
  }),
    (W.Optionlist = Ks),
    (Z.themes.optionlist = Z.themes.navigation))
  var Gs = e.func,
    Xs = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      return (
        l(e, t),
        (e.prototype.shouldComponentUpdate = function (e) {
          var t = this.getSettingsFromProps(e),
            a = this.getSettingsFromProps(this.props)
          return ((this.optimizeUpdate = { updateOptions: !fe(a, t), updateChildren: !fe(this.props.children, e.children) }), !0)
        }),
        e
      )
    })(be)
  Xs.propTypes = g({}, oe, {
    itemWidth: e.number,
    layout: e.oneOf(['liquid', 'fixed']),
    mousewheel: e.bool,
    snap: e.bool,
    threshold: e.number,
    paging: e.bool,
    onItemTap: Gs,
    onMarkupReady: Gs,
    onAnimationStart: Gs,
    onAnimationEnd: Gs,
    onMove: Gs,
    onGestureStart: Gs,
    onGestureEnd: Gs,
  })
  var Zs = (function (a) {
    function e(e) {
      var t
      return (r(c((t = a.call(this, e) || this)), 'childComponents', []), (t.renderChildren = t.renderChildren.bind(c(t))), t)
    }
    return (
      l(e, a),
      (e.prototype.renderChildren = function (e) {
        var u = this
        return Z.Route && e
          ? b.Children.map(this.props.children, function (i) {
              if (!i) return i
              var e = i.props,
                r = e.replace,
                t = e.to,
                a = e.exact,
                n = e.strict,
                s = e.location,
                o = e.isActive,
                l = e.sensitive,
                c = 'object' == typeof t ? t.pathname : t,
                d = c && c.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1')
              return b.createElement(Z.Route, { path: d, exact: a, strict: n, location: s, sensitive: l }, function (e) {
                var t = e.location,
                  a = e.match,
                  n = !!(o ? o(a, t) : a),
                  s = {
                    replace: void 0 !== r ? r : u.props.replace,
                    ref: function (e) {
                      u.childComponents.push(e)
                    },
                    selected: n,
                  }
                return (Z.withRouter && ((s.wrappedComponentRef = s.ref), delete s.ref), b.cloneElement(i, s))
              })
            })
          : b.Children.map(this.props.children, function (e) {
              return e
                ? b.cloneElement(e, {
                    ref: function (e) {
                      u.childComponents.push(e)
                    },
                  })
                : e
            })
      }),
      e
    )
  })(Xs)
  r(Zs, 'contextTypes', {
    router: e.shape({ history: e.shape({ push: e.func.isRequired, replace: e.func.isRequired, createHref: e.func.isRequired }) }),
  })
  var Qs = +new Date(),
    ei = (function (a) {
      function e(e) {
        var t
        return (
          ((t = a.call(this, e) || this)._instance = null),
          (t._DOMNode = null),
          (t.id = e.id || Qs++),
          (t.setInstance = t.setInstance.bind(c(t))),
          t
        )
      }
      l(e, a)
      var t = e.prototype
      return (
        (t.setInstance = function (e) {
          this._instance = e
        }),
        (t.componentDidMount = function () {
          this._DOMNode = i.findDOMNode(this)
        }),
        e
      )
    })(b.Component)
  ;(r(ei, 'propTypes', {
    selected: e.bool,
    disabled: e.bool,
    icon: e.string,
    id: e.oneOfType([e.string, e.number]),
    to: e.oneOfType([e.string, e.object]),
    onClick: e.func,
    replace: e.bool,
    isActive: e.func,
    exact: e.bool,
    strict: e.bool,
    sensitive: e.bool,
    location: e.oneOfType([e.string, e.object]),
  }),
    r(ei, 'contextTypes', {
      router: e.shape({ history: e.shape({ push: e.func.isRequired, replace: e.func.isRequired, createHref: e.func.isRequired }) }),
    }))
  var ti = e.number,
    ai = e.bool,
    ni = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      l(e, t)
      var a = e.prototype
      return (
        (a.componentDidMount = function () {
          var e = this.getSettingsFromProps(this.props),
            t = i.findDOMNode(this)
          this.instance = new Ks(t, e)
          for (var a = 0; a < this.childComponents.length; a++)
            this.childComponents[a].setInstance && this.childComponents[a].setInstance(this.instance)
        }),
        (a.componentDidUpdate = function () {
          this.optimizeUpdate.updateChildren && this.instance.refresh(!0)
        }),
        (a.render = function () {
          return b.createElement('div', { className: this.initialCssClass + ' mbsc-cloak' }, this.renderChildren())
        }),
        e
      )
    })(Zs),
    si = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      l(e, t)
      var a = e.prototype
      return (
        (a.render = function () {
          var e = this.props,
            t = e.icon,
            a = e.selected,
            n = e.disabled,
            s = e.onClick,
            i = e.children,
            r = x(e, ['icon', 'selected', 'disabled', 'onClick', 'children'])
          return b.createElement('div', g({ 'data-icon': t, 'data-id': this.id, 'data-selected': a, 'data-disabled': n, onClick: s }, r), i)
        }),
        (a.shouldComponentUpdate = function (e) {
          return (
            (this.optimizeUpdate = {
              updateChildren: !fe(this.props.children, e.children),
              updateSelected: this.props.selected !== e.selected,
              updateDisabled: this.props.disabled !== e.disabled,
            }),
            this.optimizeUpdate.updateChildren || this.optimizeUpdate.updateSelected || this.optimizeUpdate.updateDisabled
          )
        }),
        (a.componentDidUpdate = function () {
          this._instance &&
            (this.optimizeUpdate.updateSelected &&
              (this.props.selected ? this._instance.select(this._DOMNode) : this._instance.deselect(this._DOMNode)),
            this.optimizeUpdate.updateDisabled &&
              (this.props.disabled ? this._instance.disable(this._DOMNode) : this._instance.enable(this._DOMNode)))
        }),
        e
      )
    })(ei)
  ;((ni.propTypes = g({}, Zs.propTyes, {
    paging: ai,
    select: e.oneOf(['off', 'single', 'multiple']),
    snap: ai,
    threshold: ti,
    children: function (e, t, a) {
      var n,
        s = e[t]
      return (
        b.Children.forEach(s, function (e) {
          n || (e.type !== si && (n = new Error('`' + a + '` only accepts `OptionItem`.')))
        }),
        n
      )
    },
  })),
    (Z.Optionlist = ni),
    (Z.OptionItem = si))
  function ii(e, t) {
    var l,
      c,
      d,
      u,
      m,
      h = pa(e),
      n = h.is('ul,ol'),
      p = this
    ;(qs.call(this, e, t, !0),
      (p._initMarkup = function () {
        ;(l && l.remove(), c && h.append(c.children()))
      }),
      (p.__size = function (a, n) {
        var s,
          i = n || 72,
          r = p._$items.length,
          o = 0
        ;(m.hide(),
          'bottom' == u.type &&
            (h.removeClass('mbsc-scv-liq'),
            l.remove(),
            p._$items.remove().each(function (e) {
              var t = pa(this)
              ;(h.append(t),
                (o += n || this.offsetWidth || 0),
                Math.round(o + (e < r - 1 ? i : 0)) > a && ((s = !0), c.append(t.css('width', '').addClass('mbsc-fr-btn-e'))))
            }),
            l
              .attr('class', d + (u.moreIcon ? ' mbsc-menu-item-ic mbsc-ms-ic mbsc-ic mbsc-ic-' + u.moreIcon : ''))
              .html(p._hasIcons && p._hasText ? u.moreText : ''),
            s && h.append(l)),
          'liquid' == u.layout && h.addClass('mbsc-scv-liq'))
      }),
      (p.__onItemTap = function (e) {
        if (e.hasClass('mbsc-menu-item') && !1 !== p.trigger('onMenuShow', { target: e[0], menu: m })) return (m.show(!1, !0), !1)
      }),
      (p.__getContClass = function () {
        return 'hamburger' == u.type ? ' mbsc-ms-hamburger' : ''
      }),
      (p.__markupReady = function (e) {
        'hamburger' == u.type &&
          (c.append(p._$items.addClass('mbsc-fr-btn-e')),
          l.attr('class', d + (u.menuIcon ? ' mbsc-menu-item-ic mbsc-ms-ic mbsc-ic mbsc-ic-' + u.menuIcon : '')).html(u.menuText || ''),
          h.append(l),
          (u.menuText && u.menuIcon) || e.removeClass('mbsc-ms-icons'),
          u.menuText ? e.addClass('mbsc-ms-txt') : e.removeClass('mbsc-ms-txt'))
      }),
      (p.___init = function () {
        var a
        ;('tab' == u.type
          ? ((u.display = u.display || 'top'), (u.variant = u.variant || 'b'))
          : 'bottom' == u.type
            ? ((u.display = u.display || 'bottom'), (u.variant = u.variant || 'a'))
            : 'hamburger' == u.type && ((u.display = u.display || 'inline'), (u.variant = u.variant || 'a')),
          (d = 'mbsc-scv-item mbsc-ms-item mbsc-btn-e mbsc-menu-item ' + (u.itemClass || '')),
          l || ((l = pa(n ? '<li></li>' : '<div></div>')), (c = pa(n ? '<ul></ul>' : '<div></div>').addClass('mbsc-scv mbsc-ms'))),
          (m = new en(c[0], {
            display: 'bubble',
            theme: u.theme,
            lang: u.lang,
            context: u.context,
            buttons: [],
            anchor: l,
            onBeforeShow: function (e, t) {
              ;((a = null), (t.settings.cssClass = 'mbsc-wdg mbsc-ms-a mbsc-ms-more' + (p._hasText ? '' : ' mbsc-ms-more-icons')))
            },
            onBeforeClose: function () {
              return p.trigger('onMenuHide', { target: a && a[0], menu: m })
            },
            onMarkupReady: function (e, t) {
              p.tap(t._markup.find('.mbsc-fr-c'), function (e) {
                ;(a = pa(e.target).closest('.mbsc-ms-item')).length && !a.hasClass('mbsc-disabled') && (p.navigate(a, !0), m.hide())
              })
            },
          })))
      }),
      (p.___destroy = function () {
        ;(m.destroy(), h.append(p._$items), l.remove())
      }),
      (u = p.settings),
      p.init())
  }
  ;((ii.prototype = {
    _class: 'navigation',
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _responsive: !0,
    _defaults: va({}, qs.prototype._defaults, {
      type: 'bottom',
      moreText: 'More',
      moreIcon: 'material-more-horiz',
      menuIcon: 'material-menu',
    }),
  }),
    (W.Navigation = ii))
  var ri = (function (n) {
    function e(e, t) {
      var a
      return (((a = n.call(this, e) || this).type = t), (a.elm = a.elm.bind(c(a))), a)
    }
    l(e, n)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props, { type: this.type })
        this.instance = new ii(this.domNode, e)
        for (var t = 0; t < this.childComponents.length; t++) this.childComponents[t].setInstance(this.instance)
      }),
      (t.componentDidUpdate = function () {
        this.optimizeUpdate.updateChildren && this.instance.refresh(!0)
      }),
      (t.elm = function (e) {
        this.domNode = e
      }),
      (t.render = function () {
        return b.createElement(
          'div',
          null,
          b.createElement('div', { ref: this.elm, className: this.initialCssClass + ' mbsc-cloak' }, this.renderChildren(!0)),
        )
      }),
      e
    )
  })(Zs)
  ;((ri.defaultProps = g({}, ri.defaultProps, { replace: !1 })),
    (ri.propTypes = g({}, Zs.propTypes, {
      display: e.oneOf(['top', 'bottom', 'inline']),
      moreText: e.string,
      moreIcon: e.string,
      menuText: e.string,
      menuIcon: e.string,
      onMenuShow: e.func,
      onMenuHide: e.func,
      replace: e.bool,
      children: function (e, t, a) {
        var n,
          s = e[t]
        return (
          b.Children.forEach(s, function (e) {
            n || (null != e && !1 !== e && e.type !== Z.NavItem && (n = new Error('`' + a + '` only accepts `NavItem`.')))
          }),
          n
        )
      },
    })))
  var oi = (function (t) {
      function e(e) {
        return t.call(this, e, 'bottom') || this
      }
      return (l(e, t), e)
    })(ri),
    li = (function (t) {
      function e(e) {
        return t.call(this, e, 'hamburger') || this
      }
      return (l(e, t), e)
    })(ri),
    ci = (function (t) {
      function e(e) {
        return t.call(this, e, 'tab') || this
      }
      return (l(e, t), e)
    })(ri),
    di = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).handleClick = t.handleClick.bind(c(t))), t)
      }
      l(e, a)
      var t = e.prototype
      return (
        (t.handleClick = function (e) {
          this.props.onClick && this.props.onClick(e)
          var t = null
          if (
            (this.context.router && !e.defaultPrevented
              ? (e.preventDefault(), (t = this.context.router.history))
              : this.props.history && !e.defaultPrevented && (e.preventDefault(), (t = this.props.history)),
            t)
          ) {
            var a = this.props,
              n = a.replace,
              s = a.to
            n ? t.replace(s) : t.push(s)
          }
        }),
        (t.render = function () {
          var e = this.props,
            t = e.icon,
            a = e.selected,
            n = e.disabled,
            s = e.badge
          return b.createElement(
            'div',
            { 'data-icon': t, 'data-id': this.id, 'data-selected': a, 'data-disabled': n, 'data-badge': s, onClick: this.handleClick },
            this.props.children,
          )
        }),
        (t.shouldComponentUpdate = function (e) {
          return (
            (this.optimizeUpdate = {
              updateChildren: !fe(this.props.children, e.children),
              updateSelected: this.props.selected !== e.selected,
              updateDisabled: this.props.disabled !== e.disabled,
              updateBadge: this.props.badge !== e.badge,
            }),
            this.optimizeUpdate.updateChildren ||
              this.optimizeUpdate.updateSelected ||
              this.optimizeUpdate.updateDisabled ||
              this.optimizeUpdate.updateBadge
          )
        }),
        (t.componentDidUpdate = function () {
          this._instance &&
            (this.optimizeUpdate.updateSelected &&
              (this.props.selected ? this._instance.select(this._DOMNode) : this._instance.deselect(this._DOMNode)),
            this.optimizeUpdate.updateDisabled &&
              (this.props.disabled ? this._instance.disable(this._DOMNode) : this._instance.enable(this._DOMNode)),
            this.optimizeUpdate.updateBadge && this._instance.setBadge(this._DOMNode, this.props.badge))
        }),
        e
      )
    })(ei)
  ;((di.propTypes = g({}, ei.propTypes, { badge: e.string })),
    (Z.Nav = ri),
    (Z.BottomNav = oi),
    (Z.HamburgerNav = li),
    (Z.TabNav = ci),
    (Z.NavItem = di),
    (Z.setupReactRouter = function (e, t) {
      ;((Z.Route = e), t && ((Z.withRouter = t), (Z.NavItem = t(Z.NavItem))))
    }),
    (vt.number = vt.measurement))
  var ui = e.string,
    mi = e.number,
    hi = {
      decimalSeparator: ui,
      defaultValue: ui,
      invalid: e.array,
      max: mi,
      min: mi,
      scale: mi,
      step: mi,
      wholeText: ui,
      fractionText: ui,
      signText: ui,
    },
    pi = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { preset: 'number' }), t)
      }
      return (l(e, a), e)
    })(xe)
  ;((pi.propTypes = g({}, pi.propTypes, {}, ce, {}, hi)), (Z.Number = pi))
  function fi(s, e, t) {
    var i,
      r,
      o,
      l,
      c,
      d,
      u,
      a,
      n,
      m,
      h,
      p,
      f,
      v,
      b,
      g,
      x,
      T,
      y,
      C,
      _ = pa(s),
      w = this,
      M = [],
      S = [],
      k = {},
      D = {},
      N = { 107: '+', 109: '-' },
      E = {
        48: 0,
        49: 1,
        50: 2,
        51: 3,
        52: 4,
        53: 5,
        54: 6,
        55: 7,
        56: 8,
        57: 9,
        96: 0,
        97: 1,
        98: 2,
        99: 3,
        100: 4,
        101: 5,
        102: 6,
        103: 7,
        104: 8,
        105: 9,
      }
    function O(e) {
      var t,
        a = d.validate.call(s, { values: g.slice(0), variables: k }, w) || [],
        n = (a && a.disabled) || []
      if (
        ((w._isValid = !a.invalid),
        (w._tempValue = d.formatValue.call(s, g.slice(0), k, w)),
        (c = g.length),
        (x = a.length || y),
        w._isVisible)
      ) {
        if (
          (pa('.mbsc-np-ph', r).each(function (e) {
            pa(this).html('ltr' == d.fill ? (c <= e ? l : u || g[e]) : y - x <= e ? (e + c < y ? l : u || g[e + c - y]) : '')
          }),
          pa('.mbsc-np-cph', r).each(function () {
            pa(this).html(k[pa(this).attr('data-var')] || pa(this).attr('data-ph'))
          }),
          c === y)
        )
          for (t = 0; t <= 9; t++) n.push(t)
        for (pa('.mbsc-np-btn', r).removeClass(o), t = 0; t < n.length; t++) pa('.mbsc-np-btn[data-val="' + n[t] + '"]', r).addClass(o)
        ;(w._isValid ? pa('.mbsc-fr-btn-s .mbsc-fr-btn', r).removeClass(o) : pa('.mbsc-fr-btn-s .mbsc-fr-btn', r).addClass(o),
          w.live && ((w._hasValue = e || w._hasValue), V(e, !1, e), e && T('onSet', { valueText: w._value })))
      }
    }
    function V(e, t, a, n) {
      ;(t && O(),
        n || ((C = g.slice(0)), (D = va({}, k)), (M = S.slice(0)), (w._value = w._hasValue ? w._tempValue : null)),
        e &&
          (w._isInput && _.val(w._hasValue && w._isValid ? w._value : ''),
          T('onFill', { valueText: w._hasValue ? w._tempValue : '', change: a }),
          a && ((w._preventChange = !0), _.trigger('change'))))
    }
    function F(e) {
      var t,
        a,
        n = e || [],
        s = []
      for (S = [], k = {}, t = 0; t < n.length; t++)
        /:/.test(n[t]) ? ((a = n[t].split(':')), (k[a[0]] = a[1]), S.push(a[0])) : (s.push(n[t]), S.push('digit'))
      return s
    }
    function A(e, t) {
      T('onInput', { domEvent: t, target: e, values: g.slice(0), valueText: w._tempValue, variables: k })
    }
    function I(e, t, a) {
      !(c || t || d.allowLeadingZero) ||
        e.hasClass('mbsc-disabled') ||
        e.hasClass('mbsc-np-btn-empty') ||
        (c < y && (S.push('digit'), g.push(t), O(!0), A(e[0], a)))
    }
    function P(e, t) {
      var a,
        n,
        s = e.attr('data-val'),
        i = 'false' !== e.attr('data-track'),
        r = e.attr('data-var')
      if (!e.hasClass('mbsc-disabled')) {
        if (
          (r && ((n = r.split(':')), i && S.push(n[0]), (k[n[0]] = void 0 === n[2] ? n[1] : k[n[0]] == n[1] ? n[2] : n[1])),
          s.length + c <= x)
        )
          for (a = 0; a < s.length; ++a)
            ((n = oa(s[a]) ? +s[a] : s[a]), (d.allowLeadingZero || c || n) && (S.push('digit'), g.push(n), (c = g.length)))
        ;(O(!0), A(e[0], t))
      }
    }
    function H(e) {
      var t,
        a,
        n = S.pop()
      if (c || 'digit' !== n) {
        if ('digit' !== n && k[n]) for (delete k[n], a = S.slice(0), S = [], t = 0; t < a.length; t++) a[t] !== n && S.push(a[t])
        else g.pop()
        ;(O(!0), A(i[0], e))
      }
    }
    function L() {
      ;(clearInterval(b), (v = !1))
    }
    function z(e) {
      if (ga(e, this)) {
        if ('keydown' == e.type && 32 != e.keyCode) return
        ;(!(function (e) {
          ;((v = !0),
            (a = ua(e, 'X')),
            (n = ua(e, 'Y')),
            clearInterval(b),
            clearTimeout(b),
            H(e),
            (b = setInterval(function () {
              H(e)
            }, 150)))
        })(e),
          'mousedown' == e.type && pa(document).on('mousemove', U).on('mouseup', Y))
      }
    }
    function U(e) {
      v && ((m = ua(e, 'X')), (h = ua(e, 'Y')), (p = m - a), (f = h - n), (7 < Math.abs(p) || 7 < Math.abs(f)) && L())
    }
    function Y(e) {
      v && (e.preventDefault(), L(), 'mouseup' == e.type && pa(document).off('mousemove', U).off('mouseup', Y))
    }
    ;(qe.call(this, s, e, !0),
      (w.setVal = w._setVal =
        function (e, t, a, n) {
          ;((w._hasValue = null != e), (g = F(pa.isArray(e) ? e.slice(0) : d.parseValue.call(s, e, w))), V(t, !0, void 0 === a ? t : a, n))
        }),
      (w.getVal = w._getVal =
        function (e) {
          return w._hasValue || e ? w[e ? '_tempValue' : '_value'] : null
        }),
      (w.setArrayVal = w.setVal),
      (w.getArrayVal = function (e) {
        return e ? g.slice(0) : w._hasValue ? C.slice(0) : null
      }),
      (w._readValue = function () {
        var e = _.val() || ''
        ;('' !== e && (w._hasValue = !0),
          u
            ? ((k = {}), (S = []), (g = []))
            : ((k = w._hasValue ? D : {}),
              (S = w._hasValue ? M : []),
              (g = w._hasValue && C ? C.slice(0) : F(d.parseValue.call(s, e, w))),
              V(!1, !0)))
      }),
      (w._fillValue = function () {
        V((w._hasValue = !0), !1, !0)
      }),
      (w._generateContent = function () {
        var e,
          t,
          a,
          n = 1,
          s = ''
        for (
          s +=
            '<div class="mbsc-np-hdr"><div role="button" tabindex="0" aria-label="' +
            d.deleteText +
            '" class="mbsc-np-del mbsc-fr-btn-e mbsc-ic mbsc-ic-' +
            d.deleteIcon +
            '"></div><div class="mbsc-np-dsp">',
            s += d.template
              .replace(/d/g, '<span class="mbsc-np-ph">' + l + '</span>')
              .replace(/&#100;/g, 'd')
              .replace(/{([a-zA-Z0-9]*):?([a-zA-Z0-9\-_]*)}/g, '<span class="mbsc-np-cph" data-var="$1" data-ph="$2">$2</span>'),
            s += '</div></div>',
            s += '<div class="mbsc-np-tbl-c mbsc-w-p"><div class="mbsc-np-tbl">',
            e = 0;
          e < 4;
          e++
        ) {
          for (s += '<div class="mbsc-np-row">', t = 0; t < 3; t++)
            (10 == (a = n) || 12 == n ? (a = '') : 11 == n && (a = 0),
              '' === a
                ? 10 == n && d.leftKey
                  ? (s +=
                      '<div role="button" tabindex="0" class="mbsc-np-btn mbsc-np-btn-custom mbsc-fr-btn-e" ' +
                      (d.leftKey.variable ? 'data-var="' + d.leftKey.variable + '"' : '') +
                      ' data-val="' +
                      (d.leftKey.value || '') +
                      '" ' +
                      (void 0 !== d.leftKey.track ? ' data-track="' + d.leftKey.track + '"' : '') +
                      '>' +
                      d.leftKey.text +
                      '</div>')
                  : 12 == n && d.rightKey
                    ? (s +=
                        '<div role="button" tabindex="0" class="mbsc-np-btn mbsc-np-btn-custom mbsc-fr-btn-e" ' +
                        (d.rightKey.variable ? 'data-var="' + d.rightKey.variable + '"' : '') +
                        ' data-val="' +
                        (d.rightKey.value || '') +
                        '" ' +
                        (void 0 !== d.rightKey.track ? ' data-track="' + d.rightKey.track + '"' : '') +
                        ' >' +
                        d.rightKey.text +
                        '</div>')
                    : (s += '<div class="mbsc-np-btn mbsc-np-btn-empty"></div>')
                : (s += '<div tabindex="0" role="button" class="mbsc-np-btn mbsc-fr-btn-e" data-val="' + a + '">' + a + '</div>'),
              n++)
          s += '</div>'
        }
        return (s += '</div></div>')
      }),
      (w._markupReady = function () {
        ;((r = w._markup), O())
      }),
      (w._attachEvents = function (n) {
        ;(n.on('keydown', function (e) {
          var t,
            a = e.keyCode
          void 0 !== N[a]
            ? (t = pa('.mbsc-np-btn[data-var="sign:-:"]', n)).length && ((k.sign = 107 == a ? '-' : ''), P(t, e))
            : void 0 !== E[a]
              ? I(pa('.mbsc-np-btn[data-val="' + E[a] + '"]', n), E[a], e)
              : 8 == a && (e.preventDefault(), H(e))
        }),
          w.tap(
            pa('.mbsc-np-btn', n),
            function (e) {
              var t = pa(this)
              t.hasClass('mbsc-np-btn-custom') ? P(t, e) : I(t, +t.attr('data-val'), e)
            },
            !1,
            30,
            !0,
          ),
          (i = pa('.mbsc-np-del', n).on('touchstart mousedown keydown', z).on('touchmove mousemove', U).on('touchend mouseup keyup', Y)))
      }),
      (w.__init = function () {
        ;(((d = w.settings).template = d.template.replace(/\\d/, '&#100;')),
          (l = d.placeholder),
          (y = (d.template.match(/d/g) || []).length),
          (o = 'mbsc-disabled ' + (d.disabledClass || '')),
          (u = d.mask),
          (T = w.trigger),
          u && _.is('input') && _.attr('type', 'password'))
      }),
      (w._indexOf = function (e, t) {
        var a
        for (a = 0; a < e.length; ++a) if (e[a].toString() === t.toString()) return a
        return -1
      }),
      t || w.init())
  }
  var vi = {}
  ;((fi.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _responsive: !0,
    _class: 'numpad',
    _presets: vi,
    _defaults: va({}, qe.prototype._defaults, {
      template: 'dd.dd',
      placeholder: '0',
      deleteIcon: 'backspace',
      allowLeadingZero: !1,
      headerText: !1,
      fill: 'rtl',
      compClass: 'mbsc-np',
      deleteText: 'Delete',
      decimalSeparator: '.',
      thousandsSeparator: ',',
      validate: ra,
      parseValue: ra,
      formatValue: function (e, t, a) {
        var n,
          s = 1,
          i = a.settings,
          r = i.placeholder,
          o = i.template,
          l = e.length,
          c = o.length,
          d = ''
        for (n = 0; n < c; n++) 'd' == o[c - n - 1] ? ((d = s <= l ? e[l - s] + d : r + d), s++) : (d = o[c - n - 1] + d)
        return (
          pa.each(t, function (e, t) {
            d = d.replace('{' + e + '}', t)
          }),
          pa('<div>' + d + '</div>').text()
        )
      },
    }),
  }),
    (W.Numpad = fi),
    (Z.themes.numpad = Z.themes.frame))
  var bi = { entryMode: 'template', min: 0, max: 99.99, maxScale: 4, prefix: '', suffix: '', returnAffix: !1 }
  function gi(e) {
    for (var t = 0, a = 1, n = 0; e.length; ) (3 < t ? (a = 3600) : 1 < t && (a = 60), (n += e.pop() * a * (t % 2 ? 10 : 1)), t++)
    return n
  }
  vi.decimal = function (l) {
    var e = va({}, l.settings),
      t = { scale: 'freeform' == e.entryMode ? void 0 : 2 },
      c = va(l.settings, bi, t, e),
      d = c.scale,
      u = +c.min.toFixed(d),
      m = +c.max.toFixed(d),
      a = u < 0,
      h = new RegExp(c.thousandsSeparator, 'g'),
      p = (Math.floor(Math.max(m, Math.abs(u))) + '').length + 1,
      f = 'freeform' == c.entryMode
    function v(e, t) {
      var a = +e
        .map(function (e, t) {
          return (0 === t && '.' === e ? '0' : '') + e
        })
        .join('')
      if (!f) for (var n = 0; n < d; n++) a /= 10
      return t ? -1 * a : a
    }
    function b(e, t) {
      var a = ''
      !f || (void 0 !== d && t) ? (a = v(e).toFixed(d)) : ('.' === e[0] && (a += '0'), (a += e.join('')))
      var n = a.split('.'),
        s = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, c.thousandsSeparator),
        i = n[1] ? c.decimalSeparator + n[1] : ''
      return (void 0 !== n[1] && !n[1].length && f && (i = c.decimalSeparator), s + i)
    }
    ;((l.setVal = function (e, t, a, n) {
      return l._setVal(me(e, u, m), t, a, n)
    }),
      (l.getVal = function (e) {
        var t = l._getVal(e),
          a = (t + '').replace(h, '').replace(c.decimalSeparator, '.')
        return oa(a) ? +a : t
      }))
    var n = Array(p).join('d')
    return (
      (n += f
        ? void 0 !== d
          ? d
            ? Array(d + 2).join('d')
            : ''
          : Array(c.maxScale + 2).join('d')
        : d
          ? '.' + Array(d + 1).join('d')
          : ''),
      {
        template: (a ? '{sign}' : '') + c.prefix.replace(/d/g, '\\d') + n + c.suffix.replace(/d/g, '\\d'),
        leftKey: a ? { text: '-/+', variable: 'sign:-:', track: !1 } : void 0,
        rightKey: f ? { text: c.decimalSeparator, value: '.' } : void 0,
        allowLeadingZero: f,
        parseValue: function (e) {
          var t,
            a,
            n = e || c.defaultValue,
            s = [],
            i = void 0 !== d ? d : c.maxScale
          if (n) {
            if ((a = (n = (n + '').replace(h, '').replace(c.decimalSeparator, '.')).match(/\d+\.?\d*/g)))
              for (a = (+a[0]).toFixed(i), t = 0; t < a.length; t++)
                if ('.' != a[t]) {
                  if (+a[t]) s.push(+a[t])
                  else if (s.length) {
                    var r = a.indexOf('.'),
                      o = a.length > t + 1 && a.substring(t + 1).match(/[1-9]+/)
                    ;(!f || t < r || o) && s.push(0)
                  }
                } else f && s.push('.')
          } else 0 === n && f && s.push(0)
          return (e < 0 && s.unshift('sign:-'), s)
        },
        formatValue: function (e, t) {
          var a = b(e, !0)
          return (v(e, t && '-' == t.sign) < 0 ? '-' : '') + (c.returnAffix ? c.prefix + a + c.suffix : a)
        },
        validate: function (e) {
          var t,
            a = e.values,
            n = b(a),
            s = v(a, e.variables && '-' == e.variables.sign),
            i = [],
            r = m < s || s < u || (!!c.invalid && -1 != l._indexOf(c.invalid, s))
          if ((a.length || c.allowLeadingZero || f || i.push(0), (a.length >= p || -1 !== a.indexOf('.')) && i.push('.'), f)) {
            if (1 == a.length && 0 === a[0]) for (t = 0; t <= 9; t++) i.push(t)
            ;(a.length && '.' != a[a.length - 1]) || (r = !0)
            var o = void 0 !== d ? d : c.maxScale
            if (a.length >= o + 1 && '.' == a[a.length - o - 1]) for (t = 0; t <= 9; t++) i.push(t)
          }
          return (
            l.isVisible() && pa('.mbsc-np-dsp', l._markup).html((e.variables.sign || '') + c.prefix + n + c.suffix || '&nbsp;'),
            { disabled: i, invalid: r }
          )
        },
      }
    )
  }
  var xi = ['h', 'm', 's'],
    Ti = { min: 0, max: 362439, defaultValue: 0, hourTextShort: 'h', minuteTextShort: 'm', secTextShort: 's' }
  vi.timespan = function (s) {
    var e = va({}, s.settings),
      i = va(s.settings, Ti, e),
      r = { h: i.hourTextShort.replace(/d/g, '\\d'), m: i.minuteTextShort.replace(/d/g, '\\d'), s: i.secTextShort.replace(/d/g, '\\d') },
      t = 'd<span class="mbsc-np-sup mbsc-np-time">' + r.s + '</span>'
    function o(a) {
      var n,
        s = '',
        i = 3600
      return (
        pa(xi).each(function (e, t) {
          ;((n = Math.floor(a / i)), (a -= n * i), (i /= 60), (0 < n || ('s' == t && !s)) && (s = s + (s ? ' ' : '') + n + r[t]))
        }),
        s
      )
    }
    return (
      9 < i.max && (t = 'd' + t),
      99 < i.max &&
        (t =
          '<span class="mbsc-np-ts-m">' +
          (639 < i.max ? 'd' : '') +
          'd</span><span class="mbsc-np-sup mbsc-np-time">' +
          r.m +
          '</span>' +
          t),
      6039 < i.max &&
        (t =
          '<span class="mbsc-np-ts-h">' +
          (38439 < i.max ? 'd' : '') +
          'd</span><span class="mbsc-np-sup mbsc-np-time">' +
          r.h +
          '</span>' +
          t),
      (s.setVal = function (e, t, a, n) {
        return (oa(e) && (e = o(e)), s._setVal(e, t, a, n))
      }),
      (s.getVal = function (e) {
        return s._hasValue || e ? gi(s.getArrayVal(e)) : null
      }),
      {
        template: t,
        parseValue: function (e) {
          var a,
            n = e || o(i.defaultValue),
            s = []
          return (
            n &&
              pa(xi).each(function (e, t) {
                ;(a = new RegExp('(\\d+)' + r[t], 'gi').exec(n))
                  ? 9 < (a = +a[1])
                    ? (s.push(Math.floor(a / 10)), s.push(a % 10))
                    : (s.length && s.push(0), (a || s.length) && s.push(a))
                  : s.length && (s.push(0), s.push(0))
              }),
            s
          )
        },
        formatValue: function (e) {
          return o(gi(e))
        },
        validate: function (e) {
          var t = e.values,
            a = gi(t.slice(0)),
            n = []
          return (
            t.length || n.push(0),
            { disabled: n, invalid: a > i.max || a < i.min || (!!i.invalid && -1 != s._indexOf(i.invalid, +a)) }
          )
        },
      }
    )
  }
  var yi = { timeFormat: 'hh:ii A', amText: 'am', pmText: 'pm' }
  vi.time = function (s) {
    var e = va({}, s.settings),
      h = va(s.settings, yi, e),
      p = h.timeFormat.split(':'),
      f = h.timeFormat.match(/a/i),
      i = f ? ('a' == f[0] ? h.amText : h.amText.toUpperCase()) : '',
      r = f ? ('a' == f[0] ? h.pmText : h.pmText.toUpperCase()) : '',
      v = 0,
      b = h.min ? '' + h.min.getHours() : '',
      g = h.max ? '' + h.max.getHours() : '',
      x = h.min ? '' + (h.min.getMinutes() < 10 ? '0' + h.min.getMinutes() : h.min.getMinutes()) : '',
      T = h.max ? '' + (h.max.getMinutes() < 10 ? '0' + h.max.getMinutes() : h.max.getMinutes()) : '',
      y = h.min ? '' + (h.min.getSeconds() < 10 ? '0' + h.min.getSeconds() : h.min.getSeconds()) : '',
      C = h.max ? '' + (h.max.getSeconds() < 10 ? '0' + h.max.getSeconds() : h.max.getSeconds()) : ''
    function o(e, t) {
      var a,
        n = ''
      for (a = 0; a < e.length; ++a) n += e[a] + (a % 2 == (e.length % 2 == 1 ? 0 : 1) && a != e.length - 1 ? ':' : '')
      return (
        pa.each(t, function (e, t) {
          n += ' ' + t
        }),
        n
      )
    }
    return (
      h.min && h.min.setFullYear(2014, 7, 20),
      h.max && h.max.setFullYear(2014, 7, 20),
      {
        placeholder: '-',
        allowLeadingZero: !0,
        template: (3 == p.length ? 'dd:dd:dd' : 2 == p.length ? 'dd:dd' : 'dd') + (f ? '<span class="mbsc-np-sup">{ampm:--}</span>' : ''),
        leftKey: f ? { text: i, variable: 'ampm:' + i, value: '00' } : { text: ':00', value: '00' },
        rightKey: f ? { text: r, variable: 'ampm:' + r, value: '00' } : { text: ':30', value: '30' },
        parseValue: function (e) {
          var t,
            a,
            n = e || h.defaultValue,
            s = []
          if (n) {
            if ((a = (n += '').match(/\d/g))) for (t = 0; t < a.length; t++) s.push(+a[t])
            f && s.push('ampm:' + (n.match(new RegExp(h.pmText, 'gi')) ? r : i))
          }
          return s
        },
        formatValue: function (e, t) {
          return o(e, t)
        },
        validate: function (e) {
          var t = e.values,
            a = o(t, e.variables),
            n =
              3 <= t.length
                ? new Date(
                    2014,
                    7,
                    20,
                    '' + t[0] + (t.length % 2 == 0 ? t[1] : ''),
                    '' + t[t.length % 2 == 0 ? 2 : 1] + t[t.length % 2 == 0 ? 3 : 2],
                  )
                : ''
          return {
            disabled: (function (e) {
              var t,
                a,
                n,
                s,
                i,
                r,
                o,
                l,
                c,
                d,
                u = [],
                m = 2 * p.length
              if (
                ((v = m),
                e.length || (f && (u.push(0), u.push(h.leftKey.value)), u.push(h.rightKey.value)),
                !f && (m - e.length < 2 || (1 != e[0] && (2 < e[0] || 3 < e[1]) && m - e.length <= 2)) && (u.push('30'), u.push('00')),
                (f ? 1 < e[0] || 2 < e[1] : 1 != e[0] && (2 < e[0] || 3 < e[1])) && e[0] && (e.unshift(0), (v = m - 1)),
                e.length == m)
              )
                for (t = 0; t <= 9; ++t) u.push(t)
              else if (
                (1 == e.length && f && 1 == e[0]) ||
                (e.length && e.length % 2 == 0) ||
                (!f && 2 == e[0] && 3 < e[1] && e.length % 2 == 1)
              )
                for (t = 6; t <= 9; ++t) u.push(t)
              if (((c = void 0 !== e[1] ? '' + e[0] + e[1] : ''), (d = +T == +(void 0 !== e[3] ? '' + e[2] + e[3] : '')), h.invalid))
                for (t = 0; t < h.invalid.length; ++t)
                  if (((r = h.invalid[t].getHours()), (o = h.invalid[t].getMinutes()), (l = h.invalid[t].getSeconds()), r == +c)) {
                    if (2 == p.length && (o < 10 ? 0 : +('' + o)[0]) == +e[2]) {
                      u.push(o < 10 ? o : +('' + o)[1])
                      break
                    }
                    if ((l < 10 ? 0 : +('' + l)[0]) == +e[4]) {
                      u.push(l < 10 ? l : +('' + l)[1])
                      break
                    }
                  }
              if (h.min || h.max) {
                if (((i = (n = +g == +c) && d), (s = (a = +b == +c) && d), 0 === e.length)) {
                  for (t = f ? 2 : 19 < b ? b[0] : 3; t <= (1 == b[0] ? 9 : b[0] - 1); ++t) u.push(t)
                  if (10 <= b && (u.push(0), 2 == b[0])) for (t = 3; t <= 9; ++t) u.push(t)
                  if ((g && g < 10) || (b && 10 <= b)) for (t = g && g < 10 ? +g[0] + 1 : 0; t < (b && 10 <= b ? b[0] : 10); ++t) u.push(t)
                }
                if (1 == e.length) {
                  if (0 === e[0]) for (t = 0; t < b[0]; ++t) u.push(t)
                  if (b && 0 !== e[0] && (f ? 1 == e[0] : 2 == e[0])) for (t = f ? 3 : 4; t <= 9; ++t) u.push(t)
                  if (e[0] == b[0]) for (t = 0; t < b[1]; ++t) u.push(t)
                  if (e[0] == g[0] && !f) for (t = +g[1] + 1; t <= 9; ++t) u.push(t)
                }
                if (2 == e.length && (a || n)) for (t = n ? +T[0] + 1 : 0; t < (a ? +x[0] : 10); ++t) u.push(t)
                if (3 == e.length && ((n && e[2] == T[0]) || (a && e[2] == x[0])))
                  for (t = n && e[2] == T[0] ? +T[1] + 1 : 0; t < (a && e[2] == x[0] ? +x[1] : 10); ++t) u.push(t)
                if (4 == e.length && (s || i)) for (t = i ? +C[0] + 1 : 0; t < (s ? +y[0] : 10); ++t) u.push(t)
                if (5 == e.length && ((s && e[4] == y[0]) || (i && e[4] == C[0])))
                  for (t = i && e[4] == C[0] ? +C[1] + 1 : 0; t < (s && e[4] == y[0] ? +y[1] : 10); ++t) u.push(t)
              }
              return u
            })(t),
            length: v,
            invalid:
              (f
                ? !new RegExp('^(0?[1-9]|1[012])(:[0-5]\\d)?(:[0-5][0-9]) (?:' + h.amText + '|' + h.pmText + ')$', 'i').test(a)
                : !/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(a)) ||
              (!!h.invalid && -1 != s._indexOf(h.invalid, n)) ||
              !((!h.min || h.min <= n) && (!h.max || n <= h.max)),
          }
        },
      }
    )
  }
  var Ci = { dateOrder: 'mdy', dateFormat: 'mm/dd/yy', delimiter: '/' }
  vi.date = function (n) {
    var p,
      f,
      v,
      e,
      i = [],
      t = va({}, n.settings),
      b = va(n.settings, ke, Ci, t),
      a = b.dateOrder,
      g = b.min ? '' + (b.getMonth(b.min) + 1) : 0,
      x = b.max ? '' + (b.getMonth(b.max) + 1) : 0,
      T = b.min ? '' + b.getDay(b.min) : 0,
      y = b.max ? '' + b.getDay(b.max) : 0,
      C = b.min ? '' + b.getYear(b.min) : 0,
      _ = b.max ? '' + b.getYear(b.max) : 0
    for (
      a = (a = (a = a.replace(/y+/gi, 'yyyy')).replace(/m+/gi, 'mm')).replace(/d+/gi, 'dd'),
        p = a.toUpperCase().indexOf('Y'),
        f = a.toUpperCase().indexOf('M'),
        v = a.toUpperCase().indexOf('D'),
        a = '',
        i.push({ val: p, n: 'yyyy' }, { val: f, n: 'mm' }, { val: v, n: 'dd' }),
        i.sort(function (e, t) {
          return e.val - t.val
        }),
        pa.each(i, function (e, t) {
          a += t.n
        }),
        p = a.indexOf('y'),
        f = a.indexOf('m'),
        v = a.indexOf('d'),
        a = '',
        e = 0;
      e < 8;
      ++e
    )
      ((a += 'd'), (e + 1 != p && e + 1 != f && e + 1 != v) || (a += b.delimiter))
    function s(e) {
      return new Date(+('' + e[p] + e[p + 1] + e[p + 2] + e[p + 3]), '' + e[f] + e[f + 1] - 1, +('' + e[v] + e[v + 1]))
    }
    return (
      (n.getVal = function (e) {
        return n._hasValue || e ? s(n.getArrayVal(e)) : null
      }),
      {
        placeholder: '-',
        fill: 'ltr',
        allowLeadingZero: !0,
        template: a,
        parseValue: function (e) {
          var t,
            a = [],
            n = e || b.defaultValue,
            s = Ce(b.dateFormat, n, b)
          if (n)
            for (t = 0; t < i.length; ++t)
              a = /m/i.test(i[t].n)
                ? a.concat(((b.getMonth(s) < 9 ? '0' : '') + (b.getMonth(s) + 1)).split(''))
                : /d/i.test(i[t].n)
                  ? a.concat(((b.getDay(s) < 10 ? '0' : '') + b.getDay(s)).split(''))
                  : a.concat((b.getYear(s) + '').split(''))
          return a
        },
        formatValue: function (e) {
          return ye(b.dateFormat, s(e), b)
        },
        validate: function (e) {
          var t = e.values,
            a = s(t)
          return {
            disabled: (function (e) {
              var t,
                a,
                n,
                s,
                i,
                r,
                o = [],
                l = void 0 !== e[p + 3] ? '' + e[p] + e[p + 1] + e[p + 2] + e[p + 3] : '',
                c = void 0 !== e[f + 1] ? '' + e[f] + e[f + 1] : '',
                d = void 0 !== e[v + 1] ? '' + e[v] + e[v + 1] : '',
                u = '' + b.getMaxDayOfMonth(l || 2012, c - 1 || 0),
                m = C === l && +g == +c,
                h = _ === l && +x == +c
              if (b.invalid)
                for (t = 0; t < b.invalid.length; ++t) {
                  if (
                    ((n = b.getYear(b.invalid[t])),
                    (s = b.getMonth(b.invalid[t])),
                    (i = b.getDay(b.invalid[t])),
                    n == +l && s + 1 == +c && (i < 10 ? 0 : +('' + i)[0]) == +e[v])
                  ) {
                    o.push(i < 10 ? i : +('' + i)[1])
                    break
                  }
                  if (s + 1 == +c && i == +d && ('' + n).substring(0, 3) == '' + e[p] + e[p + 1] + e[p + 2]) {
                    o.push(('' + n)[3])
                    break
                  }
                  if (n == +l && i == +d && (s < 10 ? 0 : +('' + (s + 1))[0]) == +e[f]) {
                    o.push(s < 10 ? s : +('' + (s + 1))[1])
                    break
                  }
                }
              if (
                ('31' != d || (e.length != f && e.length != f + 1) || (1 != e[f] ? o.push(2, 4, 6, 9, 11) : o.push(1)),
                '30' == d && 0 === e[f] && e.length <= f + 1 && o.push(2),
                e.length == f)
              ) {
                for (t = _ === l && +x < 10 ? 1 : 2; t <= 9; ++t) o.push(t)
                C === l && 10 <= +g && o.push(0)
              }
              if (e.length == f + 1) {
                if (1 == e[f]) {
                  for (t = _ === l ? +x[1] + 1 : 3; t <= 9; ++t) o.push(t)
                  if (C == l) for (t = 0; t < +g[1]; ++t) o.push(t)
                }
                if (0 === e[f] && (o.push(0), _ === l || C === l))
                  for (t = _ === l ? (+y < +d ? +x : +x + 1) : 0; t <= (C === l ? g - 1 : 9); ++t) o.push(t)
              }
              if (e.length == v) {
                for (t = h ? 1 + (10 < +y ? +y[0] : 0) : +u[0] + 1; t <= 9; ++t) o.push(t)
                if (m) for (t = 0; t < (+T < 10 ? 0 : T[0]); ++t) o.push(t)
              }
              if (e.length == v + 1) {
                if (3 <= e[v] || '02' == c) for (t = +u[1] + 1; t <= 9; ++t) o.push(t)
                if (h && +y[0] == e[v]) for (t = +y[1] + 1; t <= 9; ++t) o.push(t)
                if (m && T[0] == e[v]) for (t = 0; t < +T[1]; ++t) o.push(t)
                if (0 === e[v] && (o.push(0), h || m)) for (t = h ? +y + 1 : 1; t <= (m ? T - 1 : 9); ++t) o.push(t)
              }
              if (void 0 !== e[p + 2] && '02' == c && '29' == d)
                for (a = +('' + e[p] + e[p + 1] + e[p + 2] + 0); a <= +('' + e[p] + e[p + 1] + e[p + 2] + 9); ++a)
                  o.push(((r = a) % 4 == 0 && r % 100 != 0) || r % 400 == 0 ? '' : a % 10)
              if (e.length == p) {
                if (b.min) for (t = 0; t < +C[0]; ++t) o.push(t)
                if (b.max) for (t = +_[0] + 1; t <= 9; ++t) o.push(t)
                o.push(0)
              }
              if (b.min || b.max)
                for (a = 1; a < 4; ++a)
                  if (e.length == p + a) {
                    if (e[p + a - 1] == +C[a - 1] && (3 != a || e[p + a - 2] == +C[a - 2]))
                      for (t = 0; t < +C[a] + (3 == a && e[f + 1] && +c < +g ? 1 : 0); ++t) o.push(t)
                    if (e[p + a - 1] == +_[a - 1] && (3 != a || e[p + a - 2] == +_[a - 2]))
                      for (t = +_[a] + (3 == a && +x < +c ? 0 : 1); t <= 9; ++t) o.push(t)
                  }
              return o
            })(t),
            invalid:
              !('Invalid Date' != a && (!b.min || b.min <= a) && (!b.max || a <= b.max)) || (!!b.invalid && -1 != n._indexOf(b.invalid, a)),
          }
        },
      }
    )
  }
  var _i = e.bool,
    wi = e.string,
    Mi = e.func,
    Si = e.number,
    ki = e.shape({ text: wi.isRequired, variable: wi, value: wi }),
    Di = {
      allowLeadingZero: _i,
      deleteIcon: wi,
      fill: e.oneOf(['ltr', 'rtl']),
      leftKey: ki,
      mask: wi,
      placeholder: wi,
      preset: e.oneOf(['decimal', 'timespan', 'time', 'date']),
      rightKey: ki,
      template: wi,
      onSet: Mi,
      validate: Mi,
      onClear: Mi,
      onInput: Mi,
      cancelText: wi,
      clearText: wi,
      setText: wi,
      dateFormat: wi,
      dateOrder: wi,
      decimalSeparator: wi,
      defaultValue: e.oneOfType([Si, wi]),
      delimiter: wi,
      entryMode: e.oneOf(['template', 'freeform']),
      invalid: e.array,
      scale: Si,
      maxScale: Si,
      max: e.oneOfType([Si, e.instanceOf(Date)]),
      min: e.oneOfType([Si, e.instanceOf(Date)]),
      prefix: wi,
      returnAffix: _i,
      suffix: wi,
      thousandsSeparator: wi,
      timeFormat: wi,
      formatValue: Mi,
      parseValue: Mi,
    },
    Ni = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { component: 'Numpad' }), t)
      }
      return (l(e, a), e)
    })(xe)
  ;((Ni.propTypes = g({}, Ni.propTypes, {}, Di, {}, le)), (Z.Numpad = Ni))
  var Ei = { autoCorrect: !0, showSelector: !0, minRange: 1, rangeTap: !0 }
  vt.range = function (l) {
    function a(e, t) {
      e && (e.setFullYear(t.getFullYear()), e.setMonth(t.getMonth()), e.setDate(t.getDate()))
    }
    function n(e, t) {
      var a = l._order,
        n = new Date(e)
      return (
        void 0 === a.h && n.setHours(t ? 23 : 0),
        void 0 === a.i && n.setMinutes(t ? 59 : 0),
        void 0 === a.s && n.setSeconds(t ? 59 : 0),
        n.setMilliseconds(t ? 999 : 0),
        n
      )
    }
    function t(e, t) {
      return new Date(e.getFullYear(), e.getMonth(), e.getDate() + t)
    }
    function s(e) {
      f
        ? (C - T > E.maxRange - 1 &&
            (e ? (T = new Date(Math.max(g, C - E.maxRange + 1))) : (C = new Date(Math.min(b, +T + E.maxRange - 1)))),
          C - T < E.minRange - 1 &&
            (e ? (T = new Date(Math.max(g, C - E.minRange + 1))) : (C = new Date(Math.min(b, +T + E.minRange - 1)))))
        : (Math.ceil((C - T) / F) > I && (e ? (T = n(Math.max(g, t(C, 1 - I)), !1)) : (C = n(Math.min(b, t(T, I - 1)), !0))),
          Math.ceil((C - T) / F) < A && (e ? (T = n(Math.max(g, t(C, 1 - A)), !1)) : (C = n(Math.min(b, t(T, A - 1)), !0))))
    }
    function i(e, t) {
      var a = !0
      return (e && T && C && (s(D), s(!D)), (T && C) || (a = !1), t && o(), a)
    }
    function r() {
      M &&
        m &&
        (pa('.mbsc-range-btn', m).removeClass(H).removeAttr('aria-checked'),
        (function (e) {
          e.addClass(H).attr('aria-checked', 'true')
        })(pa('.mbsc-range-btn', m).eq(D)))
    }
    function o() {
      var e,
        t,
        a,
        n,
        s,
        i = 0,
        r = V || !D ? ' mbsc-cal-day-hl mbsc-cal-sel-start' : ' mbsc-cal-sel-start',
        o = V || D ? ' mbsc-cal-day-hl mbsc-cal-sel-end' : ' mbsc-cal-sel-end'
      if (
        ((l.startVal = T ? ye(p, T, E) : ''),
        (l.endVal = C ? ye(p, C, E) : ''),
        m &&
          (pa('.mbsc-range-btn-v-start', m).html(l.startVal || '&nbsp;'),
          pa('.mbsc-range-btn-v-end', m).html(l.endVal || '&nbsp;'),
          (e = T ? new Date(T) : null),
          (a = C ? new Date(C) : null),
          !e && a && (e = new Date(a)),
          !a && e && (a = new Date(e)),
          (s = D ? a : e),
          pa('.mbsc-cal-day-picker .mbsc-cal-day-hl', m).removeClass(L),
          pa('.mbsc-cal-day-picker .mbsc-selected', m)
            .removeClass('mbsc-cal-sel-start mbsc-cal-sel-end ' + H)
            .removeAttr('aria-selected'),
          e && a))
      )
        for (t = e.setHours(0, 0, 0, 0), n = a.setHours(0, 0, 0, 0); e <= a && i < 126; )
          (pa('.mbsc-cal-day[data-full="' + s.getFullYear() + '-' + (s.getMonth() + 1) + '-' + s.getDate() + '"]', m)
            .addClass(H + ' ' + (s.getTime() === t ? r : '') + (s.getTime() === n ? o : ''))
            .attr('aria-selected', 'true'),
            s.setDate(s.getDate() + (D ? -1 : 1)),
            s.setHours(0, 0, 0, 0),
            i++)
    }
    function c(e, t) {
      return { h: e ? e.getHours() : t ? 23 : 0, i: e ? e.getMinutes() : t ? 59 : 0, s: e ? e.getSeconds() : t ? 59 : 0 }
    }
    function d() {
      ;(T && ((v = !0), l.setDate(T, !1, 0, !0), (T = l.getDate(!0))), C && ((v = !0), l.setDate(C, !1, 0, !0), (C = l.getDate(!0))))
    }
    var u,
      m,
      h,
      p,
      f,
      v,
      b,
      g,
      x,
      T,
      y,
      C,
      _,
      w,
      M,
      S = l._startDate,
      k = l._endDate,
      D = 0,
      e = new Date(),
      N = va({}, l.settings),
      E = va(l.settings, Ei, N),
      O = E.anchor,
      V = E.rangeTap,
      F = 864e5,
      A = Math.max(1, Math.ceil(E.minRange / F)),
      I = Math.max(1, Math.ceil(E.maxRange / F)),
      P = 'mbsc-disabled ' + (E.disabledClass || ''),
      H = 'mbsc-selected ' + (E.selectedClass || ''),
      L = 'mbsc-cal-day-hl',
      z =
        null === E.defaultValue
          ? []
          : E.defaultValue || [new Date(e.setHours(0, 0, 0, 0)), new Date(e.getFullYear(), e.getMonth(), e.getDate() + 6, 23, 59, 59, 999)]
    return (
      V && (E.tabs = !0),
      (u = Ct.call(this, l)),
      (p = l._format),
      (f = /time/i.test(E.controls.join(','))),
      (w = 'time' === E.controls.join('')),
      (M = E.showSelector),
      (b = E.max ? n(st(E.max, p, E), !0) : 1 / 0),
      (g = E.min ? n(st(E.min, p, E), !1) : -1 / 0),
      (z[0] = st(z[0], p, E, E.isoParts)),
      (z[1] = st(z[1], p, E, E.isoParts)),
      E.startInput &&
        l.attachShow(pa(E.startInput), function () {
          ;((D = 0), (E.anchor = O || pa(E.startInput)))
        }),
      E.endInput &&
        l.attachShow(pa(E.endInput), function () {
          ;((D = 1), (E.anchor = O || pa(E.endInput)))
        }),
      (l._getDayProps = function (e, t) {
        var a = T ? new Date(T.getFullYear(), T.getMonth(), T.getDate()) : null,
          n = C ? new Date(C.getFullYear(), C.getMonth(), C.getDate()) : null
        return {
          selected: a && n && a <= e && e <= C,
          cssClass:
            t.cssClass +
            ' ' +
            (((V || !D) && a && a.getTime() === e.getTime()) || ((V || D) && n && n.getTime() === e.getTime()) ? L : '') +
            (a && a.getTime() === e.getTime() ? ' mbsc-cal-sel-start' : '') +
            (n && n.getTime() === e.getTime() ? ' mbsc-cal-sel-end' : ''),
        }
      }),
      (l.setVal = function (e, t, a, n, s) {
        var i,
          r = e || []
        ;((T = st(r[0], p, E, E.isoParts)),
          (C = st(r[1], p, E, E.isoParts)),
          d(),
          (l.startVal = T ? ye(p, T, E) : ''),
          (l.endVal = C ? ye(p, C, E) : ''),
          (i = u.parseValue(D ? C : T, l)),
          n || ((l._startDate = S = T), (l._endDate = k = C)),
          (x = !0),
          l._setVal(i, t, a, n, s))
      }),
      (l.getVal = function (e) {
        return e ? [we(T, E, p), we(C, E, p)] : l._hasValue ? [we(S, E, p), we(k, E, p)] : null
      }),
      (l.setActiveDate = function (e) {
        var t
        ;((D = 'start' == e ? 0 : 1),
          (t = 'start' == e ? T : C),
          l.isVisible() &&
            (r(),
            V ||
              (pa('.mbsc-cal-table .mbsc-cal-day-hl', m).removeClass(L),
              t && pa('.mbsc-cal-day[data-full="' + t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate() + '"]', m).addClass(L)),
            t && ((v = !0), l.setDate(t, !1, 1e3, !0))))
      }),
      (l.getValue = l.getVal),
      va({}, u, {
        highlight: !1,
        outerMonthChange: !1,
        formatValue: function () {
          return l.startVal + (E.endInput ? '' : l.endVal ? ' - ' + l.endVal : '')
        },
        parseValue: function (e) {
          var t = e ? e.split(' - ') : [],
            a = E.startInput ? pa(E.startInput).val() : t[0],
            n = E.endInput ? pa(E.endInput).val() : t[1]
          return (
            (E.defaultValue = z[1]),
            (k = n ? Ce(p, n, E) : z[1]),
            (E.defaultValue = z[0]),
            (S = a ? Ce(p, a, E) : z[2]),
            (E.defaultValue = z[D]),
            (l.startVal = S ? ye(p, S, E) : ''),
            (l.endVal = k ? ye(p, k, E) : ''),
            (l._startDate = S),
            (l._endDate = k),
            u.parseValue(D ? k : S, l)
          )
        },
        onFill: function (e) {
          !(function (e) {
            ;((l._startDate = S = T),
              (l._endDate = k = C),
              E.startInput && (pa(E.startInput).val(l.startVal), e && pa(E.startInput).trigger('change')),
              E.endInput && (pa(E.endInput).val(l.endVal), e && pa(E.endInput).trigger('change')))
          })(e.change)
        },
        onBeforeClose: function (e) {
          if ('set' === e.button && !i(!0, !0)) return (l.setActiveDate(D ? 'start' : 'end'), !1)
        },
        onHide: function () {
          ;(u.onHide.call(l), (D = 0), (m = null), (E.anchor = O))
        },
        onClear: function () {
          V && (D = 0)
        },
        onBeforeShow: function () {
          ;((T = S || z[0]),
            (C = k || z[1]),
            (y = c(T, 0)),
            (_ = c(C, 1)),
            E.counter &&
              (E.headerText = function () {
                var e =
                  T && C ? Math.max(1, Math.round((new Date(C).setHours(0, 0, 0, 0) - new Date(T).setHours(0, 0, 0, 0)) / 864e5) + 1) : 0
                return ((1 < e && E.selectedPluralText) || E.selectedText).replace(/{count}/, e)
              }),
            (x = !0))
        },
        onMarkupReady: function (e) {
          var t
          ;(d(),
            ((D && C) || (!D && T)) && ((v = !0), l.setDate(D ? C : T, !1, 0, !0)),
            o(),
            u.onMarkupReady.call(this, e),
            (m = pa(e.target)).addClass('mbsc-range'),
            M &&
              ((t =
                '<div class="mbsc-range-btn-t" role="radiogroup"><div class="mbsc-range-btn-c mbsc-range-btn-start"><div role="radio" data-select="start" class="mbsc-fr-btn-e mbsc-fr-btn-nhl mbsc-range-btn">' +
                E.fromText +
                '<div class="mbsc-range-btn-v mbsc-range-btn-v-start">' +
                (l.startVal || '&nbsp;') +
                '</div></div></div><div class="mbsc-range-btn-c mbsc-range-btn-end"><div role="radio" data-select="end" class="mbsc-fr-btn-e mbsc-fr-btn-nhl mbsc-range-btn">' +
                E.toText +
                '<div class="mbsc-range-btn-v mbsc-range-btn-v-end">' +
                (l.endVal || '&nbsp;') +
                '</div></div></div></div>'),
              E.headerText ? pa('.mbsc-fr-hdr', m).after(t) : pa('.mbsc-fr-w', m).prepend(t),
              r()),
            pa('.mbsc-range-btn', m).on('touchstart click', function (e) {
              ga(e, this) && (l._showDayPicker(), l.setActiveDate(pa(this).attr('data-select')))
            }))
        },
        onDayChange: function (e) {
          ;((e.active = D ? 'end' : 'start'), (h = !0))
        },
        onSetDate: function (e) {
          var t
          ;(v ||
            ((t = n(e.date, D)),
            (x && !h) ||
              (V && h && (1 == D && t < T && (D = 0), D ? t.setHours(_.h, _.i, _.s, 999) : t.setHours(y.h, y.i, y.s, 0)),
              D ? ((C = new Date(t)), (_ = c(C))) : ((T = new Date(t)), (y = c(T))),
              w && E.autoCorrect && (a(T, t), a(C, t)),
              V && h && !D && (C = null))),
            w && !E.autoCorrect && C < T && (C = new Date(C.setDate(C.getDate() + 1))),
            (l._isValid = i(x || h || E.autoCorrect, !v)),
            (e.active = D ? 'end' : 'start'),
            !v && V && (h && (D = D ? 0 : 1), r()),
            l.isVisible() &&
              (l._isValid
                ? pa('.mbsc-fr-btn-s .mbsc-fr-btn', l._markup).removeClass(P)
                : pa('.mbsc-fr-btn-s .mbsc-fr-btn', l._markup).addClass(P)),
            (v = x = h = !1))
        },
        onTabChange: function (e) {
          ;('calendar' != e.tab && l.setDate(D ? C : T, !1, 1e3, !0), i(!0, !0))
        },
      })
    )
  }
  var Oi = e.string,
    Vi = e.bool,
    Fi = e.number,
    Ai = e.func,
    Ii = e.object,
    Pi = {
      autoCorrect: Vi,
      controls: e.arrayOf(e.oneOf(['time', 'date', 'calendar'])),
      endInput: e.oneOfType([Oi, Ii]),
      maxRange: Fi,
      minRange: Fi,
      showSelector: Vi,
      startInput: e.oneOfType([Oi, Ii]),
      fromText: Oi,
      toText: Oi,
      onSetDate: Ai,
    },
    Hi = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      l(e, t)
      var a = e.prototype
      return (
        (a.componentDidMount = function () {
          function e(e) {
            var t = pa(i.findDOMNode(e))
            return t.is('input') ? t : t.find('input')
          }
          var t = i.findDOMNode(this),
            a = pa(t).find('input'),
            n = {}
          this.refs.start || this.refs.end
            ? (this.refs.start && (n.startInput = e(this.refs.start)), this.refs.end && (n.endInput = e(this.refs.end)), (n.skipShow = !0))
            : 2 == a.length
              ? ((n.startInput = a[0]), (n.endInput = a[1]), (n.skipShow = !0))
              : a.length && (t = a[0])
          var s = va({ preset: 'range' }, n, this.getSettingsFromProps(this.props))
          ;((this.instance = new W.Scroller(t, s)),
            void 0 !== this.props.value && (this.instance.setVal(this.props.value, !0), this.updateForIonInput()))
        }),
        (a.render = function () {
          var a = this,
            e = this.props,
            t = e.readOnly,
            n = e.disabled,
            s = e.placeholder,
            i = e.type,
            r = e.children
          if (((i = i || 'text'), this.isIonInput(r))) {
            this.valueState = !0
            var o = this.instance ? this.instance._value : ''
            return b.cloneElement(r, g({ value: o }, r.props))
          }
          return 1 === b.Children.count(r)
            ? this.props.children
            : 0 < b.Children.count(r)
              ? b.createElement(
                  'div',
                  null,
                  b.Children.map(r, function (e) {
                    var t = {}
                    return (
                      (e.type !== Li && e.type !== zi) || ((t.wrapper = a), (t.ref = e.type === Li ? 'start' : 'end')),
                      b.cloneElement(e, t)
                    )
                  }),
                )
              : b.createElement('input', { className: this.initialCssClass, type: i, readOnly: t, disabled: n, placeholder: s })
        }),
        e
      )
    })(ge)
  ;((Hi.propTypes = g({}, Hi.propTypes, {}, ce, {}, de, {}, he, {}, Pi)), (Z.Range = Hi))
  var Li = (function (a) {
    function e(e) {
      var t
      return (r(c((t = a.call(this, e) || this)), 'rangeIndex', 0), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidUpdate = function () {
        if (this.props.value) {
          var e = this.props.wrapper.instance.getVal() || [null, null]
          fe(this.props.value, e[this.rangeIndex]) || ((e[this.rangeIndex] = this.props.value), this.props.wrapper.instance.setVal(e, !0))
        }
      }),
      (t.render = function () {
        var e = this.props,
          t = (e.value, e.wrapper, x(e, ['value', 'wrapper']))
        return 1 === b.Children.count(this.props.children)
          ? this.props.children
          : this.props.children
            ? b.createElement('div', null, this.props.children)
            : b.createElement('input', t)
      }),
      e
    )
  })(b.Component)
  Li.propTypes = { value: e.oneOfType([e.string, e.object]) }
  var zi = (function (a) {
    function e(e) {
      var t
      return (r(c((t = a.call(this, e) || this)), 'rangeIndex', 1), t)
    }
    return (l(e, a), e)
  })((Z.RangeStart = Li))
  ;((zi.propTypes = g({}, Li.propTypes)), (Z.RangeEnd = zi))
  var Ui = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).mbscInit = { component: 'Scroller' }), t)
    }
    return (l(e, a), e)
  })(xe)
  ;((Ui.propTypes = g({}, Ui.propTypes, {}, ce)), (Z.Scroller = Ui))
  var Yi = (function (a) {
    function e(e) {
      var t
      return (((t = a.call(this, e) || this).elm = t.elm.bind(c(t))), t)
    }
    l(e, a)
    var t = e.prototype
    return (
      (t.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new Bs(this.domNode, e)
      }),
      (t.componentDidUpdate = function () {
        ;(a.prototype.componentDidUpdate.call(this), this.optimizeUpdate.updateChildren && this.instance.refresh())
      }),
      (t.elm = function (e) {
        this.domNode = e
      }),
      (t.render = function () {
        return b.createElement(
          'div',
          null,
          b.createElement('div', { ref: this.elm, className: this.initialCssClass + ' mbsc-cloak' }, this.props.children),
        )
      }),
      e
    )
  })(Xs)
  Z.ScrollView = Yi
  var Ri = {
    inputClass: '',
    rtl: !1,
    showInput: !0,
    groupLabel: 'Groups',
    dataHtml: 'html',
    dataText: 'text',
    dataValue: 'value',
    dataGroup: 'group',
    dataDisabled: 'disabled',
    filterPlaceholderText: 'Type to filter',
    filterEmptyText: 'No results',
    filterClearIcon: 'material-close',
  }
  vt.select = function (o, e) {
    var l,
      h,
      c,
      d,
      a,
      p,
      n,
      f,
      u,
      m,
      s,
      v,
      i,
      b,
      r,
      t = '',
      g = {},
      x = 1e3,
      T = this,
      y = pa(T),
      C = va({}, o.settings),
      _ = va(o.settings, Ri, C),
      w = pa('<div class="mbsc-sel-empty">' + _.filterEmptyText + '</div>'),
      M = _.readonly,
      S = {},
      k = _.layout || (/top|bottom|inline/.test(_.display) || _.filter ? 'liquid' : ''),
      D = 'liquid' == k || !_.touchUi,
      N = oa(_.select) ? _.select : 'multiple' == _.select || y.prop('multiple'),
      E = N || (!(!_.filter && !_.tapSelect) && 1),
      O = this.id + '_dummy',
      V = pa('label[for="' + this.id + '"]').attr('for', O),
      F = void 0 !== _.label ? _.label : V.length ? V.text() : y.attr('name'),
      A = _.group,
      I = !!_.data,
      P = I ? !!_.group : pa('optgroup', y).length,
      H = P && A && !1 !== A.groupWheel,
      L = P && A && H && !0 === A.clustered,
      z = P && (!A || (!1 !== A.header && !L)),
      U = y.val() || (N ? [] : ['']),
      Y = []
    function R(a) {
      var n,
        s,
        i,
        r,
        o,
        l,
        c = 0,
        d = 0,
        u = {}
      if (((S = {}), (f = {}), (v = []), (p = []), (Y.length = 0), I))
        pa.each(h, function (e, t) {
          ;((o = t[_.dataText] + ''),
            (s = t[_.dataHtml]),
            (l = t[_.dataValue]),
            (i = t[_.dataGroup]),
            (r = { value: l, html: s, text: o, index: e, cssClass: z ? 'mbsc-sel-gr-itm' : '' }),
            (S[l] = r),
            (a && !G(o, a)) ||
              (v.push(r),
              P &&
                (void 0 === u[i]
                  ? ((n = { text: i, value: d, options: [], index: d }), (f[d] = n), (u[i] = d), p.push(n), d++)
                  : (n = f[u[i]]),
                L && (r.index = n.options.length),
                (r.group = u[i]),
                n.options.push(r)),
              t[_.dataDisabled] && Y.push(l)))
        })
      else if (P) {
        var m = !0
        pa('optgroup', y).each(function (t) {
          ;((f[t] = { text: this.label, value: t, options: [], index: t }),
            (m = !0),
            pa('option', this).each(function (e) {
              ;((r = { value: this.value, text: this.text, index: L ? e : c++, group: t, cssClass: z ? 'mbsc-sel-gr-itm' : '' }),
                (S[this.value] = r),
                (a && !G(this.text, a)) ||
                  (m && (p.push(f[t]), (m = !1)), v.push(r), f[t].options.push(r), this.disabled && Y.push(this.value)))
            }))
        })
      } else
        pa('option', y).each(function (e) {
          ;((r = { value: this.value, text: this.text, index: e }),
            (S[this.value] = r),
            (a && !G(this.text, a)) || (v.push(r), this.disabled && Y.push(this.value)))
        })
      ;((t = _.defaultValue ? _.defaultValue : v.length ? v[0].value : ''),
        z &&
          ((v = []),
          (c = 0),
          pa.each(f, function (e, t) {
            t.options.length &&
              ((l = '__group' + e),
              (r = { text: t.text, value: l, group: e, index: c++, cssClass: 'mbsc-sel-gr' }),
              (S[l] = r),
              v.push(r),
              Y.push(r.value),
              pa.each(t.options, function (e, t) {
                ;((t.index = c++), v.push(t))
              }))
          })),
        w && (v.length ? w.removeClass('mbsc-sel-empty-v') : w.addClass('mbsc-sel-empty-v')))
    }
    function $(e, t, a, n, s) {
      var i,
        r = []
      for (i = 0; i < e.length; i++) r.push({ value: e[i].value, display: e[i].html || e[i].text, cssClass: e[i].cssClass })
      return { circular: !1, multiple: t && !n ? 1 : n, cssClass: (t && !n ? 'mbsc-sel-one' : '') + ' ' + s, data: r, label: a }
    }
    function j() {
      return $(L && f[a] ? f[a].options : v, E, F, N, '')
    }
    function W() {
      var e = [[]]
      return (
        H && ((n = $(p, E, _.groupLabel, !1, 'mbsc-sel-gr-whl')), D ? (e[0][u] = n) : (e[u] = [n])),
        (i = j()),
        D ? (e[0][b] = i) : (e[b] = [i]),
        e
      )
    }
    function B(e) {
      ;(N && (e && ue(e) && (e = e.split(',')), pa.isArray(e) && (e = e[0])),
        !S[(s = null == e || '' === e ? t : e)] && v && v.length && (s = v[0].value),
        H && (a = S[s] ? S[s].group : null))
    }
    function J(e) {
      return g[e] || (S[e] ? S[e].text : '')
    }
    function q() {
      var e,
        t = '',
        a = o.getVal(),
        n = _.formatValue.call(T, o.getArrayVal(), o, !0)
      if (((_.filter && 'inline' == _.display) || l.val(n), y.is('select') && I)) {
        if (N) for (e = 0; e < a.length; e++) t += '<option value="' + a[e] + '">' + J(a[e]) + '</option>'
        else t = '<option value="' + (null === a ? '' : a) + '">' + n + '</option>'
        y.html(t)
      }
      T !== l[0] && y.val(a)
    }
    function K() {
      var e = {}
      ;((e[b] = j()), (r = !0), o.changeWheel(e))
    }
    function G(e, t) {
      return ((t = t.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')), e.match(new RegExp(t, 'ig')))
    }
    function X(e) {
      return _.data.dataField ? e[_.data.dataField] : _.data.processResponse ? _.data.processResponse(e) : e
    }
    function Z(e) {
      var t = {}
      ;(R(e),
        B(s),
        (_.wheels = W()),
        (t[b] = i),
        (o._tempWheelArray[b] = s),
        H && ((t[u] = n), (o._tempWheelArray[u] = a)),
        o.changeWheel(t, 0, !0),
        q())
    }
    function Q(e) {
      return o.trigger('onFilter', { filterText: e })
    }
    function ee(e) {
      e[u] != a && ((a = e[u]), (s = f[a].options[0].value), (e[b] = s), L ? K() : o.setArrayVal(e, !1, !1, !0, x))
    }
    return (
      (o.setVal = function (e, t, a, n, s) {
        if (
          E &&
          (null == e || N || (e = [e]),
          e && ue(e) && (e = e.split(',')),
          (o._tempSelected[b] = ae(e)),
          n || (o._selected[b] = ae(e)),
          (e = e ? e[0] : null),
          H)
        ) {
          var i = S[e],
            r = i && i.group
          ;((o._tempSelected[u] = ae([r])), n || (o._selected[u] = ae([r])))
        }
        o._setVal(e, t, a, n, s)
      }),
      (o.getVal = function (e, t) {
        var a
        return (
          (a = E
            ? ((a = te(e ? o._tempSelected[b] : o._selected[b])), N ? a : a.length ? a[0] : null)
            : (a = e ? o._tempWheelArray : o._hasValue ? o._wheelArray : null)
              ? a[b]
              : null),
          N ? a : void 0 !== a ? (P && t ? [S[a] ? S[a].group : null, a] : a) : null
        )
      }),
      (o.refresh = function (e, t, a) {
        ;((a = a || ra),
          e ? ((h = e), m || (_.data = e)) : pa.isArray(_.data) && (h = _.data),
          !e && m && void 0 === t
            ? an(
                _.data.url,
                function (e) {
                  ;((h = X(e)), Z(), a())
                },
                _.data.dataType,
              )
            : (Z(t), a()))
      }),
      e.invalid || (_.invalid = Y),
      (b = H ? ((u = 0), 1) : ((u = -1), 0)),
      E && (N && y.prop('multiple', !0), U && ue(U) && (U = U.split(',')), (o._selected[b] = ae(U))),
      o._$input && o._$input.remove(),
      y.next().is('.mbsc-select-input')
        ? (l = y.next().removeAttr('tabindex'))
        : _.input
          ? (l = pa(_.input))
          : (_.filter && 'inline' == _.display
              ? (o._$input = pa(
                  '<div class="mbsc-sel-input-wrap"><input type="text" id="' +
                    O +
                    '" class="mbsc-select-input mbsc-control ' +
                    _.inputClass +
                    '" readonly /></div>',
                ))
              : ((l = pa('<input type="text" id="' + O + '" class="mbsc-select-input mbsc-control ' + _.inputClass + '" readonly />')),
                (o._$input = l)),
            _.showInput && (o._$input.insertAfter(y), (l = l || o._$input.find('#' + O)))),
      o.attachShow(l.attr('placeholder', _.placeholder || '')),
      l[0] !== T && (y.addClass('mbsc-sel-hdn').attr('tabindex', -1), _.showInput || y.attr('data-enhance', !1)),
      !E || _.rows % 2 || (_.rows = _.rows - 1),
      _.filter && (c = _.filter.minLength || 0),
      (m = _.data && _.data.url) ? o.refresh() : (I && (h = _.data), R(), B(y.val())),
      {
        layout: k,
        headerText: !1,
        anchor: l,
        compClass: 'mbsc-sc mbsc-sel' + (E ? ' mbsc-sel-multi' : ''),
        setOnTap: !H || [!1, !0],
        formatValue: function (e, t, a) {
          var n,
            s = [],
            i = a ? t._selected : t._tempSelected
          if (E) {
            for (n in i[b]) s.push(J(n))
            return s.join(', ')
          }
          return J(e[b])
        },
        tapSelect: E,
        parseValue: function (e) {
          return (B(void 0 === e ? y.val() : e), H ? [a, s] : [s])
        },
        validate: function (e) {
          var t = e.index,
            a = []
          return ((a[b] = _.invalid), L && !r && void 0 === t && K(), (r = !1), { disabled: a })
        },
        onRead: q,
        onFill: q,
        onMarkupReady: function (e, t) {
          if (_.filter) {
            var a,
              n,
              s,
              i = pa('.mbsc-fr-w', e.target),
              r = pa('<span class="mbsc-sel-filter-clear mbsc-ic mbsc-ic-' + _.filterClearIcon + '"></span>')
            ;('inline' == _.display
              ? (a = l).parent().find('.mbsc-sel-filter-clear').remove()
              : (i
                  .find('.mbsc-fr-c')
                  .before(
                    '<div class="mbsc-input mbsc-sel-filter-cont mbsc-control-w mbsc-' +
                      _.theme +
                      (_.baseTheme ? ' mbsc-' + _.baseTheme : '') +
                      '"><span class="mbsc-input-wrap"><input tabindex="0" type="text" class="mbsc-sel-filter-input mbsc-control"/></span></div>',
                  ),
                (a = i.find('.mbsc-sel-filter-input'))),
              (d = null),
              (s = a[0]),
              a.prop('readonly', !1).attr('placeholder', _.filterPlaceholderText).parent().append(r),
              i.find('.mbsc-fr-c').prepend(w),
              (t._activeElm = s),
              t.tap(r, function () {
                ;((d = null), (s.value = ''), t.refresh(), r.removeClass('mbsc-sel-filter-show-clear'), Q(''))
              }),
              a
                .on('keydown', function (e) {
                  ;(13 != e.keyCode && 27 != e.keyCode) || (e.stopPropagation(), s.blur())
                })
                .on('input', function () {
                  ;(clearTimeout(n),
                    s.value.length ? r.addClass('mbsc-sel-filter-show-clear') : r.removeClass('mbsc-sel-filter-show-clear'),
                    (n = setTimeout(function () {
                      d !== s.value &&
                        !1 !== Q(s.value) &&
                        ((d = s.value).length >= c || !d.length) &&
                        (m && _.data.remoteFilter
                          ? an(
                              _.data.url + encodeURIComponent(d),
                              function (e) {
                                t.refresh(X(e))
                              },
                              _.data.dataType,
                            )
                          : t.refresh(void 0, d))
                    }, 500)))
                }))
          }
        },
        onBeforeShow: function () {
          ;(N &&
            _.counter &&
            (_.headerText = function () {
              var e = 0
              return (
                pa.each(o._tempSelected[b], function () {
                  e++
                }),
                ((1 < e && _.selectedPluralText) || _.selectedText).replace(/{count}/, e)
              )
            }),
            B(y.val()),
            E && H && (o._selected[u] = ae([a])),
            _.filter && R(void 0),
            (o.settings.wheels = W()),
            (r = !0))
        },
        onWheelGestureStart: function (e) {
          e.index == u && (_.readonly = [!1, !0])
        },
        onWheelAnimationEnd: function (e) {
          var t = o.getArrayVal(!0)
          e.index == u
            ? ((_.readonly = M), E || ee(t))
            : e.index == b &&
              t[b] != s &&
              ((s = t[b]),
              H &&
                S[s] &&
                S[s].group != a &&
                ((a = S[s].group), (t[u] = a), (o._tempSelected[u] = ae([a])), o.setArrayVal(t, !1, !1, !0, x)))
        },
        onItemTap: function (e) {
          var t
          if (e.index == b && ((g[e.value] = S[e.value].text), E && !N && e.selected)) return !1
          if (e.index == u && E) {
            if (e.selected) return !1
            ;(((t = o.getArrayVal(!0))[u] = e.value), ee(t))
          }
        },
        onClose: function () {
          m && _.data.remoteFilter && d && o.refresh()
        },
        onDestroy: function () {
          ;(o._$input && o._$input.remove(), y.removeClass('mbsc-sel-hdn').removeAttr('tabindex'))
        },
      }
    )
  }
  var $i = e.bool,
    ji = e.string,
    Wi = e.array,
    Bi = e.number,
    Ji = (function (t) {
      function e(e) {
        return t.call(this, e) || this
      }
      l(e, t)
      var a = e.prototype
      return (
        (a.componentDidMount = function () {
          var e,
            t = i.findDOMNode(this)
          ;(e = Z.$(t).find('input')).length && (t = e)
          var a = this.getSettingsFromProps(this.props, {
            preset: 'select',
            data: null === this.props.data ? [] : this.props.data,
            input: this.isIonInput(this.props.children) ? t : void 0,
          })
          ;((this.instance = new Tt(t, a)),
            void 0 !== this.props.value && (this.instance.setVal(this.props.value, !0), this.updateForIonInput()))
        }),
        (a.componentDidUpdate = function () {
          if (this.optimizeUpdate) {
            var e = this.optimizeUpdate,
              t = e.updateChildren,
              a = e.updateData,
              n = e.updateOptions,
              s = e.updateValue,
              i = this.props.data
            if (n && (a || t)) {
              var r = this.getSettingsFromProps(this.props, a ? { data: i } : {})
              this.instance.option(r)
            } else
              a || (t && !i)
                ? this.instance.refresh(i && i.url ? void 0 : i)
                : n && this.instance.option(this.getSettingsFromProps(this.props))
            s && (this.instance.setVal(this.props.value, !0), this.updateForIonInput())
          }
        }),
        (a.shouldComponentUpdate = function (e) {
          var t = this.getSettingsFromProps(this.props),
            a = !fe(this.getSettingsFromProps(e), t),
            n = !fe(e.data, this.props.data),
            s = !fe(e.children, this.props.children),
            i = !fe(e.value, this.props.value) && void 0 !== e.value && !fe(e.value, this.instance.getVal())
          return ((this.optimizeUpdate = { updateOptions: a, updateData: n, updateValue: i, updateChildren: s }), a || n || i || s)
        }),
        (a.isSelectOrInput = function (e) {
          return 1 == b.Children.count(e) && ('select' == e.type || 'input' == e.type)
        }),
        (a.render = function () {
          var e = this.props,
            t = e.readOnly,
            a = e.disabled,
            n = e.data,
            s = e.value,
            i = e.children,
            r = s
          if (this.isIonInput(i)) {
            this.valueState = !0
            var o = this.instance ? this.instance._value : ''
            return b.cloneElement(i, g({ value: o }, i.props))
          }
          return this.isSelectOrInput(i)
            ? i
            : void 0 !== n
              ? 0 < b.Children.count(i)
                ? i
                : b.createElement('input', { defaultValue: r, type: 'text', className: this.initialCssClass, readOnly: t, disabled: a })
              : b.createElement(
                  'select',
                  { className: this.initialCssClass + ' mbsc-cloak', readOnly: t, disabled: a },
                  this.props.children,
                )
        }),
        e
      )
    })(be)
  ;((Ji.propTypes = g({}, Ji.propTypes, {}, oe, {}, le, {}, ce, {
    counter: $i,
    data: e.oneOfType([
      Wi,
      e.shape({ url: ji, dataField: ji, dataType: e.oneOf(['json', 'jsonp']), processResponse: e.func, remoteFilter: $i }),
    ]),
    dataText: ji,
    dataGroup: ji,
    dataValue: ji,
    group: e.oneOfType([$i, e.shape({ groupedWheel: $i, header: $i, clustered: $i })]),
    filter: $i,
    filterPlaceholderText: ji,
    filterEmptyText: ji,
    groupLabel: ji,
    input: e.oneOfType([ji, e.object]),
    inputClass: ji,
    invalid: Wi,
    label: ji,
    placeholder: ji,
    select: e.oneOfType([Bi, e.oneOf(['single', 'multiple'])]),
    showInput: $i,
    onFilter: e.func,
  })),
    (Z.Select = Ji))
  var qi = {
    autostart: !1,
    step: 1,
    useShortLabels: !1,
    labels: ['Years', 'Months', 'Days', 'Hours', 'Minutes', 'Seconds', ''],
    labelsShort: ['Yrs', 'Mths', 'Days', 'Hrs', 'Mins', 'Secs', ''],
    startText: 'Start',
    stopText: 'Stop',
    resetText: 'Reset',
    lapText: 'Lap',
    hideText: 'Hide',
    mode: 'countdown',
  }
  vt.timer = function (a) {
    function c(e) {
      return new Date(
        e.getUTCFullYear(),
        e.getUTCMonth(),
        e.getUTCDate(),
        e.getUTCHours(),
        e.getUTCMinutes(),
        e.getUTCSeconds(),
        e.getUTCMilliseconds(),
      )
    }
    function o(e, t, a) {
      return (t || '') + (e < 10 ? '0' : '') + e + '<span class="mbsc-timer-lbl">' + a + '</span>'
    }
    function n(e) {
      var a,
        n = [],
        s = (function (a) {
          var n = {}
          if (F && C[E].index > C.days.index) {
            var e,
              t,
              s,
              i,
              r = new Date(),
              o = p ? r : V,
              l = p ? V : r
            for (
              l = c(l),
                o = c(o),
                n.years = o.getFullYear() - l.getFullYear(),
                n.months = o.getMonth() - l.getMonth(),
                n.days = o.getDate() - l.getDate(),
                n.hours = o.getHours() - l.getHours(),
                n.minutes = o.getMinutes() - l.getMinutes(),
                n.seconds = o.getSeconds() - l.getSeconds(),
                n.fract = (o.getMilliseconds() - l.getMilliseconds()) / 10,
                e = y.length;
              0 < e;
              e--
            )
              ((t = y[e - 1]),
                (s = C[t]),
                (i = y[pa.inArray(t, y) - 1]),
                C[i] &&
                  n[t] < 0 &&
                  (n[i]--, (n[t] += 'months' == i ? 32 - new Date(o.getFullYear(), o.getMonth(), 32).getDate() : s.until + 1)))
            'months' == E && ((n.months += 12 * n.years), delete n.years)
          } else
            pa(y).each(function (e, t) {
              C[t].index <= C[E].index && ((n[t] = Math.floor(a / C[t].limit)), (a -= n[t] * C[t].limit))
            })
          return n
        })(e)
      return (
        pa(y).each(function (e, t) {
          _[t] && ((a = Math.max(Math.round(N / C[t].limit), 1)), n.push(Math.round(s[t] / a) * a))
        }),
        n
      )
    }
    function s(e) {
      F
        ? ((m = V - new Date()), (p = m < 0 && ((m *= -1), !0)), (D = !(h = 0)))
        : (void 0 !== V ? ((D = !1), (m = 1e3 * V), (p = 'countdown' != g.mode)) : ((m = 0), (p = 'countdown' != g.mode), (D = p)),
          e && (h = 0))
    }
    function t() {
      S
        ? (pa('.mbsc-fr-w', f).addClass('mbsc-timer-running mbsc-timer-locked'),
          pa('.mbsc-timer-btn-toggle-c > div', f).text(g.stopText),
          a.buttons.start.icon && pa('.mbsc-timer-btn-toggle-c > div', f).removeClass('mbsc-ic-' + a.buttons.start.icon),
          a.buttons.stop.icon && pa('.mbsc-timer-btn-toggle-c > div', f).addClass('mbsc-ic-' + a.buttons.stop.icon),
          'stopwatch' == g.mode &&
            (pa('.mbsc-timer-btn-resetlap-c > div', f).text(g.lapText),
            a.buttons.reset.icon && pa('.mbsc-timer-btn-resetlap-c > div', f).removeClass('mbsc-ic-' + a.buttons.reset.icon),
            a.buttons.lap.icon && pa('.mbsc-timer-btn-resetlap-c > div', f).addClass('mbsc-ic-' + a.buttons.lap.icon)))
        : (pa('.mbsc-fr-w', f).removeClass('mbsc-timer-running'),
          pa('.mbsc-timer-btn-toggle-c > div', f).text(g.startText),
          a.buttons.start.icon && pa('.mbsc-timer-btn-toggle-c > div', f).addClass('mbsc-ic-' + a.buttons.start.icon),
          a.buttons.stop.icon && pa('.mbsc-timer-btn-toggle-c > div', f).removeClass('mbsc-ic-' + a.buttons.stop.icon),
          'stopwatch' == g.mode &&
            (pa('.mbsc-timer-btn-resetlap-c > div', f).text(g.resetText),
            a.buttons.reset.icon && pa('.mbsc-timer-btn-resetlap-c > div', f).addClass('mbsc-ic-' + a.buttons.reset.icon),
            a.buttons.lap.icon && pa('.mbsc-timer-btn-resetlap-c > div', f).removeClass('mbsc-ic-' + a.buttons.lap.icon)))
    }
    var l,
      e,
      d,
      i,
      r,
      u,
      m,
      h,
      p,
      f,
      v,
      b = va({}, a.settings),
      g = va(a.settings, qi, b),
      x = g.useShortLabels ? g.labelsShort : g.labels,
      T = ['resetlap', 'toggle'],
      y = ['years', 'months', 'days', 'hours', 'minutes', 'seconds', 'fract'],
      C = {
        years: { index: 6, until: 10, limit: 31536e6, label: x[0], wheel: {} },
        months: { index: 5, until: 11, limit: 2592e6, label: x[1], wheel: {} },
        days: { index: 4, until: 31, limit: 864e5, label: x[2], wheel: {} },
        hours: { index: 3, until: 23, limit: 36e5, label: x[3], wheel: {} },
        minutes: { index: 2, until: 59, limit: 6e4, label: x[4], wheel: {} },
        seconds: { index: 1, until: 59, limit: 1e3, label: x[5], wheel: {} },
        fract: { index: 0, until: 99, limit: 10, label: x[6], prefix: '.', wheel: {} },
      },
      _ = {},
      w = [],
      M = 0,
      S = !1,
      k = !0,
      D = !1,
      N = Math.max(10, 1e3 * g.step),
      E = g.maxWheel,
      O = 'stopwatch' == g.mode || F,
      V = g.targetTime,
      F = V && void 0 !== V.getTime,
      A = [[]]
    return (
      (a.start = function () {
        if ((k && a.reset(), !S)) {
          if ((s(), !D && m <= h)) return
          ;((k = !(S = !0)),
            (r = new Date()),
            (i = h),
            (g.readonly = !0),
            a.setVal(n(p ? h : m - h), !0, !0, !1, 100),
            (e = setInterval(function () {
              ;((h = new Date() - r + i),
                a.setVal(n(p ? h : m - h), !0, !0, !1, Math.min(100, d - 10)),
                !D &&
                  m <= h + d &&
                  (clearInterval(e),
                  setTimeout(function () {
                    ;(a.stop(), (h = m), a.setVal(n(p ? h : 0), !0, !0, !1, 100), a.trigger('onFinish', { time: m }), (k = !0))
                  }, m - h)))
            }, d)),
            t(),
            a.trigger('onStart'))
        }
      }),
      (a.stop = function () {
        S && ((S = !1), clearInterval(e), (h = new Date() - r + i), t(), a.trigger('onStop', { ellapsed: h }))
      }),
      (a.toggle = function () {
        S ? a.stop() : a.start()
      }),
      (a.reset = function () {
        ;(a.stop(),
          (w = []),
          (M = h = 0),
          a.setVal(n(p ? 0 : m), !0, !0, !1, 1e3),
          (a.settings.readonly = O),
          (k = !0),
          O || pa('.mbsc-fr-w', f).removeClass('mbsc-timer-locked'),
          a.trigger('onReset'))
      }),
      (a.lap = function () {
        S && ((u = new Date() - r + i), (v = u - M), (M = u), w.push(u), a.trigger('onLap', { ellapsed: u, lap: v, laps: w }))
      }),
      (a.resetlap = function () {
        S && 'stopwatch' == g.mode ? a.lap() : a.reset()
      }),
      (a.getTime = function () {
        return m
      }),
      (a.setTime = function (e) {
        ;((V = e / 1e3), (m = e))
      }),
      (a.getEllapsedTime = function () {
        return k ? 0 : S ? new Date() - r + i : h
      }),
      (a.setEllapsedTime = function (e, t) {
        k || ((i = h = e), (r = new Date()), a.setVal(n(p ? h : m - h), !0, t, !1, 1e3))
      }),
      s(!0),
      E || m || (E = 'minutes'),
      'inline' !== g.display && T.unshift('hide'),
      E ||
        pa(y).each(function (e, t) {
          if (!E && m >= C[t].limit) return ((E = t), !1)
        }),
      pa(y).each(function (e, t) {
        !(function (e) {
          var t = 1,
            a = C[e],
            n = a.wheel,
            s = a.prefix,
            i = a.until,
            r = C[y[pa.inArray(e, y) - 1]]
          if (a.index <= C[E].index && (!r || r.limit > N))
            if (
              (_[e] || A[0].push(n),
              (_[e] = 1),
              (n.data = []),
              (n.label = a.label || ''),
              (n.cssClass = 'mbsc-timer-whl-' + e),
              N >= a.limit && ((t = Math.max(Math.round(N / a.limit), 1)), (d = t * a.limit)),
              e == E)
            )
              ((n.min = 0),
                (n.data = function (e) {
                  return { value: e, display: o(e, s, a.label) }
                }),
                (n.getIndex = function (e) {
                  return e
                }))
            else for (l = 0; l <= i; l += t) n.data.push({ value: l, display: o(l, s, a.label) })
        })(t)
      }),
      (d = Math.max(97, d)),
      g.autostart &&
        setTimeout(function () {
          a.start()
        }, 0),
      (a.handlers.toggle = a.toggle),
      (a.handlers.start = a.start),
      (a.handlers.stop = a.stop),
      (a.handlers.resetlap = a.resetlap),
      (a.handlers.reset = a.reset),
      (a.handlers.lap = a.lap),
      (a.buttons.toggle = { parentClass: 'mbsc-timer-btn-toggle-c', text: g.startText, icon: g.startIcon, handler: 'toggle' }),
      (a.buttons.start = { text: g.startText, icon: g.startIcon, handler: 'start' }),
      (a.buttons.stop = { text: g.stopText, icon: g.stopIcon, handler: 'stop' }),
      (a.buttons.reset = { text: g.resetText, icon: g.resetIcon, handler: 'reset' }),
      (a.buttons.lap = { text: g.lapText, icon: g.lapIcon, handler: 'lap' }),
      (a.buttons.resetlap = { parentClass: 'mbsc-timer-btn-resetlap-c', text: g.resetText, icon: g.resetIcon, handler: 'resetlap' }),
      (a.buttons.hide = { parentClass: 'mbsc-timer-btn-hide-c', text: g.hideText, icon: g.closeIcon, handler: 'cancel' }),
      {
        minWidth: 100,
        wheels: A,
        headerText: !1,
        readonly: O,
        buttons: T,
        compClass: 'mbsc-timer mbsc-sc',
        parseValue: function () {
          return n(p ? 0 : m)
        },
        formatValue: function (a) {
          var n = '',
            s = 0
          return (
            pa(y).each(function (e, t) {
              'fract' != t && _[t] && ((n += a[s] + ('seconds' == t && _.fract ? '.' + a[s + 1] : '') + ' ' + x[e] + ' '), s++)
            }),
            n
          )
        },
        validate: function (e) {
          var a = e.values,
            t = e.index,
            n = 0
          k &&
            void 0 !== t &&
            ((V = 0),
            pa(y).each(function (e, t) {
              _[t] && ((V += C[t].limit * a[n]), n++)
            }),
            (V /= 1e3),
            s(!0))
        },
        onBeforeShow: function () {
          g.showLabel = !0
        },
        onMarkupReady: function (e) {
          ;((f = pa(e.target)), t(), O && pa('.mbsc-fr-w', f).addClass('mbsc-timer-locked'))
        },
        onPosition: function (e) {
          pa('.mbsc-fr-w', e.target).css('min-width', 0).css('min-width', pa('.mbsc-fr-btn-cont', e.target)[0].offsetWidth)
        },
        onDestroy: function () {
          clearInterval(e)
        },
      }
    )
  }
  var Ki = e.bool,
    Gi = e.number,
    Xi = e.string,
    Zi = e.func,
    Qi = {
      autostart: Ki,
      maxWheel: e.oneOf(['years', 'months', 'days', 'hours', 'minutes', 'seconds', 'fract']),
      mode: e.oneOf(['countdown', 'stopwatch']),
      step: Gi,
      targetTime: Gi,
      useShortLabels: Ki,
      hideText: Xi,
      labels: e.arrayOf(Xi),
      labelsShort: e.arrayOf(Xi),
      lapText: Xi,
      resetText: Xi,
      startText: Xi,
      stopText: Xi,
      lap: Zi,
      onFinish: Zi,
      onReset: Zi,
      onStart: Zi,
      onStop: Zi,
    },
    er = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { preset: 'timer' }), t)
      }
      return (l(e, a), e)
    })(xe)
  ;((er.propTypes = g({}, er.propTypes, {}, ce, {}, Qi)), (Z.Timer = er))
  var tr = {
    wheelOrder: 'hhiiss',
    useShortLabels: !1,
    min: 0,
    max: 1 / 0,
    labels: ['Years', 'Months', 'Days', 'Hours', 'Minutes', 'Seconds'],
    labelsShort: ['Yrs', 'Mths', 'Days', 'Hrs', 'Mins', 'Secs'],
  }
  vt.timespan = function (u) {
    function m(a) {
      var n = {}
      return (
        pa(v).each(function (e, t) {
          ;((n[t] = x[t] ? Math.floor(a / b[t].limit) : 0), (a -= n[t] * b[t].limit))
        }),
        n
      )
    }
    function r(e, t, a) {
      return (e < 10 && t ? '0' : '') + e + '<span class="mbsc-ts-lbl">' + a + '</span>'
    }
    function h(a) {
      var n = 0
      return (
        pa.each(d, function (e, t) {
          isNaN(+a[0]) || (n += b[t.v].limit * a[e])
        }),
        n
      )
    }
    var o,
      a,
      i,
      p,
      f,
      e = va({}, u.settings),
      l = va(u.settings, tr, e),
      c = l.wheelOrder,
      t = l.useShortLabels ? l.labelsShort : l.labels,
      v = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'],
      b = {
        years: { ord: 0, index: 6, until: 10, limit: 31536e6, label: t[0], re: 'y', wheel: {} },
        months: { ord: 1, index: 5, until: 11, limit: 2592e6, label: t[1], re: 'm', wheel: {} },
        days: { ord: 2, index: 4, until: 31, limit: 864e5, label: t[2], re: 'd', wheel: {} },
        hours: { ord: 3, index: 3, until: 23, limit: 36e5, label: t[3], re: 'h', wheel: {} },
        minutes: { ord: 4, index: 2, until: 59, limit: 6e4, label: t[4], re: 'i', wheel: {} },
        seconds: { ord: 5, index: 1, until: 59, limit: 1e3, label: t[5], re: 's', wheel: {} },
      },
      d = [],
      g = l.steps || [],
      x = {},
      T = 'seconds',
      y = l.defaultValue || Math.max(l.min, Math.min(0, l.max)),
      n = [[]]
    return (
      pa(v).each(function (e, t) {
        ;-1 < (a = c.search(new RegExp(b[t].re, 'i'))) && (d.push({ o: a, v: t }), b[t].index > b[T].index && (T = t))
      }),
      d.sort(function (e, t) {
        return e.o > t.o ? 1 : -1
      }),
      pa.each(d, function (e, t) {
        ;((x[t.v] = e + 1), n[0].push(b[t.v].wheel))
      }),
      (p = m(l.min)),
      (f = m(l.max)),
      pa.each(d, function (e, t) {
        !(function (e) {
          var t = !1,
            a = g[x[e] - 1] || 1,
            n = b[e],
            s = n.label,
            i = n.wheel
          if (((i.data = []), (i.label = n.label), c.match(new RegExp(n.re + n.re, 'i')) && (t = !0), e == T))
            ((i.min = p[e]),
              (i.max = f[e]),
              (i.data = function (e) {
                return { value: e * a, display: r(e * a, t, s) }
              }),
              (i.getIndex = function (e) {
                return Math.round(e / a)
              }))
          else for (o = 0; o <= n.until; o += a) i.data.push({ value: o, display: r(o, t, s) })
        })(t.v)
      }),
      (u.getVal = function (e, t) {
        return t ? u._getVal(e) : u._hasValue || e ? h(u.getArrayVal(e)) : null
      }),
      {
        minWidth: 100,
        showLabel: !0,
        wheels: n,
        compClass: 'mbsc-ts mbsc-sc',
        parseValue: function (a) {
          var n,
            s = []
          return (
            oa(a) || !a
              ? ((i = m(a || y)),
                pa.each(d, function (e, t) {
                  s.push(i[t.v])
                }))
              : pa.each(d, function (e, t) {
                  ;((n = new RegExp('(\\d+)\\s?(' + l.labels[b[t.v].ord] + '|' + l.labelsShort[b[t.v].ord] + ')', 'gi').exec(a)),
                    s.push(n ? n[1] : 0))
                }),
            pa(s).each(function (e, t) {
              s[e] = (function (e, t) {
                return Math.floor(e / t) * t
              })(t, g[e] || 1)
            }),
            s
          )
        },
        formatValue: function (a) {
          var n = ''
          return (
            pa.each(d, function (e, t) {
              n += +a[e] ? a[e] + ' ' + b[t.v].label + ' ' : ''
            }),
            n ? n.replace(/\s+$/g, '') : 0
          )
        },
        validate: function (e) {
          var a,
            n,
            s,
            i,
            r = e.values,
            o = e.direction,
            l = [],
            c = !0,
            d = !0
          return (
            pa(v).each(function (e, t) {
              if (void 0 !== x[t]) {
                if (((s = x[t] - 1), (l[s] = []), (i = {}), t != T)) {
                  if (c) for (n = f[t] + 1; n <= b[t].until; n++) i[n] = !0
                  if (d) for (n = 0; n < p[t]; n++) i[n] = !0
                }
                ;((r[s] = u.getValidValue(s, r[s], o, i)),
                  (a = m(h(r))),
                  (c = c && a[t] == f[t]),
                  (d = d && a[t] == p[t]),
                  pa.each(i, function (e) {
                    l[s].push(e)
                  }))
              }
            }),
            { disabled: l }
          )
        },
      }
    )
  }
  var ar = e.number,
    nr = e.string,
    sr = {
      defaultValue: ar,
      max: ar,
      min: ar,
      steps: e.arrayOf(ar),
      useShortLabels: e.bool,
      wheelOrder: nr,
      labels: e.arrayOf(nr),
      labelsShort: e.arrayOf(nr),
    },
    ir = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { preset: 'timespan' }), t)
      }
      return (l(e, a), e)
    })(xe)
  ;((ir.propTypes = g({}, ir.propTypes, {}, ce, {}, sr)), (Z.Timespan = ir), (vt.treelist = ss))
  var rr = e.array,
    or = e.string,
    lr = { defaultValue: rr, inputClass: or, invalid: rr, labels: e.arrayOf(or), placeholder: or, showInput: e.bool },
    cr = (function (a) {
      function e(e) {
        var t
        return (((t = a.call(this, e) || this).mbscInit = { preset: 'treelist' }), t)
      }
      return (l(e, a), e)
    })(Te)
  ;((cr.propTypes = g({}, cr.propTypes, {}, lr)), (Z.Treelist = cr))
  var dr = (function (t) {
    function e(e) {
      return t.call(this, e) || this
    }
    l(e, t)
    var a = e.prototype
    return (
      (a.componentDidMount = function () {
        var e = this.getSettingsFromProps(this.props)
        this.instance = new en(this.refs.popup, e)
      }),
      (a.render = function () {
        return b.createElement(
          'div',
          { className: this.initialCssClass + ' mbsc-cloak', style: this.props.style, ref: 'popup' },
          this.props.children,
        )
      }),
      e
    )
  })(ge)
  function ur(e) {
    return e < -1e-7 ? Math.ceil(e - 1e-7) : Math.floor(e + 1e-7)
  }
  function mr(e, t, a) {
    ;((e = parseInt(e)), (t = parseInt(t)), (a = parseInt(a)))
    var n,
      s,
      i,
      r,
      o = new Array(0, 0, 0)
    return (
      (n =
        1582 < e || (1582 == e && 10 < t) || (1582 == e && 10 == t && 14 < a)
          ? ur((1461 * (e + 4800 + ur((t - 14) / 12))) / 4) +
            ur((367 * (t - 2 - 12 * ur((t - 14) / 12))) / 12) -
            ur((3 * ur((e + 4900 + ur((t - 14) / 12)) / 100)) / 4) +
            a -
            32075
          : 367 * e - ur((7 * (e + 5001 + ur((t - 9) / 7))) / 4) + ur((275 * t) / 9) + a + 1729777),
      (r = ur(((s = n - 1948440 + 10632) - 1) / 10631)),
      (i = ur((10985 - (s = s - 10631 * r + 354)) / 5316) * ur((50 * s) / 17719) + ur(s / 5670) * ur((43 * s) / 15238)),
      (s = s - ur((30 - i) / 15) * ur((17719 * i) / 50) - ur(i / 16) * ur((15238 * i) / 43) + 29),
      (t = ur((24 * s) / 709)),
      (a = s - ur((709 * t) / 24)),
      (e = 30 * r + i - 30),
      (o[2] = a),
      (o[1] = t),
      (o[0] = e),
      o
    )
  }
  ;((dr.propTypes = g({}, dr.propTypes, {}, oe, {}, le)),
    (Z.Popup = dr),
    (Z.Widget = dr),
    (ie.hijri = {
      getYear: function (e) {
        return mr(e.getFullYear(), e.getMonth() + 1, e.getDate())[0]
      },
      getMonth: function (e) {
        return --mr(e.getFullYear(), e.getMonth() + 1, e.getDate())[1]
      },
      getDay: function (e) {
        return mr(e.getFullYear(), e.getMonth() + 1, e.getDate())[2]
      },
      getDate: function (e, t, a, n, s, i, r) {
        ;(t < 0 && ((e += Math.floor(t / 12)), (t = 12 + (t % 12))), 11 < t && ((e += Math.floor(t / 12)), (t %= 12)))
        var o = (function (e, t, a) {
          ;((e = parseInt(e)), (t = parseInt(t)), (a = parseInt(a)))
          var n,
            s,
            i,
            r,
            o,
            l,
            c = new Array(3)
          return (
            (e =
              2299160 < (n = ur((11 * e + 3) / 30) + 354 * e + 30 * t - ur((t - 1) / 2) + a + 1948440 - 385)
                ? ((r = ur((4 * (s = 68569 + n)) / 146097)),
                  (s -= ur((146097 * r + 3) / 4)),
                  (o = ur((4e3 * (s + 1)) / 1461001)),
                  (s = s - ur((1461 * o) / 4) + 31),
                  (i = ur((80 * s) / 2447)),
                  (a = s - ur((2447 * i) / 80)),
                  (t = i + 2 - 12 * (s = ur(i / 11))),
                  100 * (r - 49) + o + s)
                : ((l = ur(((i = 1402 + n) - 1) / 1461)),
                  (r = ur(((s = i - 1461 * l) - 1) / 365) - ur(s / 1461)),
                  (i = ur((80 * (o = s - 365 * r + 30)) / 2447)),
                  (a = o - ur((2447 * i) / 80)),
                  (t = i + 2 - 12 * (o = ur(i / 11))),
                  4 * l + r + o - 4716)),
            (c[2] = a),
            (c[1] = t),
            (c[0] = e),
            c
          )
        })(e, +t + 1, a)
        return new Date(o[0], o[1] - 1, o[2], n || 0, s || 0, i || 0, r || 0)
      },
      getMaxDayOfMonth: function (e, t) {
        return [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29][t] + (11 === t && (11 * e + 14) % 30 < 11 ? 1 : 0)
      },
    }),
    (Z.i18n.ar = {
      rtl: !0,
      setText: 'تعيين',
      cancelText: 'إلغاء',
      clearText: 'مسح',
      selectedText: '{count} المحدد',
      dateFormat: 'dd/mm/yy',
      dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
      dayNamesShort: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
      dayNamesMin: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
      dayText: 'يوم',
      hourText: 'ساعات',
      minuteText: 'الدقائق',
      monthNames: [
        'كانون الثاني',
        'شهر فبراير',
        'مارس',
        'أبريل',
        'قد',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'شهر اكتوبر',
        'شهر نوفمبر',
        'ديسمبر',
      ],
      monthNamesShort: [
        'كانون الثاني',
        'شهر فبراير',
        'مارس',
        'أبريل',
        'قد',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'شهر اكتوبر',
        'شهر نوفمبر',
        'ديسمبر',
      ],
      monthText: 'شهر',
      secText: 'ثواني',
      amText: 'ص',
      pmText: 'م',
      timeFormat: 'hh:ii A',
      yearText: 'عام',
      nowText: 'الآن',
      firstDay: 0,
      dateText: 'تاريخ',
      timeText: 'وقت',
      closeText: 'إغلاق',
      todayText: 'اليوم',
      prevMonthText: 'الشهر السابق',
      nextMonthText: 'الشهر القادم',
      prevYearText: 'السنه السابقة',
      nextYearText: 'العام القادم',
      allDayText: 'اليوم كله',
      noEventsText: 'لا توجد احداث',
      eventText: 'الحدث',
      eventsText: 'أحداث',
      moreEventsText: 'واحد آخر',
      moreEventsPluralText: 'اثنان آخران {count}',
      fromText: 'يبدا',
      toText: 'ينتهي',
      wholeText: 'كامل',
      fractionText: 'جزء',
      unitText: 'وحدة',
      delimiter: '/',
      decimalSeparator: '.',
      thousandsSeparator: ',',
      labels: ['سنوات', 'أشهر', 'أيام', 'ساعة', 'دقائق', 'ثواني', ''],
      labelsShort: ['سنوات', 'أشهر', 'أيام', 'ساعة', 'دقائق', 'ثواني', ''],
      startText: 'بدء',
      stopText: 'إيقاف',
      resetText: 'إعادة ضبط',
      lapText: 'الدورة',
      hideText: 'إخفاء',
      offText: 'إيقاف',
      onText: 'تشغيل',
      backText: 'رجوع',
      undoText: 'تراجع',
    }),
    (Z.i18n.bg = {
      setText: 'Задаване',
      cancelText: 'Отмяна',
      clearText: 'Изчистване',
      selectedText: '{count} подбран',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Неделя', 'Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота'],
      dayNamesShort: ['Нед', 'Пон', 'Вто', 'Сря', 'Чет', 'Пет', 'Съб'],
      dayNamesMin: ['Не', 'По', 'Вт', 'Ср', 'Че', 'Пе', 'Съ'],
      dayText: 'ден',
      delimiter: '.',
      hourText: 'час',
      minuteText: 'минута',
      monthNames: ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'],
      monthNamesShort: ['Яну', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Нов', 'Дек'],
      monthText: 'месец',
      secText: 'секунди',
      timeFormat: 'H:ii',
      yearText: 'година',
      nowText: 'Сега',
      pmText: 'pm',
      amText: 'am',
      firstDay: 1,
      dateText: 'Дата',
      timeText: 'път',
      todayText: 'днес',
      prevMonthText: 'Предишния месец',
      nextMonthText: 'Следващият месец',
      prevYearText: 'Предходната година',
      nextYearText: 'Следващата година',
      closeText: 'затвори',
      eventText: 'Събитие',
      eventsText: 'Събития',
      allDayText: 'Цял ден',
      noEventsText: 'Няма събития',
      moreEventsText: 'Още {count}',
      fromText: 'ОТ',
      toText: 'ДО',
      wholeText: 'цяло',
      fractionText: 'фракция',
      unitText: 'единица',
      labels: ['Години', 'месеца', 'дни', 'часа', 'минути', 'секунди', ''],
      labelsShort: ['Години', 'месеца', 'дни', 'часа', 'минути', 'секунди', ''],
      startText: 'Старт',
      stopText: 'Стоп',
      resetText: 'Нулиране',
      lapText: 'Обиколка',
      hideText: 'крия',
      backText: 'връщане',
      undoText: 'ОТМЯНА',
      offText: 'ИЗКЛ',
      onText: 'ВКЛ',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.ca = {
      setText: 'Acceptar',
      cancelText: 'Cancel·lar',
      clearText: 'Esborrar',
      selectedText: '{count} seleccionat',
      selectedPluralText: '{count} seleccionats',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
      dayNamesShort: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
      dayNamesMin: ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
      dayText: 'Dia',
      hourText: 'Hores',
      minuteText: 'Minuts',
      monthNames: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'],
      monthNamesShort: ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'],
      monthText: 'Mes',
      secText: 'Segons',
      timeFormat: 'HH:ii',
      yearText: 'Any',
      nowText: 'Ara',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Avui',
      firstDay: 1,
      dateText: 'Data',
      timeText: 'Temps',
      closeText: 'Tancar',
      allDayText: 'Tot el dia',
      noEventsText: 'Cap esdeveniment',
      eventText: 'Esdeveniments',
      eventsText: 'Esdeveniments',
      moreEventsText: '{count} més',
      fromText: 'Iniciar',
      toText: 'Final',
      wholeText: 'Sencer',
      fractionText: 'Fracció',
      unitText: 'Unitat',
      labels: ['Anys', 'Mesos', 'Dies', 'Hores', 'Minuts', 'Segons', ''],
      labelsShort: ['Anys', 'Mesos', 'Dies', 'Hrs', 'Mins', 'Secs', ''],
      startText: 'Iniciar',
      stopText: 'Aturar',
      resetText: 'Reiniciar',
      lapText: 'Volta',
      hideText: 'Amagar',
      backText: 'Enrere',
      undoText: 'Desfés',
      offText: 'No',
      onText: 'Si',
    }),
    (Z.i18n.cs = {
      setText: 'Zadej',
      cancelText: 'Storno',
      clearText: 'Vymazat',
      selectedText: 'Označený: {count}',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
      dayNamesShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
      dayNamesMin: ['N', 'P', 'Ú', 'S', 'Č', 'P', 'S'],
      dayText: 'Den',
      hourText: 'Hodiny',
      minuteText: 'Minuty',
      monthNames: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
      monthNamesShort: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čvc', 'Spr', 'Zář', 'Říj', 'Lis', 'Pro'],
      monthText: 'Měsíc',
      secText: 'Sekundy',
      timeFormat: 'HH:ii',
      yearText: 'Rok',
      nowText: 'Teď',
      amText: 'am',
      pmText: 'pm',
      todayText: 'Dnes',
      firstDay: 1,
      dateText: 'Datum',
      timeText: 'Čas',
      closeText: 'Zavřít',
      allDayText: 'Celý den',
      noEventsText: 'Žádné události',
      eventText: 'Událostí',
      eventsText: 'Události',
      moreEventsText: '{count} další',
      fromText: 'Začátek',
      toText: 'Konec',
      wholeText: 'Celý',
      fractionText: 'Část',
      unitText: 'Jednotka',
      labels: ['Roky', 'Měsíce', 'Dny', 'Hodiny', 'Minuty', 'Sekundy', ''],
      labelsShort: ['Rok', 'Měs', 'Dny', 'Hod', 'Min', 'Sec', ''],
      startText: 'Start',
      stopText: 'Stop',
      resetText: 'Resetovat',
      lapText: 'Etapa',
      hideText: 'Schovat',
      backText: 'Zpět',
      undoText: 'Zpět',
      offText: 'O',
      onText: 'I',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.da = {
      setText: 'Sæt',
      cancelText: 'Annuller',
      clearText: 'Ryd',
      selectedText: '{count} valgt',
      selectedPluralText: '{count} valgt',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
      dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
      dayNamesMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
      dayText: 'Dag',
      hourText: 'Timer',
      minuteText: 'Minutter',
      monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
      monthText: 'Måned',
      secText: 'Sekunder',
      amText: 'am',
      pmText: 'pm',
      timeFormat: 'HH.ii',
      yearText: 'År',
      nowText: 'Nu',
      todayText: 'I dag',
      firstDay: 1,
      dateText: 'Dato',
      timeText: 'Tid',
      closeText: 'Luk',
      allDayText: 'Hele dagen',
      noEventsText: 'Ingen begivenheder',
      eventText: 'Begivenheder',
      eventsText: 'Begivenheder',
      moreEventsText: '{count} mere',
      fromText: 'Start',
      toText: 'Slut',
      wholeText: 'Hele',
      fractionText: 'Dele',
      unitText: 'Enhed',
      labels: ['År', 'Måneder', 'Dage', 'Timer', 'Minutter', 'Sekunder', ''],
      labelsShort: ['År', 'Mdr', 'Dg', 'Timer', 'Min', 'Sek', ''],
      startText: 'Start',
      stopText: 'Stop',
      resetText: 'Nulstil',
      lapText: 'Omgang',
      hideText: 'Skjul',
      offText: 'Fra',
      onText: 'Til',
      backText: 'Tilbage',
      undoText: 'Fortryd',
    }),
    (Z.i18n.de = {
      setText: 'OK',
      cancelText: 'Abbrechen',
      clearText: 'Löschen',
      selectedText: '{count} ausgewählt',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      dayNamesMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
      dayText: 'Tag',
      delimiter: '.',
      hourText: 'Stunde',
      minuteText: 'Minuten',
      monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      monthText: 'Monat',
      secText: 'Sekunden',
      timeFormat: 'HH:ii',
      yearText: 'Jahr',
      nowText: 'Jetzt',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Heute',
      firstDay: 1,
      dateText: 'Datum',
      timeText: 'Zeit',
      closeText: 'Schließen',
      allDayText: 'Ganztägig',
      noEventsText: 'Keine Ereignisse',
      eventText: 'Ereignis',
      eventsText: 'Ereignisse',
      moreEventsText: '{count} weiteres Element',
      moreEventsPluralText: '{count} weitere Elemente',
      fromText: 'Von',
      toText: 'Bis',
      wholeText: 'Ganze Zahl',
      fractionText: 'Bruchzahl',
      unitText: 'Maßeinheit',
      labels: ['Jahre', 'Monate', 'Tage', 'Stunden', 'Minuten', 'Sekunden', ''],
      labelsShort: ['Jahr.', 'Mon.', 'Tag.', 'Std.', 'Min.', 'Sek.', ''],
      startText: 'Starten',
      stopText: 'Stoppen',
      resetText: 'Zurücksetzen',
      lapText: 'Lap',
      hideText: 'Ausblenden',
      backText: 'Zurück',
      undoText: 'Rückgängig machen',
      offText: 'Aus',
      onText: 'Ein',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.el = {
      setText: 'Ορισμος',
      cancelText: 'Ακυρωση',
      clearText: 'Διαγραφη',
      selectedText: '{count} επιλεγμένα',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
      dayNamesShort: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
      dayNamesMin: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σα'],
      dayText: 'ημέρα',
      delimiter: '/',
      hourText: 'ώρα',
      minuteText: 'λεπτό',
      monthNames: [
        'Ιανουάριος',
        'Φεβρουάριος',
        'Μάρτιος',
        'Απρίλιος',
        'Μάιος',
        'Ιούνιος',
        'Ιούλιος',
        'Αύγουστος',
        'Σεπτέμβριος',
        'Οκτώβριος',
        'Νοέμβριος',
        'Δεκέμβριος',
      ],
      monthNamesShort: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαι', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
      monthText: 'Μήνας',
      secText: 'δευτερόλεπτα',
      timeFormat: 'H:ii',
      yearText: 'έτος',
      nowText: 'τώρα',
      pmText: 'μμ',
      amText: 'πμ',
      firstDay: 1,
      dateText: 'Ημερομηνία',
      timeText: 'φορά',
      todayText: 'Σήμερα',
      prevMonthText: 'Προηγούμενο μήνα',
      nextMonthText: 'Επόμενο μήνα',
      prevYearText: 'Προηγούμενο έτος',
      nextYearText: 'Επόμενο έτος',
      closeText: 'Κλείσιμο',
      eventText: 'Γεγονότα',
      eventsText: 'Γεγονότα',
      allDayText: 'Ολοήμερο',
      noEventsText: 'Δεν υπάρχουν γεγονότα',
      moreEventsText: '{count} ακόμη',
      fromText: 'Αρχή',
      toText: 'Τέλος',
      wholeText: 'Ολόκληρος',
      fractionText: 'κλάσμα',
      unitText: 'Μονάδα',
      labels: ['Χρόνια', 'Μήνες', 'Ημέρες', 'Ωρες', 'Λεπτά', 'δευτερόλεπτα', ''],
      labelsShort: ['Χρόνια', 'Μήνες', 'Ημέρες', 'Ωρες', 'Λεπτά', 'δευτ', ''],
      startText: '΄Εναρξη',
      stopText: 'Διακοπή',
      resetText: 'Επαναφορά',
      lapText: 'Γύρος',
      hideText: 'κρύβω',
      backText: 'Πίσω',
      undoText: 'Αναιρεση',
      offText: 'Ανενεργό',
      onText: 'Ενεργό',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n['en-GB'] = Z.i18n['en-UK'] = { dateFormat: 'dd/mm/yy', timeFormat: 'HH:ii' }),
    (Z.i18n.es = {
      setText: 'Aceptar',
      cancelText: 'Cancelar',
      clearText: 'Borrar',
      selectedText: '{count} seleccionado',
      selectedPluralText: '{count} seleccionados',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      dayNamesShort: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      dayText: 'Día',
      hourText: 'Horas',
      minuteText: 'Minutos',
      monthNames: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      monthText: 'Mes',
      secText: 'Segundos',
      timeFormat: 'HH:ii',
      yearText: 'A&ntilde;o',
      nowText: 'Ahora',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Hoy',
      firstDay: 1,
      dateText: 'Fecha',
      timeText: 'Tiempo',
      closeText: 'Cerrar',
      allDayText: 'Todo el día',
      noEventsText: 'No hay eventos',
      eventText: 'Evento',
      eventsText: 'Eventos',
      moreEventsText: '{count} más',
      fromText: 'Iniciar',
      toText: 'Final',
      wholeText: 'Entero',
      fractionText: 'Fracción',
      unitText: 'Unidad',
      labels: ['Años', 'Meses', 'Días', 'Horas', 'Minutos', 'Segundos', ''],
      labelsShort: ['Año', 'Mes', 'Día', 'Hora', 'Min', 'Seg', ''],
      startText: 'Iniciar',
      stopText: 'Deténgase',
      resetText: 'Reinicializar',
      lapText: 'Lap',
      hideText: 'Esconder',
      backText: 'Atrás',
      undoText: 'Deshacer',
      offText: 'No',
      onText: 'Sí',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }))
  var hr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    pr = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29]
  function fr(e, t, a) {
    var n,
      s = (e = parseInt(e)) - 1600,
      i = (t = parseInt(t)) - 1,
      r = (a = parseInt(a)) - 1,
      o = 365 * s + parseInt((3 + s) / 4) - parseInt((99 + s) / 100) + parseInt((399 + s) / 400)
    for (n = 0; n < i; ++n) o += hr[n]
    1 < i && ((s % 4 == 0 && s % 100 != 0) || s % 400 == 0) && ++o
    var l = (o += r) - 79,
      c = parseInt(l / 12053)
    l %= 12053
    var d = 979 + 33 * c + 4 * parseInt(l / 1461)
    for (366 <= (l %= 1461) && ((d += parseInt((l - 1) / 365)), (l = (l - 1) % 365)), n = 0; n < 11 && l >= pr[n]; ++n) l -= pr[n]
    return [d, n + 1, l + 1]
  }
  ;((ie.jalali = {
    getYear: function (e) {
      return fr(e.getFullYear(), e.getMonth() + 1, e.getDate())[0]
    },
    getMonth: function (e) {
      return --fr(e.getFullYear(), e.getMonth() + 1, e.getDate())[1]
    },
    getDay: function (e) {
      return fr(e.getFullYear(), e.getMonth() + 1, e.getDate())[2]
    },
    getDate: function (e, t, a, n, s, i, r) {
      ;(t < 0 && ((e += Math.floor(t / 12)), (t = 12 + (t % 12))), 11 < t && ((e += Math.floor(t / 12)), (t %= 12)))
      var o = (function (e, t, a) {
        var n,
          s = (e = parseInt(e)) - 979,
          i = (t = parseInt(t)) - 1,
          r = (a = parseInt(a)) - 1,
          o = 365 * s + 8 * parseInt(s / 33) + parseInt(((s % 33) + 3) / 4)
        for (n = 0; n < i; ++n) o += pr[n]
        var l = (o += r) + 79,
          c = 1600 + 400 * parseInt(l / 146097),
          d = !0
        for (
          36525 <= (l %= 146097) && (l--, (c += 100 * parseInt(l / 36524)), 365 <= (l %= 36524) ? l++ : (d = !1)),
            c += 4 * parseInt(l / 1461),
            366 <= (l %= 1461) && ((d = !1), l--, (c += parseInt(l / 365)), (l %= 365)),
            n = 0;
          hr[n] + (1 == n && d) <= l;
          n++
        )
          l -= hr[n] + (1 == n && d)
        return [c, n + 1, l + 1]
      })(e, +t + 1, a)
      return new Date(o[0], o[1] - 1, o[2], n || 0, s || 0, i || 0, r || 0)
    },
    getMaxDayOfMonth: function (e, t) {
      for (
        var a, n, s, i = 31;
        !1 ==
        ((n = t + 1),
        (s = i),
        !((a = e) < 0 || 32767 < a || n < 1 || 12 < n || s < 1 || s > pr[n - 1] + (12 == n && ((a - 979) % 33) % 4 == 0)));
      )
        i--
      return i
    },
  }),
    (Z.i18n.fa = {
      setText: 'تاييد',
      cancelText: 'انصراف',
      clearText: 'واضح ',
      selectedText: '{count} منتخب',
      calendarSystem: 'jalali',
      dateFormat: 'yy/mm/dd',
      dayNames: ['يکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'],
      dayNamesShort: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
      dayNamesMin: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
      dayText: 'روز',
      hourText: 'ساعت',
      minuteText: 'دقيقه',
      monthNames: ['فروردين', 'ارديبهشت', 'خرداد', 'تير', 'مرداد', 'شهريور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
      monthNamesShort: ['فروردين', 'ارديبهشت', 'خرداد', 'تير', 'مرداد', 'شهريور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
      monthText: 'ماه',
      secText: 'ثانيه',
      timeFormat: 'HH:ii',
      timeWheels: 'iiHH',
      yearText: 'سال',
      nowText: 'اکنون',
      amText: 'ب',
      pmText: 'ص',
      todayText: 'امروز',
      firstDay: 6,
      rtl: !0,
      dateText: 'تاریخ ',
      timeText: 'زمان ',
      closeText: 'نزدیک',
      allDayText: 'تمام روز',
      noEventsText: 'هیچ رویداد',
      eventText: 'رویداد',
      eventsText: 'رویدادها',
      moreEventsText: '{count} مورد دیگر',
      fromText: 'شروع ',
      toText: 'پایان',
      wholeText: 'تمام',
      fractionText: 'کسر',
      unitText: 'واحد',
      labels: ['سال', 'ماه', 'روز', 'ساعت', 'دقیقه', 'ثانیه', ''],
      labelsShort: ['سال', 'ماه', 'روز', 'ساعت', 'دقیقه', 'ثانیه', ''],
      startText: 'شروع',
      stopText: 'پايان',
      resetText: 'تنظیم مجدد',
      lapText: 'Lap',
      hideText: 'پنهان کردن',
      backText: 'پشت',
      undoText: 'واچیدن',
    }),
    (Z.i18n.fi = {
      setText: 'Aseta',
      cancelText: 'Peruuta',
      clearText: 'Tyhjennä',
      selectedText: '{count} valita',
      dateFormat: 'd. MM yy',
      dayNames: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviiko', 'Torstai', 'Perjantai', 'Lauantai'],
      dayNamesShort: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
      dayNamesMin: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
      dayText: 'Päivä',
      delimiter: '.',
      hourText: 'Tuntia',
      minuteText: 'Minuutti',
      monthNames: [
        'Tammikuu',
        'Helmikuu',
        'Maaliskuu',
        'Huhtikuu',
        'Toukokuu',
        'Kesäkuu',
        'Heinäkuu',
        'Elokuu',
        'Syyskuu',
        'Lokakuu',
        'Marraskuu',
        'Joulukuu',
      ],
      monthNamesShort: ['Tam', 'Hel', 'Maa', 'Huh', 'Tou', 'Kes', 'Hei', 'Elo', 'Syy', 'Lok', 'Mar', 'Jou'],
      monthText: 'Kuukausi',
      secText: 'Sekunda',
      timeFormat: 'H:ii',
      yearText: 'Vuosi',
      nowText: 'Nyt',
      pmText: 'pm',
      amText: 'am',
      firstDay: 1,
      dateText: 'Päiväys',
      timeText: 'Aika',
      todayText: 'Tänään',
      prevMonthText: 'Edellinen kuukausi',
      nextMonthText: 'Ensi kuussa',
      prevYearText: 'Edellinen vuosi',
      nextYearText: 'Ensi vuosi',
      closeText: 'Sulje',
      eventText: 'Tapahtumia',
      eventsText: 'Tapahtumia',
      allDayText: 'Koko päivä',
      noEventsText: 'Ei tapahtumia',
      moreEventsText: '{count} muu',
      moreEventsPluralText: '{count} muuta',
      fromText: 'Alkaa',
      toText: 'Päättyy',
      wholeText: 'Kokonainen',
      fractionText: 'Murtoluku',
      unitText: 'Yksikkö',
      labels: ['Vuosi', 'Kuukausi', 'Päivä', 'Tunnin', 'Minuutti', 'sekuntia', ''],
      labelsShort: ['Vuo', 'Kuu', 'Päi', 'Tun', 'Min', 'Sek', ''],
      startText: 'Käynnistys',
      stopText: 'Seis',
      resetText: 'Aseta uudelleen',
      lapText: 'Kierros',
      hideText: 'Vuota',
      backText: 'Edellinen',
      undoText: 'Kumoa',
      offText: 'Pois',
      onText: 'Päällä',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.fr = {
      setText: 'Terminer',
      cancelText: 'Annuler',
      clearText: 'Effacer',
      selectedText: '{count} sélectionné',
      selectedPluralText: '{count} sélectionnés',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      dayText: 'Jour',
      monthText: 'Mois',
      monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
      hourText: 'Heures',
      minuteText: 'Minutes',
      secText: 'Secondes',
      timeFormat: 'HH:ii',
      yearText: 'Année',
      nowText: 'Maintenant',
      pmText: 'pm',
      amText: 'am',
      todayText: "Aujourd'hui",
      firstDay: 1,
      dateText: 'Date',
      timeText: 'Heure',
      closeText: 'Fermer',
      allDayText: 'Toute la journée',
      noEventsText: 'Aucun événement',
      eventText: 'Événement',
      eventsText: 'Événements',
      moreEventsText: '{count} autre',
      moreEventsPluralText: '{count} autres',
      fromText: 'Démarrer',
      toText: 'Fin',
      wholeText: 'Entier',
      fractionText: 'Fraction',
      unitText: 'Unité',
      labels: ['Ans', 'Mois', 'Jours', 'Heures', 'Minutes', 'Secondes', ''],
      labelsShort: ['Ans', 'Mois', 'Jours', 'Hrs', 'Min', 'Sec', ''],
      startText: 'Démarrer',
      stopText: 'Arrêter',
      resetText: 'Réinitialiser',
      lapText: 'Lap',
      hideText: 'Cachez',
      backText: 'Retour',
      undoText: 'Annuler',
      offText: 'Non',
      onText: 'Oui',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.he = {
      rtl: !0,
      setText: 'שמירה',
      cancelText: 'ביטול',
      clearText: 'נקה',
      selectedText: '{count} נבחר',
      selectedPluralText: '{count} נבחרו',
      dateFormat: 'dd/mm/yy',
      dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
      dayNamesShort: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ש'"],
      dayNamesMin: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
      dayText: 'יום',
      hourText: 'שעות',
      minuteText: 'דקות',
      monthNames: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
      monthNamesShort: ['ינו', 'פבר', 'מרץ', 'אפר', 'מאי', 'יונ', 'יול', 'אוג', 'ספט', 'אוק', 'נוב', 'דצמ'],
      monthText: 'חודש',
      secText: 'שניות',
      amText: 'am',
      pmText: 'pm',
      timeFormat: 'HH:ii',
      timeWheels: 'iiHH',
      yearText: 'שנה',
      nowText: 'עכשיו',
      firstDay: 0,
      dateText: 'תאריך',
      timeText: 'זמן',
      closeText: 'סגירה',
      todayText: 'היום',
      allDayText: 'כל היום',
      noEventsText: 'אין אירועים',
      eventText: 'מִקרֶה',
      eventsText: 'מִקרֶה',
      moreEventsText: 'אירוע אחד נוסף',
      moreEventsPluralText: '{count} אירועים נוספים',
      fromText: 'התחלה',
      toText: 'סיום',
      wholeText: 'כֹּל',
      fractionText: 'שבריר',
      unitText: 'יחידה',
      labels: ['שנים', 'חודשים', 'ימים', 'שעות', 'דקות', 'שניים', ''],
      labelsShort: ['שנים', 'חודשים', 'ימים', 'שעות', 'דקות', 'שניים', ''],
      startText: 'התחל',
      stopText: 'עצור',
      resetText: 'אתחול',
      lapText: 'הקפה',
      hideText: 'הסתר',
      offText: 'כיבוי',
      onText: 'הפעלה',
      backText: 'חזור',
      undoText: 'ביטול פעולה',
    }),
    (Z.i18n.hi = {
      setText: 'सैट करें',
      cancelText: 'रद्द करें',
      clearText: 'साफ़ को',
      selectedText: '{count} चयनित',
      dateFormat: 'dd/mm/yy',
      dayNames: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार'],
      dayNamesShort: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
      dayNamesMin: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
      dayText: 'दिन',
      delimiter: '.',
      hourText: 'घंटा',
      minuteText: 'मिनट',
      monthNames: ['जनवरी ', 'फरवरी', 'मार्च', 'अप्रेल', 'मई', 'जून', 'जूलाई', 'अगस्त ', 'सितम्बर', 'अक्टूबर', 'नवम्बर', 'दिसम्बर'],
      monthNamesShort: ['जन', 'फर', 'मार्च', 'अप्रेल', 'मई', 'जून', 'जूलाई', 'अग', 'सित', 'अक्ट', 'नव', 'दि'],
      monthText: 'महीना',
      secText: 'सेकंड',
      timeFormat: 'H:ii',
      yearText: 'साल',
      nowText: 'अब',
      pmText: 'अपराह्न',
      amText: 'पूर्वाह्न',
      firstDay: 1,
      dateText: 'तिथि',
      timeText: 'समय',
      todayText: 'आज',
      prevMonthText: 'पिछ्ला महिना',
      nextMonthText: 'अगले महीने',
      prevYearText: 'पिछला साल',
      nextYearText: 'अगले वर्ष',
      closeText: 'बंद',
      eventText: 'इवेट३',
      eventsText: 'इवेट३',
      allDayText: 'पूरे दिन',
      noEventsText: 'Ei tapahtumia',
      moreEventsText: '{count} और',
      fromText: 'से',
      toText: 'तक',
      wholeText: 'समूचा',
      fractionText: 'अंश',
      unitText: 'इकाई',
      labels: ['साल', 'महीने', 'दिन', 'घंटे', 'मिनट', 'सेकंड', ''],
      labelsShort: ['साल', 'महीने', 'दिन', 'घंटे', 'मिनट', 'सेकंड', ''],
      startText: 'प्रारंभ',
      stopText: 'रोकें',
      resetText: 'रीसेट करें',
      lapText: 'लैप',
      hideText: 'छिपाना',
      backText: 'वापस',
      undoText: 'वापस लाएं',
      offText: 'बंद',
      onText: 'चालू',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.hr = {
      setText: 'Postavi',
      cancelText: 'Izlaz',
      clearText: 'Izbriši',
      selectedText: '{count} odabran',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Nedjelja', 'Ponedjeljak', 'Utorak', 'Srijeda', 'Četvrtak', 'Petak', 'Subota'],
      dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
      dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
      dayText: 'Dan',
      delimiter: '.',
      hourText: 'Sat',
      minuteText: 'Minuta',
      monthNames: [
        'Siječanj',
        'Veljača',
        'Ožujak',
        'Travanj',
        'Svibanj',
        'Lipanj',
        'Srpanj',
        'Kolovoz',
        'Rujan',
        'Listopad',
        'Studeni',
        'Prosinac',
      ],
      monthNamesShort: ['Sij', 'Velj', 'Ožu', 'Tra', 'Svi', 'Lip', 'Srp', 'Kol', 'Ruj', 'Lis', 'Stu', 'Pro'],
      monthText: 'Mjesec',
      secText: 'Sekunda',
      timeFormat: 'H:ii',
      yearText: 'Godina',
      nowText: 'Sada',
      pmText: 'pm',
      amText: 'am',
      firstDay: 1,
      dateText: 'Datum',
      timeText: 'Vrijeme',
      todayText: 'Danas',
      prevMonthText: 'Prethodni mjesec',
      nextMonthText: 'Sljedeći mjesec',
      prevYearText: 'Prethodni godina',
      nextYearText: 'Slijedeće godine',
      closeText: 'Zatvori',
      eventText: 'Događaj',
      eventsText: 'događaja',
      allDayText: 'Cijeli dan',
      noEventsText: 'Bez događaja',
      moreEventsText: 'Još {count}',
      fromText: 'Počinje',
      toText: 'Završava',
      wholeText: 'Cjelina',
      fractionText: 'Frakcija',
      unitText: 'Jedinica',
      labels: ['godina', 'mjesec', 'dan', 'sat', 'minuta', 'sekunda', ''],
      labelsShort: ['god', 'mje', 'dan', 'sat', 'min', 'sec', ''],
      startText: 'Početak',
      stopText: 'Prekid',
      resetText: 'Resetiraj',
      lapText: 'Ciklus',
      hideText: 'Sakriti',
      backText: 'Natrag',
      undoText: 'Poništavanje',
      offText: 'Uklj.',
      onText: 'Isklj.',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.hu = {
      setText: 'OK',
      cancelText: 'Mégse',
      clearText: 'Törlés',
      selectedText: '{count} kiválasztva',
      dateFormat: 'yy.mm.dd.',
      dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
      dayNamesShort: ['Va', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo'],
      dayNamesMin: ['V', 'H', 'K', 'Sz', 'Cs', 'P', 'Sz'],
      dayText: 'Nap',
      delimiter: '.',
      hourText: 'Óra',
      minuteText: 'Perc',
      monthNames: [
        'Január',
        'Február',
        'Március',
        'Április',
        'Május',
        'Június',
        'Július',
        'Augusztus',
        'Szeptember',
        'Október',
        'November',
        'December',
      ],
      monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
      monthText: 'Hónap',
      secText: 'Másodperc',
      timeFormat: 'H:ii',
      yearText: 'Év',
      nowText: 'Most',
      pmText: 'pm',
      amText: 'am',
      firstDay: 1,
      dateText: 'Dátum',
      timeText: 'Idő',
      todayText: 'Ma',
      prevMonthText: 'Előző hónap',
      nextMonthText: 'Következő hónap',
      prevYearText: 'Előző év',
      nextYearText: 'Következő év',
      closeText: 'Bezár',
      eventText: 'esemény',
      eventsText: 'esemény',
      allDayText: 'Egész nap',
      noEventsText: 'Nincs esemény',
      moreEventsText: '{count} további',
      fromText: 'Eleje',
      toText: 'Vége',
      wholeText: 'Egész',
      fractionText: 'Tört',
      unitText: 'Egység',
      labels: ['Év', 'Hónap', 'Nap', 'Óra', 'Perc', 'Másodperc', ''],
      labelsShort: ['Év', 'Hó.', 'Nap', 'Óra', 'Perc', 'Mp.', ''],
      startText: 'Indít',
      stopText: 'Megállít',
      resetText: 'Visszaállít',
      lapText: 'Lap',
      hideText: 'Elrejt',
      backText: 'Vissza',
      undoText: 'Visszavon',
      offText: 'Ki',
      onText: 'Be',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.it = {
      setText: 'OK',
      cancelText: 'Annulla',
      clearText: 'Chiarire',
      selectedText: '{count} selezionato',
      selectedPluralText: '{count} selezionati',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Domenica', 'Lunedì', 'Mertedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
      dayNamesShort: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
      dayText: 'Giorno',
      hourText: 'Ore',
      minuteText: 'Minuti',
      monthNames: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
      ],
      monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
      monthText: 'Mese',
      secText: 'Secondi',
      timeFormat: 'HH:ii',
      yearText: 'Anno',
      nowText: 'Ora',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Oggi',
      firstDay: 1,
      dateText: 'Data',
      timeText: 'Volta',
      closeText: 'Chiudere',
      allDayText: 'Tutto il giorno',
      noEventsText: 'Nessun evento',
      eventText: 'Evento',
      eventsText: 'Eventi',
      moreEventsText: '{count} altro',
      moreEventsPluralText: 'altri {count}',
      fromText: 'Inizio',
      toText: 'Fine',
      wholeText: 'Intero',
      fractionText: 'Frazione',
      unitText: 'Unità',
      labels: ['Anni', 'Mesi', 'Giorni', 'Ore', 'Minuti', 'Secondi', ''],
      labelsShort: ['Anni', 'Mesi', 'Gio', 'Ore', 'Min', 'Sec', ''],
      startText: 'Inizio',
      stopText: 'Arresto',
      resetText: 'Ripristina',
      lapText: 'Lap',
      hideText: 'Nascondi',
      backText: 'Indietro',
      undoText: 'Annulla',
      offText: 'Via',
      onText: 'Su',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.ja = {
      setText: 'セット',
      cancelText: 'キャンセル',
      clearText: 'クリア',
      selectedText: '{count} 選択',
      dateFormat: 'yy年mm月dd日',
      dayNames: ['日', '月', '火', '水', '木', '金', '土'],
      dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
      dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
      dayText: '日',
      hourText: '時',
      minuteText: '分',
      monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      monthText: '月',
      secText: '秒',
      timeFormat: 'HH:ii',
      yearText: '年',
      nowText: '今',
      pmText: '午後',
      amText: '午前',
      yearSuffix: '年',
      monthSuffix: '月',
      daySuffix: '日',
      todayText: '今日',
      dateText: '日付',
      timeText: '時間',
      closeText: 'クローズ',
      allDayText: '終日',
      noEventsText: 'イベントはありません',
      eventText: 'イベント',
      eventsText: 'イベント',
      moreEventsText: '他 {count} 件',
      fromText: '開始',
      toText: '終わり',
      wholeText: '全数',
      fractionText: '分数',
      unitText: '単位',
      labels: ['年間', '月間', '日間', '時間', '分', '秒', ''],
      labelsShort: ['年間', '月間', '日間', '時間', '分', '秒', ''],
      startText: '開始',
      stopText: '停止',
      resetText: 'リセット',
      lapText: 'ラップ',
      hideText: '隠す',
      backText: 'バック',
      undoText: 'アンドゥ',
    }),
    (Z.i18n.ko = {
      setText: '설정',
      cancelText: '취소',
      clearText: '삭제',
      selectedText: '{count} 선택된',
      dateFormat: 'yy년mm월dd일',
      dayNames: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
      dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
      dayText: '일',
      delimiter: '-',
      hourText: '시간',
      minuteText: '분',
      monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      monthText: '달',
      secText: '초',
      timeFormat: 'H:ii',
      yearText: '년',
      nowText: '지금',
      pmText: '오후',
      amText: '오전',
      yearSuffix: '년',
      monthSuffix: '월',
      daySuffix: '일',
      firstDay: 0,
      dateText: '날짜',
      timeText: '시간',
      todayText: '오늘',
      prevMonthText: '이전 달',
      nextMonthText: '다음 달',
      prevYearText: '이전 년',
      nextYearText: '다음 년',
      closeText: '닫기',
      eventText: '이벤트',
      eventsText: '이벤트',
      allDayText: '종일',
      noEventsText: '이벤트 없음',
      moreEventsText: '{count}개 더보기',
      fromText: '시작',
      toText: '종료',
      wholeText: '정수',
      fractionText: '분수',
      unitText: '단위',
      labels: ['년', '달', '일', '시간', '분', '초', ''],
      labelsShort: ['년', '달', '일', '시간', '분', '초', ''],
      startText: '시작',
      stopText: '중지 ',
      resetText: '초기화',
      lapText: '기록',
      hideText: '숨는 장소',
      backText: '뒤로',
      undoText: '실행취소',
      offText: '끔',
      onText: '켬',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.lt = {
      setText: 'OK',
      cancelText: 'Atšaukti',
      clearText: 'Išvalyti',
      selectedText: 'Pasirinktas {count}',
      selectedPluralText: 'Pasirinkti {count}',
      dateFormat: 'yy-mm-dd',
      dayNames: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
      dayNamesShort: ['S', 'Pr', 'A', 'T', 'K', 'Pn', 'Š'],
      dayNamesMin: ['S', 'Pr', 'A', 'T', 'K', 'Pn', 'Š'],
      dayText: 'Diena',
      hourText: 'Valanda',
      minuteText: 'Minutes',
      monthNames: [
        'Sausis',
        'Vasaris',
        'Kovas',
        'Balandis',
        'Gegužė',
        'Birželis',
        'Liepa',
        'Rugpjūtis',
        'Rugsėjis',
        'Spalis',
        'Lapkritis',
        'Gruodis',
      ],
      monthNamesShort: ['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rugp', 'Rugs', 'Spa', 'Lap', 'Gruo'],
      monthText: 'Mėnuo',
      secText: 'Sekundes',
      amText: 'am',
      pmText: 'pm',
      timeFormat: 'HH:ii',
      yearText: 'Metai',
      nowText: 'Dabar',
      todayText: 'Šiandien',
      firstDay: 1,
      dateText: 'Data',
      timeText: 'Laikas',
      closeText: 'Uždaryti',
      allDayText: 'Visą dieną',
      noEventsText: 'Nėra įvykių',
      eventText: 'Įvykių',
      eventsText: 'Įvykiai',
      moreEventsText: 'Dar {count}',
      fromText: 'Nuo',
      toText: 'Iki',
      wholeText: 'Visas',
      fractionText: 'Frakcija',
      unitText: 'Vienetas',
      labels: ['Metai', 'Mėnesiai', 'Dienos', 'Valandos', 'Minutes', 'Sekundes', ''],
      labelsShort: ['m', 'mėn.', 'd', 'h', 'min', 's', ''],
      startText: 'Pradėti',
      stopText: 'Sustabdyti',
      resetText: 'Išnaujo',
      lapText: 'Ratas',
      hideText: 'Slėpti',
      backText: 'Atgal',
      undoText: 'Anuliuoti',
      offText: 'Išj.',
      onText: 'Įj.',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.nl = {
      setText: 'Instellen',
      cancelText: 'Annuleren',
      clearText: 'Leegmaken',
      selectedText: '{count} gekozen',
      dateFormat: 'dd-mm-yy',
      dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
      dayNamesShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
      dayNamesMin: ['z', 'm', 'd', 'w', 'd', 'v', 'z'],
      dayText: 'Dag',
      hourText: 'Uur',
      minuteText: 'Minuten',
      monthNames: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december',
      ],
      monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      monthText: 'Maand',
      secText: 'Seconden',
      timeFormat: 'HH:ii',
      yearText: 'Jaar',
      nowText: 'Nu',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Vandaag',
      firstDay: 1,
      dateText: 'Datum',
      timeText: 'Tijd',
      closeText: 'Sluiten',
      allDayText: 'Hele dag',
      noEventsText: 'Geen activiteiten',
      eventText: 'Activiteit',
      eventsText: 'Activiteiten',
      moreEventsText: 'nog {count}',
      fromText: 'Start',
      toText: 'Einde',
      wholeText: 'geheel',
      fractionText: 'fractie',
      unitText: 'eenheid',
      labels: ['Jaren', 'Maanden', 'Dagen', 'Uren', 'Minuten', 'Seconden', ''],
      labelsShort: ['j', 'm', 'd', 'u', 'min', 'sec', ''],
      startText: 'Start',
      stopText: 'Stop',
      resetText: 'Reset',
      lapText: 'Ronde',
      hideText: 'Verbergen',
      backText: 'Terug',
      undoText: 'Onged. maken',
      offText: 'Uit',
      onText: 'Aan',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.no = {
      setText: 'OK',
      cancelText: 'Avbryt',
      clearText: 'Tømme',
      selectedText: '{count} valgt',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
      dayNamesShort: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
      dayNamesMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
      dayText: 'Dag',
      delimiter: '.',
      hourText: 'Time',
      minuteText: 'Minutt',
      monthNames: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
      monthText: 'Måned',
      secText: 'Sekund',
      timeFormat: 'HH:ii',
      yearText: 'År',
      nowText: 'Nå',
      pmText: 'pm',
      amText: 'am',
      todayText: 'I dag',
      firstDay: 1,
      dateText: 'Dato',
      timeText: 'Tid',
      closeText: 'Lukk',
      allDayText: 'Hele dagen',
      noEventsText: 'Ingen hendelser',
      eventText: 'Hendelse',
      eventsText: 'Hendelser',
      moreEventsText: '{count} mere',
      fromText: 'Start',
      toText: 'End',
      wholeText: 'Hele',
      fractionText: 'Fraksjon',
      unitText: 'Enhet',
      labels: ['År', 'Måneder', 'Dager', 'Timer', 'Minutter', 'Sekunder', ''],
      labelsShort: ['År', 'Mån', 'Dag', 'Time', 'Min', 'Sek', ''],
      startText: 'Start',
      stopText: 'Stopp',
      resetText: 'Tilbakestille',
      lapText: 'Runde',
      hideText: 'Skjul',
      backText: 'Tilbake',
      undoText: 'Angre',
      offText: 'Av',
      onText: 'På',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.pl = {
      setText: 'Zestaw',
      cancelText: 'Anuluj',
      clearText: 'Oczyścić',
      selectedText: 'Wybór: {count}',
      dateFormat: 'yy-mm-dd',
      dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
      dayNamesShort: ['Niedz.', 'Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.'],
      dayNamesMin: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
      dayText: 'Dzień',
      hourText: 'Godziny',
      minuteText: 'Minuty',
      monthNames: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
      ],
      monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
      monthText: 'Miesiąc',
      secText: 'Sekundy',
      timeFormat: 'HH:ii',
      yearText: 'Rok',
      nowText: 'Teraz',
      amText: 'am',
      pmText: 'pm',
      todayText: 'Dzisiaj',
      firstDay: 1,
      dateText: 'Data',
      timeText: 'Czas',
      closeText: 'Zakończenie',
      allDayText: 'Cały dzień',
      noEventsText: 'Brak wydarzeń',
      eventText: 'Wydarzeń',
      eventsText: 'Wydarzenia',
      moreEventsText: 'Jeszcze {count}',
      fromText: 'Rozpoczęcie',
      toText: 'Koniec',
      wholeText: 'Cały',
      fractionText: 'Ułamek',
      unitText: 'Jednostka',
      labels: ['Lata', 'Miesiąc', 'Dni', 'Godziny', 'Minuty', 'Sekundy', ''],
      labelsShort: ['R', 'M', 'Dz', 'Godz', 'Min', 'Sek', ''],
      startText: 'Rozpoczęcie',
      stopText: 'Zatrzymać',
      resetText: 'Zresetować',
      lapText: 'Zakładka',
      hideText: 'Ukryć',
      backText: 'Wróć',
      undoText: 'Cofnij',
      offText: 'Wył',
      onText: 'Wł',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n['pt-BR'] = {
      setText: 'Selecionar',
      cancelText: 'Cancelar',
      clearText: 'Claro',
      selectedText: '{count} selecionado',
      selectedPluralText: '{count} selecionados',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      dayText: 'Dia',
      hourText: 'Hora',
      minuteText: 'Minutos',
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      monthText: 'Mês',
      secText: 'Segundo',
      timeFormat: 'HH:ii',
      yearText: 'Ano',
      nowText: 'Agora',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Hoje',
      dateText: 'Data',
      timeText: 'Tempo',
      closeText: 'Fechar',
      allDayText: 'Dia inteiro',
      noEventsText: 'Nenhum evento',
      eventText: 'Evento',
      eventsText: 'Eventos',
      moreEventsText: 'Mais {count}',
      fromText: 'In&iacute;cio',
      toText: 'Fim',
      wholeText: 'Inteiro',
      fractionText: 'Fração',
      unitText: 'Unidade',
      labels: ['Anos', 'Meses', 'Dias', 'Horas', 'Minutos', 'Segundos', ''],
      labelsShort: ['Ano', 'M&ecirc;s', 'Dia', 'Hora', 'Min', 'Seg', ''],
      startText: 'Começar',
      stopText: 'Pare',
      resetText: 'Reinicializar',
      lapText: 'Lap',
      hideText: 'Esconder',
      backText: 'Anterior',
      undoText: 'Desfazer',
      offText: 'Desl',
      onText: 'Lig',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n['pt-PT'] = {
      setText: 'Seleccionar',
      cancelText: 'Cancelar',
      clearText: 'Claro',
      selectedText: '{count} selecionado',
      selectedPluralText: '{count} selecionados',
      dateFormat: 'dd-mm-yy',
      dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      dayText: 'Dia',
      hourText: 'Horas',
      minuteText: 'Minutos',
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      monthText: 'Mês',
      secText: 'Segundo',
      timeFormat: 'HH:ii',
      yearText: 'Ano',
      nowText: 'Actualizar',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Hoy',
      firstDay: 1,
      dateText: 'Data',
      timeText: 'Tempo',
      closeText: 'Fechar',
      allDayText: 'Todo o dia',
      noEventsText: 'Nenhum evento',
      eventText: 'Evento',
      eventsText: 'Eventos',
      moreEventsText: 'mais {count}',
      fromText: 'Início',
      toText: 'Fim',
      wholeText: 'Inteiro',
      fractionText: 'Fracção',
      unitText: 'Unidade',
      labels: ['Anos', 'Meses', 'Dias', 'Horas', 'Minutos', 'Segundos', ''],
      labelsShort: ['Ano', 'Mês', 'Dia', 'Hora', 'Min', 'Seg', ''],
      startText: 'Começar',
      stopText: 'Parar',
      resetText: 'Reinicializar',
      lapText: 'Lap',
      hideText: 'Esconder',
      backText: 'Anterior',
      undoText: 'Anular',
      offText: 'Desl',
      onText: 'Lig',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.ro = {
      setText: 'Setare',
      cancelText: 'Anulare',
      clearText: 'Ştergere',
      selectedText: '{count} selectat',
      selectedPluralText: '{count} selectate',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
      dayNamesShort: ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      dayText: ' Ziua',
      delimiter: '.',
      hourText: ' Ore ',
      minuteText: 'Minute',
      monthNames: [
        'Ianuarie',
        'Februarie',
        'Martie',
        'Aprilie',
        'Mai',
        'Iunie',
        'Iulie',
        'August',
        'Septembrie',
        'Octombrie',
        'Noiembrie',
        'Decembrie',
      ],
      monthNamesShort: ['Ian.', 'Feb.', 'Mar.', 'Apr.', 'Mai', 'Iun.', 'Iul.', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'],
      monthText: 'Luna',
      secText: 'Secunde',
      timeFormat: 'HH:ii',
      yearText: 'Anul',
      nowText: 'Acum',
      amText: 'am',
      pmText: 'pm',
      todayText: 'Astăzi',
      prevMonthText: 'Luna anterioară',
      nextMonthText: 'Luna următoare',
      prevYearText: 'Anul anterior',
      nextYearText: 'Anul următor',
      eventText: 'Eveniment',
      eventsText: 'Evenimente',
      allDayText: 'Toată ziua',
      noEventsText: 'Niciun eveniment',
      moreEventsText: 'Încă unul',
      moreEventsPluralText: 'Încă {count}',
      firstDay: 1,
      dateText: 'Data',
      timeText: 'Ora',
      closeText: 'Închidere',
      fromText: 'Start',
      toText: 'Final',
      wholeText: 'Complet',
      fractionText: 'Parţial',
      unitText: 'Unitate',
      labels: ['Ani', 'Luni', 'Zile', 'Ore', 'Minute', 'Secunde', ''],
      labelsShort: ['Ani', 'Luni', 'Zile', 'Ore', 'Min.', 'Sec.', ''],
      startText: 'Start',
      stopText: 'Stop',
      resetText: 'Resetare',
      lapText: 'Tură',
      hideText: 'Ascundere',
      backText: 'Înapoi',
      undoText: 'Anulează',
      offText: 'Nu',
      onText: 'Da',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n['ru-UA'] = {
      setText: 'Установить',
      cancelText: 'Отменить',
      clearText: 'Очиститьr',
      selectedText: '{count} Вібрать',
      dateFormat: 'dd.mm.yy',
      dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
      dayNamesShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      dayNamesMin: ['в', 'п', 'в', 'с', 'ч', 'п', 'с'],
      dayText: 'День',
      delimiter: '.',
      hourText: 'Часы',
      minuteText: 'Минуты',
      monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      monthNamesShort: ['Янв.', 'Февр.', 'Март', 'Апр.', 'Май', 'Июнь', 'Июль', 'Авг.', 'Сент.', 'Окт.', 'Нояб.', 'Дек.'],
      monthText: 'Месяцы',
      secText: 'Сикунды',
      timeFormat: 'HH:ii',
      yearText: 'Год',
      nowText: 'Сейчас',
      amText: 'am',
      pmText: 'pm',
      todayText: 'Cегодня',
      firstDay: 1,
      dateText: 'Дата',
      timeText: 'Время',
      closeText: 'Закрыть',
      allDayText: 'Весь день',
      noEventsText: 'Нет событий',
      eventText: 'Мероприятия',
      eventsText: 'Мероприятия',
      moreEventsText: 'Ещё {count}',
      fromText: 'Начало',
      toText: 'Конец',
      wholeText: 'Весь',
      fractionText: 'Часть',
      unitText: 'Единица',
      labels: ['Годы', ' Месяцы ', ' Дни ', ' Часы ', ' Минуты ', ' Секунды', ''],
      labelsShort: ['Год', 'Мес.', 'Дн.', 'Ч.', 'Мин.', 'Сек.', ''],
      startText: 'Старт',
      stopText: 'Стоп',
      resetText: ' Сброс ',
      lapText: ' Этап ',
      hideText: ' Скрыть ',
      backText: 'назад',
      undoText: 'ОтменитЬ',
      offText: 'O',
      onText: 'I',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n['ru-RU'] = Z.i18n.ru =
      {
        setText: 'Установить',
        cancelText: 'Отмена',
        clearText: 'Очистить',
        selectedText: '{count} Выбрать',
        dateFormat: 'dd.mm.yy',
        dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
        dayNamesShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        dayNamesMin: ['в', 'п', 'в', 'с', 'ч', 'п', 'с'],
        dayText: 'День',
        delimiter: '.',
        hourText: 'Час',
        minuteText: 'Минут',
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        monthText: 'Месяц',
        secText: 'Секунд',
        timeFormat: 'HH:ii',
        yearText: 'Год',
        nowText: 'Сейчас',
        amText: 'am',
        pmText: 'pm',
        todayText: 'Cегодня',
        firstDay: 1,
        dateText: 'Дата',
        timeText: 'Время',
        closeText: 'Закрыть',
        allDayText: 'Весь день',
        noEventsText: 'Нет событий',
        eventText: 'Мероприятия',
        eventsText: 'Мероприятия',
        moreEventsText: 'Ещё {count}',
        fromText: 'Начало',
        toText: 'Конец',
        wholeText: 'Целое',
        fractionText: 'Дробное',
        unitText: 'Единица',
        labels: ['Лет', 'Месяцев', 'Дней', 'Часов', 'Минут', 'Секунд', ''],
        labelsShort: ['Лет', 'Мес', 'Дн', 'Час', 'Мин', 'Сек', ''],
        startText: 'Старт',
        stopText: 'Стоп',
        resetText: 'Сбросить',
        lapText: 'Круг',
        hideText: 'Скрыть',
        backText: 'назад',
        undoText: 'ОтменитЬ',
        offText: 'O',
        onText: 'I',
        decimalSeparator: ',',
        thousandsSeparator: ' ',
      }),
    (Z.i18n.sk = {
      setText: 'Zadaj',
      cancelText: 'Zrušiť',
      clearText: 'Vymazať',
      selectedText: 'Označený: {count}',
      dateFormat: 'd.m.yy',
      dayNames: ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
      dayNamesShort: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
      dayNamesMin: ['N', 'P', 'U', 'S', 'Š', 'P', 'S'],
      dayText: 'Ďeň',
      hourText: 'Hodiny',
      minuteText: 'Minúty',
      monthNames: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
      monthText: 'Mesiac',
      secText: 'Sekundy',
      timeFormat: 'H:ii',
      yearText: 'Rok',
      nowText: 'Teraz',
      amText: 'am',
      pmText: 'pm',
      todayText: 'Dnes',
      firstDay: 1,
      dateText: 'Datum',
      timeText: 'Čas',
      closeText: 'Zavrieť',
      allDayText: 'Celý deň',
      noEventsText: 'Žiadne udalosti',
      eventText: 'Udalostí',
      eventsText: 'Udalosti',
      moreEventsText: '{count} ďalšia',
      moreEventsPluralText: '{count} ďalšie',
      fromText: 'Začiatok',
      toText: 'Koniec',
      wholeText: 'Celý',
      fractionText: 'Časť',
      unitText: 'Jednotka',
      labels: ['Roky', 'Mesiace', 'Dni', 'Hodiny', 'Minúty', 'Sekundy', ''],
      labelsShort: ['Rok', 'Mes', 'Dni', 'Hod', 'Min', 'Sec', ''],
      startText: 'Start',
      stopText: 'Stop',
      resetText: 'Resetovať',
      lapText: 'Etapa',
      hideText: 'Schovať',
      backText: 'Späť',
      undoText: 'Späť',
      offText: 'O',
      onText: 'I',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.sr = {
      setText: 'Постави',
      cancelText: 'Откажи',
      clearText: 'Обриши',
      selectedText: '{count} изабрана',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Недеља', 'Понедељак', 'Уторак', 'Среда', 'Четвртак', 'Петак', 'Субота'],
      dayNamesShort: ['Нед', 'Пон', 'Уто', 'Сре', 'Чет', 'Пет', 'Суб'],
      dayNamesMin: ['Не', 'По', 'Ут', 'Ср', 'Че', 'Пе', 'Су'],
      dayText: 'Дан',
      delimiter: '.',
      hourText: 'Час',
      minuteText: 'Минут',
      monthNames: ['Јануар', 'Фебруар', 'Март', 'Април', 'Мај', 'Јун', 'Јул', 'Август', 'Септембар', 'Октобар', 'Новембар', 'Децембар'],
      monthNamesShort: ['Јан', 'Феб', 'Мар', 'Апр', 'Мај', 'Јун', 'Јул', 'Авг', 'Сеп', 'Окт', 'Нов', 'Дец'],
      monthText: 'месец',
      secText: 'Секунд',
      timeFormat: 'H:ii',
      yearText: 'година',
      nowText: 'сада',
      pmText: 'pm',
      amText: 'am',
      firstDay: 1,
      dateText: 'Датум',
      timeText: 'време',
      todayText: 'Данас',
      prevMonthText: 'Претходни мјесец',
      nextMonthText: 'Следећег месеца',
      prevYearText: 'Претходна године',
      nextYearText: 'Следеће године',
      closeText: 'Затвори',
      eventText: 'Догађај',
      eventsText: 'Догађаји',
      allDayText: 'Цео дан',
      noEventsText: 'Нема догађаја',
      moreEventsText: 'Још {count}',
      fromText: 'Од',
      toText: 'До',
      wholeText: 'цео',
      fractionText: 'Фракција',
      unitText: 'единица',
      labels: ['Године', 'Месеци', 'Дана', 'Сати', 'Минута', 'Секунди', ''],
      labelsShort: ['Год', 'Мес', 'Дана', 'Сати', 'Мину', 'Секу', ''],
      startText: 'Започни',
      stopText: 'Стоп',
      resetText: 'Ресетуј',
      lapText: 'Круг',
      hideText: 'Сакрити',
      backText: 'Повратак',
      undoText: 'Опозови',
      offText: 'нe',
      onText: 'да',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.sv = {
      setText: 'OK',
      cancelText: 'Avbryt',
      clearText: 'Klara',
      selectedText: '{count} vald',
      dateFormat: 'yy-mm-dd',
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      dayNamesMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
      dayText: 'Dag',
      hourText: 'Timme',
      minuteText: 'Minut',
      monthNames: [
        'Januari',
        'Februari',
        'Mars',
        'April',
        'Maj',
        'Juni',
        'Juli',
        'Augusti',
        'September',
        'Oktober',
        'November',
        'December',
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
      monthText: 'Månad',
      secText: 'Sekund',
      timeFormat: 'HH:ii',
      yearText: 'År',
      nowText: 'Nu',
      pmText: 'pm',
      amText: 'am',
      todayText: 'I dag',
      firstDay: 1,
      dateText: 'Datum',
      timeText: 'Tid',
      closeText: 'Stäng',
      allDayText: 'Heldag',
      noEventsText: 'Inga aktiviteter',
      eventText: 'Händelse',
      eventsText: 'Händelser',
      moreEventsText: '{count} till',
      fromText: 'Start',
      toText: 'Slut',
      wholeText: 'Hela',
      fractionText: 'Bråk',
      unitText: 'Enhet',
      labels: ['År', 'Månader', 'Dagar', 'Timmar', 'Minuter', 'Sekunder', ''],
      labelsShort: ['År', 'Mån', 'Dag', 'Tim', 'Min', 'Sek', ''],
      startText: 'Start',
      stopText: 'Stopp',
      resetText: 'Återställ',
      lapText: 'Varv',
      hideText: 'Dölj',
      backText: 'Tillbaka',
      undoText: 'Ångra',
      offText: 'Av',
      onText: 'På',
    }),
    (Z.i18n.th = {
      setText: 'ตั้งค่า',
      cancelText: 'ยกเลิก',
      clearText: 'ล้าง',
      selectedText: '{count} เลือก',
      dateFormat: 'dd/mm/yy',
      dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
      dayNamesShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
      dayNamesMin: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
      dayText: 'วัน',
      delimiter: '.',
      hourText: 'ชั่วโมง',
      minuteText: 'นาที',
      monthNames: [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม',
      ],
      monthNamesShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
      monthText: 'เดือน',
      secText: 'วินาที',
      timeFormat: 'HH:ii',
      yearText: 'ปี',
      nowText: 'ตอนนี้',
      pmText: 'pm',
      amText: 'am',
      firstDay: 0,
      dateText: 'วัน',
      timeText: 'เวลา',
      today: 'วันนี้',
      prevMonthText: 'เดือนก่อนหน้า',
      nextMonthText: 'เดือนถัดไป',
      prevYearText: 'ปีก่อนหน้า',
      nextYearText: 'ปีถัดไป',
      closeText: 'ปิด',
      eventText: 'เหตุการณ์',
      eventsText: 'เหตุการณ์',
      allDayText: 'ตลอดวัน',
      noEventsText: 'ไม่มีกิจกรรม',
      moreEventsText: 'อีก {count} กิจกรรม',
      fromText: 'จาก',
      toText: 'ถึง',
      wholeText: 'ทั้งหมด',
      fractionText: 'เศษส่วน',
      unitText: 'หน่วย',
      labels: ['ปี', 'เดือน', 'วัน', 'ชั่วโมง', 'นาที', 'วินาที', ''],
      labelsShort: ['ปี', 'เดือน', 'วัน', 'ชั่วโมง', 'นาที', 'วินาที', ''],
      startText: 'เริ่ม',
      stopText: 'หยุด',
      resetText: 'รีเซ็ต',
      lapText: 'รอบ',
      hideText: 'ซ่อน',
      backText: 'ย้อนกลับ',
      undoText: 'เลิกทา',
      offText: 'ปิด',
      onText: 'เปิด',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.tr = {
      setText: 'Seç',
      cancelText: 'İptal',
      clearText: 'Temizleyin',
      selectedText: '{count} seçilmiş',
      dateFormat: 'dd.mm.yy',
      dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
      dayNamesShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
      dayNamesMin: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
      dayText: 'Gün',
      delimiter: '.',
      hourText: 'Saat',
      minuteText: 'Dakika',
      monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
      monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
      monthText: 'Ay',
      secText: 'Saniye',
      timeFormat: 'HH:ii',
      yearText: 'Yıl',
      nowText: 'Şimdi',
      pmText: 'pm',
      amText: 'am',
      todayText: 'Bugün',
      firstDay: 1,
      dateText: 'Tarih',
      timeText: 'Zaman',
      closeText: 'Kapatmak',
      allDayText: 'Tüm gün',
      noEventsText: 'Etkinlik Yok',
      eventText: 'Etkinlik',
      eventsText: 'Etkinlikler',
      moreEventsText: '{count} tane daha',
      fromText: 'Başla',
      toText: 'Son',
      wholeText: 'Tam',
      fractionText: 'Kesir',
      unitText: 'Birim',
      labels: ['Yıl', 'Ay', 'Gün', 'Saat', 'Dakika', 'Saniye', ''],
      labelsShort: ['Yıl', 'Ay', 'Gün', 'Sa', 'Dak', 'Sn', ''],
      startText: 'Başla',
      stopText: 'Durdur',
      resetText: 'Sıfırla',
      lapText: 'Tur',
      hideText: 'Gizle',
      backText: 'Geri',
      undoText: 'Geri Al',
      offText: 'O',
      onText: 'I',
      decimalSeparator: ',',
      thousandsSeparator: '.',
    }),
    (Z.i18n.ua = {
      setText: 'встановити',
      cancelText: 'відміна',
      clearText: 'очистити',
      selectedText: '{count} вибрані',
      dateFormat: 'dd.mm.yy',
      dayNames: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п’ятниця', 'субота'],
      dayNamesShort: ['нед', 'пнд', 'вів', 'срд', 'чтв', 'птн', 'сбт'],
      dayNamesMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      dayText: 'День',
      delimiter: '.',
      hourText: 'година',
      minuteText: 'хвилина',
      monthNames: [
        'Січень',
        'Лютий',
        'Березень',
        'Квітень',
        'Травень',
        'Червень',
        'Липень',
        'Серпень',
        'Вересень',
        'Жовтень',
        'Листопад',
        'Грудень',
      ],
      monthNamesShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
      monthText: 'Місяць',
      secText: 'Секунд',
      timeFormat: 'H:ii',
      yearText: 'Рік',
      nowText: 'Зараз',
      pmText: 'pm',
      amText: 'am',
      firstDay: 1,
      dateText: 'дата',
      timeText: 'Час',
      todayText: 'Сьогодні',
      prevMonthText: 'Попередній місяць',
      nextMonthText: 'Наступного місяця',
      prevYearText: 'Попередній рік',
      nextYearText: 'Наступного року',
      closeText: 'Закрити',
      eventText: 'подія',
      eventsText: 'події',
      allDayText: 'Увесь день',
      noEventsText: 'Жодної події',
      moreEventsText: 'та ще {count}',
      fromText: 'від',
      toText: 'кінець',
      wholeText: 'всі',
      fractionText: 'фракція',
      unitText: 'одиниця',
      labels: ['Рік', 'Місяць', 'День', 'година', 'хвилина', 'Секунд', ''],
      labelsShort: ['Рік', 'Місяць', 'День', 'година', 'хвилина', 'Секунд', ''],
      startText: 'Початок',
      stopText: 'СТОП',
      resetText: 'скинути',
      lapText: 'коло',
      hideText: 'сховати',
      backText: 'назад',
      undoText: 'відмінити',
      offText: 'Вимикати',
      onText: 'Увімкнути',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.vi = {
      setText: 'Đặt',
      cancelText: 'Hủy bò',
      clearText: 'Xóa',
      selectedText: '{count} chọn',
      dateFormat: 'dd/mm/yy',
      dayNames: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
      dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
      dayNamesMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
      dayText: '',
      delimiter: '/',
      hourText: 'Giờ',
      minuteText: 'Phút',
      monthNames: [
        'Tháng Một',
        'Tháng Hai',
        'Tháng Ba',
        'Tháng Tư',
        'Tháng Năm',
        'Tháng Sáu',
        'Tháng Bảy',
        'Tháng Tám',
        'Tháng Chín',
        'Tháng Mười',
        'Tháng Mười Một',
        'Tháng Mười Hai',
      ],
      monthNamesShort: [
        'Tháng 1',
        'Tháng 2',
        'Tháng 3',
        'Tháng 4',
        'Tháng 5',
        'Tháng 6',
        'Tháng 7',
        'Tháng 8',
        'Tháng 9',
        'Tháng 10',
        'Tháng 11',
        'Tháng 12',
      ],
      monthText: 'Tháng',
      secText: 'Giây',
      timeFormat: 'H:ii',
      yearText: 'Năm',
      nowText: 'Bây giờ',
      pmText: 'pm',
      amText: 'am',
      firstDay: 0,
      dateText: 'Ngày',
      timeText: 'Hồi',
      todayText: 'Hôm nay',
      prevMonthText: 'Tháng trước',
      nextMonthText: 'Tháng tới',
      prevYearText: 'Măm trước',
      nextYearText: 'Năm tới',
      closeText: 'Đóng',
      eventText: 'Sự kiện',
      eventsText: 'Sự kiện',
      allDayText: 'Cả ngày',
      noEventsText: 'Không có sự kiện',
      moreEventsText: '{count} thẻ khác',
      fromText: 'Từ',
      toText: 'Tới',
      wholeText: 'Toàn thể',
      fractionText: 'Phân số',
      unitText: 'đơn vị',
      labels: ['Năm', 'Tháng', 'Ngày', 'Giờ', 'Phút', 'Giây', ''],
      labelsShort: ['Năm', 'Tháng', 'Ngày', 'Giờ', 'Phút', 'Giây', ''],
      startText: 'Bắt đầu',
      stopText: 'Dừng',
      resetText: 'Đặt lại',
      lapText: 'Vòng',
      hideText: 'Giấu',
      backText: 'Quay lại',
      undoText: 'Hoàn tác',
      offText: 'Tất',
      onText: 'Bật',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }),
    (Z.i18n.zh = {
      setText: '确定',
      cancelText: '取消',
      clearText: '明确',
      selectedText: '{count} 选',
      dateFormat: 'yy年mm月d日',
      dayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
      dayNamesMin: ['日', '一', '二', '三', '四', '五', '六'],
      dayText: '日',
      hourText: '时',
      minuteText: '分',
      monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      monthNamesShort: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
      monthText: '月',
      secText: '秒',
      timeFormat: 'HH:ii',
      yearText: '年',
      nowText: '当前',
      pmText: '下午',
      amText: '上午',
      yearSuffix: '年',
      monthSuffix: '月',
      daySuffix: '日',
      todayText: '今天',
      dateText: '日',
      timeText: '时间',
      closeText: '关闭',
      allDayText: '全天',
      noEventsText: '无事件',
      eventText: '活动',
      eventsText: '活动',
      moreEventsText: '他 {count} 件',
      fromText: '开始时间',
      toText: '结束时间',
      wholeText: '合计',
      fractionText: '分数',
      unitText: '单位',
      labels: ['年', '月', '日', '小时', '分钟', '秒', ''],
      labelsShort: ['年', '月', '日', '点', '分', '秒', ''],
      startText: '开始',
      stopText: '停止',
      resetText: '重置',
      lapText: '圈',
      hideText: '隐藏',
      backText: '返回',
      undoText: '复原',
      offText: '关闭',
      onText: '开启',
      decimalSeparator: ',',
      thousandsSeparator: ' ',
    }))
  var vr = Z.themes
  ;((vr.frame.bootstrap = {
    disabledClass: 'disabled',
    selectedClass: 'btn-primary',
    selectedTabClass: 'active',
    tabLink: !0,
    todayClass: 'text-primary mbsc-cal-today',
    onMarkupInserted: function (e) {
      var t = pa(e.target),
        a = pa('.mbsc-cal-tabs', t)
      ;(pa('.mbsc-fr-popup', t).addClass('popover'),
        pa('.mbsc-fr-w', t).addClass('popover-content'),
        pa('.mbsc-fr-hdr', t).addClass('popover-title popover-header'),
        pa('.mbsc-fr-arr-i', t).addClass('popover'),
        pa('.mbsc-fr-arr', t).addClass('arrow'),
        pa('.mbsc-fr-btn', t).addClass('btn btn-default btn-secondary'),
        pa('.mbsc-fr-btn-s .mbsc-fr-btn', t).removeClass('btn-default btn-secondary').addClass('btn btn-primary'),
        a.addClass('nav nav-tabs'),
        a.find('.mbsc-cal-tab').addClass('nav-item'),
        a.find('a').addClass('nav-link'),
        a.find('.mbsc-cal-tab.active .nav-link').addClass('active'),
        pa('.mbsc-cal-picker', t).addClass('popover'),
        pa('.mbsc-range-btn', t).addClass('btn btn-sm btn-small btn-default'),
        pa('.mbsc-np-btn', t).addClass('btn btn-default'),
        pa('.mbsc-sel-filter-cont', t).removeClass('mbsc-input'),
        pa('.mbsc-sel-filter-input', t).addClass('form-control'))
    },
    onTabChange: function (e, t) {
      ;(pa('.mbsc-cal-tabs .nav-link', t._markup).removeClass('active'), pa('.mbsc-cal-tab.active .nav-link', t._markup).addClass('active'))
    },
    onPosition: function (e) {
      setTimeout(function () {
        ;(pa('.mbsc-fr-bubble-top, .mbsc-fr-bubble-top .mbsc-fr-arr-i', e.target)
          .removeClass('bottom bs-popover-bottom')
          .addClass('top bs-popover-top'),
          pa('.mbsc-fr-bubble-bottom, .mbsc-fr-bubble-bottom .mbsc-fr-arr-i', e.target)
            .removeClass('top bs-popover-top')
            .addClass('bottom  bs-popover-bottom'))
      }, 10)
    },
  }),
    (vr.scroller.bootstrap = va({}, vr.frame.bootstrap, {
      dateDisplay: 'Mddyy',
      btnCalPrevClass: 'mbsc-ic mbsc-ic-arrow-left5',
      btnCalNextClass: 'mbsc-ic mbsc-ic-arrow-right5',
      btnPlusClass: 'mbsc-ic mbsc-ic-arrow-down5 btn-light',
      btnMinusClass: 'mbsc-ic mbsc-ic-arrow-up5 btn-light',
      selectedLineHeight: !0,
      onEventBubbleShow: function (e) {
        var t = pa(e.eventList)
        ;(pa('.mbsc-cal-event-list', t).addClass('list-group'), pa('.mbsc-cal-event', t).addClass('list-group-item'))
      },
    })),
    (vr.navigation.bootstrap = {
      wrapperClass: 'popover panel panel-default',
      groupClass: 'btn-group',
      activeClass: 'btn-primary',
      disabledClass: 'disabled',
      itemClass: 'btn btn-default',
    }),
    (vr.form.bootstrap = {}))
  var br = Z.themes
  function gr(e, t) {
    var a = ua(t, 'X', !0),
      n = ua(t, 'Y', !0),
      s = e[0],
      i = e.offset(),
      r = a - i.left,
      o = n - i.top,
      l = Math.max(r, s.offsetWidth - r),
      c = Math.max(o, s.offsetHeight - o),
      d = 2 * Math.sqrt(Math.pow(l, 2) + Math.pow(c, 2))
    ;(xr(Cr),
      (Cr = pa('<span class="mbsc-ripple"></span>')
        .css({ backgroundColor: getComputedStyle(s).color, width: d, height: d, top: n - i.top - d / 2, left: a - i.left - d / 2 })
        .appendTo(e)),
      setTimeout(function () {
        Cr.addClass('mbsc-ripple-scaled mbsc-ripple-visible')
      }, 10))
  }
  function xr(e) {
    setTimeout(function () {
      e &&
        (e.removeClass('mbsc-ripple-visible'),
        setTimeout(function () {
          e.remove()
        }, 2e3))
    }, 100)
  }
  function Tr(e, t, a, n) {
    var s, i
    e.off('.mbsc-ripple')
      .on('touchstart.mbsc-ripple mousedown.mbsc-ripple', t, function (e) {
        ga(e, this) && ((s = ua(e, 'X')), (i = ua(e, 'Y')), (yr = pa(this)).hasClass(a) || yr.hasClass(n) ? (yr = null) : gr(yr, e))
      })
      .on('touchmove.mbsc-ripple mousemove.mbsc-ripple', t, function (e) {
        ;((yr && 9 < Math.abs(ua(e, 'X') - s)) || 9 < Math.abs(ua(e, 'Y') - i)) && (xr(Cr), (yr = null))
      })
      .on('touchend.mbsc-ripple touchcancel.mbsc-ripple mouseleave.mbsc-ripple mouseup.mbsc-ripple', t, function () {
        yr &&
          (setTimeout(function () {
            xr(Cr)
          }, 100),
          (yr = null))
      })
  }
  ;((br.frame.ios = {
    display: 'bottom',
    headerText: !1,
    btnWidth: !1,
    deleteIcon: 'ios-backspace',
    scroll3d: 'wp' != _ && ('android' != _ || 7 < M),
  }),
    (br.scroller.ios = va({}, br.frame.ios, {
      rows: 5,
      height: 34,
      minWidth: 55,
      selectedLineHeight: !0,
      selectedLineBorder: 1,
      showLabel: !1,
      useShortLabels: !0,
      btnPlusClass: 'mbsc-ic mbsc-ic-arrow-down5',
      btnMinusClass: 'mbsc-ic mbsc-ic-arrow-up5',
      checkIcon: 'ion-ios7-checkmark-empty',
      filterClearIcon: 'ion-close-circled',
      dateDisplay: 'MMdyy',
      btnCalPrevClass: 'mbsc-ic mbsc-ic-arrow-left5',
      btnCalNextClass: 'mbsc-ic mbsc-ic-arrow-right5',
    })),
    (br.listview.ios = { leftArrowClass: 'mbsc-ic-ion-ios7-arrow-back', rightArrowClass: 'mbsc-ic-ion-ios7-arrow-forward' }),
    (br.form.ios = {}))
  var yr,
    Cr,
    _r = Z.themes
  ;((_r.frame.material = {
    headerText: !1,
    btnWidth: !1,
    deleteIcon: 'material-backspace',
    onMarkupReady: function (e) {
      Tr(pa(e.target), '.mbsc-fr-btn-e', 'mbsc-disabled', 'mbsc-fr-btn-nhl')
    },
  }),
    (_r.scroller.material = va({}, _r.frame.material, {
      showLabel: !1,
      selectedLineBorder: 2,
      weekDays: 'min',
      icon: { filled: 'material-star', empty: 'material-star-outline' },
      checkIcon: 'material-check',
      btnPlusClass: 'mbsc-ic mbsc-ic-material-keyboard-arrow-down',
      btnMinusClass: 'mbsc-ic mbsc-ic-material-keyboard-arrow-up',
      btnCalPrevClass: 'mbsc-ic mbsc-ic-material-keyboard-arrow-left',
      btnCalNextClass: 'mbsc-ic mbsc-ic-material-keyboard-arrow-right',
    })),
    (_r.listview.material = {
      leftArrowClass: 'mbsc-ic-material-keyboard-arrow-left',
      rightArrowClass: 'mbsc-ic-material-keyboard-arrow-right',
      onItemActivate: function (e) {
        gr(pa(e.target), e.domEvent)
      },
      onItemDeactivate: function () {
        xr(Cr)
      },
      onSlideStart: function (e) {
        pa('.mbsc-ripple', e.target).remove()
      },
      onSortStart: function (e) {
        pa('.mbsc-ripple', e.target).remove()
      },
    }),
    (_r.navigation.material = {
      onInit: function () {
        Tr(pa(this), '.mbsc-ms-item.mbsc-btn-e', 'mbsc-disabled', 'mbsc-btn-nhl')
      },
      onMarkupInit: function () {
        pa('.mbsc-ripple', this).remove()
      },
      onDestroy: function () {
        pa(this).off('.mbsc-ripple')
      },
    }),
    (_r.form.material = {
      addRipple: function (e, t) {
        gr(e, t)
      },
      removeRipple: function () {
        xr(Cr)
      },
    }))
  var wr = Z.themes
  ;((wr.frame.windows = { headerText: !1, deleteIcon: 'backspace4', btnReverse: !0 }),
    (wr.scroller.windows = va({}, wr.frame.windows, {
      rows: 6,
      minWidth: 88,
      height: 44,
      btnPlusClass: 'mbsc-ic mbsc-ic-arrow-down5',
      btnMinusClass: 'mbsc-ic mbsc-ic-arrow-up5',
      checkIcon: 'material-check',
      dateDisplay: 'MMdyy',
      showLabel: !1,
      showScrollArrows: !0,
      btnCalPrevClass: 'mbsc-ic mbsc-ic-arrow-left5',
      btnCalNextClass: 'mbsc-ic mbsc-ic-arrow-right5',
      dayNamesShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      useShortLabels: !0,
    })),
    (wr.form.windows = {}),
    Z.customTheme('ios-dark', 'ios'),
    Z.customTheme('material-dark', 'material'),
    Z.customTheme('mobiscroll-dark', 'mobiscroll'),
    Z.customTheme('windows-dark', 'windows'))
  var Mr = Z.themes,
    Sr = 'mobiscroll'
  return (
    'android' == _ ? (Sr = 'material') : 'ios' == _ ? (Sr = 'ios') : 'wp' == _ && (Sr = 'windows'),
    pa.each(Mr.frame, function (e, t) {
      if (Sr && t.baseTheme == Sr && e != Sr + '-dark') return ((Z.autoTheme = e), !1)
      e == Sr && (Z.autoTheme = e)
    }),
    Z.customTheme('ios-gray', 'ios'),
    Z.customTheme('material-indigo', 'material'),
    Z.customTheme('mobiscroll-lime', 'mobiscroll'),
    Z.customTheme('windows-yellow', 'windows'),
    Z
  )
})
